export const makemakeEarthSvs = [
    [
        631152000000,
        [
            -6015489450.446563,
            1049429888.590758,
            4358527912.140166,
        ],
    ],
    [
        631756800000,
        [
            -5998828819.008949,
            1051431502.855674,
            4359815384.636211,
        ],
    ],
    [
        632361600000,
        [
            -5982848511.062346,
            1055384302.831686,
            4361947450.041762,
        ],
    ],
    [
        632966400000,
        [
            -5967794562.066036,
            1061199671.728981,
            4364886998.59987,
        ],
    ],
    [
        633571200000,
        [
            -5953915986.269413,
            1068765640.250374,
            4368586002.461651,
        ],
    ],
    [
        634176000000,
        [
            -5941449731.671182,
            1077928091.91533,
            4372976385.491451,
        ],
    ],
    [
        634780800000,
        [
            -5930590133.763988,
            1088500775.532333,
            4377976869.044144,
        ],
    ],
    [
        635385600000,
        [
            -5921499468.921488,
            1100294654.343347,
            4383506872.429427,
        ],
    ],
    [
        635990400000,
        [
            -5914329685.349476,
            1113106888.797426,
            4389478796.138842,
        ],
    ],
    [
        636595200000,
        [
            -5909207113.24347,
            1126704887.002182,
            4395790446.18271,
        ],
    ],
    [
        637200000000,
        [
            -5906205029.554972,
            1140841217.9575,
            4402334269.458323,
        ],
    ],
    [
        637804800000,
        [
            -5905362086.496623,
            1155281635.161311,
            4409010082.921317,
        ],
    ],
    [
        638409600000,
        [
            -5906702450.876388,
            1169791197.934502,
            4415716163.59946,
        ],
    ],
    [
        639014400000,
        [
            -5910220630.899174,
            1184120237.51989,
            4422342882.080258,
        ],
    ],
    [
        639619200000,
        [
            -5915857891.223403,
            1198022269.943978,
            4428783369.824092,
        ],
    ],
    [
        640224000000,
        [
            -5923527564.121815,
            1211278848.220445,
            4434944247.295701,
        ],
    ],
    [
        640828800000,
        [
            -5933132820.709651,
            1223682014.354938,
            4440735256.608122,
        ],
    ],
    [
        641433600000,
        [
            -5944550858.956409,
            1235021664.024126,
            4446063937.70893,
        ],
    ],
    [
        642038400000,
        [
            -5957613166.342275,
            1245105260.147908,
            4450847102.143909,
        ],
    ],
    [
        642643200000,
        [
            -5972135819.302294,
            1253778301.407272,
            4455019020.344101,
        ],
    ],
    [
        643248000000,
        [
            -5987933991.144991,
            1260903217.834941,
            4458519705.186936,
        ],
    ],
    [
        643852800000,
        [
            -6004804587.854714,
            1266348226.042528,
            4461290700.15279,
        ],
    ],
    [
        644457600000,
        [
            -6022510342.108948,
            1270008475.852607,
            4463287120.635077,
        ],
    ],
    [
        645062400000,
        [
            -6040813178.144846,
            1271821497.615686,
            4464483046.764088,
        ],
    ],
    [
        645667200000,
        [
            -6059484924.698901,
            1271743315.958458,
            4464858832.073503,
        ],
    ],
    [
        646272000000,
        [
            -6078287937.840578,
            1269739153.303333,
            4464398152.240047,
        ],
    ],
    [
        646876800000,
        [
            -6096963316.949473,
            1265806023.575032,
            4463100542.435656,
        ],
    ],
    [
        647481600000,
        [
            -6115265767.117577,
            1259982753.614757,
            4460983891.874296,
        ],
    ],
    [
        648086400000,
        [
            -6132970354.072476,
            1252324281.163161,
            4458071229.482212,
        ],
    ],
    [
        648691200000,
        [
            -6149851160.795971,
            1242894448.789463,
            4454389097.562711,
        ],
    ],
    [
        649296000000,
        [
            -6165674089.262495,
            1231789974.27256,
            4449980465.704916,
        ],
    ],
    [
        649900800000,
        [
            -6180231958.780378,
            1219144656.82509,
            4444904261.729838,
        ],
    ],
    [
        650505600000,
        [
            -6193347240.109058,
            1205102718.041682,
            4439222057.139592,
        ],
    ],
    [
        651110400000,
        [
            -6204849052.792564,
            1189813665.833226,
            4432997687.737414,
        ],
    ],
    [
        651715200000,
        [
            -6214570848.17105,
            1173457268.766661,
            4426310284.734667,
        ],
    ],
    [
        652320000000,
        [
            -6222384571.03624,
            1156241593.628049,
            4419250795.948718,
        ],
    ],
    [
        652924800000,
        [
            -6228199121.917661,
            1138376093.769008,
            4411908951.512695,
        ],
    ],
    [
        653529600000,
        [
            -6231935965.900157,
            1120068378.322212,
            4404373978.736343,
        ],
    ],
    [
        654134400000,
        [
            -6233531493.778397,
            1101549575.414523,
            4396747384.246594,
        ],
    ],
    [
        654739200000,
        [
            -6232968984.653596,
            1083066116.308835,
            4389136524.058497,
        ],
    ],
    [
        655344000000,
        [
            -6230272222.585104,
            1064853289.742762,
            4381642240.839108,
        ],
    ],
    [
        655948800000,
        [
            -6225479785.429242,
            1047133955.704116,
            4374360619.914083,
        ],
    ],
    [
        656553600000,
        [
            -6218651270.404058,
            1030143733.596709,
            4367395187.768874,
        ],
    ],
    [
        657158400000,
        [
            -6209895745.796898,
            1014117089.618166,
            4360847854.25603,
        ],
    ],
    [
        657763200000,
        [
            -6199359817.48117,
            999262370.3129305,
            4354807714.081818,
        ],
    ],
    [
        658368000000,
        [
            -6187200621.572851,
            985763139.2521843,
            4349354087.962165,
        ],
    ],
    [
        658972800000,
        [
            -6173594845.00303,
            973803030.3663687,
            4344568009.236865,
        ],
    ],
    [
        659577600000,
        [
            -6158762703.135121,
            963547602.8249252,
            4340521244.428371,
        ],
    ],
    [
        660182400000,
        [
            -6142950239.683382,
            955122276.2511811,
            4337266885.285694,
        ],
    ],
    [
        660787200000,
        [
            -6126401550.16508,
            948617724.9423169,
            4334844252.037437,
        ],
    ],
    [
        661392000000,
        [
            -6109370111.963608,
            944114653.5338198,
            4333289769.296805,
        ],
    ],
    [
        661996800000,
        [
            -6092138252.012413,
            941663503.0484787,
            4332625041.926157,
        ],
    ],
    [
        662601600000,
        [
            -6074994678.458455,
            941266698.4739546,
            4332849813.924068,
        ],
    ],
    [
        663206400000,
        [
            -6058207482.96129,
            942889646.6339611,
            4333949347.526717,
        ],
    ],
    [
        663811200000,
        [
            -6042038549.434474,
            946485487.3838687,
            4335904731.789535,
        ],
    ],
    [
        664416000000,
        [
            -6026759482.854883,
            951974367.3473713,
            4338680865.232079,
        ],
    ],
    [
        665020800000,
        [
            -6012626598.684692,
            959230539.7473141,
            4342221942.161835,
        ],
    ],
    [
        665625600000,
        [
            -5999856980.08108,
            968099483.6717136,
            4346461463.138941,
        ],
    ],
    [
        666230400000,
        [
            -5988647563.301865,
            978421688.672436,
            4351331578.56671,
        ],
    ],
    [
        666835200000,
        [
            -5979188637.965717,
            990011937.6745068,
            4356751326.494484,
        ],
    ],
    [
        667440000000,
        [
            -5971638673.096825,
            1002650514.270974,
            4362624234.91682,
        ],
    ],
    [
        668044800000,
        [
            -5966105284.396458,
            1016105409.437001,
            4368850435.603638,
        ],
    ],
    [
        668649600000,
        [
            -5962670071.297665,
            1030153221.972312,
            4375334205.046931,
        ],
    ],
    [
        669254400000,
        [
            -5961399864.002644,
            1044557798.511703,
            4381972342.025323,
        ],
    ],
    [
        669859200000,
        [
            -5962322707.034079,
            1059064184.075089,
            4388653226.953581,
        ],
    ],
    [
        670464000000,
        [
            -5965414301.783577,
            1073424006.292096,
            4395270121.785265,
        ],
    ],
    [
        671068800000,
        [
            -5970628246.542871,
            1087411545.793156,
            4401726068.84771,
        ],
    ],
    [
        671673600000,
        [
            -5977904157.390211,
            1100801013.438448,
            4407922215.585952,
        ],
    ],
    [
        672278400000,
        [
            -5987144895.790536,
            1113362322.133625,
            4413757896.294464,
        ],
    ],
    [
        672883200000,
        [
            -5998208016.080274,
            1124887917.537061,
            4419144284.578142,
        ],
    ],
    [
        673488000000,
        [
            -6010939919.350739,
            1135202909.781457,
            4424006206.813427,
        ],
    ],
    [
        674092800000,
        [
            -6025179735.8099,
            1144140909.691667,
            4428270430.750684,
        ],
    ],
    [
        674697600000,
        [
            -6040737351.072178,
            1151541546.485552,
            4431866711.180413,
        ],
    ],
    [
        675302400000,
        [
            -6057389208.27228,
            1157277650.277432,
            4434741258.752572,
        ],
    ],
    [
        675907200000,
        [
            -6074914543.787598,
            1161259251.040887,
            4436855465.357722,
        ],
    ],
    [
        676512000000,
        [
            -6093094430.542897,
            1163408470.446582,
            4438174365.124627,
        ],
    ],
    [
        677116800000,
        [
            -6111690277.040564,
            1163659216.252095,
            4438668792.856087,
        ],
    ],
    [
        677721600000,
        [
            -6130443715.813708,
            1161984087.166239,
            4438328346.869678,
        ],
    ],
    [
        678326400000,
        [
            -6149113242.66514,
            1158392513.118605,
            4437157277.957623,
        ],
    ],
    [
        678931200000,
        [
            -6167468487.093588,
            1152905369.658964,
            4435163366.860776,
        ],
    ],
    [
        679536000000,
        [
            -6185269148.448881,
            1145557268.679473,
            4432361326.023952,
        ],
    ],
    [
        680140800000,
        [
            -6202269110.771325,
            1136422683.976923,
            4428784980.302082,
        ],
    ],
    [
        680745600000,
        [
            -6218252013.574439,
            1125608543.225559,
            4424480631.836026,
        ],
    ],
    [
        681350400000,
        [
            -6233021203.725357,
            1113229128.739692,
            4419496538.481918,
        ],
    ],
    [
        681955200000,
        [
            -6246379201.030957,
            1099411071.341355,
            4413887545.611804,
        ],
    ],
    [
        682560000000,
        [
            -6258136295.068344,
            1084318119.145485,
            4407726160.619637,
        ],
    ],
    [
        683164800000,
        [
            -6268143619.110776,
            1068138365.381003,
            4401093664.281115,
        ],
    ],
    [
        683769600000,
        [
            -6276279242.401352,
            1051059887.9723,
            4394070335.264076,
        ],
    ],
    [
        684374400000,
        [
            -6282428137.133121,
            1033278224.772349,
            4386741150.402319,
        ],
    ],
    [
        684979200000,
        [
            -6286495241.590904,
            1015019143.95394,
            4379205404.500775,
        ],
    ],
    [
        685584000000,
        [
            -6288434486.444919,
            996520675.5805728,
            4371565810.37599,
        ],
    ],
    [
        686188800000,
        [
            -6288231199.533983,
            978010018.3116095,
            4363919673.153737,
        ],
    ],
    [
        686793600000,
        [
            -6285882289.007635,
            959713156.8183665,
            4356365447.930275,
        ],
    ],
    [
        687398400000,
        [
            -6281413229.815934,
            941875165.0860112,
            4349010652.932997,
        ],
    ],
    [
        688003200000,
        [
            -6274901439.419777,
            924737542.7080377,
            4341959291.582707,
        ],
    ],
    [
        688608000000,
        [
            -6266454866.388746,
            908517338.9733794,
            4335304365.55221,
        ],
    ],
    [
        689212800000,
        [
            -6256191979.757137,
            893418882.3093737,
            4329135220.583752,
        ],
    ],
    [
        689817600000,
        [
            -6244261646.889199,
            879651685.8167231,
            4323543782.441673,
        ],
    ],
    [
        690422400000,
        [
            -6230859612.334298,
            867404266.0036775,
            4318610882.242083,
        ],
    ],
    [
        691027200000,
        [
            -6216203231.566075,
            856827019.6128898,
            4314400736.825664,
        ],
    ],
    [
        691632000000,
        [
            -6200511311.777216,
            848046647.2958385,
            4310969285.653891,
        ],
    ],
    [
        692236800000,
        [
            -6184025941.613602,
            841182372.7337681,
            4308369121.769065,
        ],
    ],
    [
        692841600000,
        [
            -6167021925.755571,
            836318076.5500102,
            4306635543.180245,
        ],
    ],
    [
        693446400000,
        [
            -6149778400.489815,
            833490694.3071557,
            4305783707.028976,
        ],
    ],
    [
        694051200000,
        [
            -6132559719.485961,
            832708303.296937,
            4305818312.167659,
        ],
    ],
    [
        694656000000,
        [
            -6115639099.972886,
            833965423.4086986,
            4306737689.771068,
        ],
    ],
    [
        695260800000,
        [
            -6099302337.961104,
            837215254.972117,
            4308520361.26472,
        ],
    ],
    [
        695865600000,
        [
            -6083818101.051872,
            842364621.6846391,
            4311125238.515374,
        ],
    ],
    [
        696470400000,
        [
            -6069422188.94331,
            849296205.2119589,
            4314502771.389142,
        ],
    ],
    [
        697075200000,
        [
            -6056343692.292487,
            857882720.2972409,
            4318598266.24723,
        ],
    ],
    [
        697680000000,
        [
            -6044805060.854964,
            867960113.9864818,
            4323339339.770172,
        ],
    ],
    [
        698284800000,
        [
            -6034993225.630922,
            879328526.0843577,
            4328638859.391261,
        ],
    ],
    [
        698889600000,
        [
            -6027049580.549259,
            891777971.4083331,
            4334407158.704581,
        ],
    ],
    [
        699494400000,
        [
            -6021099254.747666,
            905099816.8186724,
            4340554026.285698,
        ],
    ],
    [
        700099200000,
        [
            -6017248916.928236,
            919060781.2435834,
            4346977037.89553,
        ],
    ],
    [
        700704000000,
        [
            -6015560106.957584,
            933408159.0127779,
            4353566397.316157,
        ],
    ],
    [
        701308800000,
        [
            -6016046028.26768,
            947897364.9545122,
            4360217463.698783,
        ],
    ],
    [
        701913600000,
        [
            -6018703534.949824,
            962298590.4383733,
            4366830566.12079,
        ],
    ],
    [
        702518400000,
        [
            -6023508645.960979,
            976371249.6258699,
            4373300116.501012,
        ],
    ],
    [
        703123200000,
        [
            -6030392335.773163,
            989871669.1703105,
            4379520502.407166,
        ],
    ],
    [
        703728000000,
        [
            -6039243760.504851,
            1002580935.276272,
            4385398217.207105,
        ],
    ],
    [
        704332800000,
        [
            -6049943615.365528,
            1014305213.781431,
            4390848902.795892,
        ],
    ],
    [
        704937600000,
        [
            -6062356485.779399,
            1024850829.655357,
            4395787336.680002,
        ],
    ],
    [
        705542400000,
        [
            -6076308802.718756,
            1034033444.150271,
            4400133892.96251,
        ],
    ],
    [
        706147200000,
        [
            -6091597409.961094,
            1041705180.989076,
            4403825841.165375,
        ],
    ],
    [
        706752000000,
        [
            -6108022697.033681,
            1047748165.520264,
            4406811494.140445,
        ],
    ],
    [
        707356800000,
        [
            -6125377032.992363,
            1052050946.419187,
            4409041335.19495,
        ],
    ],
    [
        707961600000,
        [
            -6143424732.170746,
            1054518991.157274,
            4410474908.057128,
        ],
    ],
    [
        708566400000,
        [
            -6161914925.6881,
            1055100471.935375,
            4411091062.80873,
        ],
    ],
    [
        709171200000,
        [
            -6180613142.374335,
            1053773380.837384,
            4410879453.570106,
        ],
    ],
    [
        709776000000,
        [
            -6199285663.743483,
            1050524059.97544,
            4409833061.394958,
        ],
    ],
    [
        710380800000,
        [
            -6217681688.72683,
            1045359191.174762,
            4407955509.37748,
        ],
    ],
    [
        710985600000,
        [
            -6235549817.192492,
            1038329675.404346,
            4405270071.017946,
        ],
    ],
    [
        711590400000,
        [
            -6252667066.276234,
            1029512027.329937,
            4401808936.867247,
        ],
    ],
    [
        712195200000,
        [
            -6268819486.26466,
            1018989466.41355,
            4397607236.399524,
        ],
    ],
    [
        712800000000,
        [
            -6283786853.751063,
            1006865517.370967,
            4392710747.480298,
        ],
    ],
    [
        713404800000,
        [
            -6297362322.248583,
            993285261.1952002,
            4387183398.403488,
        ],
    ],
    [
        714009600000,
        [
            -6309377944.230884,
            978411778.5284446,
            4381094771.350412,
        ],
    ],
    [
        714614400000,
        [
            -6319682062.437741,
            962409868.6995006,
            4374515555.413095,
        ],
    ],
    [
        715219200000,
        [
            -6328126673.096904,
            945461168.0789856,
            4367525545.732413,
        ],
    ],
    [
        715824000000,
        [
            -6334589793.283728,
            927781916.5927387,
            4360219286.196066,
        ],
    ],
    [
        716428800000,
        [
            -6338996377.031157,
            909595256.0127776,
            4352692289.99365,
        ],
    ],
    [
        717033600000,
        [
            -6341292876.493684,
            891117466.3276367,
            4345037786.021825,
        ],
    ],
    [
        717638400000,
        [
            -6341436972.146118,
            872574403.8748578,
            4337354883.44862,
        ],
    ],
    [
        718243200000,
        [
            -6339421973.998689,
            854215042.5075413,
            4329752043.17477,
        ],
    ],
    [
        718848000000,
        [
            -6335291738.496323,
            836280651.7724454,
            4322332554.40381,
        ],
    ],
    [
        719452800000,
        [
            -6329112583.943328,
            818993680.0781851,
            4315192549.840089,
        ],
    ],
    [
        720057600000,
        [
            -6320964637.862227,
            802575499.5786105,
            4308429322.087548,
        ],
    ],
    [
        720662400000,
        [
            -6310967352.900652,
            787255512.5864493,
            4302142558.675447,
        ],
    ],
    [
        721267200000,
        [
            -6299287025.795725,
            773238709.1789644,
            4296419768.061527,
        ],
    ],
    [
        721872000000,
        [
            -6286106319.908898,
            760698001.7747679,
            4291335824.155807,
        ],
    ],
    [
        722476800000,
        [
            -6271616491.828556,
            749793719.2068493,
            4286961650.097034,
        ],
    ],
    [
        723081600000,
        [
            -6256043256.339345,
            740678907.3628179,
            4283363547.965494,
        ],
    ],
    [
        723686400000,
        [
            -6239646226.882729,
            733467247.6219671,
            4280589436.4076,
        ],
    ],
    [
        724291200000,
        [
            -6222686970.174849,
            728230324.5775877,
            4278670453.576975,
        ],
    ],
    [
        724896000000,
        [
            -6205422219.086489,
            725019616.8336406,
            4277630371.742657,
        ],
    ],
    [
        725500800000,
        [
            -6188130053.35653,
            723869172.7687266,
            4277483636.2205,
        ],
    ],
    [
        726105600000,
        [
            -6171102022.623391,
            724765774.3229916,
            4278223208.943944,
        ],
    ],
    [
        726710400000,
        [
            -6154611699.028367,
            727652501.2399113,
            4279824696.0138,
        ],
    ],
    [
        727315200000,
        [
            -6138910311.06577,
            732453520.0855613,
            4282256641.165177,
        ],
    ],
    [
        727920000000,
        [
            -6124253981.474665,
            739074902.993163,
            4285477755.491963,
        ],
    ],
    [
        728524800000,
        [
            -6110890584.859699,
            747377915.9003477,
            4289426704.786036,
        ],
    ],
    [
        729129600000,
        [
            -6099031219.261943,
            757189021.8115044,
            4294028723.314409,
        ],
    ],
    [
        729734400000,
        [
            -6088850376.909937,
            768326595.0369503,
            4299206382.339933,
        ],
    ],
    [
        730339200000,
        [
            -6080514866.78792,
            780599450.3034338,
            4304875988.592475,
        ],
    ],
    [
        730944000000,
        [
            -6074167548.530969,
            793782866.1025443,
            4310939090.80351,
        ],
    ],
    [
        731548800000,
        [
            -6069903334.108857,
            807633692.9348073,
            4317290945.119752,
        ],
    ],
    [
        732153600000,
        [
            -6067775358.487019,
            821917153.5713114,
            4323830918.99426,
        ],
    ],
    [
        732758400000,
        [
            -6067825111.475625,
            836401738.866945,
            4330457612.475997,
        ],
    ],
    [
        733363200000,
        [
            -6070064168.065845,
            850837140.0697396,
            4337061661.969645,
        ],
    ],
    [
        733968000000,
        [
            -6074454857.597273,
            864972531.9306864,
            4343535205.354522,
        ],
    ],
    [
        734572800000,
        [
            -6080922560.974464,
            878581643.9879537,
            4349781113.521846,
        ],
    ],
    [
        735177600000,
        [
            -6089385462.826254,
            891452758.8903955,
            4355706380.552031,
        ],
    ],
    [
        735782400000,
        [
            -6099734383.996875,
            903368319.7558348,
            4361216029.76711,
        ],
    ],
    [
        736387200000,
        [
            -6111817324.162275,
            914124866.9715694,
            4366222929.298619,
        ],
    ],
    [
        736992000000,
        [
            -6125457091.345692,
            923555319.070681,
            4370655405.747931,
        ],
    ],
    [
        737596800000,
        [
            -6140478778.862534,
            931513552.7938528,
            4374448753.592786,
        ],
    ],
    [
        738201600000,
        [
            -6156687517.740243,
            937856297.9504392,
            4377540380.105729,
        ],
    ],
    [
        738806400000,
        [
            -6173856090.746603,
            942463902.8292606,
            4379879637.691134,
        ],
    ],
    [
        739411200000,
        [
            -6191746860.691145,
            945259447.7292612,
            4381433714.785979,
        ],
    ],
    [
        740016000000,
        [
            -6210135469.063353,
            946188071.648434,
            4382177404.722155,
        ],
    ],
    [
        740620800000,
        [
            -6228786620.446752,
            945202120.2370887,
            4382089753.347718,
        ],
    ],
    [
        741225600000,
        [
            -6247444483.961406,
            942282327.5158166,
            4381163730.146178,
        ],
    ],
    [
        741830400000,
        [
            -6265858004.22356,
            937453637.0586199,
            4379410435.719228,
        ],
    ],
    [
        742435200000,
        [
            -6283799896.855522,
            930759818.7647693,
            4376847425.667041,
        ],
    ],
    [
        743040000000,
        [
            -6301040920.57177,
            922252626.5185932,
            4373497047.771578,
        ],
    ],
    [
        743644800000,
        [
            -6317343218.787873,
            912013048.338626,
            4369395773.105572,
        ],
    ],
    [
        744249600000,
        [
            -6332488157.714788,
            900163604.3407395,
            4364596731.919449,
        ],
    ],
    [
        744854400000,
        [
            -6346290089.992968,
            886838937.1598021,
            4359156932.824365,
        ],
    ],
    [
        745459200000,
        [
            -6358569656.151374,
            872179229.6182426,
            4353137288.430402,
        ],
    ],
    [
        746064000000,
        [
            -6369150307.840378,
            856351086.4047244,
            4346611376.480808,
        ],
    ],
    [
        746668800000,
        [
            -6377887689.803088,
            839555874.734758,
            4339666220.341718,
        ],
    ],
    [
        747273600000,
        [
            -6384677754.474649,
            821997087.5155479,
            4332388769.75989,
        ],
    ],
    [
        747878400000,
        [
            -6389429403.272409,
            803877806.3009822,
            4324867447.560012,
        ],
    ],
    [
        748483200000,
        [
            -6392064150.96558,
            785420783.2397113,
            4317200126.636361,
        ],
    ],
    [
        749088000000,
        [
            -6392545800.583815,
            766872329.7439151,
            4309493026.726204,
        ],
    ],
    [
        749692800000,
        [
            -6390882376.741516,
            748467534.7287166,
            4301846906.017834,
        ],
    ],
    [
        750297600000,
        [
            -6387098029.474045,
            730431415.5667886,
            4294359933.234377,
        ],
    ],
    [
        750902400000,
        [
            -6381235332.879951,
            712998075.45817,
            4287134826.933914,
        ],
    ],
    [
        751507200000,
        [
            -6373383810.678647,
            696409915.3861272,
            4280275850.989233,
        ],
    ],
    [
        752112000000,
        [
            -6363675045.202762,
            680882347.9111329,
            4273875353.606836,
        ],
    ],
    [
        752716800000,
        [
            -6352253613.633902,
            666608615.8105255,
            4268017936.74722,
        ],
    ],
    [
        753321600000,
        [
            -6339281260.442682,
            653778537.8098791,
            4262787011.781687,
        ],
    ],
    [
        753926400000,
        [
            -6324963078.651025,
            642573430.9908655,
            4258260150.537466,
        ],
    ],
    [
        754531200000,
        [
            -6309535447.853554,
            633132618.03998,
            4254496851.398921,
        ],
    ],
    [
        755136000000,
        [
            -6293236333.238981,
            625562510.4983656,
            4251544235.887913,
        ],
    ],
    [
        755740800000,
        [
            -6276310968.64062,
            619956044.443251,
            4249443562.244462,
        ],
    ],
    [
        756345600000,
        [
            -6259035424.216069,
            616384274.6343334,
            4248224445.234892,
        ],
    ],
    [
        756950400000,
        [
            -6241697977.652928,
            614867136.9853534,
            4247894800.070425,
        ],
    ],
    [
        757555200000,
        [
            -6224570385.820219,
            615387622.0946822,
            4248448355.317216,
        ],
    ],
    [
        758160000000,
        [
            -6207915703.585327,
            617912824.2141731,
            4249871611.76965,
        ],
    ],
    [
        758764800000,
        [
            -6192010153.407157,
            622383086.1264622,
            4252137405.556,
        ],
    ],
    [
        759369600000,
        [
            -6177119671.206895,
            628688580.3167843,
            4255197620.105339,
        ],
    ],
    [
        759974400000,
        [
            -6163474817.666211,
            636688669.2397822,
            4258992462.732438,
        ],
    ],
    [
        760579200000,
        [
            -6151282082.902054,
            646234281.5761024,
            4263457826.990733,
        ],
    ],
    [
        761184000000,
        [
            -6140745374.274454,
            657154668.1664805,
            4268518306.64194,
        ],
    ],
    [
        761788800000,
        [
            -6132039822.761567,
            669239740.3736204,
            4274082582.26657,
        ],
    ],
    [
        762393600000,
        [
            -6125292699.844598,
            682263450.216357,
            4280053886.533823,
        ],
    ],
    [
        762998400000,
        [
            -6120599217.659621,
            696005807.0460056,
            4286337096.872133,
        ],
    ],
    [
        763603200000,
        [
            -6118044068.280869,
            710236566.3565899,
            4292830958.624765,
        ],
    ],
    [
        764208000000,
        [
            -6117673846.8892,
            724702109.4583378,
            4299425554.598676,
        ],
    ],
    [
        764812800000,
        [
            -6119484801.368675,
            739150992.5018384,
            4306013143.970803,
        ],
    ],
    [
        765417600000,
        [
            -6123443063.095888,
            753353455.6634732,
            4312494101.637394,
        ],
    ],
    [
        766022400000,
        [
            -6129505297.83064,
            767081437.6413203,
            4318768096.274506,
        ],
    ],
    [
        766627200000,
        [
            -6137590156.910628,
            780098822.9803135,
            4324733055.444796,
        ],
    ],
    [
        767232000000,
        [
            -6147572183.858572,
            792187624.6516798,
            4330295752.459697,
        ],
    ],
    [
        767836800000,
        [
            -6159305600.107062,
            803163428.4486289,
            4335375974.026549,
        ],
    ],
    [
        768441600000,
        [
            -6172642360.510483,
            812851772.5578015,
            4339896653.058605,
        ],
    ],
    [
        769046400000,
        [
            -6187402735.752199,
            821081377.7113516,
            4343784049.023215,
        ],
    ],
    [
        769651200000,
        [
            -6203374122.80378,
            827710141.7039251,
            4346977802.619606,
        ],
    ],
    [
        770256000000,
        [
            -6220337387.409472,
            832635841.7087985,
            4349433105.428966,
        ],
    ],
    [
        770860800000,
        [
            -6238080699.037296,
            835769479.8034257,
            4351110037.822436,
        ],
    ],
    [
        771465600000,
        [
            -6256369658.346084,
            837031798.3105142,
            4351974941.526498,
        ],
    ],
    [
        772070400000,
        [
            -6274949962.969044,
            836378700.8937126,
            4352009865.546155,
        ],
    ],
    [
        772675200000,
        [
            -6293575548.327574,
            833807093.0506555,
            4351212758.685079,
        ],
    ],
    [
        773280000000,
        [
            -6312017073.135646,
            829325981.4826987,
            4349586359.632066,
        ],
    ],
    [
        773884800000,
        [
            -6330032431.377976,
            822956757.4436904,
            4347140805.234112,
        ],
    ],
    [
        774489600000,
        [
            -6347372648.216436,
            814757666.8430207,
            4343902383.581321,
        ],
    ],
    [
        775094400000,
        [
            -6363811217.282291,
            804824836.7137598,
            4339911845.167885,
        ],
    ],
    [
        775699200000,
        [
            -6379146586.200977,
            793261841.8031195,
            4335213157.24212,
        ],
    ],
    [
        776304000000,
        [
            -6393174037.404165,
            780183994.6587768,
            4329857317.215113,
        ],
    ],
    [
        776908800000,
        [
            -6405694438.222103,
            765741273.636045,
            4323910213.479223,
        ],
    ],
    [
        777513600000,
        [
            -6416544048.345037,
            750114580.251469,
            4317449143.202377,
        ],
    ],
    [
        778118400000,
        [
            -6425590640.149362,
            733484370.0277152,
            4310551668.488153,
        ],
    ],
    [
        778723200000,
        [
            -6432707461.994231,
            716038808.1579373,
            4303300496.715891,
        ],
    ],
    [
        779328000000,
        [
            -6437784424.149318,
            697994410.7321138,
            4295790171.623731,
        ],
    ],
    [
        779932800000,
        [
            -6440757278.459845,
            679587635.7300823,
            4288121891.645867,
        ],
    ],
    [
        780537600000,
        [
            -6441597113.227428,
            661043213.8430713,
            4280392685.162677,
        ],
    ],
    [
        781142400000,
        [
            -6440286517.634111,
            642585825.5624534,
            4272701190.01839,
        ],
    ],
    [
        781747200000,
        [
            -6436832547.598355,
            624457874.9265614,
            4265152975.47349,
        ],
    ],
    [
        782352000000,
        [
            -6431293765.566967,
            606906790.2535213,
            4257853855.242059,
        ],
    ],
    [
        782956800000,
        [
            -6423762929.618641,
            590154056.7331301,
            4250899708.39219,
        ],
    ],
    [
        783561600000,
        [
            -6414344896.801226,
            574410262.636442,
            4244383121.341321,
        ],
    ],
    [
        784166400000,
        [
            -6403170585.474451,
            559890040.7383348,
            4238397418.121525,
        ],
    ],
    [
        784771200000,
        [
            -6390420293.030611,
            546795946.569296,
            4233028881.772768,
        ],
    ],
    [
        785376000000,
        [
            -6376299770.122868,
            535289895.1017751,
            4228347795.57574,
        ],
    ],
    [
        785980800000,
        [
            -6361019384.438313,
            525511933.2315365,
            4224416167.317324,
        ],
    ],
    [
        786585600000,
        [
            -6344808668.918883,
            517593239.0206879,
            4221290919.226951,
        ],
    ],
    [
        787190400000,
        [
            -6327934974.825311,
            511637865.5860537,
            4219015642.730414,
        ],
    ],
    [
        787795200000,
        [
            -6310674015.734429,
            507698862.6780604,
            4217613644.873596,
        ],
    ],
    [
        788400000000,
        [
            -6293290722.242488,
            505801370.5311379,
            4217097075.992907,
        ],
    ],
    [
        789004800000,
        [
            -6276054938.205527,
            505954950.0883315,
            4217469887.238471,
        ],
    ],
    [
        789609600000,
        [
            -6259255749.108193,
            508134299.7009786,
            4218719680.511541,
        ],
    ],
    [
        790214400000,
        [
            -6243168709.468134,
            512262071.5539621,
            4220813447.275131,
        ],
    ],
    [
        790819200000,
        [
            -6228040123.787257,
            518236242.0526415,
            4223708124.289826,
        ],
    ],
    [
        791424000000,
        [
            -6214105253.776293,
            525942388.4659083,
            4227353639.499762,
        ],
    ],
    [
        792028800000,
        [
            -6201599608.39689,
            535233535.1758295,
            4231684986.485703,
        ],
    ],
    [
        792633600000,
        [
            -6190725453.46963,
            545920337.9721774,
            4236620819.019045,
        ],
    ],
    [
        793238400000,
        [
            -6181641721.055635,
            557801331.8704273,
            4242074855.467387,
        ],
    ],
    [
        793843200000,
        [
            -6174485810.165164,
            570674446.3376465,
            4247958749.789962,
        ],
    ],
    [
        794448000000,
        [
            -6169382898.945487,
            584315164.5196766,
            4254174048.29253,
        ],
    ],
    [
        795052800000,
        [
            -6166413497.926773,
            598473294.083735,
            4260613226.443059,
        ],
    ],
    [
        795657600000,
        [
            -6165610272.340098,
            612903782.3324604,
            4267170986.69234,
        ],
    ],
    [
        796262400000,
        [
            -6166983264.947723,
            627375917.5317533,
            4273746318.719615,
        ],
    ],
    [
        796867200000,
        [
            -6170527215.306981,
            641648932.211504,
            4280233909.228629,
        ],
    ],
    [
        797472000000,
        [
            -6176190601.098086,
            655474038.2806942,
            4286527006.039383,
        ],
    ],
    [
        798076800000,
        [
            -6183879219.753064,
            668623755.9414015,
            4292527794.973217,
        ],
    ],
    [
        798681600000,
        [
            -6193483555.621306,
            680897393.8867872,
            4298148090.089911,
        ],
    ],
    [
        799286400000,
        [
            -6204883244.136527,
            692094056.0839908,
            4303300065.912476,
        ],
    ],
    [
        799891200000,
        [
            -6217917346.061158,
            702018967.2941351,
            4307900499.470011,
        ],
    ],
    [
        800496000000,
        [
            -6232393665.632827,
            710510226.0397701,
            4311879842.70352,
        ],
    ],
    [
        801100800000,
        [
            -6248116739.983681,
            717439800.1001232,
            4315181286.558556,
        ],
    ],
    [
        801705600000,
        [
            -6264888463.859462,
            722684789.3923633,
            4317751046.263587,
        ],
    ],
    [
        802310400000,
        [
            -6282479513.623069,
            726137582.8582159,
            4319543749.522851,
        ],
    ],
    [
        802915200000,
        [
            -6300643268.358234,
            727729759.8905241,
            4320530173.305515,
        ],
    ],
    [
        803520000000,
        [
            -6319143282.3245,
            727428347.8222861,
            4320694654.444695,
        ],
    ],
    [
        804124800000,
        [
            -6337749398.980546,
            725206590.6865673,
            4320025347.884891,
        ],
    ],
    [
        804729600000,
        [
            -6356210797.683194,
            721057673.714066,
            4318520599.378903,
        ],
    ],
    [
        805334400000,
        [
            -6374273592.274563,
            715015795.1535985,
            4316195437.756639,
        ],
    ],
    [
        805939200000,
        [
            -6391707100.139857,
            707147630.3171171,
            4313077375.20909,
        ],
    ],
    [
        806544000000,
        [
            -6408295098.2299,
            697523776.1750339,
            4309197056.339626,
        ],
    ],
    [
        807148800000,
        [
            -6423811377.419687,
            686235642.353754,
            4304595398.66127,
        ],
    ],
    [
        807753600000,
        [
            -6438040219.380776,
            673413620.7335987,
            4299328876.573401,
        ],
    ],
    [
        808358400000,
        [
            -6450800970.33477,
            659213740.5791931,
            4293463743.554718,
        ],
    ],
    [
        808963200000,
        [
            -6461934228.440721,
            643790670.7563188,
            4287067382.070808,
        ],
    ],
    [
        809568000000,
        [
            -6471280802.13326,
            627317120.3769046,
            4280215920.192976,
        ],
    ],
    [
        810172800000,
        [
            -6478704165.289604,
            609998817.1559854,
            4272998235.569302,
        ],
    ],
    [
        810777600000,
        [
            -6484112727.622957,
            592056446.6014794,
            4265508643.027083,
        ],
    ],
    [
        811382400000,
        [
            -6487440691.211358,
            573700855.6108423,
            4257839149.938623,
        ],
    ],
    [
        811987200000,
        [
            -6488630905.956441,
            555154204.1843632,
            4250087261.643219,
        ],
    ],
    [
        812592000000,
        [
            -6487658134.79351,
            536661389.078879,
            4242358602.917217,
        ],
    ],
    [
        813196800000,
        [
            -6484548108.306043,
            518467727.3411325,
            4234758231.85318,
        ],
    ],
    [
        813801600000,
        [
            -6479352701.205498,
            500797022.3588132,
            4227384002.688665,
        ],
    ],
    [
        814406400000,
        [
            -6472136575.425451,
            483873995.241519,
            4220334431.35077,
        ],
    ],
    [
        815011200000,
        [
            -6462999910.167796,
            467932066.7367344,
            4213709972.445762,
        ],
    ],
    [
        815616000000,
        [
            -6452093128.574885,
            453187926.7531855,
            4207603383.294368,
        ],
    ],
    [
        816220800000,
        [
            -6439586265.596899,
            439823489.1168493,
            4202094540.4464,
        ],
    ],
    [
        816825600000,
        [
            -6425658946.742067,
            428009814.526214,
            4197258545.534257,
        ],
    ],
    [
        817430400000,
        [
            -6410521574.785244,
            417911781.0382919,
            4193165979.907948,
        ],
    ],
    [
        818035200000,
        [
            -6394424923.862138,
            409661401.7546991,
            4189873057.536465,
        ],
    ],
    [
        818640000000,
        [
            -6377624480.288666,
            403345164.5116004,
            4187418425.387459,
        ],
    ],
    [
        819244800000,
        [
            -6360373677.399052,
            399030264.2212462,
            4185831954.364259,
        ],
    ],
    [
        819849600000,
        [
            -6342943606.868783,
            396767191.3289617,
            4185134497.499073,
        ],
    ],
    [
        820454400000,
        [
            -6325627611.682618,
            396563769.705776,
            4185328653.377072,
        ],
    ],
    [
        821059200000,
        [
            -6308702835.847065,
            398379321.7556952,
            4186398048.224713,
        ],
    ],
    [
        821664000000,
        [
            -6292427563.048958,
            402153770.5475613,
            4188317141.272409,
        ],
    ],
    [
        822268800000,
        [
            -6277060789.184957,
            407808904.9441109,
            4191050857.959595,
        ],
    ],
    [
        822873600000,
        [
            -6262862887.742141,
            415224157.8545481,
            4194546400.100544,
        ],
    ],
    [
        823478400000,
        [
            -6250057588.053583,
            424238073.9489439,
            4198735118.229923,
        ],
    ],
    [
        824083200000,
        [
            -6238834792.110817,
            434679532.4028404,
            4203543088.203854,
        ],
    ],
    [
        824688000000,
        [
            -6229371675.040855,
            446367447.8117646,
            4208890515.326012,
        ],
    ],
    [
        825292800000,
        [
            -6221830520.42645,
            459087856.4232486,
            4214684389.206362,
        ],
    ],
    [
        825897600000,
        [
            -6216323891.062237,
            472601893.6016057,
            4220822553.892204,
        ],
    ],
    [
        826502400000,
        [
            -6212923714.264416,
            486676998.8157568,
            4227204223.76692,
        ],
    ],
    [
        827107200000,
        [
            -6211684569.831356,
            501084027.5658088,
            4233728677.909129,
        ],
    ],
    [
        827712000000,
        [
            -6212638892.834402,
            515574474.7363207,
            4240288204.9511,
        ],
    ],
    [
        828316800000,
        [
            -6215766587.336704,
            529893604.1643223,
            4246773768.249368,
        ],
    ],
    [
        828921600000,
        [
            -6221009983.434385,
            543809159.740431,
            4253084515.10803,
        ],
    ],
    [
        829526400000,
        [
            -6228298556.543211,
            557104971.1316553,
            4259125311.00193,
        ],
    ],
    [
        830131200000,
        [
            -6237540868.744773,
            569557585.7005571,
            4264799570.331662,
        ],
    ],
    [
        830736000000,
        [
            -6248598593.787749,
            580953501.5660115,
            4270016065.848301,
        ],
    ],
    [
        831340800000,
        [
            -6261306164.492839,
            591113636.0015801,
            4274696815.687691,
        ],
    ],
    [
        831945600000,
        [
            -6275495416.202007,
            599883150.3204104,
            4278773304.170691,
        ],
    ],
    [
        832550400000,
        [
            -6290983588.001365,
            607107724.7579769,
            4282179173.611577,
        ],
    ],
    [
        833155200000,
        [
            -6307551353.34646,
            612654355.9395868,
            4284857966.071646,
        ],
    ],
    [
        833760000000,
        [
            -6324965916.643385,
            616430824.1090438,
            4286769178.766232,
        ],
    ],
    [
        834364800000,
        [
            -6343004135.499515,
            618371956.8191134,
            4287883268.226344,
        ],
    ],
    [
        834969600000,
        [
            -6361436417.079853,
            618416466.9645686,
            4288174459.625268,
        ],
    ],
    [
        835574400000,
        [
            -6380008584.749015,
            616530931.7371505,
            4287629293.951697,
        ],
    ],
    [
        836179200000,
        [
            -6398467478.224906,
            612724155.065819,
            4286250880.219824,
        ],
    ],
    [
        836784000000,
        [
            -6416581509.300037,
            607030176.2514353,
            4284052835.247459,
        ],
    ],
    [
        837388800000,
        [
            -6434120817.346751,
            599486742.9291413,
            4281052550.230456,
        ],
    ],
    [
        837993600000,
        [
            -6450843122.520943,
            590161848.7515056,
            4277280334.045964,
        ],
    ],
    [
        838598400000,
        [
            -6466521131.22344,
            579163148.0053647,
            4272781962.468039,
        ],
    ],
    [
        839203200000,
        [
            -6480959801.92257,
            566617878.7745887,
            4267611638.790867,
        ],
    ],
    [
        839808000000,
        [
            -6493973311.14391,
            552653884.8536166,
            4261826017.911841,
        ],
    ],
    [
        840412800000,
        [
            -6505375107.439791,
            537427717.0210211,
            4255493600.668679,
        ],
    ],
    [
        841017600000,
        [
            -6515006391.72443,
            521129295.2140408,
            4248695656.365056,
        ],
    ],
    [
        841622400000,
        [
            -6522749449.485138,
            503958769.3484498,
            4241518201.117072,
        ],
    ],
    [
        842227200000,
        [
            -6528501802.233897,
            486110779.0341655,
            4234047000.906312,
        ],
    ],
    [
        842832000000,
        [
            -6532170482.063828,
            467802877.2970123,
            4226376809.604456,
        ],
    ],
    [
        843436800000,
        [
            -6533700580.555316,
            449275687.8251244,
            4218610739.935321,
        ],
    ],
    [
        844041600000,
        [
            -6533083901.410008,
            430766838.7925956,
            4210851277.806297,
        ],
    ],
    [
        844646400000,
        [
            -6530330276.91826,
            412499126.2378635,
            4203196476.628082,
        ],
    ],
    [
        845251200000,
        [
            -6525465732.161028,
            394708156.9536274,
            4195748727.673944,
        ],
    ],
    [
        845856000000,
        [
            -6518559729.976752,
            377638485.7739582,
            4188612758.408975,
        ],
    ],
    [
        846460800000,
        [
            -6509728335.710392,
            361515277.2045715,
            4181885896.127619,
        ],
    ],
    [
        847065600000,
        [
            -6499102432.077207,
            346537318.5030929,
            4175655788.362698,
        ],
    ],
    [
        847670400000,
        [
            -6486829251.609463,
            332903413.4547403,
            4170008671.24361,
        ],
    ],
    [
        848275200000,
        [
            -6473096896.134449,
            320805448.8159428,
            4165026405.112339,
        ],
    ],
    [
        848880000000,
        [
            -6458131566.78783,
            310399286.231921,
            4160776542.442518,
        ],
    ],
    [
        849484800000,
        [
            -6442162808.069542,
            301803963.7925337,
            4157312094.7565,
        ],
    ],
    [
        850089600000,
        [
            -6425428239.455644,
            295127234.8523351,
            4154679602.277494,
        ],
    ],
    [
        850694400000,
        [
            -6408194625.42275,
            290456892.8938122,
            4152915812.516937,
        ],
    ],
    [
        851299200000,
        [
            -6390749709.622232,
            287833005.6229773,
            4152038367.103294,
        ],
    ],
    [
        851904000000,
        [
            -6373365825.936371,
            287254550.7983735,
            4152048124.882638,
        ],
    ],
    [
        852508800000,
        [
            -6356308537.007087,
            288704854.2341511,
            4152937442.149078,
        ],
    ],
    [
        853113600000,
        [
            -6339854823.686119,
            292142217.0492939,
            4154686975.319928,
        ],
    ],
    [
        853718400000,
        [
            -6324281153.36652,
            297475235.2369778,
            4157257658.051313,
        ],
    ],
    [
        854323200000,
        [
            -6309828091.0152,
            304577057.0876181,
            4160595677.670092,
        ],
    ],
    [
        854928000000,
        [
            -6296714157.575969,
            313310800.1660697,
            4164641039.917881,
        ],
    ],
    [
        855532800000,
        [
            -6285152602.861346,
            323519443.6879525,
            4169324478.168456,
        ],
    ],
    [
        856137600000,
        [
            -6275337499.565645,
            335004674.1213408,
            4174560836.600801,
        ],
    ],
    [
        856742400000,
        [
            -6267412212.727936,
            347547421.2044953,
            4180256194.137308,
        ],
    ],
    [
        857347200000,
        [
            -6261489272.153145,
            360932118.9467845,
            4186316237.912747,
        ],
    ],
    [
        857952000000,
        [
            -6257666862.232116,
            374934781.1928353,
            4192642773.384178,
        ],
    ],
    [
        858556800000,
        [
            -6256013681.575781,
            389304664.0813584,
            4199128121.476205,
        ],
    ],
    [
        859161600000,
        [
            -6256543083.067607,
            403788929.1829416,
            4205663574.742344,
        ],
    ],
    [
        859766400000,
        [
            -6259238390.770041,
            418153935.7067716,
            4212146823.823445,
        ],
    ],
    [
        860371200000,
        [
            -6264069121.870072,
            432170342.0585482,
            4218477499.078174,
        ],
    ],
    [
        860976000000,
        [
            -6270974082.229612,
            445596762.7404238,
            4224552132.055607,
        ],
    ],
    [
        861580800000,
        [
            -6279841689.17853,
            458206775.8317466,
            4230273282.796595,
        ],
    ],
    [
        862185600000,
        [
            -6290539072.624652,
            469805681.370218,
            4235555412.267899,
        ],
    ],
    [
        862790400000,
        [
            -6302927206.976532,
            480212256.0243233,
            4240319207.14104,
        ],
    ],
    [
        863395200000,
        [
            -6316841285.595587,
            489244226.9736134,
            4244486938.628914,
        ],
    ],
    [
        864000000000,
        [
            -6332077083.860043,
            496746692.4571335,
            4247991940.899368,
        ],
    ],
    [
        864604800000,
        [
            -6348421968.141753,
            502603467.9164765,
            4250782641.346801,
        ],
    ],
    [
        865209600000,
        [
            -6365667979.765897,
            506715950.1398118,
            4252815784.177322,
        ],
    ],
    [
        865814400000,
        [
            -6383589002.283773,
            508990829.6971948,
            4254052291.121295,
        ],
    ],
    [
        866419200000,
        [
            -6401932980.239058,
            509369520.1211804,
            4254466984.691871,
        ],
    ],
    [
        867024000000,
        [
            -6420453345.567055,
            507833791.2983997,
            4254050713.320753,
        ],
    ],
    [
        867628800000,
        [
            -6438919340.24654,
            504382557.0037438,
            4252802763.762908,
        ],
    ],
    [
        868233600000,
        [
            -6457090253.41285,
            499022391.44971,
            4250727415.306759,
        ],
    ],
    [
        868838400000,
        [
            -6474713396.346751,
            491797572.8172837,
            4247843808.091476,
        ],
    ],
    [
        869443200000,
        [
            -6491554941.736995,
            482790009.4943635,
            4244186181.193664,
        ],
    ],
    [
        870048000000,
        [
            -6507406979.997496,
            472094683.7168419,
            4239795738.39615,
        ],
    ],
    [
        870652800000,
        [
            -6522059632.024491,
            459813326.3992059,
            4234718035.584875,
        ],
    ],
    [
        871257600000,
        [
            -6535304568.444356,
            446084408.2486657,
            4229012785.674902,
        ],
    ],
    [
        871862400000,
        [
            -6546964550.689483,
            431077499.029317,
            4222752237.921869,
        ],
    ],
    [
        872467200000,
        [
            -6556896699.666821,
            414967847.4542777,
            4216012643.911508,
        ],
    ],
    [
        873072000000,
        [
            -6564963380.627507,
            397933306.5076994,
            4208872540.788249,
        ],
    ],
    [
        873676800000,
        [
            -6571040698.982754,
            380183332.956207,
            4201422185.119815,
        ],
    ],
    [
        874281600000,
        [
            -6575046055.730788,
            361948061.3353006,
            4193760128.459969,
        ],
    ],
    [
        874886400000,
        [
            -6576936892.216157,
            343452344.6505892,
            4185984351.315475,
        ],
    ],
    [
        875491200000,
        [
            -6576680955.434352,
            324916005.428465,
            4178191505.5617,
        ],
    ],
    [
        876096000000,
        [
            -6574268741.726912,
            306580850.7050893,
            4170485679.326284,
        ],
    ],
    [
        876700800000,
        [
            -6569738208.26737,
            288695076.9414335,
            4162973347.233715,
        ],
    ],
    [
        877305600000,
        [
            -6563168053.079025,
            271487255.7278398,
            4155754308.147412,
        ],
    ],
    [
        877910400000,
        [
            -6554647584.925718,
            255170382.3225508,
            4148922100.006671,
        ],
    ],
    [
        878515200000,
        [
            -6544291816.43804,
            239966230.9915574,
            4142571965.496149,
        ],
    ],
    [
        879120000000,
        [
            -6532262375.868948,
            226086322.013307,
            4136794618.130291,
        ],
    ],
    [
        879724800000,
        [
            -6518754584.877538,
            213706868.9367689,
            4131667358.888121,
        ],
    ],
    [
        880329600000,
        [
            -6503967149.409802,
            202977767.5067109,
            4127256146.079318,
        ],
    ],
    [
        880934400000,
        [
            -6488118925.269964,
            194044239.7764058,
            4123622895.452668,
        ],
    ],
    [
        881539200000,
        [
            -6471465450.290766,
            187026237.3514965,
            4120818797.475194,
        ],
    ],
    [
        882144000000,
        [
            -6454280061.348423,
            181995925.8667142,
            4118876243.804091,
        ],
    ],
    [
        882748800000,
        [
            -6436824333.948308,
            178993097.4842275,
            4117813189.741705,
        ],
    ],
    [
        883353600000,
        [
            -6419366583.090613,
            178044500.3166928,
            4117640065.213895,
        ],
    ],
    [
        883958400000,
        [
            -6402194369.801937,
            179143573.9307017,
            4118353403.53142,
        ],
    ],
    [
        884563200000,
        [
            -6385591374.76408,
            182231943.3016623,
            4119929185.311361,
        ],
    ],
    [
        885168000000,
        [
            -6369810555.401649,
            187222017.1856921,
            4122329857.355798,
        ],
    ],
    [
        885772800000,
        [
            -6355095546.473798,
            194014095.2236985,
            4125510933.591289,
        ],
    ],
    [
        886377600000,
        [
            -6341690328.654496,
            202477312.0292604,
            4129415250.146246,
        ],
    ],
    [
        886982400000,
        [
            -6329814433.176379,
            212435612.8412038,
            4133967918.922507,
        ],
    ],
    [
        887587200000,
        [
            -6319641123.473594,
            223696640.2977431,
            4139085702.872843,
        ],
    ],
    [
        888192000000,
        [
            -6311322941.315302,
            236065852.7791524,
            4144682952.574972,
        ],
    ],
    [
        888796800000,
        [
            -6304999590.419184,
            249328121.0589214,
            4150666166.07722,
        ],
    ],
    [
        889401600000,
        [
            -6300773401.613676,
            263237550.5366702,
            4156930254.120267,
        ],
    ],
    [
        890006400000,
        [
            -6298693995.175115,
            277550298.6510707,
            4163369409.326405,
        ],
    ],
    [
        890611200000,
        [
            -6298788091.188303,
            292034389.0040325,
            4169881756.45767,
        ],
    ],
    [
        891216000000,
        [
            -6301065736.540689,
            306450694.3809034,
            4176363594.455486,
        ],
    ],
    [
        891820800000,
        [
            -6305496474.211446,
            320545745.4291216,
            4182706542.829567,
        ],
    ],
    [
        892425600000,
        [
            -6312000712.494183,
            334085897.5798684,
            4188808980.189881,
        ],
    ],
    [
        893030400000,
        [
            -6320482549.632196,
            346861842.9322889,
            4194578914.531357,
        ],
    ],
    [
        893635200000,
        [
            -6330833686.289941,
            358668107.9669699,
            4199927466.680816,
        ],
    ],
    [
        894240000000,
        [
            -6342909683.206058,
            369298583.3697628,
            4204766707.432605,
        ],
    ],
    [
        894844800000,
        [
            -6356527606.847896,
            378580181.6935372,
            4209021038.762905,
        ],
    ],
    [
        895449600000,
        [
            -6371499946.137079,
            386371771.5068188,
            4212628120.577283,
        ],
    ],
    [
        896054400000,
        [
            -6387635506.749974,
            392542148.9341199,
            4215531527.337893,
        ],
    ],
    [
        896659200000,
        [
            -6404715074.800157,
            396968666.4597154,
            4217679380.90063,
        ],
    ],
    [
        897264000000,
        [
            -6422494943.099128,
            399569331.2246329,
            4219035351.150494,
        ],
    ],
    [
        897868800000,
        [
            -6440740074.175914,
            400296421.7563062,
            4219577713.571108,
        ],
    ],
    [
        898473600000,
        [
            -6459221697.831411,
            399113465.6594974,
            4219291373.443112,
        ],
    ],
    [
        899078400000,
        [
            -6477692216.397909,
            395997505.6801826,
            4218167507.078731,
        ],
    ],
    [
        899683200000,
        [
            -6495894445.229746,
            390968989.471625,
            4216213991.877092,
        ],
    ],
    [
        900288000000,
        [
            -6513592569.737067,
            384080500.4504073,
            4213452720.939555,
        ],
    ],
    [
        900892800000,
        [
            -6530566554.651841,
            375393420.6860121,
            4209911265.545878,
        ],
    ],
    [
        901497600000,
        [
            -6546586648.111639,
            364984069.4028058,
            4205623654.934253,
        ],
    ],
    [
        902102400000,
        [
            -6561428185.888551,
            352970785.5712969,
            4200640042.99675,
        ],
    ],
    [
        902707200000,
        [
            -6574899247.612562,
            339498153.228164,
            4195022352.304007,
        ],
    ],
    [
        903312000000,
        [
            -6586832053.466427,
            324713934.4031171,
            4188835800.870046,
        ],
    ],
    [
        903916800000,
        [
            -6597057643.311212,
            308778835.5289408,
            4182150796.161499,
        ],
    ],
    [
        904521600000,
        [
            -6605425782.44982,
            291890142.1063001,
            4175051609.835723,
        ],
    ],
    [
        905126400000,
        [
            -6611828407.101893,
            274261751.8665383,
            4167630379.545381,
        ],
    ],
    [
        905731200000,
        [
            -6616187909.004031,
            256101880.0748892,
            4159978667.097367,
        ],
    ],
    [
        906336000000,
        [
            -6618432453.420119,
            237625883.346166,
            4152190343.859804,
        ],
    ],
    [
        906940800000,
        [
            -6618519968.68285,
            219075901.9496281,
            4144369075.021674,
        ],
    ],
    [
        907545600000,
        [
            -6616456514.772132,
            200697137.3290247,
            4136620767.143305,
        ],
    ],
    [
        908150400000,
        [
            -6612280915.285147,
            182716969.1778201,
            4129045361.509049,
        ],
    ],
    [
        908755200000,
        [
            -6606040927.11943,
            165360381.9335892,
            4121740647.501951,
        ],
    ],
    [
        909360000000,
        [
            -6597819745.434052,
            148865446.3029807,
            4114808519.564738,
        ],
    ],
    [
        909964800000,
        [
            -6587748540.755156,
            133456744.6804286,
            4108346177.65723,
        ],
    ],
    [
        910569600000,
        [
            -6575986679.78304,
            119326969.0186539,
            4102438546.716167,
        ],
    ],
    [
        911174400000,
        [
            -6562698959.44074,
            106655124.7686211,
            4097163200.636324,
        ],
    ],
    [
        911779200000,
        [
            -6548082949.484581,
            95618278.7851473,
            4092595611.203291,
        ],
    ],
    [
        912384000000,
        [
            -6532375469.510505,
            86363744.86701718,
            4088799735.447803,
        ],
    ],
    [
        912988800000,
        [
            -6515828127.440631,
            78994706.32075913,
            4085821684.501431,
        ],
    ],
    [
        913593600000,
        [
            -6498686448.848555,
            73592105.61521886,
            4083696226.622327,
        ],
    ],
    [
        914198400000,
        [
            -6481217075.488034,
            70223486.18680644,
            4082451394.570899,
        ],
    ],
    [
        914803200000,
        [
            -6463709004.687538,
            68915956.36880082,
            4082099287.795358,
        ],
    ],
    [
        915408000000,
        [
            -6446445432.000479,
            69647285.8864502,
            4082631613.70595,
        ],
    ],
    [
        916012800000,
        [
            -6429686652.215771,
            72372408.10535744,
            4084028237.320104,
        ],
    ],
    [
        916617600000,
        [
            -6413697337.557197,
            77029823.04211342,
            4086261309.685009,
        ],
    ],
    [
        917222400000,
        [
            -6398744336.414983,
            83516845.19464347,
            4089286889.209304,
        ],
    ],
    [
        917827200000,
        [
            -6385067013.042996,
            91686563.103239,
            4093042565.774432,
        ],
    ],
    [
        918432000000,
        [
            -6372866308.948454,
            101378786.1229498,
            4097458060.158539,
        ],
    ],
    [
        919036800000,
        [
            -6362333003.302981,
            112423408.0623477,
            4102458539.363065,
        ],
    ],
    [
        919641600000,
        [
            -6353643812.005921,
            124618194.5924856,
            4107957090.174384,
        ],
    ],
    [
        920246400000,
        [
            -6346932492.603273,
            137730591.2473229,
            4113854063.543219,
        ],
    ],
    [
        920851200000,
        [
            -6342286665.867125,
            151531488.221493,
            4120049112.61746,
        ],
    ],
    [
        921456000000,
        [
            -6339777456.17044,
            165794123.7213057,
            4126442997.018788,
        ],
    ],
    [
        922060800000,
        [
            -6339454485.185962,
            180273699.8532327,
            4132930498.374451,
        ],
    ],
    [
        922665600000,
        [
            -6341318956.65096,
            194712451.9414822,
            4139400870.895422,
        ],
    ],
    [
        923270400000,
        [
            -6345328273.990304,
            208873917.0129337,
            4145750430.319667,
        ],
    ],
    [
        923875200000,
        [
            -6351426369.283755,
            222536175.3031596,
            4151882242.909513,
        ],
    ],
    [
        924480000000,
        [
            -6359537007.920927,
            235472550.9357572,
            4157699073.565258,
        ],
    ],
    [
        925084800000,
        [
            -6369538962.182607,
            247458918.4000043,
            4163104537.522146,
        ],
    ],
    [
        925689600000,
        [
            -6381277325.829679,
            258306459.7685251,
            4168015487.97846,
        ],
    ],
    [
        926294400000,
        [
            -6394593167.953688,
            267849001.1694429,
            4172359399.675407,
        ],
    ],
    [
        926899200000,
        [
            -6409314230.81499,
            275924585.4306605,
            4176067212.918799,
        ],
    ],
    [
        927504000000,
        [
            -6425231920.405006,
            282384920.0138229,
            4179075159.565822,
        ],
    ],
    [
        928108800000,
        [
            -6442118009.32322,
            287125255.0307251,
            4181336449.427405,
        ],
    ],
    [
        928713600000,
        [
            -6459752254.570422,
            290066452.0525782,
            4182816539.328173,
        ],
    ],
    [
        929318400000,
        [
            -6477909979.854588,
            291137635.9525583,
            4183485961.7007,
        ],
    ],
    [
        929923200000,
        [
            -6496340827.841602,
            290288213.1851219,
            4183323032.234716,
        ],
    ],
    [
        930528000000,
        [
            -6514789880.814541,
            287513940.8814207,
            4182324480.114061,
        ],
    ],
    [
        931132800000,
        [
            -6533022180.892451,
            282834754.432113,
            4180498950.909982,
        ],
    ],
    [
        931737600000,
        [
            -6550807266.110953,
            276278765.6338463,
            4177859969.335623,
        ],
    ],
    [
        932342400000,
        [
            -6567899948.719556,
            267897239.8990821,
            4174429742.964031,
        ],
    ],
    [
        932947200000,
        [
            -6584065224.011581,
            257786066.9915476,
            4170248410.609569,
        ],
    ],
    [
        933552000000,
        [
            -6599098852.257874,
            246060356.1303562,
            4165366092.504089,
        ],
    ],
    [
        934156800000,
        [
            -6612809258.272665,
            232839894.0525343,
            4159836092.698633,
        ],
    ],
    [
        934761600000,
        [
            -6625000697.260572,
            218267089.5955387,
            4153719875.487834,
        ],
    ],
    [
        935366400000,
        [
            -6635501382.420691,
            202523083.0541098,
            4147094604.460732,
        ],
    ],
    [
        935971200000,
        [
            -6644179304.691252,
            185799952.0054465,
            4140043956.038013,
        ],
    ],
    [
        936576000000,
        [
            -6650921887.840675,
            168287636.56721,
            4132651620.55602,
        ],
    ],
    [
        937180800000,
        [
            -6655621687.038824,
            150194435.1398577,
            4125007371.646641,
        ],
    ],
    [
        937785600000,
        [
            -6658206897.128575,
            131757130.7313889,
            4117212624.911603,
        ],
    ],
    [
        938390400000,
        [
            -6658651456.863692,
            113211554.8510405,
            4109370197.683251,
        ],
    ],
    [
        938995200000,
        [
            -6656952565.779627,
            94781132.79862536,
            4101578208.940983,
        ],
    ],
    [
        939600000000,
        [
            -6653118675.146377,
            76699317.49532786,
            4093937092.562834,
        ],
    ],
    [
        940204800000,
        [
            -6647201128.814255,
            59213596.60859053,
            4086553094.737512,
        ],
    ],
    [
        940809600000,
        [
            -6639297563.0262,
            42555355.35651599,
            4079527279.627988,
        ],
    ],
    [
        941414400000,
        [
            -6629527092.251933,
            26930744.88312514,
            4072950137.090679,
        ],
    ],
    [
        942019200000,
        [
            -6618020109.51057,
            12544678.04458177,
            4066909491.485806,
        ],
    ],
    [
        942624000000,
        [
            -6604949588.004605,
            -400575.7632258087,
            4061492203.663359,
        ],
    ],
    [
        943228800000,
        [
            -6590527210.39649,
            -11734854.7236418,
            4056772967.605309,
        ],
    ],
    [
        943833600000,
        [
            -6574976178.399855,
            -21325481.02931561,
            4052810245.160969,
        ],
    ],
    [
        944438400000,
        [
            -6558522772.973521,
            -29051542.96947035,
            4049655228.704666,
        ],
    ],
    [
        945043200000,
        [
            -6541426253.389832,
            -34809180.93508548,
            4047352335.867022,
        ],
    ],
    [
        945648000000,
        [
            -6523968293.523922,
            -38538697.57675321,
            4045928528.434191,
        ],
    ],
    [
        946252800000,
        [
            -6506424197.311628,
            -40224446.77825731,
            4045391337.980979,
        ],
    ],
    [
        946857600000,
        [
            -6489057347.005403,
            -39866996.13210873,
            4045739125.473275,
        ],
    ],
    [
        947462400000,
        [
            -6472147584.88799,
            -37490722.73269066,
            4046960920.395804,
        ],
    ],
    [
        948067200000,
        [
            -6455975947.271646,
            -33167298.37641309,
            4049026856.130994,
        ],
    ],
    [
        948672000000,
        [
            -6440796080.68867,
            -27009126.67215373,
            4051888739.31644,
        ],
    ],
    [
        949276800000,
        [
            -6426833796.512437,
            -19139614.5936214,
            4055491585.470397,
        ],
    ],
    [
        949881600000,
        [
            -6414314487.865409,
            -9702567.928044528,
            4059772842.963705,
        ],
    ],
    [
        950486400000,
        [
            -6403445730.375832,
            1118112.364119515,
            4064654065.683273,
        ],
    ],
    [
        951091200000,
        [
            -6394390894.292782,
            13110839.79101974,
            4070043823.323777,
        ],
    ],
    [
        951696000000,
        [
            -6387275886.556182,
            26066581.88087328,
            4075850001.682434,
        ],
    ],
    [
        952300800000,
        [
            -6382215800.625123,
            39766840.08968002,
            4081977869.207061,
        ],
    ],
    [
        952905600000,
        [
            -6379297129.666943,
            53966993.28096611,
            4088322677.609378,
        ],
    ],
    [
        953510400000,
        [
            -6378554687.025881,
            68412759.21610463,
            4094774218.203951,
        ],
    ],
    [
        954115200000,
        [
            -6379986217.720963,
            82868916.55043463,
            4101229080.519563,
        ],
    ],
    [
        954720000000,
        [
            -6383577488.572005,
            97103410.83432081,
            4107586878.750268,
        ],
    ],
    [
        955324800000,
        [
            -6389284437.389538,
            110872994.2468248,
            4113743437.360564,
        ],
    ],
    [
        955929600000,
        [
            -6397013430.229187,
            123941922.901106,
            4119596294.257787,
        ],
    ],
    [
        956534400000,
        [
            -6406642893.407911,
            136107428.7195797,
            4125056207.785375,
        ],
    ],
    [
        957139200000,
        [
            -6418045452.289347,
            147179348.305352,
            4130041190.260131,
        ],
    ],
    [
        957744000000,
        [
            -6431069487.252701,
            156967929.5037598,
            4134470205.323491,
        ],
    ],
    [
        958348800000,
        [
            -6445522344.049996,
            165303710.0588886,
            4138269234.982399,
        ],
    ],
    [
        958953600000,
        [
            -6461197373.911888,
            172058735.3692723,
            4141381595.114627,
        ],
    ],
    [
        959558400000,
        [
            -6477891924.108657,
            177122037.7227573,
            4143759861.770998,
        ],
    ],
    [
        960163200000,
        [
            -6495387769.609403,
            180389956.6575961,
            4145360245.748953,
        ],
    ],
    [
        960768000000,
        [
            -6513437145.062325,
            181786870.2233112,
            4146149147.781547,
        ],
    ],
    [
        961372800000,
        [
            -6531793555.164475,
            181281680.3346888,
            4146112014.3782,
        ],
    ],
    [
        961977600000,
        [
            -6550225009.60365,
            178860036.1251774,
            4145243509.052939,
        ],
    ],
    [
        962582400000,
        [
            -6568493182.027267,
            174517527.0733833,
            4143542766.098237,
        ],
    ],
    [
        963187200000,
        [
            -6586342546.219272,
            168281233.0332345,
            4141020496.511022,
        ],
    ],
    [
        963792000000,
        [
            -6603533570.957412,
            160221135.6053338,
            4137706128.536523,
        ],
    ],
    [
        964396800000,
        [
            -6619851056.246605,
            150420114.6203289,
            4133636636.66528,
        ],
    ],
    [
        965001600000,
        [
            -6635082171.095501,
            138970062.4955577,
            4128852762.811299,
        ],
    ],
    [
        965606400000,
        [
            -6649009165.158156,
            125994154.7725342,
            4123406721.345702,
        ],
    ],
    [
        966211200000,
        [
            -6661443736.996263,
            111652746.231384,
            4117367312.071389,
        ],
    ],
    [
        966816000000,
        [
            -6672230435.732158,
            96112111.66072965,
            4110807775.727383,
        ],
    ],
    [
        967420800000,
        [
            -6681223769.460007,
            79543180.04278396,
            4103802931.63396,
        ],
    ],
    [
        968025600000,
        [
            -6688284797.501932,
            62144237.75875978,
            4096437449.324856,
        ],
    ],
    [
        968630400000,
        [
            -6693315426.304555,
            44140793.8573208,
            4088808607.829699,
        ],
    ],
    [
        969235200000,
        [
            -6696256624.622805,
            25754031.17539051,
            4081013522.415698,
        ],
    ],
    [
        969840000000,
        [
            -6697064615.09476,
            7201727.268374557,
            4073147092.312736,
        ],
    ],
    [
        970444800000,
        [
            -6695711183.118612,
            -11278977.4541601,
            4065310759.043248,
        ],
    ],
    [
        971049600000,
        [
            -6692216476.685549,
            -29438042.18280017,
            4057612706.607375,
        ],
    ],
    [
        971654400000,
        [
            -6686641470.34013,
            -47043188.30170211,
            4050154899.30244,
        ],
    ],
    [
        972259200000,
        [
            -6679063061.468855,
            -63876934.69660397,
            4043031847.751985,
        ],
    ],
    [
        972864000000,
        [
            -6669577410.119268,
            -79713915.37269591,
            4036339841.502776,
        ],
    ],
    [
        973468800000,
        [
            -6658329784.330008,
            -94333287.53748415,
            4030174692.078584,
        ],
    ],
    [
        974073600000,
        [
            -6645500701.446879,
            -107546908.4261596,
            4024619243.543648,
        ],
    ],
    [
        974678400000,
        [
            -6631279918.49741,
            -119193761.1403027,
            4019743262.279952,
        ],
    ],
    [
        975283200000,
        [
            -6615872023.353233,
            -129117035.2814993,
            4015613293.429923,
        ],
    ],
    [
        975888000000,
        [
            -6599522389.746113,
            -137181148.5618112,
            4012288459.180851,
        ],
    ],
    [
        976492800000,
        [
            -6582497131.483181,
            -143295534.8362802,
            4009809286.150864,
        ],
    ],
    [
        977097600000,
        [
            -6565056792.802135,
            -147405226.0774031,
            4008199321.212213,
        ],
    ],
    [
        977702400000,
        [
            -6547464132.91573,
            -149467125.1912018,
            4007475822.879943,
        ],
    ],
    [
        978307200000,
        [
            -6530006385.573123,
            -149469769.7535909,
            4007644343.463742,
        ],
    ],
    [
        978912000000,
        [
            -6512970467.050587,
            -147451252.5334464,
            4008689575.357632,
        ],
    ],
    [
        979516800000,
        [
            -6496618287.26109,
            -143484861.9457274,
            4010579249.370039,
        ],
    ],
    [
        980121600000,
        [
            -6481197831.116999,
            -137654570.6585387,
            4013275604.051014,
        ],
    ],
    [
        980726400000,
        [
            -6466962861.143568,
            -130076160.5629269,
            4016729225.810815,
        ],
    ],
    [
        981331200000,
        [
            -6454145787.063677,
            -120909128.7532558,
            4020872067.817605,
        ],
    ],
    [
        981936000000,
        [
            -6442936907.329783,
            -110337431.3818986,
            4025623688.089373,
        ],
    ],
    [
        982540800000,
        [
            -6433500385.686008,
            -98545492.5113472,
            4030902920.777982,
        ],
    ],
    [
        983145600000,
        [
            -6425992299.018905,
            -85740475.08404681,
            4036620898.426498,
        ],
    ],
    [
        983750400000,
        [
            -6420533329.80503,
            -72159405.82541493,
            4042675809.008534,
        ],
    ],
    [
        984355200000,
        [
            -6417193347.504339,
            -58046332.07046968,
            4048960964.186417,
        ],
    ],
    [
        984960000000,
        [
            -6416013139.112981,
            -43631057.3948208,
            4055375740.378394,
        ],
    ],
    [
        985564800000,
        [
            -6417020448.491817,
            -29153078.67560605,
            4061817391.213755,
        ],
    ],
    [
        986169600000,
        [
            -6420203522.703976,
            -14865510.54595177,
            4068176945.726041,
        ],
    ],
    [
        986774400000,
        [
            -6425500989.026108,
            -1010370.640311845,
            4074348403.05093,
        ],
    ],
    [
        987379200000,
        [
            -6432828926.085341,
            12197946.58316173,
            4080238087.40011,
        ],
    ],
    [
        987984000000,
        [
            -6442093487.731362,
            24546753.82856806,
            4085755000.112825,
        ],
    ],
    [
        988588800000,
        [
            -6453165427.874662,
            35823455.67978077,
            4090807542.508542,
        ],
    ],
    [
        989193600000,
        [
            -6465874379.094667,
            45840856.77339038,
            4095313300.243134,
        ],
    ],
    [
        989798400000,
        [
            -6480040025.013434,
            54447868.45553571,
            4099206320.049978,
        ],
    ],
    [
        990403200000,
        [
            -6495479815.824452,
            61501964.62725449,
            4102426107.323382,
        ],
    ],
    [
        991008000000,
        [
            -6511984387.102218,
            66869833.50956832,
            4104915237.830399,
        ],
    ],
    [
        991612800000,
        [
            -6529315364.365417,
            70452566.13033846,
            4106629426.525294,
        ],
    ],
    [
        992217600000,
        [
            -6547239207.117718,
            72190307.89687407,
            4107542546.830792,
        ],
    ],
    [
        992822400000,
        [
            -6565529171.520463,
            72033859.1630897,
            4107634605.649518,
        ],
    ],
    [
        993427200000,
        [
            -6583941769.711003,
            69947921.80970946,
            4106890479.442924,
        ],
    ],
    [
        994032000000,
        [
            -6602217707.620105,
            65935726.16940126,
            4105310080.7191,
        ],
    ],
    [
        994636800000,
        [
            -6620117070.218753,
            60037831.55871266,
            4102911077.878725,
        ],
    ],
    [
        995241600000,
        [
            -6637415416.211856,
            52303671.08681653,
            4099716224.222873,
        ],
    ],
    [
        995846400000,
        [
            -6653881591.457738,
            42797601.33067949,
            4095753403.787411,
        ],
    ],
    [
        996451200000,
        [
            -6669281826.698262,
            31622490.49846722,
            4091065718.628036,
        ],
    ],
    [
        997056000000,
        [
            -6683414976.19018,
            18912949.760841,
            4085711862.025182,
        ],
    ],
    [
        997660800000,
        [
            -6696103066.770281,
            4807432.244836688,
            4079753113.021684,
        ],
    ],
    [
        998265600000,
        [
            -6707170679.143748,
            -10543039.25533617,
            4073254716.017257,
        ],
    ],
    [
        998870400000,
        [
            -6716452352.88009,
            -26952929.88858267,
            4066295680.198438,
        ],
    ],
    [
        999475200000,
        [
            -6723826452.593005,
            -44214311.49227021,
            4058966726.102813,
        ],
    ],
    [
        1000080000000,
        [
            -6729200559.945879,
            -62123723.86903404,
            4051357206.173835,
        ],
    ],
    [
        1000684800000,
        [
            -6732492277.827227,
            -80471158.98596877,
            4043557704.458135,
        ],
    ],
    [
        1001289600000,
        [
            -6733639879.335056,
            -99020364.43972951,
            4035669345.051677,
        ],
    ],
    [
        1001894400000,
        [
            -6732633114.953271,
            -117526059.0682216,
            4027799275.654652,
        ],
    ],
    [
        1002499200000,
        [
            -6729493656.079006,
            -135759100.1527819,
            4020047848.139564,
        ],
    ],
    [
        1003104000000,
        [
            -6724256748.107401,
            -153493539.112425,
            4012512313.875163,
        ],
    ],
    [
        1003708800000,
        [
            -6716984650.966799,
            -170489434.9794811,
            4005295560.52167,
        ],
    ],
    [
        1004313600000,
        [
            -6707792570.649312,
            -186514581.2366017,
            3998499280.408602,
        ],
    ],
    [
        1004918400000,
        [
            -6696824243.737958,
            -201366783.9757204,
            3992211997.516079,
        ],
    ],
    [
        1005523200000,
        [
            -6684233757.100513,
            -214858926.7931931,
            3986513894.698996,
        ],
    ],
    [
        1006128000000,
        [
            -6670201125.813385,
            -226803879.9225033,
            3981485151.124615,
        ],
    ],
    [
        1006732800000,
        [
            -6654951952.582595,
            -237039535.3559063,
            3977197239.37312,
        ],
    ],
    [
        1007337600000,
        [
            -6638728602.68509,
            -245446353.5079364,
            3973702700.974748,
        ],
    ],
    [
        1007942400000,
        [
            -6621772160.980347,
            -251929814.874994,
            3971041379.421689,
        ],
    ],
    [
        1008547200000,
        [
            -6604339870.705033,
            -256406397.9602031,
            3969248741.530458,
        ],
    ],
    [
        1009152000000,
        [
            -6586718328.30743,
            -258830263.4020291,
            3968345962.738214,
        ],
    ],
    [
        1009756800000,
        [
            -6569191654.373428,
            -259204156.985837,
            3968332405.719237,
        ],
    ],
    [
        1010361600000,
        [
            -6552024896.490716,
            -257558570.0482001,
            3969193583.456737,
        ],
    ],
    [
        1010966400000,
        [
            -6535483879.507509,
            -253937941.7734529,
            3970909715.363635,
        ],
    ],
    [
        1011571200000,
        [
            -6519843187.099611,
            -248427644.1013324,
            3973445139.021166,
        ],
    ],
    [
        1012176000000,
        [
            -6505353632.394649,
            -241157386.3662193,
            3976743977.940172,
        ],
    ],
    [
        1012780800000,
        [
            -6492229446.964098,
            -232277248.1340341,
            3980739830.234901,
        ],
    ],
    [
        1013385600000,
        [
            -6480671523.909394,
            -221944459.184081,
            3985364273.68091,
        ],
    ],
    [
        1013990400000,
        [
            -6470871959.764881,
            -210350323.0060684,
            3990535718.727092,
        ],
    ],
    [
        1014595200000,
        [
            -6462983004.753245,
            -197716966.8625861,
            3996157989.900311,
        ],
    ],
    [
        1015200000000,
        [
            -6457110055.69941,
            -184271551.4474794,
            4002131245.797757,
        ],
    ],
    [
        1015804800000,
        [
            -6453338679.890239,
            -170235299.4400998,
            4008359605.334177,
        ],
    ],
    [
        1016409600000,
        [
            -6451736642.451381,
            -155850702.5625542,
            4014739253.847689,
        ],
    ],
    [
        1017014400000,
        [
            -6452325379.104191,
            -141373532.1315802,
            4021159175.456427,
        ],
    ],
    [
        1017619200000,
        [
            -6455079390.459873,
            -127046942.8132988,
            4027512600.502773,
        ],
    ],
    [
        1018224000000,
        [
            -6459956318.934649,
            -113094773.286259,
            4033702806.815782,
        ],
    ],
    [
        1018828800000,
        [
            -6466896095.100545,
            -99749175.18125486,
            4039630409.89863,
        ],
    ],
    [
        1019433600000,
        [
            -6475794894.135603,
            -87239649.14308803,
            4045195531.222773,
        ],
    ],
    [
        1020038400000,
        [
            -6486510240.365298,
            -75768265.3821385,
            4050309242.558961,
        ],
    ],
    [
        1020643200000,
        [
            -6498892718.814596,
            -65508619.70596747,
            4054896878.028673,
        ],
    ],
    [
        1021248000000,
        [
            -6512781246.515573,
            -56633311.89361329,
            4058884797.022403,
        ],
    ],
    [
        1021852800000,
        [
            -6527979212.071859,
            -49300983.85321781,
            4062203614.481412,
        ],
    ],
    [
        1022457600000,
        [
            -6544264150.650129,
            -43633160.80984481,
            4064799384.819786,
        ],
    ],
    [
        1023062400000,
        [
            -6561419673.057406,
            -39719361.98269044,
            4066634128.303296,
        ],
    ],
    [
        1023667200000,
        [
            -6579226074.620965,
            -37643370.52053815,
            4067672600.489803,
        ],
    ],
    [
        1024272000000,
        [
            -6597438716.895906,
            -37468628.63337713,
            4067886501.850881,
        ],
    ],
    [
        1024876800000,
        [
            -6615801307.590461,
            -39216846.88895246,
            4067265269.762864,
        ],
    ],
    [
        1025481600000,
        [
            -6634076942.998562,
            -42879170.06295747,
            4065813765.742508,
        ],
    ],
    [
        1026086400000,
        [
            -6652033821.363734,
            -48440195.88094109,
            4063539587.903766,
        ],
    ],
    [
        1026691200000,
        [
            -6669426325.438686,
            -55861906.21269155,
            4060458276.320069,
        ],
    ],
    [
        1027296000000,
        [
            -6686011246.038953,
            -65064262.30215827,
            4056603544.599566,
        ],
    ],
    [
        1027900800000,
        [
            -6701577052.655639,
            -75942041.89817438,
            4052022185.89719,
        ],
    ],
    [
        1028505600000,
        [
            -6715924926.18987,
            -88385922.8308874,
            4046762307.904523,
        ],
    ],
    [
        1029110400000,
        [
            -6728853070.663405,
            -102265245.2667376,
            4040879496.776073,
        ],
    ],
    [
        1029715200000,
        [
            -6740175359.42585,
            -117411079.28861,
            4034446220.641857,
        ],
    ],
    [
        1030320000000,
        [
            -6749747918.250918,
            -133638195.4507907,
            4027544078.895698,
        ],
    ],
    [
        1030924800000,
        [
            -6757445853.364355,
            -150762951.0104045,
            4020253154.958372,
        ],
    ],
    [
        1031529600000,
        [
            -6763150990.652302,
            -168585311.7304851,
            4012659012.131701,
        ],
    ],
    [
        1032134400000,
        [
            -6766772336.863587,
            -186875065.134463,
            4004860941.849321,
        ],
    ],
    [
        1032739200000,
        [
            -6768268811.934742,
            -205398178.6389169,
            3996961793.739493,
        ],
    ],
    [
        1033344000000,
        [
            -6767621960.450264,
            -223931436.4312594,
            3989058548.626338,
        ],
    ],
    [
        1033948800000,
        [
            -6764826729.228642,
            -242244055.7548206,
            3981250016.809153,
        ],
    ],
    [
        1034553600000,
        [
            -6759912934.534583,
            -260087579.2182024,
            3973643668.734685,
        ],
    ],
    [
        1035158400000,
        [
            -6752962699.584605,
            -277225486.2550702,
            3966343494.261981,
        ],
    ],
    [
        1035763200000,
        [
            -6744079347.458055,
            -293444310.6379046,
            3959441997.35516,
        ],
    ],
    [
        1036368000000,
        [
            -6733380340.692664,
            -308534736.6495569,
            3953028619.000828,
        ],
    ],
    [
        1036972800000,
        [
            -6721018931.376599,
            -322285125.0529989,
            3947195125.216118,
        ],
    ],
    [
        1037577600000,
        [
            -6707194918.614553,
            -334512688.101248,
            3942022220.642822,
        ],
    ],
    [
        1038182400000,
        [
            -6692120243.173687,
            -345070191.4022812,
            3937573468.63106,
        ],
    ],
    [
        1038787200000,
        [
            -6676013320.242577,
            -353825785.9796296,
            3933904701.030562,
        ],
    ],
    [
        1039392000000,
        [
            -6659120547.33357,
            -360659357.0664856,
            3931068254.219901,
        ],
    ],
    [
        1039996800000,
        [
            -6641719751.31397,
            -365493207.381016,
            3929099220.404727,
        ],
    ],
    [
        1040601600000,
        [
            -6624083987.322569,
            -368292956.0065413,
            3928012048.232991,
        ],
    ],
    [
        1041206400000,
        [
            -6606477471.615245,
            -369045190.8300946,
            3927811254.933012,
        ],
    ],
    [
        1041811200000,
        [
            -6589177623.154659,
            -367755546.6769828,
            3928494905.295983,
        ],
    ],
    [
        1042416000000,
        [
            -6572471902.461136,
            -364477204.0884314,
            3930041218.566542,
        ],
    ],
    [
        1043020800000,
        [
            -6556622450.42867,
            -359304964.8296974,
            3932408467.117099,
        ],
    ],
    [
        1043625600000,
        [
            -6541865017.54485,
            -352350624.9525054,
            3935546974.793677,
        ],
    ],
    [
        1044230400000,
        [
            -6528432846.183438,
            -343742365.359954,
            3939401924.377778,
        ],
    ],
    [
        1044835200000,
        [
            -6516548543.229826,
            -333650578.9028008,
            3943900521.922386,
        ],
    ],
    [
        1045440000000,
        [
            -6506392371.130897,
            -322275431.6888648,
            3948955193.808181,
        ],
    ],
    [
        1046044800000,
        [
            -6498105868.388268,
            -309821273.7279103,
            3954476275.854769,
        ],
    ],
    [
        1046649600000,
        [
            -6491818341.778924,
            -296498063.6436733,
            3960373740.174397,
        ],
    ],
    [
        1047254400000,
        [
            -6487635206.792034,
            -282545186.2810765,
            3966544651.78061,
        ],
    ],
    [
        1047859200000,
        [
            -6485611541.653334,
            -268214067.1102002,
            3972879050.681362,
        ],
    ],
    [
        1048464000000,
        [
            -6485761186.807591,
            -253743736.5070021,
            3979272403.890991,
        ],
    ],
    [
        1049068800000,
        [
            -6488085233.01091,
            -239365572.6657881,
            3985625618.757878,
        ],
    ],
    [
        1049673600000,
        [
            -6492557328.895511,
            -225325914.3926195,
            3991832510.739151,
        ],
    ],
    [
        1050278400000,
        [
            -6499102494.994636,
            -211865556.8514302,
            3997787582.608419,
        ],
    ],
    [
        1050883200000,
        [
            -6507611308.538186,
            -199198197.6364934,
            4003397466.214469,
        ],
    ],
    [
        1051488000000,
        [
            -6517968711.310636,
            -187519457.7650957,
            4008578743.090507,
        ],
    ],
    [
        1052092800000,
        [
            -6530036145.492407,
            -177028347.8596815,
            4013245523.45636,
        ],
    ],
    [
        1052697600000,
        [
            -6543634775.287079,
            -167904933.6671216,
            4017318528.229577,
        ],
    ],
    [
        1053302400000,
        [
            -6558563804.336902,
            -160292424.5974783,
            4020735148.298357,
        ],
    ],
    [
        1053907200000,
        [
            -6574627772.700042,
            -154310781.1998141,
            4023444865.981873,
        ],
    ],
    [
        1054512000000,
        [
            -6591615420.185241,
            -150076292.7147213,
            4025397441.037067,
        ],
    ],
    [
        1055116800000,
        [
            -6609286566.460925,
            -147678133.3081653,
            4026552936.055761,
        ],
    ],
    [
        1055721600000,
        [
            -6627393670.511772,
            -147164126.094083,
            4026890321.558975,
        ],
    ],
    [
        1056326400000,
        [
            -6645706208.297969,
            -148558809.0550533,
            4026400468.355579,
        ],
    ],
    [
        1056931200000,
        [
            -6663986542.492352,
            -151880067.7543303,
            4025075583.925579,
        ],
    ],
    [
        1057536000000,
        [
            -6681980217.552116,
            -157115121.8726021,
            4022919918.514266,
        ],
    ],
    [
        1058140800000,
        [
            -6699440082.99122,
            -164209775.7631606,
            4019956928.464126,
        ],
    ],
    [
        1058745600000,
        [
            -6716146805.781449,
            -173090666.9085414,
            4016219878.373942,
        ],
    ],
    [
        1059350400000,
        [
            -6731882328.469261,
            -183678068.4480214,
            4011743069.8399,
        ],
    ],
    [
        1059955200000,
        [
            -6746423707.958256,
            -195861972.6705764,
            4006572934.904254,
        ],
    ],
    [
        1060560000000,
        [
            -6759569153.489846,
            -209494756.9595917,
            4000773715.753932,
        ],
    ],
    [
        1061164800000,
        [
            -6771153972.219934,
            -224417288.1964523,
            3994415762.104141,
        ],
    ],
    [
        1061769600000,
        [
            -6781022222.315525,
            -240467421.6450651,
            3987568873.798952,
        ],
    ],
    [
        1062374400000,
        [
            -6789024225.795916,
            -257457008.8502991,
            3980313421.688724,
        ],
    ],
    [
        1062979200000,
        [
            -6795043645.767995,
            -275168094.540694,
            3972744429.31014,
        ],
    ],
    [
        1063584000000,
        [
            -6799008182.276361,
            -293382391.7547245,
            3964957760.61306,
        ],
    ],
    [
        1064188800000,
        [
            -6800859763.140256,
            -311885380.5346711,
            3957045695.989025,
        ],
    ],
    [
        1064793600000,
        [
            -6800555514.098598,
            -330444987.8185912,
            3949107733.546652,
        ],
    ],
    [
        1065398400000,
        [
            -6798094641.586782,
            -348811443.9612296,
            3941252959.945172,
        ],
    ],
    [
        1066003200000,
        [
            -6793523115.955732,
            -366749227.5145354,
            3933584561.388643,
        ],
    ],
    [
        1066608000000,
        [
            -6786902372.18213,
            -384036752.6528547,
            3926197683.415631,
        ],
    ],
    [
        1067212800000,
        [
            -6778313076.731676,
            -400446960.3200983,
            3919189758.368044,
        ],
    ],
    [
        1067817600000,
        [
            -6767880401.224717,
            -415750645.2233704,
            3912661179.752636,
        ],
    ],
    [
        1068422400000,
        [
            -6755772007.226027,
            -429749269.7282035,
            3906698935.14575,
        ],
    ],
    [
        1069027200000,
        [
            -6742165186.333205,
            -442269919.8426395,
            3901376914.268765,
        ],
    ],
    [
        1069632000000,
        [
            -6727252678.328638,
            -453147187.7200927,
            3896765963.47317,
        ],
    ],
    [
        1070236800000,
        [
            -6711265339.459123,
            -462229232.1337982,
            3892933094.23002,
        ],
    ],
    [
        1070841600000,
        [
            -6694463291.512691,
            -469409167.6511787,
            3889925369.729367,
        ],
    ],
    [
        1071446400000,
        [
            -6677102184.082938,
            -474614575.926883,
            3887773005.084531,
        ],
    ],
    [
        1072051200000,
        [
            -6659440940.881292,
            -477789408.9063627,
            3886499621.328175,
        ],
    ],
    [
        1072656000000,
        [
            -6641761970.521337,
            -478901771.7502986,
            3886120331.177108,
        ],
    ],
    [
        1073260800000,
        [
            -6624356360.833879,
            -477971563.8743222,
            3886627001.617147,
        ],
    ],
    [
        1073865600000,
        [
            -6607491332.063054,
            -475054028.5496379,
            3887994438.832903,
        ],
    ],
    [
        1074470400000,
        [
            -6591420772.876944,
            -470220733.4502507,
            3890191166.903236,
        ],
    ],
    [
        1075075200000,
        [
            -6576404322.994795,
            -463568580.8478314,
            3893176529.116114,
        ],
    ],
    [
        1075680000000,
        [
            -6562688309.245155,
            -455242428.1592143,
            3896887946.132144,
        ],
    ],
    [
        1076284800000,
        [
            -6550477361.212459,
            -445413218.1233453,
            3901250032.238987,
        ],
    ],
    [
        1076889600000,
        [
            -6539948944.95523,
            -434258436.6352985,
            3906185648.662944,
        ],
    ],
    [
        1077494400000,
        [
            -6531272770.547082,
            -421972879.94372,
            3911611747.313977,
        ],
    ],
    [
        1078099200000,
        [
            -6524589000.877941,
            -408786500.0171894,
            3917428564.77378,
        ],
    ],
    [
        1078704000000,
        [
            -6519986429.112256,
            -394938835.6606002,
            3923530968.064528,
        ],
    ],
    [
        1079308800000,
        [
            -6517521438.637703,
            -380660631.002824,
            3929818987.227603,
        ],
    ],
    [
        1079913600000,
        [
            -6517238080.662765,
            -366187435.3539876,
            3936191932.815986,
        ],
    ],
    [
        1080518400000,
        [
            -6519144143.099342,
            -351773728.3625162,
            3942539126.577579,
        ],
    ],
    [
        1081123200000,
        [
            -6523196675.547267,
            -337665677.4407918,
            3948752582.973123,
        ],
    ],
    [
        1081728000000,
        [
            -6529324639.921681,
            -324085812.1417598,
            3954736129.316353,
        ],
    ],
    [
        1082332800000,
        [
            -6537448694.504024,
            -311250133.4499815,
            3960397539.242772,
        ],
    ],
    [
        1082937600000,
        [
            -6547454994.53731,
            -299379307.2077081,
            3965640545.592949,
        ],
    ],
    [
        1083542400000,
        [
            -6559187489.220338,
            -288671171.2528695,
            3970378179.459952,
        ],
    ],
    [
        1084147200000,
        [
            -6572472965.427582,
            -279289653.6989397,
            3974539880.283556,
        ],
    ],
    [
        1084752000000,
        [
            -6587138995.506749,
            -271385263.2063308,
            3978061745.308297,
        ],
    ],
    [
        1085356800000,
        [
            -6602985412.765002,
            -265103437.4150196,
            3980879913.165694,
        ],
    ],
    [
        1085961600000,
        [
            -6619782344.141888,
            -260557466.5895833,
            3982944184.380548,
        ],
    ],
    [
        1086566400000,
        [
            -6637296533.098698,
            -257822025.7290746,
            3984222880.843908,
        ],
    ],
    [
        1087171200000,
        [
            -6655306047.930555,
            -256956393.832322,
            3984691513.30827,
        ],
    ],
    [
        1087776000000,
        [
            -6673569929.478883,
            -258009589.0355679,
            3984327851.676763,
        ],
    ],
    [
        1088380800000,
        [
            -6691831070.291132,
            -260994034.1101944,
            3983125587.747377,
        ],
    ],
    [
        1088985600000,
        [
            -6709843143.027092,
            -265883638.2279922,
            3981096908.513494,
        ],
    ],
    [
        1089590400000,
        [
            -6727381046.151199,
            -272639040.4051259,
            3978259879.771575,
        ],
    ],
    [
        1090195200000,
        [
            -6744209738.287084,
            -281209136.2155159,
            3974635532.064406,
        ],
    ],
    [
        1090800000000,
        [
            -6760091335.137285,
            -291505901.1304549,
            3970261296.717798,
        ],
    ],
    [
        1091404800000,
        [
            -6774812233.227624,
            -303406847.5494434,
            3965191329.513682,
        ],
    ],
    [
        1092009600000,
        [
            -6788188522.152727,
            -316781753.9951992,
            3959482833.192139,
        ],
    ],
    [
        1092614400000,
        [
            -6800035149.64845,
            -331490399.9374005,
            3953195354.634729,
        ],
    ],
    [
        1093219200000,
        [
            -6810176648.497304,
            -347359242.0676534,
            3946403610.275159,
        ],
    ],
    [
        1093824000000,
        [
            -6818473966.219182,
            -364188094.8584422,
            3939195609.29624,
        ],
    ],
    [
        1094428800000,
        [
            -6824824141.572556,
            -381777964.2666814,
            3931658094.167908,
        ],
    ],
    [
        1095033600000,
        [
            -6829130677.670429,
            -399925037.6329039,
            3923878094.019092,
        ],
    ],
    [
        1095638400000,
        [
            -6831317128.68642,
            -418400057.4883742,
            3915954686.594769,
        ],
    ],
    [
        1096243200000,
        [
            -6831352794.421849,
            -436958964.6771367,
            3907995042.597956,
        ],
    ],
    [
        1096848000000,
        [
            -6829245933.421327,
            -455371354.2018935,
            3900099245.28313,
        ],
    ],
    [
        1097452800000,
        [
            -6825015673.694307,
            -473410774.2814357,
            3892364098.319752,
        ],
    ],
    [
        1098057600000,
        [
            -6818707421.168649,
            -490837411.5783418,
            3884893450.707008,
        ],
    ],
    [
        1098662400000,
        [
            -6810416188.508358,
            -507412063.8000482,
            3877792457.312605,
        ],
    ],
    [
        1099267200000,
        [
            -6800272758.945292,
            -522924263.1657727,
            3871152290.049866,
        ],
    ],
    [
        1099872000000,
        [
            -6788417011.738005,
            -537178604.5906475,
            3865056312.909655,
        ],
    ],
    [
        1100476800000,
        [
            -6775014125.062653,
            -549980657.613367,
            3859588887.693439,
        ],
    ],
    [
        1101081600000,
        [
            -6760274311.667459,
            -561153061.7134411,
            3854828376.807748,
        ],
    ],
    [
        1101686400000,
        [
            -6744432006.575652,
            -570561646.2017758,
            3850832617.588696,
        ],
    ],
    [
        1102291200000,
        [
            -6727720648.027206,
            -578097053.3658575,
            3847647750.569306,
        ],
    ],
    [
        1102896000000,
        [
            -6710389310.97573,
            -583662963.424169,
            3845315800.348562,
        ],
    ],
    [
        1103500800000,
        [
            -6692718373.06948,
            -587192782.7654622,
            3843867048.692778,
        ],
    ],
    [
        1104105600000,
        [
            -6674993042.520674,
            -588671683.4789087,
            3843307343.533369,
        ],
    ],
    [
        1104710400000,
        [
            -6657480579.891367,
            -588112868.2366483,
            3843629818.480339,
        ],
    ],
    [
        1105315200000,
        [
            -6640448147.737298,
            -585546977.4587007,
            3844821673.773446,
        ],
    ],
    [
        1105920000000,
        [
            -6624175122.946891,
            -581038361.9032419,
            3846856301.739148,
        ],
    ],
    [
        1106524800000,
        [
            -6608923418.111954,
            -574701495.992805,
            3849683249.59428,
        ],
    ],
    [
        1107129600000,
        [
            -6594919139.524315,
            -566672309.1203604,
            3853242595.778142,
        ],
    ],
    [
        1107734400000,
        [
            -6582373112.01565,
            -557098434.3129619,
            3857471050.121846,
        ],
    ],
    [
        1108339200000,
        [
            -6571491167.804712,
            -546155336.2152071,
            3862293676.641741,
        ],
    ],
    [
        1108944000000,
        [
            -6562443717.069732,
            -534056847.4087094,
            3867616723.974858,
        ],
    ],
    [
        1109548800000,
        [
            -6555353849.534985,
            -521023471.0395904,
            3873343761.147033,
        ],
    ],
    [
        1110153600000,
        [
            -6550321386.955922,
            -507274273.9211961,
            3879380748.915381,
        ],
    ],
    [
        1110758400000,
        [
            -6547431914.483877,
            -493044145.3980361,
            3885626810.114186,
        ],
    ],
    [
        1111363200000,
        [
            -6546726854.869914,
            -478589226.2482033,
            3891969673.68356,
        ],
    ],
    [
        1111968000000,
        [
            -6548198940.275179,
            -464154768.3553275,
            3898302335.978132,
        ],
    ],
    [
        1112572800000,
        [
            -6551819241.800508,
            -449969944.6564986,
            3904526559.631192,
        ],
    ],
    [
        1113177600000,
        [
            -6557544622.060724,
            -436267403.9250381,
            3910542237.887513,
        ],
    ],
    [
        1113782400000,
        [
            -6565288287.882825,
            -423284431.9412389,
            3916245160.838059,
        ],
    ],
    [
        1114387200000,
        [
            -6574922349.337473,
            -411232457.0674018,
            3921543157.575917,
        ],
    ],
    [
        1114992000000,
        [
            -6586306267.654111,
            -400295666.9132282,
            3926357621.333643,
        ],
    ],
    [
        1115596800000,
        [
            -6599291804.292641,
            -390653103.628094,
            3930611456.135795,
        ],
    ],
    [
        1116201600000,
        [
            -6613693624.977662,
            -382475903.9090856,
            3934229081.827357,
        ],
    ],
    [
        1116806400000,
        [
            -6629298081.390435,
            -375899555.5215521,
            3937151446.87186,
        ],
    ],
    [
        1117411200000,
        [
            -6645891423.162116,
            -371026585.8162044,
            3939335417.064045,
        ],
    ],
    [
        1118016000000,
        [
            -6663261413.354379,
            -367950566.7543046,
            3940740689.449058,
        ],
    ],
    [
        1118620800000,
        [
            -6681167962.79171,
            -366749439.6104199,
            3941332092.147072,
        ],
    ],
    [
        1119225600000,
        [
            -6699357245.875419,
            -367460905.6704171,
            3941093195.137875,
        ],
    ],
    [
        1119830400000,
        [
            -6717588488.811514,
            -370089093.048539,
            3940023547.398897,
        ],
    ],
    [
        1120435200000,
        [
            -6735631785.753008,
            -374629469.4694254,
            3938125090.277636,
        ],
    ],
    [
        1121040000000,
        [
            -6753239354.695518,
            -381058334.1634086,
            3935406759.513086,
        ],
    ],
    [
        1121644800000,
        [
            -6770164205.600159,
            -389311469.0989388,
            3931896558.403882,
        ],
    ],
    [
        1122249600000,
        [
            -6786184814.014517,
            -399294648.8296491,
            3927636667.026348,
        ],
    ],
    [
        1122854400000,
        [
            -6801098894.224002,
            -410908524.1841548,
            3922669837.618361,
        ],
    ],
    [
        1123459200000,
        [
            -6814696227.886078,
            -424034689.1670212,
            3917046130.742859,
        ],
    ],
    [
        1124064000000,
        [
            -6826781055.926718,
            -438517761.0095114,
            3910833321.005842,
        ],
    ],
    [
        1124668800000,
        [
            -6837194190.355565,
            -454179675.7669301,
            3904109900.04255,
        ],
    ],
    [
        1125273600000,
        [
            -6845802443.369915,
            -470843835.8811873,
            3896951831.782902,
        ],
    ],
    [
        1125878400000,
        [
            -6852473941.21981,
            -488318443.5575407,
            3889441080.803492,
        ],
    ],
    [
        1126483200000,
        [
            -6857103145.802383,
            -506382276.9885982,
            3881674193.023029,
        ],
    ],
    [
        1127088000000,
        [
            -6859629907.608572,
            -524802677.8737476,
            3873753261.850511,
        ],
    ],
    [
        1127692800000,
        [
            -6860023990.567278,
            -543358378.2366159,
            3865773379.080348,
        ],
    ],
    [
        1128297600000,
        [
            -6858263424.383963,
            -561820781.1198428,
            3857832575.540366,
        ],
    ],
    [
        1128902400000,
        [
            -6854360685.556611,
            -579943630.968045,
            3850038440.567993,
        ],
    ],
    [
        1129507200000,
        [
            -6848377990.602411,
            -597484247.5615574,
            3842497303.80754,
        ],
    ],
    [
        1130112000000,
        [
            -6840406160.714148,
            -614224258.7405783,
            3835302811.151274,
        ],
    ],
    [
        1130716800000,
        [
            -6830546156.203956,
            -629949063.5574131,
            3828547080.826649,
        ],
    ],
    [
        1131321600000,
        [
            -6818934772.829636,
            -644441208.0137401,
            3822325361.766274,
        ],
    ],
    [
        1131926400000,
        [
            -6805755448.331392,
            -657503711.5163969,
            3816724011.856005,
        ],
    ],
    [
        1132531200000,
        [
            -6791211031.652176,
            -668977442.3023163,
            3811810845.037034,
        ],
    ],
    [
        1133136000000,
        [
            -6775508615.59864,
            -678718266.5953625,
            3807647638.475529,
        ],
    ],
    [
        1133740800000,
        [
            -6758883577.120318,
            -686593361.240031,
            3804293059.38076,
        ],
    ],
    [
        1134345600000,
        [
            -6741605691.67909,
            -692504777.4931781,
            3801790320.747177,
        ],
    ],
    [
        1134950400000,
        [
            -6723946537.139104,
            -696401839.2248465,
            3800160096.967636,
        ],
    ],
    [
        1135555200000,
        [
            -6706168343.721346,
            -698255075.5537777,
            3799414708.190655,
        ],
    ],
    [
        1136160000000,
        [
            -6688546425.292391,
            -698054463.0023258,
            3799559668.53875,
        ],
    ],
    [
        1136764800000,
        [
            -6671371375.879084,
            -695831418.8824251,
            3800581855.592038,
        ],
    ],
    [
        1137369600000,
        [
            -6654913417.067235,
            -691665030.7340196,
            3802445586.6495,
        ],
    ],
    [
        1137974400000,
        [
            -6639416748.873055,
            -685652480.8522397,
            3805108544.727362,
        ],
    ],
    [
        1138579200000,
        [
            -6625121633.894012,
            -677908795.0926969,
            3808522103.001962,
        ],
    ],
    [
        1139184000000,
        [
            -6612264080.678763,
            -668586586.9883472,
            3812620340.347768,
        ],
    ],
    [
        1139788800000,
        [
            -6601040225.743118,
            -657876137.8296057,
            3817319302.422026,
        ],
    ],
    [
        1140393600000,
        [
            -6591607635.739573,
            -645973449.8851233,
            3822534095.673625,
        ],
    ],
    [
        1140998400000,
        [
            -6584108409.898154,
            -633082091.8983873,
            3828177756.44835,
        ],
    ],
    [
        1141603200000,
        [
            -6578667272.999829,
            -619431446.5932717,
            3834150831.417528,
        ],
    ],
    [
        1142208000000,
        [
            -6575358335.9892,
            -605271745.1988975,
            3840343352.415207,
        ],
    ],
    [
        1142812800000,
        [
            -6574213747.225957,
            -590842059.0254781,
            3846651983.290148,
        ],
    ],
    [
        1143417600000,
        [
            -6575248141.833067,
            -576375319.4505109,
            3852977038.267369,
        ],
    ],
    [
        1144022400000,
        [
            -6578454944.984767,
            -562116364.8465215,
            3859212122.944182,
        ],
    ],
    [
        1144627200000,
        [
            -6583776375.7981,
            -548313103.3587927,
            3865248324.847195,
        ],
    ],
    [
        1145232000000,
        [
            -6591118633.45961,
            -535186802.3012491,
            3870990222.999163,
        ],
    ],
    [
        1145836800000,
        [
            -6600376821.785236,
            -522940931.655507,
            3876350861.947975,
        ],
    ],
    [
        1146441600000,
        [
            -6611428526.285899,
            -511779788.3125046,
            3881241184.212226,
        ],
    ],
    [
        1147046400000,
        [
            -6624106952.162367,
            -501896318.7176902,
            3885576234.358448,
        ],
    ],
    [
        1147651200000,
        [
            -6638221295.43835,
            -493446337.3952135,
            3889289141.718765,
        ],
    ],
    [
        1148256000000,
        [
            -6653580759.794617,
            -486561079.8983735,
            3892324172.719738,
        ],
    ],
    [
        1148860800000,
        [
            -6669984597.227876,
            -481366336.41384,
            3894626062.217167,
        ],
    ],
    [
        1149465600000,
        [
            -6687198190.482232,
            -477966914.7691975,
            3896148261.465537,
        ],
    ],
    [
        1150070400000,
        [
            -6704977376.490629,
            -476425639.1648484,
            3896864377.901591,
        ],
    ],
    [
        1150675200000,
        [
            -6723090308.020858,
            -476779030.0988801,
            3896759602.62577,
        ],
    ],
    [
        1151280000000,
        [
            -6741303746.885022,
            -479056351.5159155,
            3895820277.018319,
        ],
    ],
    [
        1151884800000,
        [
            -6759362244.424652,
            -483260668.7685362,
            3894044196.439883,
        ],
    ],
    [
        1152489600000,
        [
            -6777015485.66136,
            -489353005.0915336,
            3891449256.382404,
        ],
    ],
    [
        1153094400000,
        [
            -6794037096.726103,
            -497270540.235366,
            3888063550.485493,
        ],
    ],
    [
        1153699200000,
        [
            -6810207503.074413,
            -506944872.3494756,
            3883915538.902636,
        ],
    ],
    [
        1154304000000,
        [
            -6825296603.362963,
            -518280011.6323186,
            3879046209.73465,
        ],
    ],
    [
        1154908800000,
        [
            -6839093354.868402,
            -531141855.5859178,
            3873514831.931874,
        ],
    ],
    [
        1155513600000,
        [
            -6851420869.246595,
            -545378525.3135335,
            3867387929.720594,
        ],
    ],
    [
        1156118400000,
        [
            -6862116301.864385,
            -560837262.5634539,
            3860730353.449955,
        ],
    ],
    [
        1156723200000,
        [
            -6871017339.473445,
            -577340174.4802947,
            3853618843.167115,
        ],
    ],
    [
        1157328000000,
        [
            -6877993151.927198,
            -594679051.6489137,
            3846144893.648469,
        ],
    ],
    [
        1157932800000,
        [
            -6882955150.157773,
            -612637674.8351549,
            3838402731.797678,
        ],
    ],
    [
        1158537600000,
        [
            -6885834131.588124,
            -631006843.9674425,
            3830481562.700866,
        ],
    ],
    [
        1159142400000,
        [
            -6886570567.794967,
            -649558942.823262,
            3822479914.72956,
        ],
    ],
    [
        1159747200000,
        [
            -6885145744.393324,
            -668047889.5389192,
            3814505753.243219,
        ],
    ],
    [
        1160352000000,
        [
            -6881587454.17146,
            -686233201.0689814,
            3806663613.174791,
        ],
    ],
    [
        1160956800000,
        [
            -6875944187.980415,
            -703892461.2083195,
            3799048396.455003,
        ],
    ],
    [
        1161561600000,
        [
            -6868278866.676682,
            -720795585.5147103,
            3791759924.934814,
        ],
    ],
    [
        1162166400000,
        [
            -6858698679.408949,
            -736709229.7884841,
            3784900643.832197,
        ],
    ],
    [
        1162771200000,
        [
            -6847355033.540429,
            -751421939.5742861,
            3778562262.312406,
        ],
    ],
    [
        1163376000000,
        [
            -6834414392.999316,
            -764752852.8821709,
            3772821712.053283,
        ],
    ],
    [
        1163980800000,
        [
            -6820055142.729908,
            -776525907.2198275,
            3767755621.494408,
        ],
    ],
    [
        1164585600000,
        [
            -6804494713.299426,
            -786577417.2877524,
            3763436194.758851,
        ],
    ],
    [
        1165190400000,
        [
            -6787983703.230868,
            -794780923.7288259,
            3759918022.242614,
        ],
    ],
    [
        1165795200000,
        [
            -6770773533.147491,
            -801050445.8641111,
            3757237002.248088,
        ],
    ],
    [
        1166400000000,
        [
            -6753116840.790865,
            -805314204.8877685,
            3755424787.739208,
        ],
    ],
    [
        1167004800000,
        [
            -6735291269.3,
            -807523791.8619167,
            3754503534.767777,
        ],
    ],
    [
        1167609600000,
        [
            -6717588863.434236,
            -807676984.5497098,
            3754473688.400243,
        ],
    ],
    [
        1168214400000,
        [
            -6700282000.811007,
            -805814135.7052394,
            3755316509.361821,
        ],
    ],
    [
        1168819200000,
        [
            -6683628735.058583,
            -801991014.1243309,
            3757008583.555704,
        ],
    ],
    [
        1169424000000,
        [
            -6667893781.29945,
            -796288573.6091802,
            3759515893.581487,
        ],
    ],
    [
        1170028800000,
        [
            -6653335283.674449,
            -788832621.6783179,
            3762783111.154629,
        ],
    ],
    [
        1170633600000,
        [
            -6640171557.389853,
            -779783258.0340856,
            3766739731.780379,
        ],
    ],
    [
        1171238400000,
        [
            -6628593099.941093,
            -769307376.8351082,
            3771314363.493526,
        ],
    ],
    [
        1171843200000,
        [
            -6618781849.588731,
            -757589321.0200508,
            3776428055.802427,
        ],
    ],
    [
        1172448000000,
        [
            -6610897203.99356,
            -744847535.5118514,
            3781985098.988771,
        ],
    ],
    [
        1173052800000,
        [
            -6605045955.599778,
            -731318520.2994493,
            3787882032.254368,
        ],
    ],
    [
        1173657600000,
        [
            -6601301690.855728,
            -717230592.3502092,
            3794020985.64473,
        ],
    ],
    [
        1174262400000,
        [
            -6599722861.923618,
            -702816613.4962257,
            3800301830.448166,
        ],
    ],
    [
        1174867200000,
        [
            -6600338591.305857,
            -688328554.2233541,
            3806614165.06978,
        ],
    ],
    [
        1175472000000,
        [
            -6603123043.36651,
            -674017980.7669208,
            3812848191.515939,
        ],
    ],
    [
        1176076800000,
        [
            -6608021352.192765,
            -660112927.2455877,
            3818906262.299098,
        ],
    ],
    [
        1176681600000,
        [
            -6614966127.664115,
            -646833710.2260181,
            3824693500.737691,
        ],
    ],
    [
        1177286400000,
        [
            -6623862316.209091,
            -634406141.5942734,
            3830110740.898752,
        ],
    ],
    [
        1177891200000,
        [
            -6634566248.323145,
            -623039977.9188417,
            3835066546.666166,
        ],
    ],
    [
        1178496000000,
        [
            -6646916225.547152,
            -612910243.5865875,
            3839486308.409683,
        ],
    ],
    [
        1179100800000,
        [
            -6660746650.288754,
            -604176284.437131,
            3843301355.671197,
        ],
    ],
    [
        1179705600000,
        [
            -6675870893.351427,
            -596993710.2453359,
            3846442886.086625,
        ],
    ],
    [
        1180310400000,
        [
            -6692064997.054887,
            -591491351.8130243,
            3848854822.801782,
        ],
    ],
    [
        1180915200000,
        [
            -6709100940.139596,
            -587757748.6705792,
            3850500074.363862,
        ],
    ],
    [
        1181520000000,
        [
            -6726757731.068154,
            -585862838.2136078,
            3851348480.075871,
        ],
    ],
    [
        1182124800000,
        [
            -6744801691.864557,
            -585868267.8712205,
            3851371925.548628,
        ],
    ],
    [
        1182729600000,
        [
            -6762975000.026945,
            -587802952.1404023,
            3850557944.98583,
        ],
    ],
    [
        1183334400000,
        [
            -6781030013.772617,
            -591655079.9879656,
            3848912951.285318,
        ],
    ],
    [
        1183939200000,
        [
            -6798736988.458012,
            -597395547.2096577,
            3846449466.088527,
        ],
    ],
    [
        1184544000000,
        [
            -6815861828.20351,
            -604986258.4437608,
            3843182595.536702,
        ],
    ],
    [
        1185148800000,
        [
            -6832159809.193934,
            -614354443.7108063,
            3839144243.316965,
        ],
    ],
    [
        1185753600000,
        [
            -6847409726.317873,
            -625390413.1082935,
            3834383227.653132,
        ],
    ],
    [
        1186358400000,
        [
            -6861418045.853897,
            -637971929.0863588,
            3828952209.966165,
        ],
    ],
    [
        1186963200000,
        [
            -6873994592.576056,
            -651970343.2297751,
            3822905571.228007,
        ],
    ],
    [
        1187568000000,
        [
            -6884951644.310862,
            -667224154.4591587,
            3816313940.018013,
        ],
    ],
    [
        1188172800000,
        [
            -6894136855.384866,
            -683542650.563857,
            3809261191.117261,
        ],
    ],
    [
        1188777600000,
        [
            -6901433542.769044,
            -700730632.6468338,
            3801831407.396551,
        ],
    ],
    [
        1189382400000,
        [
            -6906734823.40749,
            -718592425.7198963,
            3794108089.613638,
        ],
    ],
    [
        1189987200000,
        [
            -6909947781.42826,
            -736905448.0601242,
            3786188558.762301,
        ],
    ],
    [
        1190592000000,
        [
            -6911024112.249479,
            -755429674.9678282,
            3778177946.160295,
        ],
    ],
    [
        1191196800000,
        [
            -6909955944.714639,
            -773932243.0080776,
            3770176485.357234,
        ],
    ],
    [
        1191801600000,
        [
            -6906748726.281352,
            -792189278.2309186,
            3762280032.289132,
        ],
    ],
    [
        1192406400000,
        [
            -6901429570.284753,
            -809960234.9743341,
            3754593875.851292,
        ],
    ],
    [
        1193011200000,
        [
            -6894074492.758605,
            -827002601.5571018,
            3747224057.879753,
        ],
    ],
    [
        1193616000000,
        [
            -6884798951.15605,
            -843095696.0867829,
            3740265370.996128,
        ],
    ],
    [
        1194220800000,
        [
            -6873729550.905129,
            -858039711.8625889,
            3733803433.300695,
        ],
    ],
    [
        1194825600000,
        [
            -6861015356.868672,
            -871631201.8482265,
            3727927598.943953,
        ],
    ],
    [
        1195430400000,
        [
            -6846850749.713522,
            -883681661.4307967,
            3722720289.553924,
        ],
    ],
    [
        1196035200000,
        [
            -6831460174.790364,
            -894039359.8366091,
            3718246247.731934,
        ],
    ],
    [
        1196640000000,
        [
            -6815069013.160692,
            -902584232.3797433,
            3714556767.313889,
        ],
    ],
    [
        1197244800000,
        [
            -6797917106.027618,
            -909204359.118855,
            3711701646.660028,
        ],
    ],
    [
        1197849600000,
        [
            -6780276948.498713,
            -913816381.6253171,
            3709717500.259022,
        ],
    ],
    [
        1198454400000,
        [
            -6762433250.119904,
            -916383937.4543402,
            3708618901.127082,
        ],
    ],
    [
        1199059200000,
        [
            -6744654235.66913,
            -916906744.5273753,
            3708405483.679227,
        ],
    ],
    [
        1199664000000,
        [
            -6727207837.826904,
            -915397856.1305804,
            3709072960.358727,
        ],
    ],
    [
        1200268800000,
        [
            -6710375950.12087,
            -911904021.5809983,
            3710601323.73864,
        ],
    ],
    [
        1200873600000,
        [
            -6694430793.055313,
            -906519810.6905578,
            3712948250.783939,
        ],
    ],
    [
        1201478400000,
        [
            -6679608853.047398,
            -899370104.7157841,
            3716059385.858595,
        ],
    ],
    [
        1202083200000,
        [
            -6666131199.715224,
            -890588662.9766912,
            3719878155.022046,
        ],
    ],
    [
        1202688000000,
        [
            -6654214992.866158,
            -880337718.7010466,
            3724334287.890645,
        ],
    ],
    [
        1203292800000,
        [
            -6644049154.007234,
            -868818075.0104659,
            3729339319.527333,
        ],
    ],
    [
        1203897600000,
        [
            -6635773096.332264,
            -856245868.0168027,
            3734799599.075849,
        ],
    ],
    [
        1204502400000,
        [
            -6629502355.514468,
            -842833975.4500906,
            3740624227.354157,
        ],
    ],
    [
        1205107200000,
        [
            -6625337956.763776,
            -828811450.5083667,
            3746713780.279096,
        ],
    ],
    [
        1205712000000,
        [
            -6623343002.978863,
            -814430734.4575564,
            3752957387.359672,
        ],
    ],
    [
        1206316800000,
        [
            -6623527213.012699,
            -799940733.2742362,
            3759247453.211083,
        ],
    ],
    [
        1206921600000,
        [
            -6625877697.39018,
            -785572845.7381705,
            3765484957.089025,
        ],
    ],
    [
        1207526400000,
        [
            -6630365758.615148,
            -771561225.1228231,
            3771568072.625293,
        ],
    ],
    [
        1208131200000,
        [
            -6636924602.83544,
            -758148087.7732171,
            3777390414.875012,
        ],
    ],
    [
        1208736000000,
        [
            -6645439529.654798,
            -745555156.0585234,
            3782856433.341758,
        ],
    ],
    [
        1209340800000,
        [
            -6655782403.016387,
            -733975412.7906239,
            3787883620.828827,
        ],
    ],
    [
        1209945600000,
        [
            -6667814978.267234,
            -723594653.2633444,
            3792390909.202063,
        ],
    ],
    [
        1210550400000,
        [
            -6681367152.448632,
            -714595080.954974,
            3796298040.325605,
        ],
    ],
    [
        1211155200000,
        [
            -6696232261.890124,
            -707126489.3532143,
            3799540900.668825,
        ],
    ],
    [
        1211760000000,
        [
            -6712203308.247229,
            -701303956.7076505,
            3802070589.961727,
        ],
    ],
    [
        1212364800000,
        [
            -6729072200.822524,
            -697230465.2946395,
            3803841728.056125,
        ],
    ],
    [
        1212969600000,
        [
            -6746607991.044771,
            -694998367.3188747,
            3804813156.15177,
        ],
    ],
    [
        1213574400000,
        [
            -6764557004.474698,
            -694661072.4541707,
            3804962778.224356,
        ],
    ],
    [
        1214179200000,
        [
            -6782679006.509175,
            -696236381.5019767,
            3804283691.739633,
        ],
    ],
    [
        1214784000000,
        [
            -6800742338.159509,
            -699729610.0709047,
            3802772654.708363,
        ],
    ],
    [
        1215388800000,
        [
            -6818501966.545532,
            -705132417.4707265,
            3800432333.147034,
        ],
    ],
    [
        1215993600000,
        [
            -6835704549.488598,
            -712395540.7046455,
            3797285330.340294,
        ],
    ],
    [
        1216598400000,
        [
            -6852123007.843462,
            -721437387.8040329,
            3793367658.839132,
        ],
    ],
    [
        1217203200000,
        [
            -6867547934.396099,
            -732167101.4442124,
            3788717598.325726,
        ],
    ],
    [
        1217808000000,
        [
            -6881765591.739781,
            -744480528.3746918,
            3783379549.046551,
        ],
    ],
    [
        1218412800000,
        [
            -6894568100.38322,
            -758234586.100959,
            3777416911.386124,
        ],
    ],
    [
        1219017600000,
        [
            -6905785055.940897,
            -773260854.6195097,
            3770903162.059204,
        ],
    ],
    [
        1219622400000,
        [
            -6915271620.394284,
            -789388126.9837457,
            3763911290.165998,
        ],
    ],
    [
        1220227200000,
        [
            -6922886641.157661,
            -806435674.353514,
            3756519119.937662,
        ],
    ],
    [
        1220832000000,
        [
            -6928507865.607743,
            -824189916.3844286,
            3748820667.943063,
        ],
    ],
    [
        1221436800000,
        [
            -6932059261.707777,
            -842422797.4611881,
            3740915070.031196,
        ],
    ],
    [
        1222041600000,
        [
            -6933495906.30169,
            -860913369.5721114,
            3732896810.336444,
        ],
    ],
    [
        1222646400000,
        [
            -6932782224.335437,
            -879438707.3262748,
            3724862265.043253,
        ],
    ],
    [
        1223251200000,
        [
            -6929911549.907148,
            -897753440.4080389,
            3716919224.572609,
        ],
    ],
    [
        1223856000000,
        [
            -6924927802.438232,
            -915612465.0911717,
            3709173994.623741,
        ],
    ],
    [
        1224460800000,
        [
            -6917906886.306415,
            -932790828.401285,
            3701722776.482123,
        ],
    ],
    [
        1225065600000,
        [
            -6908934884.824432,
            -949072445.9242469,
            3694659266.892875,
        ],
    ],
    [
        1225670400000,
        [
            -6898130709.288004,
            -964232591.1357661,
            3688082255.237741,
        ],
    ],
    [
        1226275200000,
        [
            -6885661048.123836,
            -978063891.0244683,
            3682081446.037102,
        ],
    ],
    [
        1226880000000,
        [
            -6871717896.599098,
            -990393248.8542702,
            3676730576.023989,
        ],
    ],
    [
        1227484800000,
        [
            -6856496793.341688,
            -1001067902.23576,
            3672096187.501864,
        ],
    ],
    [
        1228089600000,
        [
            -6840221228.301721,
            -1009940301.110214,
            3668243535.77969,
        ],
    ],
    [
        1228694400000,
        [
            -6823150657.805817,
            -1016895621.57078,
            3665221954.319725,
        ],
    ],
    [
        1229299200000,
        [
            -6805554398.72648,
            -1021864081.312121,
            3663060431.684051,
        ],
    ],
    [
        1229904000000,
        [
            -6787690932.804128,
            -1024803306.544345,
            3661777933.410504,
        ],
    ],
    [
        1230508800000,
        [
            -6769833487.406452,
            -1025684775.492291,
            3661388022.407835,
        ],
    ],
    [
        1231113600000,
        [
            -6752272269.817883,
            -1024520897.303124,
            3661884644.570795,
        ],
    ],
    [
        1231718400000,
        [
            -6735286121.719874,
            -1021371498.189657,
            3663240668.864437,
        ],
    ],
    [
        1232323200000,
        [
            -6719125083.343801,
            -1016321694.182367,
            3665420026.13339,
        ],
    ],
    [
        1232928000000,
        [
            -6704037610.948336,
            -1009469804.197137,
            3668381177.698118,
        ],
    ],
    [
        1233532800000,
        [
            -6690269104.820273,
            -1000952807.469492,
            3672063875.953477,
        ],
    ],
    [
        1234137600000,
        [
            -6678033475.654789,
            -990947131.8546479,
            3676390548.639444,
        ],
    ],
    [
        1234742400000,
        [
            -6667501460.812535,
            -979642387.2497817,
            3681280011.23732,
        ],
    ],
    [
        1235347200000,
        [
            -6658830224.01362,
            -967231980.2748238,
            3686649344.565906,
        ],
    ],
    [
        1235952000000,
        [
            -6652159834.737233,
            -953936942.6930591,
            3692401718.844293,
        ],
    ],
    [
        1236556800000,
        [
            -6647586481.120385,
            -940002497.2969658,
            3698429894.666246,
        ],
    ],
    [
        1237161600000,
        [
            -6645157977.75371,
            -925669182.9154483,
            3704630755.742584,
        ],
    ],
    [
        1237766400000,
        [
            -6644905669.874496,
            -911168136.3993275,
            3710904809.705702,
        ],
    ],
    [
        1238371200000,
        [
            -6646839150.643087,
            -896743842.45819,
            3717144955.454003,
        ],
    ],
    [
        1238976000000,
        [
            -6650921721.114002,
            -882648231.7935451,
            3723241255.463505,
        ],
    ],
    [
        1239580800000,
        [
            -6657072970.446808,
            -869111038.7507011,
            3729095406.041735,
        ],
    ],
    [
        1240185600000,
        [
            -6665201842.770714,
            -856341258.5953327,
            3734617256.969316,
        ],
    ],
    [
        1240790400000,
        [
            -6675198852.600953,
            -844549051.0509617,
            3739714512.097011,
        ],
    ],
    [
        1241395200000,
        [
            -6686913615.435188,
            -833938382.2336473,
            3744298271.191158,
        ],
    ],
    [
        1242000000000,
        [
            -6700163444.347547,
            -824678015.713672,
            3748296763.532925,
        ],
    ],
    [
        1242604800000,
        [
            -6714765985.681456,
            -816909550.8357382,
            3751648774.179735,
        ],
    ],
    [
        1243209600000,
        [
            -6730528114.135381,
            -810768164.0887274,
            3754294451.838128,
        ],
    ],
    [
        1243814400000,
        [
            -6747225282.974487,
            -806373923.2029526,
            3756181520.498841,
        ],
    ],
    [
        1244419200000,
        [
            -6764614995.42445,
            -803804333.1946392,
            3757277842.55212,
        ],
    ],
    [
        1245024000000,
        [
            -6782467609.079547,
            -803108474.3211945,
            3757562040.681554,
        ],
    ],
    [
        1245628800000,
        [
            -6800551641.025548,
            -804326065.8550951,
            3757015612.590929,
        ],
    ],
    [
        1246233600000,
        [
            -6818614995.411345,
            -807477129.4166412,
            3755629900.509037,
        ],
    ],
    [
        1246838400000,
        [
            -6836402511.051852,
            -812536812.1452156,
            3753417166.522592,
        ],
    ],
    [
        1247443200000,
        [
            -6853683880.828529,
            -819454753.8638593,
            3750398899.651348,
        ],
    ],
    [
        1248048000000,
        [
            -6870235631.512398,
            -828172136.2151071,
            3746599321.161397,
        ],
    ],
    [
        1248652800000,
        [
            -6885824500.295284,
            -838609396.3671958,
            3742053178.590709,
        ],
    ],
    [
        1249257600000,
        [
            -6900228567.818735,
            -850644101.3007205,
            3736814997.946136,
        ],
    ],
    [
        1249862400000,
        [
            -6913261397.944236,
            -864134661.7396916,
            3730945608.57601,
        ],
    ],
    [
        1250467200000,
        [
            -6924751190.445224,
            -878935332.5542548,
            3724506969.267557,
        ],
    ],
    [
        1251072000000,
        [
            -6934526512.047006,
            -894881933.4032576,
            3717570737.794153,
        ],
    ],
    [
        1251676800000,
        [
            -6942440574.361213,
            -911773637.3864361,
            3710225310.006336,
        ],
    ],
    [
        1252281600000,
        [
            -6948390586.938668,
            -929400229.897443,
            3702561085.619582,
        ],
    ],
    [
        1252886400000,
        [
            -6952294492.634066,
            -947555177.8393564,
            3694666478.442278,
        ],
    ],
    [
        1253491200000,
        [
            -6954078923.878324,
            -966019539.0461506,
            3686637115.301616,
        ],
    ],
    [
        1254096000000,
        [
            -6953705950.077549,
            -984548432.773676,
            3678580302.855827,
        ],
    ],
    [
        1254700800000,
        [
            -6951186391.537332,
            -1002900963.666177,
            3670599580.566831,
        ],
    ],
    [
        1255305600000,
        [
            -6946554296.211867,
            -1020851273.525483,
            3662791884.12147,
        ],
    ],
    [
        1255910400000,
        [
            -6939856576.280283,
            -1038170803.828154,
            3655257240.557796,
        ],
    ],
    [
        1256515200000,
        [
            -6931181201.109111,
            -1054619740.390833,
            3648100522.198237,
        ],
    ],
    [
        1257120000000,
        [
            -6920663175.327522,
            -1069978352.195071,
            3641415946.038193,
        ],
    ],
    [
        1257724800000,
        [
            -6908456816.751673,
            -1084055321.75689,
            3635285643.518586,
        ],
    ],
    [
        1258329600000,
        [
            -6894726426.849459,
            -1096668186.701718,
            3629789880.409986,
        ],
    ],
    [
        1258934400000,
        [
            -6879674832.663647,
            -1107639204.58636,
            3625006360.090942,
        ],
    ],
    [
        1259539200000,
        [
            -6863541329.672921,
            -1116826341.247849,
            3620995489.913472,
        ],
    ],
    [
        1260144000000,
        [
            -6846572244.694546,
            -1124127449.041215,
            3617800922.641037,
        ],
    ],
    [
        1260748800000,
        [
            -6829012643.475728,
            -1129458317.005452,
            3615460518.974968,
        ],
    ],
    [
        1261353600000,
        [
            -6811134671.650994,
            -1132751670.899156,
            3614003835.044801,
        ],
    ],
    [
        1261958400000,
        [
            -6793228132.268604,
            -1133985923.731759,
            3613438972.748075,
        ],
    ],
    [
        1262563200000,
        [
            -6775570764.905324,
            -1133183660.858073,
            3613755692.706917,
        ],
    ],
    [
        1263168000000,
        [
            -6758422287.409624,
            -1130386866.235732,
            3614937271.875585,
        ],
    ],
    [
        1263772800000,
        [
            -6742052868.05171,
            -1125657934.084383,
            3616956809.253952,
        ],
    ],
    [
        1264377600000,
        [
            -6726728442.394989,
            -1119105056.545601,
            3619766105.916175,
        ],
    ],
    [
        1264982400000,
        [
            -6712682855.630884,
            -1110874477.570293,
            3623301512.437126,
        ],
    ],
    [
        1265587200000,
        [
            -6700116473.134836,
            -1101123405.302982,
            3627496393.216654,
        ],
    ],
    [
        1266192000000,
        [
            -6689225393.929191,
            -1090023085.953892,
            3632276423.756222,
        ],
    ],
    [
        1266796800000,
        [
            -6680183959.779045,
            -1077780978.858352,
            3637550383.33479,
        ],
    ],
    [
        1267401600000,
        [
            -6673120524.619939,
            -1064627780.133276,
            3643218239.718288,
        ],
    ],
    [
        1268006400000,
        [
            -6668122492.277581,
            -1050789616.244711,
            3649183440.570941,
        ],
    ],
    [
        1268611200000,
        [
            -6665266081.934785,
            -1036494412.042667,
            3655346852.47718,
        ],
    ],
    [
        1269216000000,
        [
            -6664597514.620996,
            -1021991701.028024,
            3661599069.404122,
        ],
    ],
    [
        1269820800000,
        [
            -6666112905.310636,
            -1007536289.65777,
            3667829865.959764,
        ],
    ],
    [
        1270425600000,
        [
            -6669770219.126152,
            -993361625.9907285,
            3673939422.613492,
        ],
    ],
    [
        1271030400000,
        [
            -6675518258.937354,
            -979690858.5876124,
            3679830432.535855,
        ],
    ],
    [
        1271635200000,
        [
            -6683276771.418797,
            -966754766.9081358,
            3685401702.389295,
        ],
    ],
    [
        1272240000000,
        [
            -6692919917.021861,
            -954773704.4485071,
            3690558215.491662,
        ],
    ],
    [
        1272844800000,
        [
            -6704294416.459138,
            -943933495.4661771,
            3695220672.889029,
        ],
    ],
    [
        1273449600000,
        [
            -6717245942.944179,
            -934401837.2068528,
            3699315572.867507,
        ],
    ],
    [
        1274054400000,
        [
            -6731597858.21491,
            -926344041.670724,
            3702770203.251303,
        ],
    ],
    [
        1274659200000,
        [
            -6747137550.027416,
            -919904157.2191017,
            3705522886.960999,
        ],
    ],
    [
        1275264000000,
        [
            -6763639555.864082,
            -915184047.6406007,
            3707530575.112926,
        ],
    ],
    [
        1275868800000,
        [
            -6780887865.180238,
            -912264920.5831505,
            3708757060.593782,
        ],
    ],
    [
        1276473600000,
        [
            -6798653178.341983,
            -911220143.7866843,
            3709169608.403083,
        ],
    ],
    [
        1277078400000,
        [
            -6816681831.207914,
            -912095885.7847987,
            3708749194.648011,
        ],
    ],
    [
        1277683200000,
        [
            -6834722709.526166,
            -914893682.1071632,
            3707496092.504344,
        ],
    ],
    [
        1278288000000,
        [
            -6852544606.009378,
            -919596369.5424464,
            3705416590.400685,
        ],
    ],
    [
        1278892800000,
        [
            -6869912257.27419,
            -926177377.714448,
            3702521424.032988,
        ],
    ],
    [
        1279497600000,
        [
            -6886578035.588857,
            -934581049.780637,
            3698835877.469818,
        ],
    ],
    [
        1280102400000,
        [
            -6902311592.417024,
            -944709024.271515,
            3694403329.490942,
        ],
    ],
    [
        1280707200000,
        [
            -6916911902.286608,
            -956449709.9926162,
            3689270908.373039,
        ],
    ],
    [
        1281312000000,
        [
            -6930182483.764577,
            -969683904.750236,
            3683489690.901355,
        ],
    ],
    [
        1281916800000,
        [
            -6941926195.661626,
            -984265012.8659554,
            3677124494.075651,
        ],
    ],
    [
        1282521600000,
        [
            -6951976543.783512,
            -1000009752.431403,
            3670255274.042186,
        ],
    ],
    [
        1283126400000,
        [
            -6960204185.367841,
            -1016730286.324538,
            3662962163.945107,
        ],
    ],
    [
        1283731200000,
        [
            -6966491589.606958,
            -1034236453.505618,
            3655327224.854153,
        ],
    ],
    [
        1284336000000,
        [
            -6970731063.258745,
            -1052316164.630942,
            3647443733.351413,
        ],
    ],
    [
        1284940800000,
        [
            -6972856486.312115,
            -1070731037.737189,
            3639415260.426244,
        ],
    ],
    [
        1285545600000,
        [
            -6972843885.023919,
            -1089250160.437689,
            3631340599.654911,
        ],
    ],
    [
        1286150400000,
        [
            -6970685460.929366,
            -1107649365.331132,
            3623316805.407403,
        ],
    ],
    [
        1286755200000,
        [
            -6966390511.250535,
            -1125691944.315397,
            3615447866.212788,
        ],
    ],
    [
        1287360000000,
        [
            -6960016158.129439,
            -1143129595.645957,
            3607841361.405252,
        ],
    ],
    [
        1287964800000,
        [
            -6951661369.548436,
            -1159736371.972264,
            3600593942.703444,
        ],
    ],
    [
        1288569600000,
        [
            -6941440101.864642,
            -1175305121.012262,
            3593795544.726913,
        ],
    ],
    [
        1289174400000,
        [
            -6929484410.004975,
            -1189628209.259977,
            3587537563.259897,
        ],
    ],
    [
        1289779200000,
        [
            -6915972825.661349,
            -1202503528.991002,
            3581907259.401662,
        ],
    ],
    [
        1290384000000,
        [
            -6901117344.350293,
            -1213766573.51843,
            3576974678.716535,
        ],
    ],
    [
        1290988800000,
        [
            -6885135797.995975,
            -1223283494.269951,
            3572798215.66992,
        ],
    ],
    [
        1291593600000,
        [
            -6868256604.9098,
            -1230930988.7794,
            3569432691.95679,
        ],
    ],
    [
        1292198400000,
        [
            -6850744154.878405,
            -1236606357.461761,
            3566922016.777562,
        ],
    ],
    [
        1292803200000,
        [
            -6832879141.215301,
            -1240255371.426436,
            3565288501.227626,
        ],
    ],
    [
        1293408000000,
        [
            -6814931383.163239,
            -1241860946.520888,
            3564540126.057603,
        ],
    ],
    [
        1294012800000,
        [
            -6797166560.310895,
            -1241421340.193848,
            3564678954.545079,
        ],
    ],
    [
        1294617600000,
        [
            -6779869149.28553,
            -1238962994.904435,
            3565692690.993738,
        ],
    ],
    [
        1295222400000,
        [
            -6763317751.702761,
            -1234562526.856198,
            3567547047.459909,
        ],
    ],
    [
        1295827200000,
        [
            -6747760708.174557,
            -1228330443.772667,
            3570194858.5434,
        ],
    ],
    [
        1296432000000,
        [
            -6733426110.188131,
            -1220387758.327272,
            3573584847.892173,
        ],
    ],
    [
        1297036800000,
        [
            -6720543528.530231,
            -1210881018.677622,
            3577652467.270346,
        ],
    ],
    [
        1297641600000,
        [
            -6709316660.779153,
            -1199998313.03706,
            3582315284.114157,
        ],
    ],
    [
        1298246400000,
        [
            -6699904113.641173,
            -1187948678.284144,
            3587483567.009642,
        ],
    ],
    [
        1298851200000,
        [
            -6692434044.365827,
            -1174938646.070064,
            3593068776.752082,
        ],
    ],
    [
        1299456000000,
        [
            -6687025343.333961,
            -1161189820.820508,
            3598973670.213184,
        ],
    ],
    [
        1300060800000,
        [
            -6683759393.818869,
            -1146950141.261681,
            3605090088.535661,
        ],
    ],
    [
        1300665600000,
        [
            -6682667102.2556,
            -1132470587.994516,
            3611310262.059845,
        ],
    ],
    [
        1301270400000,
        [
            -6683748582.766422,
            -1117983880.390896,
            3617534060.835198,
        ],
    ],
    [
        1301875200000,
        [
            -6686993079.687917,
            -1103725259.452073,
            3623658197.828381,
        ],
    ],
    [
        1302480000000,
        [
            -6692350560.869309,
            -1089940412.851913,
            3629575724.095267,
        ],
    ],
    [
        1303084800000,
        [
            -6699724528.060526,
            -1076861077.276611,
            3635187352.601549,
        ],
    ],
    [
        1303689600000,
        [
            -6708996131.011844,
            -1064687692.1402,
            3640406686.836209,
        ],
    ],
    [
        1304294400000,
        [
            -6720041153.054724,
            -1053613550.168002,
            3645148526.163174,
        ],
    ],
    [
        1304899200000,
        [
            -6732701572.759639,
            -1043830019.907502,
            3649329695.97953,
        ],
    ],
    [
        1305504000000,
        [
            -6746782951.968172,
            -1035502018.413793,
            3652879995.126412,
        ],
    ],
    [
        1306108800000,
        [
            -6762081943.16354,
            -1028755527.726668,
            3655745040.661838,
        ],
    ],
    [
        1306713600000,
        [
            -6778398647.206739,
            -1023704619.610789,
            3657873929.11947,
        ],
    ],
    [
        1307318400000,
        [
            -6795508393.465081,
            -1020453809.130202,
            3659221345.282128,
        ],
    ],
    [
        1307923200000,
        [
            -6813162643.545718,
            -1019073862.509378,
            3659757980.324868,
        ],
    ],
    [
        1308528000000,
        [
            -6831118920.57572,
            -1019594408.050361,
            3659470958.234777,
        ],
    ],
    [
        1309132800000,
        [
            -6849147423.645317,
            -1022033010.167251,
            3658351235.565598,
        ],
    ],
    [
        1309737600000,
        [
            -6867003635.964076,
            -1026394205.528567,
            3656397030.106395,
        ],
    ],
    [
        1310342400000,
        [
            -6884432162.911733,
            -1032645993.223271,
            3653623602.478111,
        ],
    ],
    [
        1310947200000,
        [
            -6901198234.506105,
            -1040717513.765221,
            3650061375.921746,
        ],
    ],
    [
        1311552000000,
        [
            -6917088088.986286,
            -1050529359.469858,
            3645743439.12553,
        ],
    ],
    [
        1312156800000,
        [
            -6931883171.752862,
            -1061989044.078318,
            3640710257.329403,
        ],
    ],
    [
        1312761600000,
        [
            -6945366687.883868,
            -1074968664.78073,
            3635018620.54234,
        ],
    ],
    [
        1313366400000,
        [
            -6957355750.026091,
            -1089307610.016543,
            3628737597.336448,
        ],
    ],
    [
        1313971200000,
        [
            -6967695442.895106,
            -1104843441.566842,
            3621936421.75842,
        ],
    ],
    [
        1314576000000,
        [
            -6976235153.838225,
            -1121403933.910609,
            3614690319.424479,
        ],
    ],
    [
        1315180800000,
        [
            -6982837680.144807,
            -1138786548.285514,
            3607088334.307591,
        ],
    ],
    [
        1315785600000,
        [
            -6987410789.666401,
            -1156766129.253257,
            3599227256.727763,
        ],
    ],
    [
        1316390400000,
        [
            -6989895005.967628,
            -1175125745.403572,
            3591200129.581027,
        ],
    ],
    [
        1316995200000,
        [
            -6990242075.502422,
            -1193645693.875017,
            3583102957.707019,
        ],
    ],
    [
        1317600000000,
        [
            -6988426260.223984,
            -1212085342.343015,
            3575041158.135054,
        ],
    ],
    [
        1318204800000,
        [
            -6984473693.373128,
            -1230195600.046818,
            3567121656.033134,
        ],
    ],
    [
        1318809600000,
        [
            -6978443907.325805,
            -1247748843.730885,
            3559442326.20974,
        ],
    ],
    [
        1319414400000,
        [
            -6970409868.242618,
            -1264525177.466614,
            3552099446.185839,
        ],
    ],
    [
        1320019200000,
        [
            -6960470837.242015,
            -1280296707.156864,
            3545192744.919859,
        ],
    ],
    [
        1320624000000,
        [
            -6948777763.722017,
            -1294844137.574129,
            3538816030.047685,
        ],
    ],
    [
        1321228800000,
        [
            -6935508722.652029,
            -1307984266.374171,
            3533048111.248654,
        ],
    ],
    [
        1321833600000,
        [
            -6920849838.813874,
            -1319553309.337704,
            3527961102.490572,
        ],
    ],
    [
        1322438400000,
        [
            -6905009227.962925,
            -1329392878.762783,
            3523624412.624325,
        ],
    ],
    [
        1323043200000,
        [
            -6888237196.707691,
            -1337369530.450202,
            3520094497.488384,
        ],
    ],
    [
        1323648000000,
        [
            -6870796417.819006,
            -1343397632.200067,
            3517408054.681931,
        ],
    ],
    [
        1324252800000,
        [
            -6852943856.990177,
            -1347419139.87034,
            3515591474.476522,
        ],
    ],
    [
        1324857600000,
        [
            -6834946043.95091,
            -1349390043.906964,
            3514664363.625425,
        ],
    ],
    [
        1325462400000,
        [
            -6817094094.930431,
            -1349301573.651716,
            3514629073.699947,
        ],
    ],
    [
        1326067200000,
        [
            -6799670535.38582,
            -1347196314.890234,
            3515466913.682353,
        ],
    ],
    [
        1326672000000,
        [
            -6782933721.753186,
            -1343144134.647549,
            3517148883.814127,
        ],
    ],
    [
        1327276800000,
        [
            -6767135561.508083,
            -1337228336.213151,
            3519639145.758068,
        ],
    ],
    [
        1327881600000,
        [
            -6752532574.058376,
            -1329567896.368411,
            3522884680.01307,
        ],
    ],
    [
        1328486400000,
        [
            -6739351933.661584,
            -1320325932.634242,
            3526814765.536219,
        ],
    ],
    [
        1329091200000,
        [
            -6727780663.959835,
            -1309682617.942652,
            3531352595.559373,
        ],
    ],
    [
        1329696000000,
        [
            -6717986966.143208,
            -1297821614.783979,
            3536418540.182284,
        ],
    ],
    [
        1330300800000,
        [
            -6710128656.28196,
            -1284953708.803915,
            3541919831.608242,
        ],
    ],
    [
        1330905600000,
        [
            -6704320485.44186,
            -1271318371.171027,
            3547752894.707391,
        ],
    ],
    [
        1331510400000,
        [
            -6700629736.49872,
            -1257155555.668067,
            3553814985.67288,
        ],
    ],
    [
        1332115200000,
        [
            -6699101300.402194,
            -1242694085.830741,
            3560006600.061874,
        ],
    ],
    [
        1332720000000,
        [
            -6699763853.055593,
            -1228177375.104075,
            3566220902.051871,
        ],
    ],
    [
        1333324800000,
        [
            -6702599220.077888,
            -1213859685.138258,
            3572348153.01839,
        ],
    ],
    [
        1333929600000,
        [
            -6707544527.678797,
            -1199978736.882543,
            3578286532.26913,
        ],
    ],
    [
        1334534400000,
        [
            -6714519995.586539,
            -1186747802.816094,
            3583942997.571811,
        ],
    ],
    [
        1335139200000,
        [
            -6723432172.524202,
            -1174383597.984564,
            3589222382.029797,
        ],
    ],
    [
        1335744000000,
        [
            -6734145185.498093,
            -1163098607.013144,
            3594033283.036006,
        ],
    ],
    [
        1336348800000,
        [
            -6746488508.449928,
            -1153075638.236903,
            3598297612.332649,
        ],
    ],
    [
        1336953600000,
        [
            -6760285993.083779,
            -1144464721.129671,
            3601949506.425087,
        ],
    ],
    [
        1337558400000,
        [
            -6775355137.328301,
            -1137412383.414541,
            3604924346.551057,
        ],
    ],
    [
        1338163200000,
        [
            -6791480020.582896,
            -1132050774.298928,
            3607165742.77074,
        ],
    ],
    [
        1338768000000,
        [
            -6808423502.334082,
            -1128474472.802616,
            3608633745.217618,
        ],
    ],
    [
        1339372800000,
        [
            -6825956257.904077,
            -1126742624.382693,
            3609301702.362247,
        ],
    ],
    [
        1339977600000,
        [
            -6843851306.670656,
            -1126908349.761683,
            3609145653.583655,
        ],
    ],
    [
        1340582400000,
        [
            -6861858923.004546,
            -1129004982.973835,
            3608152188.873279,
        ],
    ],
    [
        1341187200000,
        [
            -6879722297.951245,
            -1133025118.551589,
            3606325411.557251,
        ],
    ],
    [
        1341792000000,
        [
            -6897205766.45094,
            -1138928088.041552,
            3603681789.275013,
        ],
    ],
    [
        1342396800000,
        [
            -6914084245.798288,
            -1146668292.190898,
            3600240370.160809,
        ],
    ],
    [
        1343001600000,
        [
            -6930120868.333508,
            -1156178849.298891,
            3596031288.377646,
        ],
    ],
    [
        1343606400000,
        [
            -6945085370.224672,
            -1167352957.329426,
            3591101532.034925,
        ],
    ],
    [
        1344211200000,
        [
            -6958780888.184597,
            -1180056677.945441,
            3585507881.716296,
        ],
    ],
    [
        1344816000000,
        [
            -6971028224.044072,
            -1194155288.235467,
            3579308282.853825,
        ],
    ],
    [
        1345420800000,
        [
            -6981646993.973353,
            -1209494840.251821,
            3572570685.813679,
        ],
    ],
    [
        1346025600000,
        [
            -6990476016.419534,
            -1225886189.746589,
            3565377536.781077,
        ],
    ],
    [
        1346630400000,
        [
            -6997397951.249473,
            -1243122936.787249,
            3557816933.371379,
        ],
    ],
    [
        1347235200000,
        [
            -7002318384.718517,
            -1261005217.651413,
            3549975346.558054,
        ],
    ],
    [
        1347840000000,
        [
            -7005150914.00186,
            -1279319822.721273,
            3541946466.384244,
        ],
    ],
    [
        1348444800000,
        [
            -7005838615.746194,
            -1297827385.284769,
            3533834258.904575,
        ],
    ],
    [
        1349049600000,
        [
            -7004375489.00035,
            -1316284997.142145,
            3525742579.135137,
        ],
    ],
    [
        1349654400000,
        [
            -7000780301.745298,
            -1334466970.158762,
            3517769376.679526,
        ],
    ],
    [
        1350259200000,
        [
            -6995085382.009571,
            -1352143989.605468,
            3510015345.659126,
        ],
    ],
    [
        1350864000000,
        [
            -6987358050.016419,
            -1369073755.220043,
            3502585480.937376,
        ],
    ],
    [
        1351468800000,
        [
            -6977717563.292337,
            -1385027188.061383,
            3495577610.705199,
        ],
    ],
    [
        1352073600000,
        [
            -6966303758.715344,
            -1399805428.063989,
            3489078312.224785,
        ],
    ],
    [
        1352678400000,
        [
            -6953268841.219095,
            -1413217911.182187,
            3483171464.642232,
        ],
    ],
    [
        1353283200000,
        [
            -6938797838.560732,
            -1425076149.06876,
            3477938512.625349,
        ],
    ],
    [
        1353888000000,
        [
            -6923119919.953375,
            -1435221746.435607,
            3473446667.900545,
        ],
    ],
    [
        1354492800000,
        [
            -6906472509.091157,
            -1443538362.964216,
            3469746955.4708,
        ],
    ],
    [
        1355097600000,
        [
            -6889095579.868821,
            -1449927932.282558,
            3466883090.622015,
        ],
    ],
    [
        1355702400000,
        [
            -6871251056.391049,
            -1454306626.064769,
            3464890937.17165,
        ],
    ],
    [
        1356307200000,
        [
            -6853228233.824227,
            -1456632649.554661,
            3463787261.908514,
        ],
    ],
    [
        1356912000000,
        [
            -6835305306.945457,
            -1456911651.848726,
            3463570392.602184,
        ],
    ],
    [
        1357516800000,
        [
            -6817746658.536371,
            -1455170319.38729,
            3464229847.738467,
        ],
    ],
    [
        1358121600000,
        [
            -6800822348.743028,
            -1451453598.007715,
            3465745452.305977,
        ],
    ],
    [
        1358726400000,
        [
            -6784808488.058675,
            -1445850952.182463,
            3468077251.682985,
        ],
    ],
    [
        1359331200000,
        [
            -6769949244.454356,
            -1438494377.060504,
            3471168965.250934,
        ],
    ],
    [
        1359936000000,
        [
            -6756458493.733261,
            -1429529714.544244,
            3474958301.840772,
        ],
    ],
    [
        1360540800000,
        [
            -6744541060.789813,
            -1419115116.629994,
            3479375786.90654,
        ],
    ],
    [
        1361145600000,
        [
            -6734389312.534514,
            -1407445835.257169,
            3484335841.738981,
        ],
    ],
    [
        1361750400000,
        [
            -6726148575.037098,
            -1394745320.81661,
            3489742687.497583,
        ],
    ],
    [
        1362355200000,
        [
            -6719924325.316239,
            -1381236075.782305,
            3495500624.691844,
        ],
    ],
    [
        1362960000000,
        [
            -6715806016.321069,
            -1367140329.224687,
            3501512181.313853,
        ],
    ],
    [
        1363564800000,
        [
            -6713860531.607725,
            -1352704341.064337,
            3507669925.640154,
        ],
    ],
    [
        1364169600000,
        [
            -6714102547.576777,
            -1338184013.988732,
            3513864134.520215,
        ],
    ],
    [
        1364774400000,
        [
            -6716507338.40219,
            -1323817671.559726,
            3519992070.828952,
        ],
    ],
    [
        1365379200000,
        [
            -6721036545.140523,
            -1309830090.648255,
            3525954970.05338,
        ],
    ],
    [
        1365984000000,
        [
            -6727628263.226192,
            -1296457069.703549,
            3531650196.610047,
        ],
    ],
    [
        1366588800000,
        [
            -6736172396.719005,
            -1283926975.061462,
            3536980046.034179,
        ],
    ],
    [
        1367193600000,
        [
            -6746528164.669051,
            -1272437223.740788,
            3541859334.389673,
        ],
    ],
    [
        1367798400000,
        [
            -6758550241.820992,
            -1262162286.813925,
            3546210977.499971,
        ],
    ],
    [
        1368403200000,
        [
            -6772074985.847265,
            -1253278350.341588,
            3549958436.461171,
        ],
    ],
    [
        1369008000000,
        [
            -6786900188.267115,
            -1245941714.709048,
            3553035275.431576,
        ],
    ],
    [
        1369612800000,
        [
            -6802806115.847495,
            -1240269732.751398,
            3555390826.889628,
        ],
    ],
    [
        1370217600000,
        [
            -6819580408.664347,
            -1236352837.01883,
            3556984387.955173,
        ],
    ],
    [
        1370822400000,
        [
            -6837000302.294897,
            -1234278353.409946,
            3557778190.672949,
        ],
    ],
    [
        1371427200000,
        [
            -6854816326.620568,
            -1234106333.284333,
            3557747498.180646,
        ],
    ],
    [
        1372032000000,
        [
            -6872775958.209668,
            -1235854977.121029,
            3556884410.376938,
        ],
    ],
    [
        1372636800000,
        [
            -6890646075.111714,
            -1239516528.378372,
            3555190815.414062,
        ],
    ],
    [
        1373241600000,
        [
            -6908191501.586932,
            -1245079051.006839,
            3552672226.475923,
        ],
    ],
    [
        1373846400000,
        [
            -6925162603.032359,
            -1252500316.224089,
            3549348176.940471,
        ],
    ],
    [
        1374451200000,
        [
            -6941320889.425057,
            -1261697494.59794,
            3545254322.364419,
        ],
    ],
    [
        1375056000000,
        [
            -6956458204.903222,
            -1272566813.452873,
            3540434258.466132,
        ],
    ],
    [
        1375660800000,
        [
            -6970372160.469656,
            -1285002266.563885,
            3534934529.791591,
        ],
    ],
    [
        1376265600000,
        [
            -6982857803.954399,
            -1298868449.052313,
            3528814963.997047,
        ],
    ],
    [
        1376870400000,
        [
            -6993734531.012671,
            -1313994336.529745,
            3522149193.14987,
        ],
    ],
    [
        1377475200000,
        [
            -7002861326.181273,
            -1330196673.552776,
            3515015392.915722,
        ],
    ],
    [
        1378080000000,
        [
            -7010109564.125346,
            -1347294882.453757,
            3507492675.121671,
        ],
    ],
    [
        1378684800000,
        [
            -7015358840.710059,
            -1365083973.2392,
            3499670918.755667,
        ],
    ],
    [
        1379289600000,
        [
            -7018524285.095289,
            -1383332293.178527,
            3491649787.28455,
        ],
    ],
    [
        1379894400000,
        [
            -7019567095.020427,
            -1401808473.607888,
            3483528464.8463,
        ],
    ],
    [
        1380499200000,
        [
            -7018464866.958108,
            -1420292001.771045,
            3475403582.200311,
        ],
    ],
    [
        1381104000000,
        [
            -7015211313.236197,
            -1438547256.729859,
            3467378171.458065,
        ],
    ],
    [
        1381708800000,
        [
            -7009842686.018013,
            -1456324996.727398,
            3459559300.69006,
        ],
    ],
    [
        1382313600000,
        [
            -7002442757.312759,
            -1473392178.392207,
            3452047055.017419,
        ],
    ],
    [
        1382918400000,
        [
            -6993110546.235489,
            -1489537572.031343,
            3444934194.888387,
        ],
    ],
    [
        1383523200000,
        [
            -6981963299.792418,
            -1504547403.426646,
            3438314136.548038,
        ],
    ],
    [
        1384128000000,
        [
            -6969160605.64241,
            -1518209957.178872,
            3432277513.564144,
        ],
    ],
    [
        1384732800000,
        [
            -6954903190.495295,
            -1530346733.338767,
            3426900968.000878,
        ],
    ],
    [
        1385337600000,
        [
            -6939398101.559797,
            -1540812161.954871,
            3422248890.895067,
        ],
    ],
    [
        1385942400000,
        [
            -6922864447.012117,
            -1549470421.05268,
            3418380725.510598,
        ],
    ],
    [
        1386547200000,
        [
            -6905554340.347568,
            -1556202081.753954,
            3415346992.502188,
        ],
    ],
    [
        1387152000000,
        [
            -6887745694.022052,
            -1560934345.492695,
            3413178746.728316,
        ],
    ],
    [
        1387756800000,
        [
            -6869705912.321558,
            -1563633792.303173,
            3411891803.818197,
        ],
    ],
    [
        1388361600000,
        [
            -6851700664.746692,
            -1564283376.740463,
            3411493893.183686,
        ],
    ],
    [
        1388966400000,
        [
            -6834012071.167826,
            -1562890083.109808,
            3411980672.766431,
        ],
    ],
    [
        1389571200000,
        [
            -6816926761.81224,
            -1559512148.337008,
            3413326661.108966,
        ],
    ],
    [
        1390176000000,
        [
            -6800700517.327405,
            -1554244457.348454,
            3415492058.884778,
        ],
    ],
    [
        1390780800000,
        [
            -6785571186.340727,
            -1547195206.909641,
            3418430050.318007,
        ],
    ],
    [
        1391385600000,
        [
            -6771775617.093059,
            -1538494403.817975,
            3422082932.139965,
        ],
    ],
    [
        1391990400000,
        [
            -6759534727.956172,
            -1528317195.333428,
            3426374838.738258,
        ],
    ],
    [
        1392595200000,
        [
            -6749022111.339307,
            -1516862870.522935,
            3431220700.383546,
        ],
    ],
    [
        1393200000000,
        [
            -6740382078.470081,
            -1504331975.925141,
            3436533410.6806,
        ],
    ],
    [
        1393804800000,
        [
            -6733746720.390918,
            -1490936585.565621,
            3442219676.193206,
        ],
    ],
    [
        1394409600000,
        [
            -6729219019.553274,
            -1476920234.827027,
            3448174270.809034,
        ],
    ],
    [
        1395014400000,
        [
            -6726847612.277593,
            -1462532534.581228,
            3454290271.549064,
        ],
    ],
    [
        1395619200000,
        [
            -6726649801.554977,
            -1448008516.67393,
            3460465383.086555,
        ],
    ],
    [
        1396224000000,
        [
            -6728628998.286992,
            -1433581896.626,
            3466596945.223132,
        ],
    ],
    [
        1396828800000,
        [
            -6732755725.656057,
            -1419502504.925225,
            3472577260.921824,
        ],
    ],
    [
        1397433600000,
        [
            -6738949266.998044,
            -1406008468.356365,
            3478304309.270499,
        ],
    ],
    [
        1398038400000,
        [
            -6747104305.077816,
            -1393309520.378406,
            3483686559.936451,
        ],
    ],
    [
        1398643200000,
        [
            -6757107903.7932,
            -1381603826.934736,
            3488636825.601707,
        ],
    ],
    [
        1399248000000,
        [
            -6768817695.116877,
            -1371093284.870818,
            3493068411.898008,
        ],
    ],
    [
        1399852800000,
        [
            -6782050142.690681,
            -1361954485.308262,
            3496905843.273448,
        ],
    ],
    [
        1400457600000,
        [
            -6796609099.367761,
            -1354327017.079845,
            3500087832.020827,
        ],
    ],
    [
        1401062400000,
        [
            -6812301137.263314,
            -1348333567.273665,
            3502560032.781356,
        ],
    ],
    [
        1401667200000,
        [
            -6828910549.973011,
            -1344092776.44753,
            3504272033.758221,
        ],
    ],
    [
        1402272000000,
        [
            -6846193706.99278,
            -1341689568.259783,
            3505187911.17357,
        ],
    ],
    [
        1402876800000,
        [
            -6863908158.42638,
            -1341168779.153614,
            3505287311.091871,
        ],
    ],
    [
        1403481600000,
        [
            -6881825303.844861,
            -1342557807.185733,
            3504557378.655935,
        ],
    ],
    [
        1404086400000,
        [
            -6899702574.376404,
            -1345876427.442263,
            3502990723.058799,
        ],
    ],
    [
        1404691200000,
        [
            -6917283436.275035,
            -1351106912.112913,
            3500595692.869602,
        ],
    ],
    [
        1405296000000,
        [
            -6934326185.015862,
            -1358192941.240313,
            3497395655.505042,
        ],
    ],
    [
        1405900800000,
        [
            -6950613205.881958,
            -1367064104.224852,
            3493420385.942915,
        ],
    ],
    [
        1406505600000,
        [
            -6965921262.138161,
            -1377642195.277189,
            3488705104.224104,
        ],
    ],
    [
        1407110400000,
        [
            -6980026726.281148,
            -1389811737.935822,
            3483300287.443059,
        ],
    ],
    [
        1407715200000,
        [
            -6992733526.240749,
            -1403424002.099273,
            3477269243.142843,
        ],
    ],
    [
        1408320000000,
        [
            -7003878338.184547,
            -1418322900.836063,
            3470679141.369756,
        ],
    ],
    [
        1408924800000,
        [
            -7013300045.237157,
            -1434347547.56616,
            3463601148.518718,
        ],
    ],
    [
        1409529600000,
        [
            -7020849582.349095,
            -1451304076.017062,
            3456119481.878527,
        ],
    ],
    [
        1410134400000,
        [
            -7026416507.264905,
            -1468974511.551079,
            3448327366.745968,
        ],
    ],
    [
        1410739200000,
        [
            -7029929354.222128,
            -1487143774.699326,
            3440317805.579773,
        ],
    ],
    [
        1411344000000,
        [
            -7031325055.387996,
            -1505598410.285424,
            3432184810.33301,
        ],
    ],
    [
        1411948800000,
        [
            -7030562433.793253,
            -1524100711.436084,
            3424031381.361157,
        ],
    ],
    [
        1412553600000,
        [
            -7027646629.831667,
            -1542401961.887276,
            3415964006.121453,
        ],
    ],
    [
        1413158400000,
        [
            -7022623685.913926,
            -1560270127.217155,
            3408083293.325665,
        ],
    ],
    [
        1413763200000,
        [
            -7015550260.558647,
            -1577484457.971576,
            3400486406.610743,
        ],
    ],
    [
        1414368000000,
        [
            -7006509517.88913,
            -1593812674.96723,
            3393273795.972746,
        ],
    ],
    [
        1414972800000,
        [
            -6995632394.409675,
            -1609027593.886806,
            3386542601.002249,
        ],
    ],
    [
        1415577600000,
        [
            -6983085622.332646,
            -1622934549.707443,
            3380377487.085872,
        ],
    ],
    [
        1416182400000,
        [
            -6969041850.256857,
            -1635361049.729521,
            3374854609.394794,
        ],
    ],
    [
        1416787200000,
        [
            -6953696841.191252,
            -1646137122.408336,
            3370047224.756053,
        ],
    ],
    [
        1417392000000,
        [
            -6937286738.967805,
            -1655113716.758515,
            3366018647.387673,
        ],
    ],
    [
        1417996800000,
        [
            -6920069566.178597,
            -1662188206.928952,
            3362813904.510234,
        ],
    ],
    [
        1418601600000,
        [
            -6902296334.922346,
            -1667287870.396664,
            3360465742.533069,
        ],
    ],
    [
        1419206400000,
        [
            -6884229341.391402,
            -1670352839.548365,
            3358999504.604463,
        ],
    ],
    [
        1419811200000,
        [
            -6866155431.201159,
            -1671354501.005033,
            3358426394.649641,
        ],
    ],
    [
        1420416000000,
        [
            -6848362439.068334,
            -1670317232.487668,
            3358736646.527544,
        ],
    ],
    [
        1421020800000,
        [
            -6831112897.312435,
            -1667294929.520141,
            3359907917.372617,
        ],
    ],
    [
        1421625600000,
        [
            -6814664385.660638,
            -1662356005.765611,
            3361909751.928207,
        ],
    ],
    [
        1422230400000,
        [
            -6799279816.544333,
            -1655600829.961071,
            3364697575.880032,
        ],
    ],
    [
        1422835200000,
        [
            -6785201355.272644,
            -1647178637.026997,
            3368207746.798388,
        ],
    ],
    [
        1423440000000,
        [
            -6772628984.855887,
            -1637257802.317081,
            3372368082.519977,
        ],
    ],
    [
        1424044800000,
        [
            -6761744273.677489,
            -1626013146.287814,
            3377101820.855264,
        ],
    ],
    [
        1424649600000,
        [
            -6752718935.928768,
            -1613642878.317522,
            3382322129.963714,
        ],
    ],
    [
        1425254400000,
        [
            -6745688450.284061,
            -1600380870.42326,
            3387928885.570015,
        ],
    ],
    [
        1425859200000,
        [
            -6740737243.983647,
            -1586462931.322382,
            3393820467.714203,
        ],
    ],
    [
        1426464000000,
        [
            -6737926347.965541,
            -1572117472.505603,
            3399896732.975184,
        ],
    ],
    [
        1427068800000,
        [
            -6737300690.576445,
            -1557583324.629279,
            3406053417.703701,
        ],
    ],
    [
        1427673600000,
        [
            -6738863197.20431,
            -1543118167.009766,
            3412180217.353236,
        ],
    ],
    [
        1428278400000,
        [
            -6742567141.28138,
            -1528963528.512332,
            3418172833.506022,
        ],
    ],
    [
        1428883200000,
        [
            -6748346735.482107,
            -1515339895.42135,
            3423934455.069182,
        ],
    ],
    [
        1429488000000,
        [
            -6756122657.16829,
            -1502466501.186667,
            3429369522.380083,
        ],
    ],
    [
        1430092800000,
        [
            -6765776188.995669,
            -1490566354.774478,
            3434382823.942157,
        ],
    ],
    [
        1430697600000,
        [
            -6777148385.849986,
            -1479832054.902876,
            3438891065.69414,
        ],
    ],
    [
        1431302400000,
        [
            -6790071800.125815,
            -1470425837.61132,
            3442822636.374411,
        ],
    ],
    [
        1431907200000,
        [
            -6804373427.879543,
            -1462501531.447753,
            3446110574.954815,
        ],
    ],
    [
        1432512000000,
        [
            -6819848235.979009,
            -1456205993.114844,
            3448692680.021578,
        ],
    ],
    [
        1433116800000,
        [
            -6836264588.60262,
            -1451646915.641705,
            3450522236.325668,
        ],
    ],
    [
        1433721600000,
        [
            -6853395298.42615,
            -1448897751.492333,
            3451566114.477247,
        ],
    ],
    [
        1434326400000,
        [
            -6871017466.996312,
            -1448021281.274454,
            3451797100.567944,
        ],
    ],
    [
        1434931200000,
        [
            -6888885261.669565,
            -1449067011.417616,
            3451195145.633052,
        ],
    ],
    [
        1435536000000,
        [
            -6906741168.380939,
            -1452041611.551496,
            3449757082.349351,
        ],
    ],
    [
        1436140800000,
        [
            -6924344994.327312,
            -1456918408.641831,
            3447493213.852682,
        ],
    ],
    [
        1436745600000,
        [
            -6941470459.233361,
            -1463661750.217331,
            3444419290.571268,
        ],
    ],
    [
        1437350400000,
        [
            -6957877699.630971,
            -1472220156.584092,
            3440558960.673328,
        ],
    ],
    [
        1437955200000,
        [
            -6973329938.442726,
            -1482499872.638381,
            3435952346.13469,
        ],
    ],
    [
        1438560000000,
        [
            -6987619509.087558,
            -1494378636.457129,
            3430651242.46654,
        ],
    ],
    [
        1439164800000,
        [
            -7000561191.087275,
            -1507730090.433792,
            3424711005.508553,
        ],
    ],
    [
        1439769600000,
        [
            -7011965234.262856,
            -1522412954.26489,
            3418194108.9224,
        ],
    ],
    [
        1440374400000,
        [
            -7021658801.486606,
            -1538248185.633661,
            3411177422.545001,
        ],
    ],
    [
        1440979200000,
        [
            -7029508333.552143,
            -1555036792.457357,
            3403746081.221383,
        ],
    ],
    [
        1441584000000,
        [
            -7035409427.409549,
            -1572583693.745777,
            3395985473.650093,
        ],
    ],
    [
        1442188800000,
        [
            -7039261092.343726,
            -1590683557.381141,
            3387985707.475707,
        ],
    ],
    [
        1442793600000,
        [
            -7040990863.082282,
            -1609102031.478469,
            3379847440.073034,
        ],
    ],
    [
        1443398400000,
        [
            -7040572865.887081,
            -1627597311.737189,
            3371674478.429362,
        ],
    ],
    [
        1444003200000,
        [
            -7038013655.58584,
            -1645942843.920354,
            3363566047.903616,
        ],
    ],
    [
        1444608000000,
        [
            -7033328119.690729,
            -1663910430.285928,
            3355622009.021091,
        ],
    ],
    [
        1445212800000,
        [
            -7026566673.487233,
            -1681255729.932643,
            3347947210.630005,
        ],
    ],
    [
        1445817600000,
        [
            -7017828360.078682,
            -1697742884.36598,
            3340643041.865842,
        ],
    ],
    [
        1446422400000,
        [
            -7007241784.012011,
            -1713165120.962334,
            3333800297.033242,
        ],
    ],
    [
        1447027200000,
        [
            -6994942878.933161,
            -1727325169.240981,
            3327505222.734149,
        ],
    ],
    [
        1447632000000,
        [
            -6981102433.017125,
            -1740024746.782326,
            3321842604.702744,
        ],
    ],
    [
        1448236800000,
        [
            -6965933819.055632,
            -1751090834.257239,
            3316886795.502307,
        ],
    ],
    [
        1448841600000,
        [
            -6949668531.938646,
            -1760392718.154769,
            3312695729.152161,
        ],
    ],
    [
        1449446400000,
        [
            -6932536391.830303,
            -1767818966.744371,
            3309318182.755052,
        ],
    ],
    [
        1450051200000,
        [
            -6914792231.175638,
            -1773270146.227546,
            3306796026.091664,
        ],
    ],
    [
        1450656000000,
        [
            -6896718660.456968,
            -1776684757.859573,
            3305155505.677177,
        ],
    ],
    [
        1451260800000,
        [
            -6878596948.372075,
            -1778051096.317307,
            3304403057.71734,
        ],
    ],
    [
        1451865600000,
        [
            -6860691137.942892,
            -1777379813.137936,
            3304534244.704208,
        ],
    ],
    [
        1452470400000,
        [
            -6843273953.18793,
            -1774699187.95597,
            3305535530.248868,
        ],
    ],
    [
        1453075200000,
        [
            -6826626017.272373,
            -1770079018.894623,
            3307376492.791715,
        ],
    ],
    [
        1453680000000,
        [
            -6811004270.66996,
            -1763636446.431399,
            3310007786.290951,
        ],
    ],
    [
        1454284800000,
        [
            -6796632143.258263,
            -1755504052.55677,
            3313371823.628321,
        ],
    ],
    [
        1454889600000,
        [
            -6783725695.122982,
            -1745827842.572628,
            3317404018.555316,
        ],
    ],
    [
        1455494400000,
        [
            -6772490979.593664,
            -1734788608.438681,
            3322026068.858729,
        ],
    ],
    [
        1456099200000,
        [
            -6763092655.310378,
            -1722602263.35026,
            3327145847.956522,
        ],
    ],
    [
        1456704000000,
        [
            -6755651863.277446,
            -1709484961.731261,
            3332669272.626683,
        ],
    ],
    [
        1457308800000,
        [
            -6750273420.28141,
            -1695654843.021302,
            3338500511.891265,
        ],
    ],
    [
        1457913600000,
        [
            -6747042141.785452,
            -1681351619.251681,
            3344535933.213201,
        ],
    ],
    [
        1458518400000,
        [
            -6745993384.922267,
            -1666832821.499224,
            3350665347.58261,
        ],
    ],
    [
        1459123200000,
        [
            -6747118838.328819,
            -1652338372.771678,
            3356784137.165248,
        ],
    ],
    [
        1459728000000,
        [
            -6750394526.453079,
            -1638097210.550205,
            3362791867.233749,
        ],
    ],
    [
        1460332800000,
        [
            -6755775673.190304,
            -1624346142.641436,
            3368586363.080966,
        ],
    ],
    [
        1460937600000,
        [
            -6763169593.703236,
            -1611323098.981678,
            3374065835.171842,
        ],
    ],
    [
        1461542400000,
        [
            -6772448373.420626,
            -1599233451.122208,
            3379140446.476558,
        ],
    ],
    [
        1462147200000,
        [
            -6783476545.807095,
            -1588261873.164341,
            3383729077.288089,
        ],
    ],
    [
        1462752000000,
        [
            -6796103519.78782,
            -1578590977.4905,
            3387753248.60839,
        ],
    ],
    [
        1463356800000,
        [
            -6810138583.522248,
            -1570391777.231841,
            3391140006.874993,
        ],
    ],
    [
        1463961600000,
        [
            -6825369111.835805,
            -1563793356.484324,
            3393832413.247211,
        ],
    ],
    [
        1464566400000,
        [
            -6841586561.42809,
            -1558899479.45224,
            3395784586.803576,
        ],
    ],
    [
        1465171200000,
        [
            -6858575765.572225,
            -1555806895.700842,
            3396955479.283122,
        ],
    ],
    [
        1465776000000,
        [
            -6876091928.846821,
            -1554592627.096677,
            3397312655.526091,
        ],
    ],
    [
        1466380800000,
        [
            -6893883282.094866,
            -1555288012.84715,
            3396841397.320683,
        ],
    ],
    [
        1466985600000,
        [
            -6911714263.258464,
            -1557899151.355464,
            3395538346.592792,
        ],
    ],
    [
        1467590400000,
        [
            -6929351586.217073,
            -1562424495.10962,
            3393405272.471789,
        ],
    ],
    [
        1468195200000,
        [
            -6946543479.230525,
            -1568838591.113037,
            3390453907.363288,
        ],
    ],
    [
        1468800000000,
        [
            -6963046034.630009,
            -1577071243.011136,
            3386713425.497703,
        ],
    ],
    [
        1469404800000,
        [
            -6978642716.697145,
            -1587030871.922921,
            3382223001.169173,
        ],
    ],
    [
        1470009600000,
        [
            -6993127547.767714,
            -1598621065.158328,
            3377025709.046887,
        ],
    ],
    [
        1470614400000,
        [
            -7006287033.05127,
            -1611720831.927932,
            3371174432.945023,
        ],
    ],
    [
        1471219200000,
        [
            -7017929524.634836,
            -1626169495.330784,
            3364737491.44815,
        ],
    ],
    [
        1471824000000,
        [
            -7027900321.81672,
            -1641792258.269011,
            3357790319.969711,
        ],
    ],
    [
        1472428800000,
        [
            -7036062384.698215,
            -1658415483.207676,
            3350409603.2736,
        ],
    ],
    [
        1473033600000,
        [
            -7042281239.460241,
            -1675844043.483244,
            3342680100.541236,
        ],
    ],
    [
        1473638400000,
        [
            -7046456460.186189,
            -1693852369.031718,
            3334698239.948468,
        ],
    ],
    [
        1474243200000,
        [
            -7048531586.869748,
            -1712211666.046175,
            3326563052.058728,
        ],
    ],
    [
        1474848000000,
        [
            -7048472503.291607,
            -1730703638.6575,
            3318370644.886267,
        ],
    ],
    [
        1475452800000,
        [
            -7046255224.04359,
            -1749095807.259283,
            3310221711.905811,
        ],
    ],
    [
        1476057600000,
        [
            -7041898217.969191,
            -1767138709.107113,
            3302223076.4048,
        ],
    ],
    [
        1476662400000,
        [
            -7035466305.174343,
            -1784594137.525687,
            3294478051.683654,
        ],
    ],
    [
        1477267200000,
        [
            -7027046453.546032,
            -1801246603.501122,
            3287081516.146407,
        ],
    ],
    [
        1477872000000,
        [
            -7016738037.492101,
            -1816877320.571278,
            3280127970.619618,
        ],
    ],
    [
        1478476800000,
        [
            -7004684465.126245,
            -1831266845.191058,
            3273711311.461123,
        ],
    ],
    [
        1479081600000,
        [
            -6991070456.727117,
            -1844223282.360557,
            3267915001.8325,
        ],
    ],
    [
        1479686400000,
        [
            -6976094971.074829,
            -1855590101.692927,
            3262808283.667051,
        ],
    ],
    [
        1480291200000,
        [
            -6959963774.605637,
            -1865218894.071851,
            3258454891.936551,
        ],
    ],
    [
        1480896000000,
        [
            -6942919083.074233,
            -1872975978.383707,
            3254911661.553959,
        ],
    ],
    [
        1481500800000,
        [
            -6925230515.022046,
            -1878769029.307511,
            3252219136.546902,
        ],
    ],
    [
        1482105600000,
        [
            -6907165554.585365,
            -1882549425.553449,
            3250399660.14219,
        ],
    ],
    [
        1482710400000,
        [
            -6888985286.959663,
            -1884283406.546423,
            3249467019.116606,
        ],
    ],
    [
        1483315200000,
        [
            -6870971644.357761,
            -1883960999.464773,
            3249424548.842374,
        ],
    ],
    [
        1483920000000,
        [
            -6853413682.324594,
            -1881619582.846156,
            3250256808.765912,
        ],
    ],
    [
        1484524800000,
        [
            -6836577160.359697,
            -1877339470.672283,
            3251930102.576906,
        ],
    ],
    [
        1485129600000,
        [
            -6820705439.609243,
            -1871213443.766616,
            3254403146.824228,
        ],
    ],
    [
        1485734400000,
        [
            -6806044826.218374,
            -1863357206.29163,
            3257624928.031747,
        ],
    ],
    [
        1486339200000,
        [
            -6792828642.037304,
            -1853929306.000066,
            3261527690.323995,
        ],
    ],
    [
        1486944000000,
        [
            -6781248139.935647,
            -1843120174.871012,
            3266029830.781583,
        ],
    ],
    [
        1487548800000,
        [
            -6771460647.628105,
            -1831121116.76737,
            3271047197.81059,
        ],
    ],
    [
        1488153600000,
        [
            -6763613550.749711,
            -1818136836.999408,
            3276490342.762503,
        ],
    ],
    [
        1488758400000,
        [
            -6757828073.318852,
            -1804402236.439064,
            3282258568.259116,
        ],
    ],
    [
        1489363200000,
        [
            -6754173189.717416,
            -1790166564.880512,
            3288244571.541297,
        ],
    ],
    [
        1489968000000,
        [
            -6752681812.107872,
            -1775663819.016653,
            3294345596.849218,
        ],
    ],
    [
        1490572800000,
        [
            -6753373153.856014,
            -1761128537.768119,
            3300459444.491787,
        ],
    ],
    [
        1491177600000,
        [
            -6756236676.169025,
            -1746810333.953651,
            3306479143.102434,
        ],
    ],
    [
        1491782400000,
        [
            -6761209527.706676,
            -1732955117.554456,
            3312298603.584889,
        ],
    ],
    [
        1492387200000,
        [
            -6768199931.807693,
            -1719778800.361268,
            3317822871.945275,
        ],
    ],
    [
        1492992000000,
        [
            -6777106952.544736,
            -1707487095.345997,
            3322962470.813344,
        ],
    ],
    [
        1493596800000,
        [
            -6787803976.406666,
            -1696288184.881115,
            3327628448.452524,
        ],
    ],
    [
        1494201600000,
        [
            -6800119549.08235,
            -1686372246.961113,
            3331738600.471244,
        ],
    ],
    [
        1494806400000,
        [
            -6813866185.835077,
            -1677889690.678415,
            3335226360.895749,
        ],
    ],
    [
        1495411200000,
        [
            -6828856508.274015,
            -1670974777.957317,
            3338033474.183447,
        ],
    ],
    [
        1496016000000,
        [
            -6844885445.576506,
            -1665756264.81549,
            3340105448.435335,
        ],
    ],
    [
        1496620800000,
        [
            -6861714395.792539,
            -1662335633.9227,
            3341398233.331328,
        ],
    ],
    [
        1497225600000,
        [
            -6879103614.547686,
            -1660770506.47803,
            3341885507.177547,
        ],
    ],
    [
        1497830400000,
        [
            -6896824140.629805,
            -1661101250.325586,
            3341549972.574879,
        ],
    ],
    [
        1498435200000,
        [
            -6914638315.42516,
            -1663359238.664085,
            3340379360.02141,
        ],
    ],
    [
        1499040000000,
        [
            -6932287559.366217,
            -1667543791.662153,
            3338373617.9417,
        ],
    ],
    [
        1499644800000,
        [
            -6949526797.816833,
            -1673611170.880193,
            3335550410.367935,
        ],
    ],
    [
        1500249600000,
        [
            -6966132017.20923,
            -1681503137.599463,
            3331935424.947666,
        ],
    ],
    [
        1500854400000,
        [
            -6981879144.585932,
            -1691152663.562175,
            3327559026.396162,
        ],
    ],
    [
        1501459200000,
        [
            -6996535938.601251,
            -1702459648.908153,
            3322464000.842893,
        ],
    ],
    [
        1502064000000,
        [
            -7009897176.665944,
            -1715285908.246431,
            3316709035.600674,
        ],
    ],
    [
        1502668800000,
        [
            -7021787815.975776,
            -1729484717.487257,
            3310358383.395086,
        ],
    ],
    [
        1503273600000,
        [
            -7032040474.866865,
            -1744904127.855295,
            3303479157.177845,
        ],
    ],
    [
        1503878400000,
        [
            -7040491797.025065,
            -1761361801.937051,
            3296149569.399758,
        ],
    ],
    [
        1504483200000,
        [
            -7047017179.608711,
            -1778646404.362478,
            3288460147.195319,
        ],
    ],
    [
        1505088000000,
        [
            -7051529332.286419,
            -1796547276.010311,
            3280503027.147751,
        ],
    ],
    [
        1505692800000,
        [
            -7053954525.402382,
            -1814855669.530639,
            3272369826.761786,
        ],
    ],
    [
        1506297600000,
        [
            -7054233311.084758,
            -1833339257.743957,
            3264160240.461489,
        ],
    ],
    [
        1506902400000,
        [
            -7052353453.093306,
            -1851750110.64535,
            3255980845.65485,
        ],
    ],
    [
        1507507200000,
        [
            -7048343349.053216,
            -1869853570.328671,
            3247934318.069438,
        ],
    ],
    [
        1508112000000,
        [
            -7042247008.250056,
            -1887427508.411686,
            3240117901.924703,
        ],
    ],
    [
        1508716800000,
        [
            -7034128422.433062,
            -1904236986.195693,
            3232632263.218913,
        ],
    ],
    [
        1509321600000,
        [
            -7024101292.717229,
            -1920048365.354221,
            3225578019.847912,
        ],
    ],
    [
        1509926400000,
        [
            -7012316653.409933,
            -1934656143.963084,
            3219045324.627729,
        ],
    ],
    [
        1510531200000,
        [
            -6998936546.939754,
            -1947879665.129344,
            3213113222.979506,
        ],
    ],
    [
        1511136000000,
        [
            -6984141089.413986,
            -1959537997.909565,
            3207858830.682563,
        ],
    ],
    [
        1511740800000,
        [
            -6968153958.147277,
            -1969468794.237193,
            3203352123.516974,
        ],
    ],
    [
        1512345600000,
        [
            -6951224067.74189,
            -1977551483.627821,
            3199646540.642052,
        ],
    ],
    [
        1512950400000,
        [
            -6933598491.94758,
            -1983700091.980211,
            3196779837.47841,
        ],
    ],
    [
        1513555200000,
        [
            -6915531837.628342,
            -1987838020.851276,
            3194783789.407873,
        ],
    ],
    [
        1514160000000,
        [
            -6897307434.858856,
            -1989919599.893091,
            3193678052.091098,
        ],
    ],
    [
        1514764800000,
        [
            -6879214143.741822,
            -1989948173.639102,
            3193462433.034196,
        ],
    ],
    [
        1515369600000,
        [
            -6861520132.84419,
            -1987963592.448075,
            3194119896.131432,
        ],
    ],
    [
        1515974400000,
        [
            -6844485387.885557,
            -1984016840.349434,
            3195626840.842882,
        ],
    ],
    [
        1516579200000,
        [
            -6828379582.379113,
            -1978192540.677801,
            3197946675.441999,
        ],
    ],
    [
        1517184000000,
        [
            -6813456283.284477,
            -1970621492.541382,
            3201024006.906987,
        ],
    ],
    [
        1517788800000,
        [
            -6799929868.915864,
            -1961462416.399784,
            3204790026.157619,
        ],
    ],
    [
        1518393600000,
        [
            -6787992787.014488,
            -1950877452.062246,
            3209172947.819507,
        ],
    ],
    [
        1518998400000,
        [
            -6777831180.934215,
            -1939055068.218717,
            3214091367.325666,
        ],
    ],
    [
        1519603200000,
        [
            -6769598858.675401,
            -1926217970.73715,
            3219450051.694921,
        ],
    ],
    [
        1520208000000,
        [
            -6763399111.095719,
            -1912600161.446226,
            3225147309.556204,
        ],
    ],
    [
        1520812800000,
        [
            -6759307823.763622,
            -1898425334.457253,
            3231084757.279457,
        ],
    ],
    [
        1521417600000,
        [
            -6757386916.949554,
            -1883930661.41982,
            3237160062.474979,
        ],
    ],
    [
        1522022400000,
        [
            -6757659391.57582,
            -1869371580.901392,
            3243263748.73607,
        ],
    ],
    [
        1522627200000,
        [
            -6760096470.641882,
            -1854996012.36279,
            3249287831.960011,
        ],
    ],
    [
        1523232000000,
        [
            -6764646313.011235,
            -1841027703.322253,
            3255134063.238483,
        ],
    ],
    [
        1523836800000,
        [
            -6771244221.466432,
            -1827691415.294341,
            3260705671.386091,
        ],
    ],
    [
        1524441600000,
        [
            -6779788920.486532,
            -1815215590.506986,
            3265904780.864345,
        ],
    ],
    [
        1525046400000,
        [
            -6790134428.086349,
            -1803805346.962721,
            3270641696.640423,
        ],
    ],
    [
        1525651200000,
        [
            -6802123028.36266,
            -1793631986.11794,
            3274841107.795348,
        ],
    ],
    [
        1526256000000,
        [
            -6815590956.161877,
            -1784859495.837358,
            3278432768.887595,
        ],
    ],
    [
        1526860800000,
        [
            -6830345597.48491,
            -1777645213.243023,
            3281349493.94502,
        ],
    ],
    [
        1527465600000,
        [
            -6846161354.197613,
            -1772112614.871157,
            3283536725.803032,
        ],
    ],
    [
        1528070400000,
        [
            -6862815173.595331,
            -1768347255.501097,
            3284956545.599336,
        ],
    ],
    [
        1528675200000,
        [
            -6880086963.954288,
            -1766423976.726438,
            3285577519.441245,
        ],
    ],
    [
        1529280000000,
        [
            -6897737537.95744,
            -1766405193.278989,
            3285373456.205935,
        ],
    ],
    [
        1529884800000,
        [
            -6915508140.432678,
            -1768314077.597954,
            3284333064.094747,
        ],
    ],
    [
        1530489600000,
        [
            -6933156935.335938,
            -1772136666.484168,
            3282461787.316013,
        ],
    ],
    [
        1531094400000,
        [
            -6950454132.750841,
            -1777849043.153709,
            3279771139.205399,
        ],
    ],
    [
        1531699200000,
        [
            -6967160741.764572,
            -1785412908.599426,
            3276278415.849463,
        ],
    ],
    [
        1532304000000,
        [
            -6983031861.1415,
            -1794749676.50941,
            3272016283.826402,
        ],
    ],
    [
        1532908800000,
        [
            -6997852680.927475,
            -1805748369.598791,
            3267032460.755093,
        ],
    ],
    [
        1533513600000,
        [
            -7011428751.723053,
            -1818292193.446107,
            3261378814.020392,
        ],
    ],
    [
        1534118400000,
        [
            -7023565666.171095,
            -1832251376.485232,
            3255112095.015657,
        ],
    ],
    [
        1534723200000,
        [
            -7034076358.371696,
            -1847458786.317032,
            3248303277.423555,
        ],
    ],
    [
        1535328000000,
        [
            -7042815177.088884,
            -1863723327.601511,
            3241035029.187291,
        ],
    ],
    [
        1535932800000,
        [
            -7049663777.14253,
            -1880855465.402979,
            3233390793.603323,
        ],
    ],
    [
        1536537600000,
        [
            -7054511648.010426,
            -1898657640.028334,
            3225456476.867397,
        ],
    ],
    [
        1537142400000,
        [
            -7057267454.438875,
            -1916902065.926754,
            3217329341.808278,
        ],
    ],
    [
        1537747200000,
        [
            -7057889578.14078,
            -1935349375.190987,
            3209113214.253754,
        ],
    ],
    [
        1538352000000,
        [
            -7056367862.490783,
            -1953772540.773199,
            3200907788.812355,
        ],
    ],
    [
        1538956800000,
        [
            -7052704579.328333,
            -1971945251.095247,
            3192811171.658343,
        ],
    ],
    [
        1539561600000,
        [
            -7046929373.943349,
            -1989622342.883881,
            3184928211.552258,
        ],
    ],
    [
        1540166400000,
        [
            -7039124552.995398,
            -2006563166.787178,
            3177363536.822895,
        ],
    ],
    [
        1540771200000,
        [
            -7029402651.433698,
            -2022552906.27508,
            3170211510.97616,
        ],
    ],
    [
        1541376000000,
        [
            -7017887295.546672,
            -2037388973.151268,
            3163559667.091761,
        ],
    ],
    [
        1541980800000,
        [
            -7004730916.549468,
            -2050863952.908999,
            3157496572.756119,
        ],
    ],
    [
        1542585600000,
        [
            -6990133381.593213,
            -2062792531.978693,
            3152103113.483318,
        ],
    ],
    [
        1543190400000,
        [
            -6974315489.057455,
            -2073028577.866125,
            3147443815.596734,
        ],
    ],
    [
        1543795200000,
        [
            -6957499653.432946,
            -2081449013.458537,
            3143571463.283493,
        ],
    ],
    [
        1544400000000,
        [
            -6939929662.972718,
            -2087938493.773953,
            3140534823.122825,
        ],
    ],
    [
        1545004800000,
        [
            -6921882339.545091,
            -2092418120.451044,
            3138368881.273441,
        ],
    ],
    [
        1545609600000,
        [
            -6903637892.609508,
            -2094856442.59832,
            3137088369.365243,
        ],
    ],
    [
        1546214400000,
        [
            -6885461568.687682,
            -2095249952.592584,
            3136693996.144327,
        ],
    ],
    [
        1546819200000,
        [
            -6867625505.491093,
            -2093608626.454843,
            3137180330.759584,
        ],
    ],
    [
        1547424000000,
        [
            -6850414618.200086,
            -2089984700.649105,
            3138525700.741045,
        ],
    ],
    [
        1548028800000,
        [
            -6834095765.481674,
            -2084476563.329446,
            3140688436.726164,
        ],
    ],
    [
        1548633600000,
        [
            -6818902658.304598,
            -2077205575.341828,
            3143614930.387938,
        ],
    ],
    [
        1549238400000,
        [
            -6805060587.433722,
            -2068302582.889617,
            3147247513.024816,
        ],
    ],
    [
        1549843200000,
        [
            -6792788532.176513,
            -2057935955.298438,
            3151514307.082628,
        ],
    ],
    [
        1550448000000,
        [
            -6782269343.273369,
            -2046308965.044616,
            3156328014.40379,
        ],
    ],
    [
        1551052800000,
        [
            -6773640202.916295,
            -2033633806.921075,
            3161595512.767503,
        ],
    ],
    [
        1551657600000,
        [
            -6767020812.562666,
            -2020120584.565675,
            3167224983.296253,
        ],
    ],
    [
        1552262400000,
        [
            -6762513056.941116,
            -2006004755.041393,
            3173115559.577528,
        ],
    ],
    [
        1552867200000,
        [
            -6760173531.443794,
            -1991539849.228441,
            3179157949.855438,
        ],
    ],
    [
        1553472000000,
        [
            -6760010574.044183,
            -1976970318.294966,
            3185244939.213258,
        ],
    ],
    [
        1554076800000,
        [
            -6762015486.546521,
            -1962525101.243157,
            3191276803.714462,
        ],
    ],
    [
        1554681600000,
        [
            -6766159680.919018,
            -1948444724.098171,
            3197150540.009014,
        ],
    ],
    [
        1555286400000,
        [
            -6772369734.328527,
            -1934971247.939615,
            3202761590.62149,
        ],
    ],
    [
        1555891200000,
        [
            -6780530581.573266,
            -1922321407.088335,
            3208014662.199467,
        ],
    ],
    [
        1556496000000,
        [
            -6790518442.170796,
            -1910686326.960338,
            3212826715.096511,
        ],
    ],
    [
        1557100800000,
        [
            -6802194522.538092,
            -1900257935.935064,
            3217115848.173176,
        ],
    ],
    [
        1557705600000,
        [
            -6815382298.136183,
            -1891217225.088006,
            3220803730.240689,
        ],
    ],
    [
        1558310400000,
        [
            -6829875783.824679,
            -1883708530.14411,
            3223826379.855815,
        ],
    ],
    [
        1558915200000,
        [
            -6845472614.673305,
            -1877845958.58725,
            3226134438.747455,
        ],
    ],
    [
        1559520000000,
        [
            -6861963490.237876,
            -1873738250.685271,
            3227682074.049632,
        ],
    ],
    [
        1560124800000,
        [
            -6879111585.376619,
            -1871475667.594257,
            3228430050.15423,
        ],
    ],
    [
        1560729600000,
        [
            -6896664881.625928,
            -1871105852.886693,
            3228356264.954211,
        ],
    ],
    [
        1561334400000,
        [
            -6914388101.207527,
            -1872646736.871401,
            3227453325.745891,
        ],
    ],
    [
        1561939200000,
        [
            -6932047676.463876,
            -1876108948.679947,
            3225717895.977058,
        ],
    ],
    [
        1562544000000,
        [
            -6949393554.962178,
            -1881481341.278636,
            3223154487.7681,
        ],
    ],
    [
        1563148800000,
        [
            -6966174897.896983,
            -1888708837.76172,
            3219785546.047772,
        ],
    ],
    [
        1563753600000,
        [
            -6982169858.698974,
            -1897711189.298797,
            3215646479.2367,
        ],
    ],
    [
        1564358400000,
        [
            -6997166378.412679,
            -1908402390.732115,
            3210775755.988415,
        ],
    ],
    [
        1564963200000,
        [
            -7010946776.467235,
            -1920674910.61784,
            3205219478.319664,
        ],
    ],
    [
        1565568000000,
        [
            -7023306347.11083,
            -1934380125.670532,
            3199040729.909482,
        ],
    ],
    [
        1566172800000,
        [
            -7034080050.04884,
            -1949352172.194227,
            3192312240.390179,
        ],
    ],
    [
        1566777600000,
        [
            -7043119626.466091,
            -1965424251.365067,
            3185107365.791854,
        ],
    ],
    [
        1567382400000,
        [
            -7050281143.936903,
            -1982411800.501153,
            3177505416.329341,
        ],
    ],
    [
        1567987200000,
        [
            -7055446018.357556,
            -2000096301.037269,
            3169599933.543298,
        ],
    ],
    [
        1568592000000,
        [
            -7058543499.904194,
            -2018253369.84136,
            3161489194.563239,
        ],
    ],
    [
        1569196800000,
        [
            -7059524500.040003,
            -2036666064.006493,
            3153268115.802773,
        ],
    ],
    [
        1569801600000,
        [
            -7058351770.663336,
            -2055107262.738184,
            3145034269.672418,
        ],
    ],
    [
        1570406400000,
        [
            -7055022678.481767,
            -2073327557.411772,
            3136894805.383362,
        ],
    ],
    [
        1571011200000,
        [
            -7049586067.466501,
            -2091086488.926475,
            3128955125.509563,
        ],
    ],
    [
        1571616000000,
        [
            -7042113003.94041,
            -2108162755.119353,
            3121311836.731355,
        ],
    ],
    [
        1572220800000,
        [
            -7032688787.984484,
            -2124335799.133324,
            3114059479.353349,
        ],
    ],
    [
        1572825600000,
        [
            -7021436632.730815,
            -2139377980.01115,
            3107296017.440099,
        ],
    ],
    [
        1573430400000,
        [
            -7008527434.93108,
            -2153087390.943451,
            3101110270.688772,
        ],
    ],
    [
        1574035200000,
        [
            -6994147769.795947,
            -2165294224.308103,
            3095576321.499475,
        ],
    ],
    [
        1574640000000,
        [
            -6978492926.403174,
            -2175841033.121296,
            3090761180.951147,
        ],
    ],
    [
        1575244800000,
        [
            -6961790873.936377,
            -2184578557.075961,
            3086729098.079112,
        ],
    ],
    [
        1575849600000,
        [
            -6944304139.629045,
            -2191398090.712822,
            3083528574.985044,
        ],
    ],
    [
        1576454400000,
        [
            -6926296138.466282,
            -2196232616.551364,
            3081188944.712059,
        ],
    ],
    [
        1577059200000,
        [
            -6908025259.776653,
            -2199034890.808015,
            3079729314.740307,
        ],
    ],
    [
        1577664000000,
        [
            -6889769291.416874,
            -2199775758.952403,
            3079162131.7535,
        ],
    ],
    [
        1578268800000,
        [
            -6871820005.854797,
            -2198474172.542613,
            3079480579.916831,
        ],
    ],
    [
        1578873600000,
        [
            -6854450006.772538,
            -2195191849.504802,
            3080658003.073403,
        ],
    ],
    [
        1579478400000,
        [
            -6837909199.498427,
            -2190008859.39384,
            3082658253.250069,
        ],
    ],
    [
        1580083200000,
        [
            -6822450614.2674,
            -2183023661.817309,
            3085438719.253295,
        ],
    ],
    [
        1580688000000,
        [
            -6808319562.832512,
            -2174379918.974351,
            3088938476.598062,
        ],
    ],
    [
        1581292800000,
        [
            -6795723614.695111,
            -2164254661.773741,
            3093080687.822636,
        ],
    ],
    [
        1581897600000,
        [
            -6784833428.716605,
            -2152832325.106684,
            3097783972.292464,
        ],
    ],
    [
        1582502400000,
        [
            -6775810731.638027,
            -2140306898.280158,
            3102964572.150148,
        ],
    ],
    [
        1583107200000,
        [
            -6768793995.314562,
            -2126905966.565054,
            3108525082.164141,
        ],
    ],
    [
        1583712000000,
        [
            -6763873255.29516,
            -2112873790.901759,
            3114359304.270412,
        ],
    ],
    [
        1584316800000,
        [
            -6761096618.738927,
            -2098445730.256738,
            3120363853.306082,
        ],
    ],
    [
        1584921600000,
        [
            -6760499967.963678,
            -2083853762.274689,
            3126438771.129568,
        ],
    ],
    [
        1585526400000,
        [
            -6762090140.0845,
            -2069348603.836463,
            3132476493.891288,
        ],
    ],
    [
        1586131200000,
        [
            -6765824748.209463,
            -2055179645.647124,
            3138368366.724919,
        ],
    ],
    [
        1586736000000,
        [
            -6771624400.686538,
            -2041571599.722734,
            3144015729.564804,
        ],
    ],
    [
        1587340800000,
        [
            -6779402540.536018,
            -2028734567.796864,
            3149328363.770042,
        ],
    ],
    [
        1587945600000,
        [
            -6789046180.512606,
            -2016884472.69416,
            3154213645.259491,
        ],
    ],
    [
        1588550400000,
        [
            -6800399905.049139,
            -2006221354.583002,
            3158584083.549483,
        ],
    ],
    [
        1589155200000,
        [
            -6813282992.683271,
            -1996909244.350175,
            3162367459.779572,
        ],
    ],
    [
        1589760000000,
        [
            -6827517477.576843,
            -1989091277.420757,
            3165502805.893763,
        ],
    ],
    [
        1590364800000,
        [
            -6842906289.53202,
            -1982907825.463583,
            3167930101.33027,
        ],
    ],
    [
        1590969600000,
        [
            -6859220606.845587,
            -1978473992.650287,
            3169598475.294383,
        ],
    ],
    [
        1591574400000,
        [
            -6876220920.444825,
            -1975862954.580395,
            3170475260.513736,
        ],
    ],
    [
        1592179200000,
        [
            -6893681776.010469,
            -1975125985.775014,
            3170539476.699703,
        ],
    ],
    [
        1592784000000,
        [
            -6911367481.787846,
            -1976307314.021472,
            3169772623.193294,
        ],
    ],
    [
        1593388800000,
        [
            -6929022481.738266,
            -1979421313.274172,
            3168167340.075466,
        ],
    ],
    [
        1593993600000,
        [
            -6946395552.942827,
            -1984439270.925779,
            3165735324.954199,
        ],
    ],
    [
        1594598400000,
        [
            -6963260242.032922,
            -1991313886.295272,
            3162498427.198801,
        ],
    ],
    [
        1595203200000,
        [
            -6979388662.929272,
            -1999990051.165228,
            3158481020.777425,
        ],
    ],
    [
        1595808000000,
        [
            -6994544999.380724,
            -2010382224.67789,
            3153718954.379526,
        ],
    ],
    [
        1596412800000,
        [
            -7008512084.644346,
            -2022364670.160891,
            3148266221.293341,
        ],
    ],
    [
        1597017600000,
        [
            -7021106894.121046,
            -2035799854.916856,
            3142183828.739295,
        ],
    ],
    [
        1597622400000,
        [
            -7032153025.065381,
            -2050544833.022144,
            3135534009.86001,
        ],
    ],
    [
        1598227200000,
        [
            -7041477520.480232,
            -2066429412.221364,
            3128389253.993771,
        ],
    ],
    [
        1598832000000,
        [
            -7048938931.293192,
            -2083250122.241397,
            3120837524.140496,
        ],
    ],
    [
        1599436800000,
        [
            -7054437329.28276,
            -2100801820.248806,
            3112969135.336575,
        ],
    ],
    [
        1600041600000,
        [
            -7057885836.475429,
            -2118879795.570113,
            3104872849.573472,
        ],
    ],
    [
        1600646400000,
        [
            -7059210685.596997,
            -2137259307.292095,
            3096644781.77525,
        ],
    ],
    [
        1601251200000,
        [
            -7058379564.968169,
            -2155693630.05853,
            3088391939.82308,
        ],
    ],
    [
        1601856000000,
        [
            -7055405522.823893,
            -2173947855.924613,
            3080217511.280941,
        ],
    ],
    [
        1602460800000,
        [
            -7050317528.18095,
            -2191796991.882054,
            3072218794.337162,
        ],
    ],
    [
        1603065600000,
        [
            -7043163224.892684,
            -2209007076.982564,
            3064495904.804238,
        ],
    ],
    [
        1603670400000,
        [
            -7034036143.002406,
            -2225337412.384346,
            3057153528.184476,
        ],
    ],
    [
        1604275200000,
        [
            -7023072807.195072,
            -2240574969.657227,
            3050285315.736804,
        ],
    ],
    [
        1604880000000,
        [
            -7010422153.089081,
            -2254528457.609957,
            3043973712.829163,
        ],
    ],
    [
        1605484800000,
        [
            -6996250196.45478,
            -2267010499.632371,
            3038298672.14851,
        ],
    ],
    [
        1606089600000,
        [
            -6980764946.613215,
            -2277843577.530003,
            3033337750.572805,
        ],
    ],
    [
        1606694400000,
        [
            -6964206376.880576,
            -2286892784.449228,
            3029150656.203215,
        ],
    ],
    [
        1607299200000,
        [
            -6946815079.797814,
            -2294055300.901332,
            3025781272.594268,
        ],
    ],
    [
        1607904000000,
        [
            -6928838495.625937,
            -2299242435.0053,
            3023266841.853238,
        ],
    ],
    [
        1608508800000,
        [
            -6910553328.621397,
            -2302388298.017149,
            3021636748.406748,
        ],
    ],
    [
        1609113600000,
        [
            -6892248983.876215,
            -2303478461.984003,
            3020898349.417354,
        ],
    ],
    [
        1609718400000,
        [
            -6874197143.777048,
            -2302534162.02839,
            3021041584.896245,
        ],
    ],
    [
        1610323200000,
        [
            -6856660189.115613,
            -2299593128.474869,
            3022049011.887673,
        ],
    ],
    [
        1610928000000,
        [
            -6839912141.087,
            -2294720184.388891,
            3023893536.307916,
        ],
    ],
    [
        1611532800000,
        [
            -6824217228.375431,
            -2288030243.438775,
            3026526259.089365,
        ],
    ],
    [
        1612137600000,
        [
            -6809803154.018186,
            -2279667356.557767,
            3029883750.912266,
        ],
    ],
    [
        1612742400000,
        [
            -6796873015.291487,
            -2269784482.701366,
            3033898789.811037,
        ],
    ],
    [
        1613347200000,
        [
            -6785626190.345773,
            -2258556082.143581,
            3038496917.370316,
        ],
    ],
    [
        1613952000000,
        [
            -6776233943.238358,
            -2246195474.962867,
            3043586331.316835,
        ],
    ],
    [
        1614556800000,
        [
            -6768818866.128121,
            -2232930096.55586,
            3049067348.043151,
        ],
    ],
    [
        1615161600000,
        [
            -6763471184.569861,
            -2218981793.191941,
            3054843098.712315,
        ],
    ],
    [
        1615766400000,
        [
            -6760270088.964708,
            -2204582215.017259,
            3060814478.694623,
        ],
    ],
    [
        1616371200000,
        [
            -6759257523.630623,
            -2189985665.633475,
            3066871646.044699,
        ],
    ],
    [
        1616976000000,
        [
            -6760424743.929938,
            -2175442531.08658,
            3072904874.612048,
        ],
    ],
    [
        1617580800000,
        [
            -6763732781.300734,
            -2161182168.426027,
            3078814275.82406,
        ],
    ],
    [
        1618185600000,
        [
            -6769133323.376096,
            -2147431770.469804,
            3084502796.493582,
        ],
    ],
    [
        1618790400000,
        [
            -6776540950.133347,
            -2134425795.770335,
            3089868926.376032,
        ],
    ],
    [
        1619395200000,
        [
            -6785826218.492352,
            -2122379132.737846,
            3094818255.423121,
        ],
    ],
    [
        1620000000000,
        [
            -6796839286.940399,
            -2111474052.832899,
            3099271543.510657,
        ],
    ],
    [
        1620604800000,
        [
            -6809428679.27577,
            -2101882515.984283,
            3103155754.280711,
        ],
    ],
    [
        1621209600000,
        [
            -6823412022.142931,
            -2093772550.057695,
            3106397927.026128,
        ],
    ],
    [
        1621814400000,
        [
            -6838574451.810729,
            -2087281940.432641,
            3108937039.474617,
        ],
    ],
    [
        1622419200000,
        [
            -6854694357.647609,
            -2082509832.18645,
            3110730119.793796,
        ],
    ],
    [
        1623024000000,
        [
            -6871558435.232409,
            -2079541867.954676,
            3111741555.235917,
        ],
    ],
    [
        1623628800000,
        [
            -6888931364.636994,
            -2078453286.211498,
            3111938390.449878,
        ],
    ],
    [
        1624233600000,
        [
            -6906558488.472573,
            -2079283468.594321,
            3111302271.759674,
        ],
    ],
    [
        1624838400000,
        [
            -6924192959.165287,
            -2082032220.626374,
            3109833527.45355,
        ],
    ],
    [
        1625443200000,
        [
            -6941605936.022487,
            -2086686972.240062,
            3107539044.41655,
        ],
    ],
    [
        1626048000000,
        [
            -6958556105.612526,
            -2093222217.953554,
            3104429344.249118,
        ],
    ],
    [
        1626652800000,
        [
            -6974795953.377197,
            -2101575260.334177,
            3100530385.505309,
        ],
    ],
    [
        1627257600000,
        [
            -6990099822.104416,
            -2111647040.107016,
            3095885600.975025,
        ],
    ],
    [
        1627862400000,
        [
            -7004268506.537895,
            -2123330741.838024,
            3090542582.789784,
        ],
    ],
    [
        1628467200000,
        [
            -7017099684.983899,
            -2136507400.159508,
            3084552184.875416,
        ],
    ],
    [
        1629072000000,
        [
            -7028397314.119701,
            -2151023426.507415,
            3077979873.350947,
        ],
    ],
    [
        1629676800000,
        [
            -7038000017.096673,
            -2166695874.892575,
            3070905700.889943,
        ],
    ],
    [
        1630281600000,
        [
            -7045779533.286499,
            -2183341932.253394,
            3063410000.636902,
        ],
    ],
    [
        1630886400000,
        [
            -7051612892.145761,
            -2200770815.566935,
            3055574585.307284,
        ],
    ],
    [
        1631491200000,
        [
            -7055394390.908535,
            -2218763853.414377,
            3047493272.965946,
        ],
    ],
    [
        1632096000000,
        [
            -7057063363.657469,
            -2237084023.698243,
            3039269809.197779,
        ],
    ],
    [
        1632700800000,
        [
            -7056596007.409327,
            -2255505761.406247,
            3031002828.420011,
        ],
    ],
    [
        1633305600000,
        [
            -7053979571.140358,
            -2273803409.252521,
            3022789103.197368,
        ],
    ],
    [
        1633910400000,
        [
            -7049226130.144908,
            -2291734469.7577,
            3014732936.368942,
        ],
    ],
    [
        1634515200000,
        [
            -7042398355.573298,
            -2309052969.874926,
            3006942177.723872,
        ],
    ],
    [
        1635120000000,
        [
            -7033594349.32178,
            -2325538647.44194,
            2999512925.76551,
        ],
    ],
    [
        1635724800000,
        [
            -7022923557.40212,
            -2340981999.445141,
            2992534823.952121,
        ],
    ],
    [
        1636329600000,
        [
            -7010521444.145198,
            -2355170688.781402,
            2986099268.594373,
        ],
    ],
    [
        1636934400000,
        [
            -6996571780.494575,
            -2367905772.406013,
            2980293889.649645,
        ],
    ],
    [
        1637539200000,
        [
            -6981284581.83687,
            -2379028665.120818,
            2975187818.387434,
        ],
    ],
    [
        1638144000000,
        [
            -6964873418.970665,
            -2388402340.178891,
            2970839199.674811,
        ],
    ],
    [
        1638748800000,
        [
            -6947570532.016456,
            -2395900001.834587,
            2967302535.435069,
        ],
    ],
    [
        1639353600000,
        [
            -6929644789.102127,
            -2401422782.696668,
            2964622160.818886,
        ],
    ],
    [
        1639958400000,
        [
            -6911373824.653275,
            -2404922355.435152,
            2962819183.797939,
        ],
    ],
    [
        1640563200000,
        [
            -6893023264.834987,
            -2406377644.561162,
            2961901454.032405,
        ],
    ],
    [
        1641168000000,
        [
            -6874862844.616649,
            -2405784464.95148,
            2961870540.502843,
        ],
    ],
    [
        1641772800000,
        [
            -6857180426.008786,
            -2403173537.077598,
            2962714608.38912,
        ],
    ],
    [
        1642377600000,
        [
            -6840250577.260331,
            -2398626914.750062,
            2964398008.672569,
        ],
    ],
    [
        1642982400000,
        [
            -6824317464.998394,
            -2392250306.362141,
            2966873646.750897,
        ],
    ],
    [
        1643587200000,
        [
            -6809613385.623141,
            -2384163012.965088,
            2970089819.889105,
        ],
    ],
    [
        1644192000000,
        [
            -6796370139.631854,
            -2374516159.834015,
            2973982453.928483,
        ],
    ],
    [
        1644796800000,
        [
            -6784786615.347252,
            -2363502332.902938,
            2978467736.569893,
        ],
    ],
    [
        1645401600000,
        [
            -6775017513.31791,
            -2351325010.194399,
            2983456240.66466,
        ],
    ],
    [
        1646006400000,
        [
            -6767195385.329318,
            -2338189411.337785,
            2988859296.8343,
        ],
    ],
    [
        1646611200000,
        [
            -6761440372.145014,
            -2324321920.42675,
            2994580123.876184,
        ],
    ],
    [
        1647216000000,
        [
            -6757828460.050897,
            -2309973644.682796,
            3000509284.003263,
        ],
    ],
    [
        1647820800000,
        [
            -6756387322.741108,
            -2295389388.274199,
            3006539502.066505,
        ],
    ],
    [
        1648425600000,
        [
            -6757121679.945082,
            -2280800818.353778,
            3012570915.715815,
        ],
    ],
    [
        1649030400000,
        [
            -6760021326.500895,
            -2266448135.343339,
            3018500648.810906,
        ],
    ],
    [
        1649635200000,
        [
            -6765030422.431477,
            -2252578693.840491,
            3024220657.195847,
        ],
    ],
    [
        1650240000000,
        [
            -6772050337.880922,
            -2239417669.957704,
            3029632262.096151,
        ],
    ],
    [
        1650844800000,
        [
            -6780966994.747355,
            -2227164774.450876,
            3034649692.09464,
        ],
    ],
    [
        1651449600000,
        [
            -6791656299.179364,
            -2216018405.730123,
            3039188061.336901,
        ],
    ],
    [
        1652054400000,
        [
            -6803954175.986635,
            -2206170121.394871,
            3043163324.433178,
        ],
    ],
    [
        1652659200000,
        [
            -6817665451.442409,
            -2197778158.644364,
            3046505940.134811,
        ],
    ],
    [
        1653264000000,
        [
            -6832591590.673803,
            -2190968275.340259,
            3049162382.585384,
        ],
    ],
    [
        1653868800000,
        [
            -6848532570.019537,
            -2185859707.523137,
            3051081916.361389,
        ],
    ],
    [
        1654473600000,
        [
            -6865257575.486876,
            -2182555836.307209,
            3052218581.885094,
        ],
    ],
    [
        1655078400000,
        [
            -6882518835.276582,
            -2181120870.237372,
            3052543761.049807,
        ],
    ],
    [
        1655683200000,
        [
            -6900078574.197908,
            -2181584911.581015,
            3052045533.562811,
        ],
    ],
    [
        1656288000000,
        [
            -6917706691.448953,
            -2183970608.37446,
            3050714822.534035,
        ],
    ],
    [
        1656892800000,
        [
            -6935152611.95952,
            -2188280255.566424,
            3048549396.752108,
        ],
    ],
    [
        1657497600000,
        [
            -6952163161.88956,
            -2194475610.288006,
            3045565254.904222,
        ],
    ],
    [
        1658102400000,
        [
            -6968508058.286884,
            -2202487136.258196,
            3041793775.095499,
        ],
    ],
    [
        1658707200000,
        [
            -6983973045.713985,
            -2212240281.467278,
            3037267758.128975,
        ],
    ],
    [
        1659312000000,
        [
            -6998333810.495171,
            -2223639444.017687,
            3032027355.314593,
        ],
    ],
    [
        1659916800000,
        [
            -7011377083.479044,
            -2236550955.827099,
            3026130168.089169,
        ],
    ],
    [
        1660521600000,
        [
            -7022924223.047746,
            -2250816485.467836,
            3019646150.235126,
        ],
    ],
    [
        1661126400000,
        [
            -7032819527.379736,
            -2266278123.700552,
            3012643948.047358,
        ],
    ],
    [
        1661731200000,
        [
            -7040907160.617368,
            -2282759898.991652,
            3005198525.172978,
        ],
    ],
    [
        1662336000000,
        [
            -7047054522.594635,
            -2300054159.681837,
            2997399804.353828,
        ],
    ],
    [
        1662940800000,
        [
            -7051173401.589911,
            -2317939070.59726,
            2989345330.476241,
        ],
    ],
    [
        1663545600000,
        [
            -7053203051.414465,
            -2336201885.033047,
            2981127226.233963,
        ],
    ],
    [
        1664150400000,
        [
            -7053090726.004215,
            -2354618762.112748,
            2972841205.916017,
        ],
    ],
    [
        1664755200000,
        [
            -7050816042.279707,
            -2372944828.949051,
            2964593568.509181,
        ],
    ],
    [
        1665360000000,
        [
            -7046408902.161514,
            -2390935385.15485,
            2956491803.457373,
        ],
    ],
    [
        1665964800000,
        [
            -7039926797.154414,
            -2408366677.431988,
            2948632527.562756,
        ],
    ],
    [
        1666569600000,
        [
            -7031439007.915819,
            -2425014449.542577,
            2941111672.53371,
        ],
    ],
    [
        1667174400000,
        [
            -7021050479.40672,
            -2440647665.369061,
            2934029753.544341,
        ],
    ],
    [
        1667779200000,
        [
            -7008915543.442191,
            -2455052369.253032,
            2927480919.498552,
        ],
    ],
    [
        1668384000000,
        [
            -6995209152.554553,
            -2468048897.783737,
            2921542428.922128,
        ],
    ],
    [
        1668988800000,
        [
            -6980114511.915707,
            -2479468900.200794,
            2916286069.120981,
        ],
    ],
    [
        1669593600000,
        [
            -6963845324.537095,
            -2489152089.341085,
            2911781870.52628,
        ],
    ],
    [
        1670198400000,
        [
            -6946654680.764918,
            -2496970967.663616,
            2908086427.214738,
        ],
    ],
    [
        1670803200000,
        [
            -6928800886.761233,
            -2502842992.718067,
            2905234683.621805,
        ],
    ],
    [
        1671408000000,
        [
            -6910538676.236372,
            -2506705218.850722,
            2903252882.779613,
        ],
    ],
    [
        1672012800000,
        [
            -6892139786.686262,
            -2508512994.958551,
            2902161096.639324,
        ],
    ],
    [
        1672617600000,
        [
            -6873897304.463295,
            -2508263626.30912,
            2901961670.834094,
        ],
    ],
    [
        1673222400000,
        [
            -6856088252.936886,
            -2506002157.508298,
            2902634055.240063,
        ],
    ],
    [
        1673827200000,
        [
            -6838969391.046619,
            -2501793068.639079,
            2904149448.163771,
        ],
    ],
    [
        1674432000000,
        [
            -6822797382.089891,
            -2495720171.995436,
            2906472403.725744,
        ],
    ],
    [
        1675036800000,
        [
            -6807829745.269586,
            -2487908218.170815,
            2909549813.53077,
        ],
    ],
    [
        1675641600000,
        [
            -6794287367.936862,
            -2478521957.160606,
            2913309070.355776,
        ],
    ],
    [
        1676246400000,
        [
            -6782356304.21096,
            -2467735637.124835,
            2917674003.608932,
        ],
    ],
    [
        1676851200000,
        [
            -6772209163.285872,
            -2455734370.564285,
            2922565426.857093,
        ],
    ],
    [
        1677456000000,
        [
            -6764003734.734356,
            -2442734160.827734,
            2927890433.094283,
        ],
    ],
    [
        1678060800000,
        [
            -6757848146.311272,
            -2428975095.948285,
            2933543618.209539,
        ],
    ],
    [
        1678665600000,
        [
            -6753809393.185223,
            -2414690770.332277,
            2939423297.623841,
        ],
    ],
    [
        1679270400000,
        [
            -6751936615.642514,
            -2400112144.309488,
            2945430568.093197,
        ],
    ],
    [
        1679875200000,
        [
            -6752257495.326076,
            -2385487241.244602,
            2951458388.541763,
        ],
    ],
    [
        1680480000000,
        [
            -6754747304.526708,
            -2371069767.210129,
            2957395361.266712,
        ],
    ],
    [
        1681084800000,
        [
            -6759343682.242724,
            -2357090903.276285,
            2963141044.949705,
        ],
    ],
    [
        1681689600000,
        [
            -6765971103.951967,
            -2343766525.516555,
            2968603194.527586,
        ],
    ],
    [
        1682294400000,
        [
            -6774534300.921529,
            -2331317435.457447,
            2973686310.255348,
        ],
    ],
    [
        1682899200000,
        [
            -6784891219.36714,
            -2319954298.135726,
            2978297630.068283,
        ],
    ],
    [
        1683504000000,
        [
            -6796872797.115676,
            -2309853549.071943,
            2982360630.992379,
        ],
    ],
    [
        1684108800000,
        [
            -6810307194.771965,
            -2301168151.392262,
            2985810400.894948,
        ],
    ],
    [
        1684713600000,
        [
            -6825009449.575167,
            -2294048315.37544,
            2988581775.345715,
        ],
    ],
    [
        1685318400000,
        [
            -6840758031.846233,
            -2288623105.083355,
            2990617414.713265,
        ],
    ],
    [
        1685923200000,
        [
            -6857318338.992414,
            -2284981261.941886,
            2991879001.467748,
        ],
    ],
    [
        1686528000000,
        [
            -6874465305.824859,
            -2283185150.737845,
            2992340891.872593,
        ],
    ],
    [
        1687132800000,
        [
            -6891969038.738946,
            -2283291265.734257,
            2991978274.177068,
        ],
    ],
    [
        1687737600000,
        [
            -6909574914.30521,
            -2285328713.912564,
            2990777246.814127,
        ],
    ],
    [
        1688342400000,
        [
            -6927029810.855195,
            -2289285134.079677,
            2988743524.877504,
        ],
    ],
    [
        1688947200000,
        [
            -6944102093.118697,
            -2295123387.185409,
            2985894536.044886,
        ],
    ],
    [
        1689552000000,
        [
            -6960563516.786659,
            -2302800961.706307,
            2982248112.258658,
        ],
    ],
    [
        1690156800000,
        [
            -6976173114.518188,
            -2312245814.069208,
            2977834346.199065,
        ],
    ],
    [
        1690761600000,
        [
            -6990705416.927041,
            -2323347309.217493,
            2972701772.121584,
        ],
    ],
    [
        1691366400000,
        [
            -7003967113.565108,
            -2335975393.142357,
            2966907992.885731,
        ],
    ],
    [
        1691971200000,
        [
            -7015775732.322247,
            -2349998124.294681,
            2960509344.689912,
        ],
    ],
    [
        1692576000000,
        [
            -7025947607.670787,
            -2365255764.476576,
            2953574098.752503,
        ],
    ],
    [
        1693180800000,
        [
            -7034327317.478791,
            -2381556593.218496,
            2946186151.260368,
        ],
    ],
    [
        1693785600000,
        [
            -7040800396.662984,
            -2398698495.364338,
            2938434205.899681,
        ],
    ],
    [
        1694390400000,
        [
            -7045269112.697585,
            -2416484007.324662,
            2930402765.95682,
        ],
    ],
    [
        1694995200000,
        [
            -7047644572.092057,
            -2434693827.045132,
            2922186087.141947,
        ],
    ],
    [
        1695600000000,
        [
            -7047876326.10337,
            -2453087270.71626,
            2913889481.258667,
        ],
    ],
    [
        1696204800000,
        [
            -7045960424.458939,
            -2471426175.75409,
            2905617119.257869,
        ],
    ],
    [
        1696809600000,
        [
            -7041912212.824665,
            -2489486810.667202,
            2897464718.378116,
        ],
    ],
    [
        1697414400000,
        [
            -7035762279.633203,
            -2507033825.716018,
            2889533662.741819,
        ],
    ],
    [
        1698019200000,
        [
            -7027584819.901155,
            -2523824806.014949,
            2881930167.248222,
        ],
    ],
    [
        1698624000000,
        [
            -7017500257.164398,
            -2539635937.780336,
            2874751992.446495,
        ],
    ],
    [
        1699228800000,
        [
            -7005644717.437404,
            -2554269787.192732,
            2868083352.614862,
        ],
    ],
    [
        1699833600000,
        [
            -6992169367.891593,
            -2567530096.637296,
            2862008872.136712,
        ],
    ],
    [
        1700438400000,
        [
            -6977266083.925905,
            -2579229364.059238,
            2856611061.588456,
        ],
    ],
    [
        1701043200000,
        [
            -6961164266.999237,
            -2589214940.097183,
            2851956602.986546,
        ],
    ],
    [
        1701648000000,
        [
            -6944097056.199292,
            -2597371229.384626,
            2848094195.038516,
        ],
    ],
    [
        1702252800000,
        [
            -6926304050.64514,
            -2603594927.191435,
            2845068385.095304,
        ],
    ],
    [
        1702857600000,
        [
            -6908053509.884522,
            -2607804157.119153,
            2842915945.562139,
        ],
    ],
    [
        1703462400000,
        [
            -6889634017.794706,
            -2609963101.646804,
            2841652645.502516,
        ],
    ],
    [
        1704067200000,
        [
            -6871318712.435907,
            -2610077261.649409,
            2841274695.358728,
        ],
    ],
    [
        1704672000000,
        [
            -6853372309.274664,
            -2608168459.738832,
            2841772650.049503,
        ],
    ],
    [
        1705276800000,
        [
            -6836070311.213869,
            -2604284406.348084,
            2843127120.82414,
        ],
    ],
    [
        1705881600000,
        [
            -6819687257.929997,
            -2598520330.826762,
            2845296778.10784,
        ],
    ],
    [
        1706486400000,
        [
            -6804461538.9529,
            -2591007026.523695,
            2848223551.633349,
        ],
    ],
    [
        1707091200000,
        [
            -6790608186.972793,
            -2581885678.848705,
            2851846514.842573,
        ],
    ],
    [
        1707696000000,
        [
            -6778336418.094534,
            -2571317875.729398,
            2856096903.669288,
        ],
    ],
    [
        1708300800000,
        [
            -6767836319.24534,
            -2559503948.238014,
            2860887541.148933,
        ],
    ],
    [
        1708905600000,
        [
            -6759247011.484839,
            -2546665081.409307,
            2866121223.984785,
        ],
    ],
    [
        1709510400000,
        [
            -6752676052.588711,
            -2533019200.625822,
            2871704004.963072,
        ],
    ],
    [
        1710115200000,
        [
            -6748216310.303319,
            -2518792510.366055,
            2877539072.69433,
        ],
    ],
    [
        1710720000000,
        [
            -6745931831.987415,
            -2504235331.07277,
            2883517324.670405,
        ],
    ],
    [
        1711324800000,
        [
            -6745831093.120912,
            -2489600351.599468,
            2889527979.253394,
        ],
    ],
    [
        1711929600000,
        [
            -6747892402.80829,
            -2475121380.032035,
            2895470412.961793,
        ],
    ],
    [
        1712534400000,
        [
            -6752080083.774353,
            -2461027579.581291,
            2901246457.02287,
        ],
    ],
    [
        1713139200000,
        [
            -6758328956.357522,
            -2447557673.673389,
            2906751819.916898,
        ],
    ],
    [
        1713744000000,
        [
            -6766523174.203594,
            -2434936020.882662,
            2911888127.211462,
        ],
    ],
    [
        1714348800000,
        [
            -6776525906.966414,
            -2423355711.793144,
            2916572571.061806,
        ],
    ],
    [
        1714953600000,
        [
            -6788194066.769387,
            -2412995905.99154,
            2920728535.890778,
        ],
    ],
    [
        1715558400000,
        [
            -6801360366.569593,
            -2404034650.600084,
            2924277847.590768,
        ],
    ],
    [
        1716163200000,
        [
            -6815817679.809169,
            -2396623584.658466,
            2927153843.501504,
        ],
    ],
    [
        1716768000000,
        [
            -6831351047.766472,
            -2390876187.221335,
            2929308353.727562,
        ],
    ],
    [
        1717372800000,
        [
            -6847750114.171069,
            -2386887796.021432,
            2930700926.147757,
        ],
    ],
    [
        1717977600000,
        [
            -6864788136.070972,
            -2384746708.365716,
            2931292128.313125,
        ],
    ],
    [
        1718582400000,
        [
            -6882211840.108919,
            -2384507781.561091,
            2931057496.122243,
        ],
    ],
    [
        1719187200000,
        [
            -6899774163.839975,
            -2386186133.364312,
            2929991599.395076,
        ],
    ],
    [
        1719792000000,
        [
            -6917243814.201617,
            -2389779043.537974,
            2928096280.619436,
        ],
    ],
    [
        1720396800000,
        [
            -6934381338.776559,
            -2395274855.993061,
            2925375291.524,
        ],
    ],
    [
        1721001600000,
        [
            -6950934584.59438,
            -2402625737.916018,
            2921848960.378825,
        ],
    ],
    [
        1721606400000,
        [
            -6966671034.833612,
            -2411746898.298424,
            2917555247.945438,
        ],
    ],
    [
        1722211200000,
        [
            -6981384099.753399,
            -2422539624.752159,
            2912537374.44041,
        ],
    ],
    [
        1722816000000,
        [
            -6994866890.179594,
            -2434897685.142478,
            2906839970.831014,
        ],
    ],
    [
        1723420800000,
        [
            -7006913272.246542,
            -2448679806.056261,
            2900524152.982195,
        ],
    ],
    [
        1724025600000,
        [
            -7017348935.708785,
            -2463714369.260665,
            2893665578.218935,
        ],
    ],
    [
        1724630400000,
        [
            -7026033990.208405,
            -2479823077.086942,
            2886341731.306829,
        ],
    ],
    [
        1725235200000,
        [
            -7032835212.381146,
            -2496824784.04866,
            2878629638.86867,
        ],
    ],
    [
        1725840000000,
        [
            -7037632281.575234,
            -2514508545.457393,
            2870620882.969025,
        ],
    ],
    [
        1726444800000,
        [
            -7040346755.87222,
            -2532643600.824737,
            2862416781.244383,
        ],
    ],
    [
        1727049600000,
        [
            -7040940310.335118,
            -2551003328.509157,
            2854115541.42506,
        ],
    ],
    [
        1727654400000,
        [
            -7039385988.425352,
            -2569366443.179766,
            2845811571.744401,
        ],
    ],
    [
        1728259200000,
        [
            -7035678662.253633,
            -2587491502.772554,
            2837609909.407142,
        ],
    ],
    [
        1728864000000,
        [
            -7029860975.943914,
            -2605131623.662496,
            2829618838.307618,
        ],
    ],
    [
        1729468800000,
        [
            -7022016332.595018,
            -2622058252.50362,
            2821937183.76248,
        ],
    ],
    [
        1730073600000,
        [
            -7012239335.42598,
            -2638059255.896948,
            2814655446.290059,
        ],
    ],
    [
        1730678400000,
        [
            -7000649187.077057,
            -2652915425.78449,
            2807869230.136409,
        ],
    ],
    [
        1731283200000,
        [
            -6987411639.586697,
            -2666418718.587265,
            2801669909.78796,
        ],
    ],
    [
        1731888000000,
        [
            -6972726017.380858,
            -2678394883.951164,
            2796132543.174719,
        ],
    ],
    [
        1732492800000,
        [
            -6956795064.636535,
            -2688697259.799882,
            2791319390.680503,
        ],
    ],
    [
        1733097600000,
        [
            -6939840326.270914,
            -2697185215.908965,
            2787292179.534481,
        ],
    ],
    [
        1733702400000,
        [
            -6922119584.629532,
            -2703744027.806024,
            2784101714.586384,
        ],
    ],
    [
        1734307200000,
        [
            -6903908166.615632,
            -2708304909.147605,
            2781777094.249947,
        ],
    ],
    [
        1734912000000,
        [
            -6885469167.980494,
            -2710832921.985186,
            2780332351.03629,
        ],
    ],
    [
        1735516800000,
        [
            -6867070948.216345,
            -2711306971.649146,
            2779777569.429762,
        ],
    ],
    [
        1736121600000,
        [
            -6849000471.48587,
            -2709739383.373657,
            2780108333.723717,
        ],
    ],
    [
        1736726400000,
        [
            -6831540605.01168,
            -2706192053.778517,
            2781296846.297703,
        ],
    ],
    [
        1737331200000,
        [
            -6814942753.510156,
            -2700757555.321152,
            2783302100.218226,
        ],
    ],
    [
        1737936000000,
        [
            -6799447712.04366,
            -2693540755.78463,
            2786079733.925116,
        ],
    ],
    [
        1738540800000,
        [
            -6785296079.105149,
            -2684677179.395791,
            2789571768.296166,
        ],
    ],
    [
        1739145600000,
        [
            -6772704082.555424,
            -2674345019.692094,
            2793699767.382958,
        ],
    ],
    [
        1739750400000,
        [
            -6761840954.306254,
            -2662740159.827121,
            2798378181.368446,
        ],
    ],
    [
        1740355200000,
        [
            -6752854410.587505,
            -2650060442.30791,
            2803522465.607658,
        ],
    ],
    [
        1740960000000,
        [
            -6745879092.149852,
            -2636523323.250834,
            2809038958.808517,
        ],
    ],
    [
        1741564800000,
        [
            -6741012825.779264,
            -2622374552.114257,
            2814819768.889912,
        ],
    ],
    [
        1742169600000,
        [
            -6738300159.348227,
            -2607859240.86077,
            2820758242.40973,
        ],
    ],
    [
        1742774400000,
        [
            -6737762548.875714,
            -2593210292.152187,
            2826754705.893021,
        ],
    ],
    [
        1743379200000,
        [
            -6739404826.841024,
            -2578666538.183654,
            2832706051.863989,
        ],
    ],
    [
        1743984000000,
        [
            -6743192334.799047,
            -2564479065.559752,
            2838501985.502378,
        ],
    ],
    [
        1744588800000,
        [
            -6749040781.57459,
            -2550880686.682958,
            2844041428.184862,
        ],
    ],
    [
        1745193600000,
        [
            -6756849865.09943,
            -2538079617.781709,
            2849235428.090721,
        ],
    ],
    [
        1745798400000,
        [
            -6766507072.893359,
            -2526278913.523843,
            2853996176.604831,
        ],
    ],
    [
        1746403200000,
        [
            -6777865093.312238,
            -2515680764.357797,
            2858234555.822868,
        ],
    ],
    [
        1747008000000,
        [
            -6790737542.243851,
            -2506456020.611884,
            2861876592.672964,
        ],
    ],
    [
        1747612800000,
        [
            -6804934084.721932,
            -2498743410.874935,
            2864863425.823015,
        ],
    ],
    [
        1748217600000,
        [
            -6820260888.88495,
            -2492670322.602996,
            2867139801.020556,
        ],
    ],
    [
        1748822400000,
        [
            -6836497619.751695,
            -2488354742.950237,
            2868653138.261019,
        ],
    ],
    [
        1749427200000,
        [
            -6853398699.032068,
            -2485875753.744815,
            2869369504.428798,
        ],
    ],
    [
        1750032000000,
        [
            -6870728058.835545,
            -2485278034.035405,
            2869270745.38613,
        ],
    ],
    [
        1750636800000,
        [
            -6888256045.631639,
            -2486593513.787684,
            2868342720.856577,
        ],
    ],
    [
        1751241600000,
        [
            -6905735754.546156,
            -2489840423.77672,
            2866576169.900968,
        ],
    ],
    [
        1751846400000,
        [
            -6922909790.379672,
            -2494995336.428108,
            2863981855.53203,
        ],
    ],
    [
        1752451200000,
        [
            -6939543112.254133,
            -2502002549.946325,
            2860585055.207835,
        ],
    ],
    [
        1753056000000,
        [
            -6955416587.883489,
            -2510796012.014609,
            2856413838.041595,
        ],
    ],
    [
        1753660800000,
        [
            -6970302892.057727,
            -2521295189.88001,
            2851501861.294845,
        ],
    ],
    [
        1754265600000,
        [
            -6983978803.616611,
            -2533379231.374175,
            2845902356.513869,
        ],
    ],
    [
        1754870400000,
        [
            -6996254890.134855,
            -2546900904.62968,
            2839680179.014707,
        ],
    ],
    [
        1755475200000,
        [
            -7006965994.882627,
            -2561708275.348141,
            2832900387.66788,
        ],
    ],
    [
        1756080000000,
        [
            -7015947118.784249,
            -2577637528.299713,
            2825632875.950656,
        ],
    ],
    [
        1756684800000,
        [
            -7023050986.680003,
            -2594489902.345397,
            2817964840.208223,
        ],
    ],
    [
        1757289600000,
        [
            -7028173468.515375,
            -2612049926.740822,
            2809990592.773354,
        ],
    ],
    [
        1757894400000,
        [
            -7031241020.566614,
            -2630106406.874484,
            2801800689.046513,
        ],
    ],
    [
        1758499200000,
        [
            -7032186864.518555,
            -2648442617.917115,
            2793488126.233507,
        ],
    ],
    [
        1759104000000,
        [
            -7030972975.494226,
            -2666816582.018306,
            2785158973.920931,
        ],
    ],
    [
        1759708800000,
        [
            -7027610188.286937,
            -2684983200.396465,
            2776920227.322607,
        ],
    ],
    [
        1760313600000,
        [
            -7022142179.059482,
            -2702713954.911427,
            2768869813.410618,
        ],
    ],
    [
        1760918400000,
        [
            -7014622031.932685,
            -2719784785.139578,
            2761104118.296155,
        ],
    ],
    [
        1761523200000,
        [
            -7005137208.800981,
            -2735959874.940335,
            2753726630.202527,
        ],
    ],
    [
        1762128000000,
        [
            -6993823455.545424,
            -2751016797.411891,
            2746834312.888344,
        ],
    ],
    [
        1762732800000,
        [
            -6980844682.908396,
            -2764763895.36586,
            2740509020.155931,
        ],
    ],
    [
        1763337600000,
        [
            -6966370063.514786,
            -2777025559.053764,
            2734826388.809476,
        ],
    ],
    [
        1763942400000,
        [
            -6950600393.506212,
            -2787629056.8193,
            2729862612.114694,
        ],
    ],
    [
        1764547200000,
        [
            -6933775527.010241,
            -2796431103.134111,
            2725680108.128769,
        ],
    ],
    [
        1765152000000,
        [
            -6916149970.549195,
            -2803331400.990015,
            2722321057.755044,
        ],
    ],
    [
        1765756800000,
        [
            -6897971349.963938,
            -2808254337.946586,
            2719818037.404846,
        ],
    ],
    [
        1766361600000,
        [
            -6879507234.785258,
            -2811138012.70962,
            2718199222.130221,
        ],
    ],
    [
        1766966400000,
        [
            -6861046969.096143,
            -2811960246.668899,
            2717474277.903957,
        ],
    ],
    [
        1767571200000,
        [
            -6842873987.246816,
            -2810746889.010612,
            2717630649.514621,
        ],
    ],
    [
        1768176000000,
        [
            -6825247609.955152,
            -2807548940.383851,
            2718646322.933811,
        ],
    ],
    [
        1768780800000,
        [
            -6808430557.771996,
            -2802433388.679098,
            2720493602.6391,
        ],
    ],
    [
        1769385600000,
        [
            -6792687059.985633,
            -2795507209.44705,
            2723125925.351738,
        ],
    ],
    [
        1769990400000,
        [
            -6778254010.315503,
            -2786920125.855724,
            2726477008.7252,
        ],
    ],
    [
        1770595200000,
        [
            -6765328588.82745,
            -2776837238.079025,
            2730475654.467074,
        ],
    ],
    [
        1771200000000,
        [
            -6754097295.036328,
            -2765432463.746356,
            2735047776.777933,
        ],
    ],
    [
        1771804800000,
        [
            -6744732130.330161,
            -2752910298.809547,
            2740104326.827898,
        ],
    ],
    [
        1772409600000,
        [
            -6737362705.925714,
            -2739504130.276418,
            2745542768.279774,
        ],
    ],
    [
        1773014400000,
        [
            -6732071379.076702,
            -2725445842.718327,
            2751263199.573661,
        ],
    ],
    [
        1773619200000,
        [
            -6728924071.47184,
            -2710963518.304923,
            2757167959.246884,
        ],
    ],
    [
        1774224000000,
        [
            -6727965126.900106,
            -2696301628.325343,
            2763150490.218534,
        ],
    ],
    [
        1774828800000,
        [
            -6729191428.558818,
            -2681716547.647477,
            2769098365.293324,
        ],
    ],
    [
        1775433600000,
        [
            -6732555156.057963,
            -2667445221.970345,
            2774909707.722832,
        ],
    ],
    [
        1776038400000,
        [
            -6737995565.681366,
            -2653708535.045798,
            2780489817.94157,
        ],
    ],
    [
        1776643200000,
        [
            -6745431945.167791,
            -2640730568.528255,
            2785740815.40103,
        ],
    ],
    [
        1777248000000,
        [
            -6754739764.633801,
            -2628732394.738183,
            2790565717.171833,
        ],
    ],
    [
        1777852800000,
        [
            -6765760024.691064,
            -2617901570.454809,
            2794884251.009922,
        ],
    ],
    [
        1778457600000,
        [
            -6778330545.904106,
            -2608401579.142985,
            2798626393.967351,
        ],
    ],
    [
        1779062400000,
        [
            -6792276137.884493,
            -2600390258.467563,
            2801722822.605065,
        ],
    ],
    [
        1779667200000,
        [
            -6807386499.19739,
            -2594012019.016864,
            2804109982.334061,
        ],
    ],
    [
        1780272000000,
        [
            -6823430915.268691,
            -2589369345.609969,
            2805744651.162083,
        ],
    ],
    [
        1780876800000,
        [
            -6840187646.601169,
            -2586537803.37161,
            2806594688.920495,
        ],
    ],
    [
        1781481600000,
        [
            -6857430856.212158,
            -2585583355.075245,
            2806630442.973629,
        ],
    ],
    [
        1782086400000,
        [
            -6874910208.222722,
            -2586552606.189786,
            2805830985.691523,
        ],
    ],
    [
        1782691200000,
        [
            -6892370004.039606,
            -2589447156.258787,
            2804196970.618259,
        ],
    ],
    [
        1783296000000,
        [
            -6909575571.481185,
            -2594243234.695053,
            2801739089.087899,
        ],
    ],
    [
        1783900800000,
        [
            -6926297067.343444,
            -2600907624.831397,
            2798470541.359385,
        ],
    ],
    [
        1784505600000,
        [
            -6942291019.193171,
            -2609385522.479163,
            2794414604.108367,
        ],
    ],
    [
        1785110400000,
        [
            -6957323329.463818,
            -2619578524.829351,
            2789615377.396538,
        ],
    ],
    [
        1785715200000,
        [
            -6971191776.58234,
            -2631367954.56119,
            2784124478.299682,
        ],
    ],
    [
        1786320000000,
        [
            -6983707134.52435,
            -2644629302.858917,
            2777994574.288783,
        ],
    ],
    [
        1786924800000,
        [
            -6994676961.063024,
            -2659217595.853612,
            2771288281.358921,
        ],
    ],
    [
        1787529600000,
        [
            -7003931971.606377,
            -2674949840.771202,
            2764086399.766083,
        ],
    ],
    [
        1788134400000,
        [
            -7011343749.637399,
            -2691631243.931913,
            2756473344.544483,
        ],
    ],
    [
        1788739200000,
        [
            -7016803603.838855,
            -2709068221.460947,
            2748531670.002319,
        ],
    ],
    [
        1789344000000,
        [
            -7020208670.827417,
            -2727051511.529287,
            2740352120.604368,
        ],
    ],
    [
        1789948800000,
        [
            -7021490920.549159,
            -2745343790.393295,
            2732039005.166931,
        ],
    ],
    [
        1790553600000,
        [
            -7020629013.512527,
            -2763708037.432768,
            2723694855.06559,
        ],
    ],
    [
        1791158400000,
        [
            -7017625043.299828,
            -2781919020.856164,
            2715415948.312322,
        ],
    ],
    [
        1791763200000,
        [
            -7012492625.13263,
            -2799744522.346858,
            2707303252.146166,
        ],
    ],
    [
        1792368000000,
        [
            -7005287393.009677,
            -2816938392.633359,
            2699464789.835526,
        ],
    ],
    [
        1792972800000,
        [
            -6996111888.852822,
            -2833270085.027485,
            2692000091.420199,
        ],
    ],
    [
        1793577600000,
        [
            -6985090095.153302,
            -2848533987.790755,
            2684996988.882016,
        ],
    ],
    [
        1794182400000,
        [
            -6972356979.424949,
            -2862528881.67278,
            2678543285.335518,
        ],
    ],
    [
        1794787200000,
        [
            -6958089134.088687,
            -2875055879.067636,
            2672726353.524311,
        ],
    ],
    [
        1795392000000,
        [
            -6942502018.381112,
            -2885947665.385803,
            2667618106.308499,
        ],
    ],
    [
        1795996800000,
        [
            -6925822362.535947,
            -2895074309.801448,
            2663273673.361985,
        ],
    ],
    [
        1796601600000,
        [
            -6908279083.988353,
            -2902320614.020573,
            2659743843.866227,
        ],
    ],
    [
        1797206400000,
        [
            -6890133106.950187,
            -2907587574.845515,
            2657072515.651877,
        ],
    ],
    [
        1797811200000,
        [
            -6871667476.932711,
            -2910819578.382176,
            2655282980.146403,
        ],
    ],
    [
        1798416000000,
        [
            -6853158564.82156,
            -2912005009.84931,
            2654379210.972163,
        ],
    ],
    [
        1799020800000,
        [
            -6834869480.064775,
            -2911151005.662422,
            2654359210.294046,
        ],
    ],
    [
        1799625600000,
        [
            -6817079013.306978,
            -2908287023.307391,
            2655211011.13387,
        ],
    ],
    [
        1800230400000,
        [
            -6800066601.076705,
            -2903488680.279281,
            2656900837.154176,
        ],
    ],
    [
        1800835200000,
        [
            -6784084190.63309,
            -2896872240.170262,
            2659377382.022496,
        ],
    ],
    [
        1801440000000,
        [
            -6769354374.771283,
            -2888566971.856114,
            2662585887.027289,
        ],
    ],
    [
        1802044800000,
        [
            -6756099000.444634,
            -2878720480.170659,
            2666462992.637115,
        ],
    ],
    [
        1802649600000,
        [
            -6744521575.931006,
            -2867519044.848947,
            2670926812.088113,
        ],
    ],
    [
        1803254400000,
        [
            -6734781732.263179,
            -2855176602.224038,
            2675883883.967275,
        ],
    ],
    [
        1803859200000,
        [
            -6727000192.048937,
            -2841906053.497109,
            2681243303.445584,
        ],
    ],
    [
        1804464000000,
        [
            -6721287148.980774,
            -2827927350.3852,
            2686910158.112829,
        ],
    ],
    [
        1805068800000,
        [
            -6717723904.300038,
            -2813485112.162827,
            2692777182.708368,
        ],
    ],
    [
        1805673600000,
        [
            -6716340868.819983,
            -2798833858.282315,
            2698733548.067106,
        ],
    ],
    [
        1806278400000,
        [
            -6717130133.858182,
            -2784210204.016425,
            2704678112.646389,
        ],
    ],
    [
        1806883200000,
        [
            -6720072670.010881,
            -2769845113.277053,
            2710510966.887498,
        ],
    ],
    [
        1807488000000,
        [
            -6725119584.671893,
            -2755979516.030545,
            2716126402.257335,
        ],
    ],
    [
        1808092800000,
        [
            -6732173499.016893,
            -2742847533.342184,
            2721422694.392991,
        ],
    ],
    [
        1808697600000,
        [
            -6741108027.561335,
            -2730651175.973254,
            2726313700.385015,
        ],
    ],
    [
        1809302400000,
        [
            -6751792215.414971,
            -2719577515.364088,
            2730718283.37295,
        ],
    ],
    [
        1809907200000,
        [
            -6764070999.411439,
            -2709812339.035251,
            2734554629.712084,
        ],
    ],
    [
        1810512000000,
        [
            -6777749429.18462,
            -2701522364.718164,
            2737750519.007267,
        ],
    ],
    [
        1811116800000,
        [
            -6792617633.193425,
            -2694833361.113422,
            2740252825.591911,
        ],
    ],
    [
        1811721600000,
        [
            -6808471111.620399,
            -2689852031.480178,
            2742014987.331523,
        ],
    ],
    [
        1812326400000,
        [
            -6825090013.198476,
            -2686677235.93523,
            2742992888.563813,
        ],
    ],
    [
        1812931200000,
        [
            -6842225981.424933,
            -2685381506.464073,
            2743155420.878472,
        ],
    ],
    [
        1813536000000,
        [
            -6859631131.755207,
            -2685993052.025356,
            2742491691.291719,
        ],
    ],
    [
        1814140800000,
        [
            -6877073439.547701,
            -2688521546.278017,
            2740996950.851765,
        ],
    ],
    [
        1814745600000,
        [
            -6894314820.91145,
            -2692966451.711113,
            2738670214.292009,
        ],
    ],
    [
        1815350400000,
        [
            -6911100833.719699,
            -2699297868.406435,
            2735525032.846304,
        ],
    ],
    [
        1815955200000,
        [
            -6927192377.218812,
            -2707442809.66058,
            2731594292.835327,
        ],
    ],
    [
        1816560000000,
        [
            -6942375933.10125,
            -2717313919.807372,
            2726915092.957702,
        ],
    ],
    [
        1817164800000,
        [
            -6956440692.77583,
            -2728814786.515949,
            2721528087.563153,
        ],
    ],
    [
        1817769600000,
        [
            -6969171542.347061,
            -2741820195.876516,
            2715488361.798774,
        ],
    ],
    [
        1818374400000,
        [
            -6980382312.820436,
            -2756167194.960067,
            2708867672.476694,
        ],
    ],
    [
        1818979200000,
        [
            -6989920792.93246,
            -2771685809.324818,
            2701738762.537962,
        ],
    ],
    [
        1819584000000,
        [
            -6997645118.515049,
            -2788201614.135925,
            2694176228.36995,
        ],
    ],
    [
        1820188800000,
        [
            -7003420309.104587,
            -2805515603.662401,
            2686267321.845276,
        ],
    ],
    [
        1820793600000,
        [
            -7007151835.283082,
            -2823400649.674555,
            2678111436.221799,
        ],
    ],
    [
        1821398400000,
        [
            -7008785136.708869,
            -2841633277.34159,
            2669804378.103976,
        ],
    ],
    [
        1822003200000,
        [
            -7008281253.772365,
            -2859993917.33382,
            2661440486.155498,
        ],
    ],
    [
        1822608000000,
        [
            -7005616735.99921,
            -2878246608.036144,
            2653123185.398921,
        ],
    ],
    [
        1823212800000,
        [
            -7000816113.270576,
            -2896141269.615229,
            2644961579.343906,
        ],
    ],
    [
        1823817600000,
        [
            -6993945344.855075,
            -2913445335.028565,
            2637055320.711459,
        ],
    ],
    [
        1824422400000,
        [
            -6985086468.248358,
            -2929941832.546421,
            2629497835.605934,
        ],
    ],
    [
        1825027200000,
        [
            -6974340226.784064,
            -2945408867.795087,
            2622386587.969623,
        ],
    ],
    [
        1825632000000,
        [
            -6961856001.753734,
            -2959627506.701603,
            2615816900.724347,
        ],
    ],
    [
        1826236800000,
        [
            -6947818614.386859,
            -2972411547.61259,
            2609868256.134375,
        ],
    ],
    [
        1826841600000,
        [
            -6932421977.131933,
            -2983602903.042436,
            2604608790.228478,
        ],
    ],
    [
        1827446400000,
        [
            -6915873746.950405,
            -2993050339.170914,
            2600105456.005573,
        ],
    ],
    [
        1828051200000,
        [
            -6898421795.141441,
            -3000621868.61686,
            2596415595.37887,
        ],
    ],
    [
        1828656000000,
        [
            -6880334506.401681,
            -3006230578.811978,
            2593575602.908086,
        ],
    ],
    [
        1829260800000,
        [
            -6861874301.809727,
            -3009826152.751843,
            2591607130.378192,
        ],
    ],
    [
        1829865600000,
        [
            -6843304348.11466,
            -3011372169.493418,
            2590527448.832431,
        ],
    ],
    [
        1830470400000,
        [
            -6824911759.654004,
            -3010861399.347646,
            2590339544.492313,
        ],
    ],
    [
        1831075200000,
        [
            -6806982848.129285,
            -3008336028.466834,
            2591023838.956552,
        ],
    ],
    [
        1831680000000,
        [
            -6789778528.630945,
            -3003874324.141051,
            2592546460.426322,
        ],
    ],
    [
        1832284800000,
        [
            -6773544207.181549,
            -2997566477.754709,
            2594869826.469728,
        ],
    ],
    [
        1832889600000,
        [
            -6758530843.856984,
            -2989531674.940037,
            2597941879.728984,
        ],
    ],
    [
        1833494400000,
        [
            -6744967550.102018,
            -2979932438.155205,
            2601690916.220706,
        ],
    ],
    [
        1834099200000,
        [
            -6733041232.575042,
            -2968956568.07168,
            2606035789.612829,
        ],
    ],
    [
        1834704000000,
        [
            -6722911202.663136,
            -2956792817.166797,
            2610896143.345695,
        ],
    ],
    [
        1835308800000,
        [
            -6714728987.947658,
            -2943649727.19206,
            2616180971.305135,
        ],
    ],
    [
        1835913600000,
        [
            -6708610398.517621,
            -2929765244.367102,
            2621785963.477839,
        ],
    ],
    [
        1836518400000,
        [
            -6704620782.735615,
            -2915385263.26927,
            2627605005.795976,
        ],
    ],
    [
        1837123200000,
        [
            -6702795169.305469,
            -2900741305.831177,
            2633539068.684433,
        ],
    ],
    [
        1837728000000,
        [
            -6703156433.468204,
            -2886071790.802648,
            2639484000.229421,
        ],
    ],
    [
        1838332800000,
        [
            -6705687841.111338,
            -2871628452.45555,
            2645329643.262181,
        ],
    ],
    [
        1838937600000,
        [
            -6710323782.475986,
            -2857653133.461333,
            2650971870.379846,
        ],
    ],
    [
        1839542400000,
        [
            -6716975073.928535,
            -2844359450.633359,
            2656319217.813236,
        ],
    ],
    [
        1840147200000,
        [
            -6725543971.777492,
            -2831956886.140561,
            2661279895.653292,
        ],
    ],
    [
        1840752000000,
        [
            -6735897353.271407,
            -2820654851.686507,
            2665762247.15824,
        ],
    ],
    [
        1841356800000,
        [
            -6747861912.48919,
            -2810638903.850176,
            2669686778.114555,
        ],
    ],
    [
        1841961600000,
        [
            -6761253513.585803,
            -2802057509.38672,
            2672990036.166858,
        ],
    ],
    [
        1842566400000,
        [
            -6775887403.93375,
            -2795048638.983077,
            2675611070.848989,
        ],
    ],
    [
        1843171200000,
        [
            -6791552080.182284,
            -2789741449.26517,
            2677493179.814079,
        ],
    ],
    [
        1843776000000,
        [
            -6808007960.970101,
            -2786232529.358252,
            2678595651.932087,
        ],
    ],
    [
        1844380800000,
        [
            -6825019539.640761,
            -2784578087.275935,
            2678894785.833169,
        ],
    ],
    [
        1844985600000,
        [
            -6842359752.051472,
            -2784822252.461363,
            2678370191.422806,
        ],
    ],
    [
        1845590400000,
        [
            -6859784851.067039,
            -2786995974.160071,
            2677007905.784132,
        ],
    ],
    [
        1846195200000,
        [
            -6877036055.215502,
            -2791093686.943203,
            2674811668.126488,
        ],
    ],
    [
        1846800000000,
        [
            -6893873351.658213,
            -2797070871.428531,
            2671801189.3992,
        ],
    ],
    [
        1847404800000,
        [
            -6910073727.598707,
            -2804873213.76772,
            2667998685.118582,
        ],
    ],
    [
        1848009600000,
        [
            -6925407555.395046,
            -2814432444.627783,
            2663433378.350425,
        ],
    ],
    [
        1848614400000,
        [
            -6939643132.251624,
            -2825643856.849977,
            2658152086.862009,
        ],
    ],
    [
        1849219200000,
        [
            -6952580973.730597,
            -2838369132.697099,
            2652214929.326692,
        ],
    ],
    [
        1849824000000,
        [
            -6964046078.032434,
            -2852465687.309178,
            2645682377.404522,
        ],
    ],
    [
        1850428800000,
        [
            -6973866172.673673,
            -2867779543.417207,
            2638621006.893505,
        ],
    ],
    [
        1851033600000,
        [
            -6981879190.207511,
            -2884124272.118809,
            2631113090.653636,
        ],
    ],
    [
        1851638400000,
        [
            -6987966710.013499,
            -2901289030.878411,
            2623249927.692668,
        ],
    ],
    [
        1852243200000,
        [
            -6992040543.456029,
            -2919067543.353607,
            2615119641.41103,
        ],
    ],
    [
        1852848000000,
        [
            -6994022762.957973,
            -2937248378.525789,
            2606813941.415357,
        ],
    ],
    [
        1853452800000,
        [
            -6993855974.794063,
            -2955595856.288235,
            2598436417.496628,
        ],
    ],
    [
        1854057600000,
        [
            -6991534256.514114,
            -2973863170.421021,
            2590093692.822047,
        ],
    ],
    [
        1854662400000,
        [
            -6987084225.408861,
            -2991820285.621362,
            2581884268.291139,
        ],
    ],
    [
        1855267200000,
        [
            -6980546271.538608,
            -3009241956.283327,
            2573906094.101398,
        ],
    ],
    [
        1855872000000,
        [
            -6971987160.565126,
            -3025890779.595875,
            2566263430.590333,
        ],
    ],
    [
        1856476800000,
        [
            -6961526641.838693,
            -3041534923.984209,
            2559056145.178195,
        ],
    ],
    [
        1857081600000,
        [
            -6949313110.780114,
            -3055973647.81445,
            2552370138.757755,
        ],
    ],
    [
        1857686400000,
        [
            -6935505318.080239,
            -3069022974.163446,
            2546285730.279706,
        ],
    ],
    [
        1858291200000,
        [
            -6920286728.522385,
            -3080500388.24739,
            2540883282.186304,
        ],
    ],
    [
        1858896000000,
        [
            -6903886363.634542,
            -3090246093.666205,
            2536231194.183265,
        ],
    ],
    [
        1859500800000,
        [
            -6886549603.6926,
            -3098144148.906941,
            2532378717.217949,
        ],
    ],
    [
        1860105600000,
        [
            -6868520294.809393,
            -3104105192.025222,
            2529365393.152084,
        ],
    ],
    [
        1860710400000,
        [
            -6850056756.181975,
            -3108051700.245119,
            2527225941.699385,
        ],
    ],
    [
        1861315200000,
        [
            -6831446593.968989,
            -3109941297.383764,
            2525977667.903617,
        ],
    ],
    [
        1861920000000,
        [
            -6812974190.421195,
            -3109781398.62445,
            2525616477.454766,
        ],
    ],
    [
        1862524800000,
        [
            -6794904474.566464,
            -3107608392.326277,
            2526127591.366648,
        ],
    ],
    [
        1863129600000,
        [
            -6777501312.803188,
            -3103472625.694345,
            2527490137.004658,
        ],
    ],
    [
        1863734400000,
        [
            -6761037430.74083,
            -3097462647.542603,
            2529664527.435371,
        ],
    ],
    [
        1864339200000,
        [
            -6745761007.920231,
            -3089712316.079856,
            2532592021.277726,
        ],
    ],
    [
        1864944000000,
        [
            -6731883394.961457,
            -3080376733.377945,
            2536206512.081207,
        ],
    ],
    [
        1865548800000,
        [
            -6719600972.875813,
            -3069617344.659652,
            2540438762.514353,
        ],
    ],
    [
        1866153600000,
        [
            -6709101810.482466,
            -3057626978.592834,
            2545203894.45291,
        ],
    ],
    [
        1866758400000,
        [
            -6700533588.396842,
            -3044630085.629452,
            2550404105.464014,
        ],
    ],
    [
        1867363200000,
        [
            -6693997205.258808,
            -3030856843.777964,
            2555940833.846437,
        ],
    ],
    [
        1867968000000,
        [
            -6689572500.938375,
            -3016530042.510404,
            2561717998.443359,
        ],
    ],
    [
        1868572800000,
        [
            -6687322452.817603,
            -3001891419.253734,
            2567629469.464628,
        ],
    ],
    [
        1869177600000,
        [
            -6687263469.97636,
            -2987196783.828125,
            2573564094.702088,
        ],
    ],
    [
        1869782400000,
        [
            -6689365419.788984,
            -2972690065.0434,
            2579417416.476171,
        ],
    ],
    [
        1870387200000,
        [
            -6693580463.318018,
            -2958593976.964859,
            2585093100.787376,
        ],
    ],
    [
        1870992000000,
        [
            -6699844359.587604,
            -2945137842.7873,
            2590490375.188736,
        ],
    ],
    [
        1871596800000,
        [
            -6708049090.577922,
            -2932549255.610861,
            2595510574.501645,
        ],
    ],
    [
        1872201600000,
        [
            -6718048573.647154,
            -2921029279.215627,
            2600067869.652322,
        ],
    ],
    [
        1872806400000,
        [
            -6729689198.239525,
            -2910748293.384259,
            2604088320.029356,
        ],
    ],
    [
        1873411200000,
        [
            -6742807210.213705,
            -2901874692.045809,
            2607497567.313254,
        ],
    ],
    [
        1874016000000,
        [
            -6757203394.304881,
            -2894564003.680901,
            2610228428.259717,
        ],
    ],
    [
        1874620800000,
        [
            -6772653303.245818,
            -2888935702.771658,
            2612230462.461343,
        ],
    ],
    [
        1875225600000,
        [
            -6788938135.07454,
            -2885074825.606492,
            2613466447.939344,
        ],
    ],
    [
        1875830400000,
        [
            -6805837358.365315,
            -2883060380.030165,
            2613900814.6944,
        ],
    ],
    [
        1876435200000,
        [
            -6823105575.000381,
            -2882952270.271038,
            2613508045.110454,
        ],
    ],
    [
        1877040000000,
        [
            -6840486270.216201,
            -2884769804.438546,
            2612281098.640246,
        ],
    ],
    [
        1877644800000,
        [
            -6857742016.480647,
            -2888499149.628376,
            2610225361.759623,
        ],
    ],
    [
        1878249600000,
        [
            -6874642013.200032,
            -2894120267.504646,
            2607348295.203645,
        ],
    ],
    [
        1878854400000,
        [
            -6890941685.148443,
            -2901591832.975516,
            2603668443.626348,
        ],
    ],
    [
        1879459200000,
        [
            -6906399247.627623,
            -2910831591.072769,
            2599222717.01462,
        ],
    ],
    [
        1880064000000,
        [
            -6920804449.409456,
            -2921729491.997634,
            2594057987.514844,
        ],
    ],
    [
        1880668800000,
        [
            -6933961116.286211,
            -2934172299.288426,
            2588222273.406754,
        ],
    ],
    [
        1881273600000,
        [
            -6945670129.924157,
            -2948026826.092413,
            2581774095.515207,
        ],
    ],
    [
        1881878400000,
        [
            -6955748222.157736,
            -2963122561.634074,
            2574788485.612679,
        ],
    ],
    [
        1882483200000,
        [
            -6964054421.992406,
            -2979270190.362971,
            2567346477.350716,
        ],
    ],
    [
        1883088000000,
        [
            -6970467846.615765,
            -2996283418.362872,
            2559527969.146957,
        ],
    ],
    [
        1883692800000,
        [
            -6974874371.697228,
            -3013961007.113027,
            2551421123.675077,
        ],
    ],
    [
        1884297600000,
        [
            -6977186964.397281,
            -3032072278.716846,
            2543126865.389879,
        ],
    ],
    [
        1884902400000,
        [
            -6977368723.944568,
            -3050380477.955788,
            2534746615.532416,
        ],
    ],
    [
        1885507200000,
        [
            -6975406101.32637,
            -3068661565.135145,
            2526376877.690772,
        ],
    ],
    [
        1886112000000,
        [
            -6971298957.715539,
            -3086685445.033714,
            2518118459.049553,
        ],
    ],
    [
        1886716800000,
        [
            -6965081544.765143,
            -3104204831.34727,
            2510079261.03963,
        ],
    ],
    [
        1887321600000,
        [
            -6956840725.43477,
            -3120982433.254833,
            2502360786.71681,
        ],
    ],
    [
        1887926400000,
        [
            -6946684767.596524,
            -3136806259.982509,
            2495054566.128391,
        ],
    ],
    [
        1888531200000,
        [
            -6934735961.089142,
            -3151469979.222342,
            2488251228.312969,
        ],
    ],
    [
        1889136000000,
        [
            -6921151374.389767,
            -3164765062.40987,
            2482041639.131492,
        ],
    ],
    [
        1889740800000,
        [
            -6906134889.807474,
            -3176510137.87395,
            2476502952.775782,
        ],
    ],
    [
        1890345600000,
        [
            -6889902118.691842,
            -3186561762.212455,
            2471697219.016211,
        ],
    ],
    [
        1890950400000,
        [
            -6872674834.126422,
            -3194793199.997195,
            2467680657.018517,
        ],
    ],
    [
        1891555200000,
        [
            -6854701234.622062,
            -3201089041.323641,
            2464503529.056377,
        ],
    ],
    [
        1892160000000,
        [
            -6836261182.986791,
            -3205374677.930252,
            2462196665.761296,
        ],
    ],
    [
        1892764800000,
        [
            -6817628850.950692,
            -3207621025.814966,
            2460772751.865796,
        ],
    ],
    [
        1893369600000,
        [
            -6799069152.455326,
            -3207820851.584157,
            2460236250.456792,
        ],
    ],
    [
        1893974400000,
        [
            -6780858323.287114,
            -3205984837.10755,
            2460582515.647508,
        ],
    ],
    [
        1894579200000,
        [
            -6763283010.041697,
            -3202169580.375783,
            2461785540.616194,
        ],
    ],
    [
        1895184000000,
        [
            -6746603424.169868,
            -3196475155.410096,
            2463802215.038158,
        ],
    ],
    [
        1895788800000,
        [
            -6731053096.704101,
            -3189018967.154107,
            2466582966.721428,
        ],
    ],
    [
        1896393600000,
        [
            -6716861260.727486,
            -3179932959.970509,
            2470070325.051847,
        ],
    ],
    [
        1896998400000,
        [
            -6704247251.696741,
            -3169389775.317917,
            2474188100.983723,
        ],
    ],
    [
        1897603200000,
        [
            -6693387096.123781,
            -3157593334.468046,
            2478848364.948861,
        ],
    ],
    [
        1898208000000,
        [
            -6684418111.650164,
            -3144751637.393424,
            2483962210.593806,
        ],
    ],
    [
        1898812800000,
        [
            -6677463999.65341,
            -3131075947.380894,
            2489437505.029404,
        ],
    ],
    [
        1899417600000,
        [
            -6672625724.58607,
            -3116805852.56332,
            2495169203.893024,
        ],
    ],
    [
        1900022400000,
        [
            -6669953266.4269,
            -3102194294.598525,
            2501048328.18407,
        ],
    ],
    [
        1900627200000,
        [
            -6669455681.304454,
            -3087481513.708998,
            2506971892.649536,
        ],
    ],
    [
        1901232000000,
        [
            -6671128393.874453,
            -3072897518.405165,
            2512839360.989651,
        ],
    ],
    [
        1901836800000,
        [
            -6674940821.038355,
            -3058686834.175371,
            2518543735.268922,
        ],
    ],
    [
        1902441600000,
        [
            -6680813410.023059,
            -3045089674.521179,
            2523981748.49307,
        ],
    ],
    [
        1903046400000,
        [
            -6688632631.63416,
            -3032318838.797753,
            2529062183.586518,
        ],
    ],
    [
        1903651200000,
        [
            -6698278867.47847,
            -3020566408.595557,
            2533700696.745657,
        ],
    ],
    [
        1904256000000,
        [
            -6709610515.669844,
            -3010028151.705805,
            2537811616.944955,
        ],
    ],
    [
        1904860800000,
        [
            -6722445574.739212,
            -3000882063.255021,
            2541318816.415754,
        ],
    ],
    [
        1905465600000,
        [
            -6736580540.905401,
            -2993269037.919011,
            2544162098.562961,
        ],
    ],
    [
        1906070400000,
        [
            -6751817110.024809,
            -2987304105.18458,
            2546290329.302865,
        ],
    ],
    [
        1906675200000,
        [
            -6767942634.552089,
            -2983099619.065437,
            2547654188.949107,
        ],
    ],
    [
        1907280000000,
        [
            -6784715566.909475,
            -2980741901.124928,
            2548217415.624111,
        ],
    ],
    [
        1907884800000,
        [
            -6801887340.283113,
            -2980275747.186848,
            2547961290.608934,
        ],
    ],
    [
        1908489600000,
        [
            -6819226511.077617,
            -2981720142.057771,
            2546876193.568463,
        ],
    ],
    [
        1909094400000,
        [
            -6836495844.747108,
            -2985089028.407317,
            2544955668.332919,
        ],
    ],
    [
        1909699200000,
        [
            -6853441388.862151,
            -2990366640.690352,
            2542207784.983953,
        ],
    ],
    [
        1910304000000,
        [
            -6869816668.018412,
            -2997495647.267132,
            2538657878.046628,
        ],
    ],
    [
        1910908800000,
        [
            -6885403341.579584,
            -3006397206.166011,
            2534338680.354189,
        ],
    ],
    [
        1911513600000,
        [
            -6899985483.19639,
            -3016988250.064341,
            2529286014.580123,
        ],
    ],
    [
        1912118400000,
        [
            -6913342408.585996,
            -3029156246.140348,
            2523549931.329381,
        ],
    ],
    [
        1912723200000,
        [
            -6925274571.0244,
            -3042750860.87022,
            2517195825.102721,
        ],
    ],
    [
        1913328000000,
        [
            -6935620027.604456,
            -3057608216.437725,
            2510293289.653603,
        ],
    ],
    [
        1913932800000,
        [
            -6944226481.54742,
            -3073564002.74277,
            2502913616.735769,
        ],
    ],
    [
        1914537600000,
        [
            -6950947999.94854,
            -3090428590.537817,
            2495140274.823547,
        ],
    ],
    [
        1915142400000,
        [
            -6955671775.344164,
            -3107982268.857835,
            2487068451.406047,
        ],
    ],
    [
        1915747200000,
        [
            -6958329674.399642,
            -3126003409.567599,
            2478792810.597828,
        ],
    ],
    [
        1916352000000,
        [
            -6958868353.542366,
            -3144277057.085829,
            2470406861.606249,
        ],
    ],
    [
        1916956800000,
        [
            -6957249667.076344,
            -3162571287.798734,
            2462012379.23385,
        ],
    ],
    [
        1917561600000,
        [
            -6953477083.104074,
            -3180636067.412065,
            2453717411.294345,
        ],
    ],
    [
        1918166400000,
        [
            -6947601487.141726,
            -3198234563.029418,
            2445623276.919903,
        ],
    ],
    [
        1918771200000,
        [
            -6939689346.673182,
            -3215146938.58842,
            2437825853.170571,
        ],
    ],
    [
        1919376000000,
        [
            -6929826172.129374,
            -3231148373.036385,
            2430423785.078474,
        ],
    ],
    [
        1919980800000,
        [
            -6918141167.175903,
            -3246011267.970901,
            2423515136.308646,
        ],
    ],
    [
        1920585600000,
        [
            -6904806564.015817,
            -3259538151.696544,
            2417184253.147316,
        ],
    ],
    [
        1921190400000,
        [
            -6890003809.936779,
            -3271560142.776252,
            2411505143.861404,
        ],
    ],
    [
        1921795200000,
        [
            -6873929366.85845,
            -3281916168.383149,
            2406548736.366549,
        ],
    ],
    [
        1922400000000,
        [
            -6856816589.77888,
            -3290457736.074274,
            2402378591.638406,
        ],
    ],
    [
        1923004800000,
        [
            -6838928487.9569,
            -3297081106.958348,
            2399038549.236775,
        ],
    ],
    [
        1923609600000,
        [
            -6820522679.073215,
            -3301719580.95891,
            2396558497.679399,
        ],
    ],
    [
        1924214400000,
        [
            -6801859447.302031,
            -3304322770.084995,
            2394961256.982774,
        ],
    ],
    [
        1924819200000,
        [
            -6783221016.751634,
            -3304862940.294854,
            2394257874.833447,
        ],
    ],
    [
        1925424000000,
        [
            -6764898682.863412,
            -3303364103.740214,
            2394436990.660387,
        ],
    ],
    [
        1926028800000,
        [
            -6747158654.001178,
            -3299887562.709789,
            2395473135.640285,
        ],
    ],
    [
        1926633600000,
        [
            -6730253257.543066,
            -3294510387.872924,
            2397333702.42962,
        ],
    ],
    [
        1927238400000,
        [
            -6714438990.845534,
            -3287332932.092004,
            2399974073.573494,
        ],
    ],
    [
        1927843200000,
        [
            -6699959703.430045,
            -3278503582.506489,
            2403329212.769017,
        ],
    ],
    [
        1928448000000,
        [
            -6687016331.20457,
            -3268198109.055454,
            2407324126.248013,
        ],
    ],
    [
        1929052800000,
        [
            -6675782416.388809,
            -3256597808.29437,
            2411880811.421681,
        ],
    ],
    [
        1929657600000,
        [
            -6666422456.146297,
            -3243898860.878981,
            2416912978.921918,
        ],
    ],
    [
        1930262400000,
        [
            -6659072504.782964,
            -3230332978.580271,
            2422319755.689147,
        ],
    ],
    [
        1930867200000,
        [
            -6653816255.938571,
            -3216142282.34513,
            2427997455.664793,
        ],
    ],
    [
        1931472000000,
        [
            -6650705173.64081,
            -3201558818.047384,
            2433845843.920093,
        ],
    ],
    [
        1932076800000,
        [
            -6649777562.590671,
            -3186816946.255118,
            2439761961.13459,
        ],
    ],
    [
        1932681600000,
        [
            -6651036930.726346,
            -3172170835.571322,
            2445635495.022829,
        ],
    ],
    [
        1933286400000,
        [
            -6654435333.094124,
            -3157866891.957525,
            2451360944.012425,
        ],
    ],
    [
        1933891200000,
        [
            -6659897202.76359,
            -3144126551.382897,
            2456842443.480653,
        ],
    ],
    [
        1934496000000,
        [
            -6667338287.173641,
            -3131162419.318457,
            2461986375.924785,
        ],
    ],
    [
        1935100800000,
        [
            -6676641423.431014,
            -3119193219.741549,
            2466698074.877932,
        ],
    ],
    [
        1935705600000,
        [
            -6687646757.776161,
            -3108415220.084682,
            2470893773.973007,
        ],
    ],
    [
        1936310400000,
        [
            -6700177813.34541,
            -3098989519.955321,
            2474503550.603587,
        ],
    ],
    [
        1936915200000,
        [
            -6714058880.841693,
            -3091061803.820084,
            2477462762.532534,
        ],
    ],
    [
        1937520000000,
        [
            -6729088007.184571,
            -3084774643.634955,
            2479710007.951079,
        ],
    ],
    [
        1938124800000,
        [
            -6745033236.666545,
            -3080238654.404616,
            2481198598.48705,
        ],
    ],
    [
        1938729600000,
        [
            -6761659671.194409,
            -3077524699.85555,
            2481897525.721613,
        ],
    ],
    [
        1939334400000,
        [
            -6778744032.245664,
            -3076686604.692962,
            2481782006.92031,
        ],
    ],
    [
        1939939200000,
        [
            -6796045283.063403,
            -3077770283.48774,
            2480832765.696303,
        ],
    ],
    [
        1940544000000,
        [
            -6813306128.33422,
            -3080785047.382608,
            2479046924.518417,
        ],
    ],
    [
        1941148800000,
        [
            -6830280311.362398,
            -3085700693.845087,
            2476437082.53742,
        ],
    ],
    [
        1941753600000,
        [
            -6846743393.877727,
            -3092472492.58664,
            2473021296.755042,
        ],
    ],
    [
        1942358400000,
        [
            -6862461970.595945,
            -3101046603.31083,
            2468823737.004888,
        ],
    ],
    [
        1942963200000,
        [
            -6877199840.014398,
            -3111332049.080376,
            2463884855.335055,
        ],
    ],
    [
        1943568000000,
        [
            -6890745102.030824,
            -3123202528.369753,
            2458258697.616033,
        ],
    ],
    [
        1944172800000,
        [
            -6902916403.124206,
            -3136523195.358298,
            2452002567.591485,
        ],
    ],
    [
        1944777600000,
        [
            -6913531875.6764,
            -3151152048.084629,
            2445179037.1851,
        ],
    ],
    [
        1945382400000,
        [
            -6922419386.583848,
            -3166913350.868867,
            2437865126.796641,
        ],
    ],
    [
        1945987200000,
        [
            -6929442979.351602,
            -3183603986.260141,
            2430147959.998214,
        ],
    ],
    [
        1946592000000,
        [
            -6934503824.457007,
            -3201021716.424465,
            2422114272.026653,
        ],
    ],
    [
        1947196800000,
        [
            -6937509778.764951,
            -3218962450.11906,
            2413853707.906266,
        ],
    ],
    [
        1947801600000,
        [
            -6938388894.333178,
            -3237196083.96084,
            2405466673.395585,
        ],
    ],
    [
        1948406400000,
        [
            -6937114457.213379,
            -3255477081.111486,
            2397058475.192238,
        ],
    ],
    [
        1949011200000,
        [
            -6933699809.158482,
            -3273573784.60496,
            2388728845.862081,
        ],
    ],
    [
        1949616000000,
        [
            -6928168933.028194,
            -3291261445.107771,
            2380576510.463903,
        ],
    ],
    [
        1950220800000,
        [
            -6920572102.923306,
            -3308301254.161423,
            2372705472.457512,
        ],
    ],
    [
        1950825600000,
        [
            -6911008396.038828,
            -3324454427.117107,
            2365217943.626567,
        ],
    ],
    [
        1951430400000,
        [
            -6899613649.778738,
            -3339511635.007576,
            2358204230.787542,
        ],
    ],
    [
        1952035200000,
        [
            -6886532077.46632,
            -3353281336.190525,
            2351748731.563344,
        ],
    ],
    [
        1952640000000,
        [
            -6871932948.756697,
            -3365572120.329593,
            2345934728.543125,
        ],
    ],
    [
        1953244800000,
        [
            -6856029465.399657,
            -3376208981.685735,
            2340836679.399811,
        ],
    ],
    [
        1953849600000,
        [
            -6839059803.270702,
            -3385061178.163019,
            2336511082.990461,
        ],
    ],
    [
        1954454400000,
        [
            -6821259966.494395,
            -3392024979.465183,
            2333004274.781629,
        ],
    ],
    [
        1955059200000,
        [
            -6802881077.412243,
            -3397008619.476026,
            2330356155.005974,
        ],
    ],
    [
        1955664000000,
        [
            -6784204244.498282,
            -3399949143.835309,
            2328592576.540613,
        ],
    ],
    [
        1956268800000,
        [
            -6765515945.728545,
            -3400836592.85306,
            2327717946.943542,
        ],
    ],
    [
        1956873600000,
        [
            -6747083262.515807,
            -3399690429.577933,
            2327725145.953331,
        ],
    ],
    [
        1957478400000,
        [
            -6729172542.809712,
            -3396546160.129626,
            2328598687.280463,
        ],
    ],
    [
        1958083200000,
        [
            -6712061042.51534,
            -3391471721.906066,
            2330307717.244195,
        ],
    ],
    [
        1958688000000,
        [
            -6696009088.875025,
            -3384586445.670436,
            2332800873.41414,
        ],
    ],
    [
        1959292800000,
        [
            -6681239771.492575,
            -3376031593.147258,
            2336018147.439601,
        ],
    ],
    [
        1959897600000,
        [
            -6667960423.972467,
            -3365958442.263887,
            2339893626.354424,
        ],
    ],
    [
        1960502400000,
        [
            -6656372377.087353,
            -3354544521.299037,
            2344349024.864544,
        ],
    ],
    [
        1961107200000,
        [
            -6646642320.941507,
            -3342007096.90161,
            2349290801.531779,
        ],
    ],
    [
        1961712000000,
        [
            -6638888455.760224,
            -3328569804.853775,
            2354623131.848806,
        ],
    ],
    [
        1962316800000,
        [
            -6633205607.228848,
            -3314453045.491008,
            2360249892.364076,
        ],
    ],
    [
        1962921600000,
        [
            -6629673829.635394,
            -3299891398.339829,
            2366068166.345037,
        ],
    ],
    [
        1963526400000,
        [
            -6628330128.461002,
            -3285142324.281248,
            2371967237.915625,
        ],
    ],
    [
        1964131200000,
        [
            -6629161976.076668,
            -3270451599.755651,
            2377841566.484761,
        ],
    ],
    [
        1964736000000,
        [
            -6632135447.492917,
            -3256047233.869103,
            2383591504.363013,
        ],
    ],
    [
        1965340800000,
        [
            -6637202342.387009,
            -3242159280.30953,
            2389116221.913467,
        ],
    ],
    [
        1965945600000,
        [
            -6644272123.40019,
            -3229024409.619063,
            2394314215.159367,
        ],
    ],
    [
        1966550400000,
        [
            -6653212560.060028,
            -3216852387.052718,
            2399095416.967198,
        ],
    ],
    [
        1967155200000,
        [
            -6663879251.08803,
            -3205824294.519293,
            2403380338.440922,
        ],
    ],
    [
        1967760000000,
        [
            -6676120382.88555,
            -3196115024.249893,
            2407092222.115947,
        ],
    ],
    [
        1968364800000,
        [
            -6689748348.82661,
            -3187893831.506678,
            2410158928.814114,
        ],
    ],
    [
        1968969600000,
        [
            -6704546783.825613,
            -3181293134.772656,
            2412523749.183365,
        ],
    ],
    [
        1969574400000,
        [
            -6720299733.085561,
            -3176411222.916028,
            2414142950.782147,
        ],
    ],
    [
        1970179200000,
        [
            -6736793300.328636,
            -3173336839.999132,
            2414977324.402765,
        ],
    ],
    [
        1970784000000,
        [
            -6753786843.207135,
            -3172145495.461258,
            2414995456.689904,
        ],
    ],
    [
        1971388800000,
        [
            -6771025666.852419,
            -3172871161.462298,
            2414183100.957017,
        ],
    ],
    [
        1971993600000,
        [
            -6788268552.839094,
            -3175513321.265377,
            2412539265.618849,
        ],
    ],
    [
        1972598400000,
        [
            -6805285917.765893,
            -3180062687.320853,
            2410067485.171619,
        ],
    ],
    [
        1973203200000,
        [
            -6821831110.928267,
            -3186493165.991442,
            2406780436.229675,
        ],
    ],
    [
        1973808000000,
        [
            -6837658113.78689,
            -3194736768.948393,
            2402707824.740425,
        ],
    ],
    [
        1974412800000,
        [
            -6852546641.402039,
            -3204694825.417493,
            2397891147.707101,
        ],
    ],
    [
        1975017600000,
        [
            -6866296627.988846,
            -3216263930.549551,
            2392375018.689434,
        ],
    ],
    [
        1975622400000,
        [
            -6878700531.213608,
            -3229323851.911518,
            2386212937.28689,
        ],
    ],
    [
        1976227200000,
        [
            -6889565277.658941,
            -3243715980.891476,
            2379473631.932866,
        ],
    ],
    [
        1976832000000,
        [
            -6898734420.113631,
            -3259258599.04101,
            2372234562.514199,
        ],
    ],
    [
        1977436800000,
        [
            -6906078669.521529,
            -3275772352.634175,
            2364573554.993161,
        ],
    ],
    [
        1978041600000,
        [
            -6911470097.326035,
            -3293064745.561866,
            2356575423.739256,
        ],
    ],
    [
        1978646400000,
        [
            -6914807238.787892,
            -3310912498.813091,
            2348336679.245082,
        ],
    ],
    [
        1979251200000,
        [
            -6916033793.280124,
            -3329080714.549698,
            2339957823.151907,
        ],
    ],
    [
        1979856000000,
        [
            -6915124617.469307,
            -3347347254.757809,
            2331535501.942937,
        ],
    ],
    [
        1980460800000,
        [
            -6912062396.132165,
            -3365484509.11969,
            2323169710.079448,
        ],
    ],
    [
        1981065600000,
        [
            -6906864387.784002,
            -3383245915.443588,
            2314966827.502231,
        ],
    ],
    [
        1981670400000,
        [
            -6899597020.63451,
            -3400388512.721091,
            2307030878.074909,
        ],
    ],
    [
        1982275200000,
        [
            -6890356517.72042,
            -3416695381.415217,
            2299456491.369565,
        ],
    ],
    [
        1982880000000,
        [
            -6879248257.524955,
            -3431954935.023131,
            2292336626.940779,
        ],
    ],
    [
        1983484800000,
        [
            -6866413437.997577,
            -3445951462.974535,
            2285764106.604393,
        ],
    ],
    [
        1984089600000,
        [
            -6852038964.121285,
            -3458489859.64209,
            2279822287.038919,
        ],
    ],
    [
        1984694400000,
        [
            -6836332149.225945,
            -3469414780.841846,
            2274579323.895523,
        ],
    ],
    [
        1985299200000,
        [
            -6819503042.377588,
            -3478586948.583637,
            2270096679.338717,
        ],
    ],
    [
        1985904000000,
        [
            -6801789739.766004,
            -3485877040.061852,
            2266429578.280172,
        ],
    ],
    [
        1986508800000,
        [
            -6783463532.174767,
            -3491190689.243083,
            2263617843.317354,
        ],
    ],
    [
        1987113600000,
        [
            -6764798260.793709,
            -3494482667.564067,
            2261682096.258903,
        ],
    ],
    [
        1987718400000,
        [
            -6746056568.848102,
            -3495729279.678414,
            2260633480.556211,
        ],
    ],
    [
        1988323200000,
        [
            -6727513793.206846,
            -3494924737.835188,
            2260473541.352351,
        ],
    ],
    [
        1988928000000,
        [
            -6709459325.295689,
            -3492104591.947445,
            2261185971.136074,
        ],
    ],
    [
        1989532800000,
        [
            -6692162774.555458,
            -3487353708.012688,
            2262735182.685,
        ],
    ],
    [
        1990137600000,
        [
            -6675865877.406912,
            -3480774479.983629,
            2265077406.821002,
        ],
    ],
    [
        1990742400000,
        [
            -6660806089.488193,
            -3472485422.666358,
            2268160184.615435,
        ],
    ],
    [
        1991347200000,
        [
            -6647215678.368969,
            -3462642315.368245,
            2271915307.602155,
        ],
    ],
    [
        1991952000000,
        [
            -6635287643.147887,
            -3451440031.726546,
            2276259664.535475,
        ],
    ],
    [
        1992556800000,
        [
            -6625174895.971516,
            -3439077790.538952,
            2281107251.118491,
        ],
    ],
    [
        1993161600000,
        [
            -6617014783.455711,
            -3425760664.898938,
            2286367978.418249,
        ],
    ],
    [
        1993766400000,
        [
            -6610926880.320572,
            -3411719128.857276,
            2291941482.531975,
        ],
    ],
    [
        1994371200000,
        [
            -6606980904.768759,
            -3397205877.118042,
            2297719706.639071,
        ],
    ],
    [
        1994976000000,
        [
            -6605203598.05655,
            -3382460521.669702,
            2303598890.565216,
        ],
    ],
    [
        1995580800000,
        [
            -6605604384.275224,
            -3367715085.330059,
            2309477187.209926,
        ],
    ],
    [
        1996185600000,
        [
            -6608171643.941153,
            -3353213184.292788,
            2315248766.657706,
        ],
    ],
    [
        1996790400000,
        [
            -6612843421.609738,
            -3339202998.277447,
            2320807585.644024,
        ],
    ],
    [
        1997395200000,
        [
            -6619521157.568837,
            -3325903895.69861,
            2326058442.941411,
        ],
    ],
    [
        1998000000000,
        [
            -6628095588.063033,
            -3313516447.804814,
            2330913094.713571,
        ],
    ],
    [
        1998604800000,
        [
            -6638440546.907341,
            -3302241979.193475,
            2335284280.232622,
        ],
    ],
    [
        1999209600000,
        [
            -6650386324.672921,
            -3292272099.758325,
            2339090443.317344,
        ],
    ],
    [
        1999814400000,
        [
            -6663738880.0945,
            -3283759044.171863,
            2342265277.937505,
        ],
    ],
    [
        2000419200000,
        [
            -6678304618.639254,
            -3276829948.930038,
            2344752389.790695,
        ],
    ],
    [
        2001024000000,
        [
            -6693880895.640411,
            -3271606729.363701,
            2346499193.768306,
        ],
    ],
    [
        2001628800000,
        [
            -6710231843.034945,
            -3268191980.315217,
            2347462608.695591,
        ],
    ],
    [
        2002233600000,
        [
            -6727111868.231126,
            -3266644083.429548,
            2347616811.971906,
        ],
    ],
    [
        2002838400000,
        [
            -6744288097.088828,
            -3266995023.817507,
            2346946722.017657,
        ],
    ],
    [
        2003443200000,
        [
            -6761527343.798584,
            -3269270070.851585,
            2345441917.588061,
        ],
    ],
    [
        2004048000000,
        [
            -6778574587.817621,
            -3273469810.244527,
            2343103370.077409,
        ],
    ],
    [
        2004652800000,
        [
            -6795179884.776005,
            -3279550631.45443,
            2339949269.25258,
        ],
    ],
    [
        2005257600000,
        [
            -6811117572.747835,
            -3287445339.131695,
            2336007629.33509,
        ],
    ],
    [
        2005862400000,
        [
            -6826169983.416639,
            -3297082036.817387,
            2331310420.219395,
        ],
    ],
    [
        2006467200000,
        [
            -6840109013.546241,
            -3308362473.349358,
            2325901259.11125,
        ],
    ],
    [
        2007072000000,
        [
            -6852725697.138234,
            -3321148304.561333,
            2319839211.480783,
        ],
    ],
    [
        2007676800000,
        [
            -6863845484.011887,
            -3335283966.686762,
            2313190724.147352,
        ],
    ],
    [
        2008281600000,
        [
            -6873309121.618422,
            -3350614270.114685,
            2306024123.588001,
        ],
    ],
    [
        2008886400000,
        [
            -6880957690.921996,
            -3366959789.332872,
            2298418004.483619,
        ],
    ],
    [
        2009491200000,
        [
            -6886663946.969678,
            -3384109102.013121,
            2290462947.772622,
        ],
    ],
    [
        2010096000000,
        [
            -6890343003.330605,
            -3401843590.956338,
            2282252878.119998,
        ],
    ],
    [
        2010700800000,
        [
            -6891930588.820312,
            -3419953287.794013,
            2273880069.307256,
        ],
    ],
    [
        2011305600000,
        [
            -6891371560.138047,
            -3438210377.482255,
            2265443880.690413,
        ],
    ],
    [
        2011910400000,
        [
            -6888651791.677429,
            -3456367287.720464,
            2257050443.326339,
        ],
    ],
    [
        2012515200000,
        [
            -6883803522.707553,
            -3474183052.217102,
            2248803540.49461,
        ],
    ],
    [
        2013120000000,
        [
            -6876880776.832692,
            -3491436690.42543,
            2240800350.842182,
        ],
    ],
    [
        2013724800000,
        [
            -6867951002.314922,
            -3507899777.430738,
            2233140284.724981,
        ],
    ],
    [
        2014329600000,
        [
            -6857125995.771509,
            -3523339699.673394,
            2225922918.810317,
        ],
    ],
    [
        2014934400000,
        [
            -6844561263.697198,
            -3537546803.728464,
            2219238669.892068,
        ],
    ],
    [
        2015539200000,
        [
            -6830428207.426722,
            -3550344032.763273,
            2213165734.107972,
        ],
    ],
    [
        2016144000000,
        [
            -6814908613.90385,
            -3561558903.128166,
            2207779045.132372,
        ],
    ],
    [
        2016748800000,
        [
            -6798223201.463723,
            -3571030586.90605,
            2203147040.0021,
        ],
    ],
    [
        2017353600000,
        [
            -6780624990.055954,
            -3578636437.992227,
            2199322667.059079,
        ],
    ],
    [
        2017958400000,
        [
            -6762368391.574231,
            -3584296102.745827,
            2196342204.078497,
        ],
    ],
    [
        2018563200000,
        [
            -6743707068.049819,
            -3587942586.232001,
            2194234606.501987,
        ],
    ],
    [
        2019168000000,
        [
            -6724919458.933784,
            -3589531549.815816,
            2193017830.516211,
        ],
    ],
    [
        2019772800000,
        [
            -6706297371.248132,
            -3589065542.523174,
            2192690832.389473,
        ],
    ],
    [
        2020377600000,
        [
            -6688113351.782367,
            -3586591082.421448,
            2193234859.021707,
        ],
    ],
    [
        2020982400000,
        [
            -6670623531.926961,
            -3582168547.423833,
            2194623386.039607,
        ],
    ],
    [
        2021587200000,
        [
            -6654090565.39252,
            -3575882696.642762,
            2196818446.894624,
        ],
    ],
    [
        2022192000000,
        [
            -6638769648.547434,
            -3567863581.868479,
            2199764010.039271,
        ],
    ],
    [
        2022796800000,
        [
            -6624876561.749394,
            -3558276460.82117,
            2203389793.143526,
        ],
    ],
    [
        2023401600000,
        [
            -6612597435.508158,
            -3547291217.090104,
            2207621547.456949,
        ],
    ],
    [
        2024006400000,
        [
            -6602109968.913875,
            -3535094376.787915,
            2212377251.675616,
        ],
    ],
    [
        2024611200000,
        [
            -6593568859.338995,
            -3521906870.486783,
            2217561734.911692,
        ],
    ],
    [
        2025216000000,
        [
            -6587076717.356625,
            -3507968242.336693,
            2223072429.060964,
        ],
    ],
    [
        2025820800000,
        [
            -6582701630.374632,
            -3493507343.061805,
            2228809303.484544,
        ],
    ],
    [
        2026425600000,
        [
            -6580496970.595786,
            -3478756968.177191,
            2234670370.803475,
        ],
    ],
    [
        2027030400000,
        [
            -6580486858.492164,
            -3463969340.992988,
            2240547102.905955,
        ],
    ],
    [
        2027635200000,
        [
            -6582641035.437789,
            -3449396679.314034,
            2246331313.868421,
        ],
    ],
    [
        2028240000000,
        [
            -6586899450.546792,
            -3435265106.894338,
            2251923980.222868,
        ],
    ],
    [
        2028844800000,
        [
            -6593190116.303677,
            -3421792823.608629,
            2257229576.090652,
        ],
    ],
    [
        2029449600000,
        [
            -6601413953.764338,
            -3409203950.284168,
            2262151919.223204,
        ],
    ],
    [
        2030054400000,
        [
            -6611423764.261485,
            -3397706921.456425,
            2266601623.32566,
        ],
    ],
    [
        2030659200000,
        [
            -6623054010.766976,
            -3387473017.982613,
            2270503307.380945,
        ],
    ],
    [
        2031264000000,
        [
            -6636135850.524187,
            -3378658111.192699,
            2273788643.725915,
        ],
    ],
    [
        2031868800000,
        [
            -6650480356.876577,
            -3371414884.22143,
            2276392554.626619,
        ],
    ],
    [
        2032473600000,
        [
            -6665861542.144957,
            -3365869593.307252,
            2278261038.081809,
        ],
    ],
    [
        2033078400000,
        [
            -6682049369.043705,
            -3362106004.672452,
            2279356553.493139,
        ],
    ],
    [
        2033683200000,
        [
            -6698821319.015606,
            -3360190010.607182,
            2279649992.792019,
        ],
    ],
    [
        2034288000000,
        [
            -6715943388.305985,
            -3360179864.896641,
            2279117335.00649,
        ],
    ],
    [
        2034892800000,
        [
            -6733157387.025874,
            -3362101355.005315,
            2277747848.04061,
        ],
    ],
    [
        2035497600000,
        [
            -6750215555.062079,
            -3365937595.847586,
            2275547554.092536,
        ],
    ],
    [
        2036102400000,
        [
            -6766888384.688366,
            -3371655530.763504,
            2272530470.866095,
        ],
    ],
    [
        2036707200000,
        [
            -6782943369.797996,
            -3379213856.311051,
            2268715841.151294,
        ],
    ],
    [
        2037312000000,
        [
            -6798137026.747699,
            -3388536695.911593,
            2264136704.765359,
        ],
    ],
    [
        2037916800000,
        [
            -6812249827.4487,
            -3399509599.842436,
            2258841337.629633,
        ],
    ],
    [
        2038521600000,
        [
            -6825090158.992937,
            -3412007008.855743,
            2252884087.092751,
        ],
    ],
    [
        2039126400000,
        [
            -6836471172.455542,
            -3425897808.12209,
            2246323207.266722,
        ],
    ],
    [
        2039731200000,
        [
            -6846207853.690364,
            -3441017929.37289,
            2239229678.745941,
        ],
    ],
    [
        2040336000000,
        [
            -6854151126.634511,
            -3457172827.474507,
            2231686498.36199,
        ],
    ],
    [
        2040940800000,
        [
            -6860187716.420107,
            -3474165160.158964,
            2223779344.613181,
        ],
    ],
    [
        2041545600000,
        [
            -6864215480.664435,
            -3491798123.408267,
            2215594981.08134,
        ],
    ],
    [
        2042150400000,
        [
            -6866145383.132741,
            -3509847717.033652,
            2207230103.347836,
        ],
    ],
    [
        2042755200000,
        [
            -6865933576.827751,
            -3528071723.478493,
            2198788427.866249,
        ],
    ],
    [
        2043360000000,
        [
            -6863576634.861934,
            -3546236919.639323,
            2190371382.34059,
        ],
    ],
    [
        2043964800000,
        [
            -6859085538.694154,
            -3564120234.221298,
            2182077088.281849,
        ],
    ],
    [
        2044569600000,
        [
            -6852491778.964408,
            -3581481433.952375,
            2174009042.367386,
        ],
    ],
    [
        2045174400000,
        [
            -6843876164.624868,
            -3598078074.417844,
            2166271170.663798,
        ],
    ],
    [
        2045779200000,
        [
            -6833358681.08631,
            -3613691354.08475,
            2158958833.015895,
        ],
    ],
    [
        2046384000000,
        [
            -6821071159.321399,
            -3628124550.123443,
            2152158621.705493,
        ],
    ],
    [
        2046988800000,
        [
            -6807166385.388159,
            -3641176513.017184,
            2145956875.623708,
        ],
    ],
    [
        2047593600000,
        [
            -6791842593.670259,
            -3652661213.164824,
            2140433224.511069,
        ],
    ],
    [
        2048198400000,
        [
            -6775327517.763094,
            -3662430940.349135,
            2135652403.690622,
        ],
    ],
    [
        2048803200000,
        [
            -6757850082.833661,
            -3670370673.798561,
            2131665421.374628,
        ],
    ],
    [
        2049408000000,
        [
            -6739651847.067859,
            -3676372289.913538,
            2128518102.841408,
        ],
    ],
    [
        2050012800000,
        [
            -6721006906.948417,
            -3680356633.789258,
            2126243943.733775,
        ],
    ],
    [
        2050617600000,
        [
            -6702200816.693815,
            -3682292612.474277,
            2124857331.877766,
        ],
    ],
    [
        2051222400000,
        [
            -6683502604.773389,
            -3682185842.969851,
            2124356770.332772,
        ],
    ],
    [
        2051827200000,
        [
            -6665179069.850086,
            -3680053452.894117,
            2124733622.223948,
        ],
    ],
    [
        2052432000000,
        [
            -6647510835.449761,
            -3675946727.13596,
            2125965038.408584,
        ],
    ],
    [
        2053036800000,
        [
            -6630768154.485837,
            -3669965291.655833,
            2128008938.847933,
        ],
    ],
    [
        2053641600000,
        [
            -6615185453.34702,
            -3662239237.924276,
            2130809637.219668,
        ],
    ],
    [
        2054246400000,
        [
            -6600980001.633671,
            -3652905213.725807,
            2134306558.447335,
        ],
    ],
    [
        2054851200000,
        [
            -6588365264.315276,
            -3642128818.615281,
            2138427488.043228,
        ],
    ],
    [
        2055456000000,
        [
            -6577526078.945306,
            -3630114337.868671,
            2143085141.118602,
        ],
    ],
    [
        2056060800000,
        [
            -6568597811.946968,
            -3617081160.305591,
            2148184879.179921,
        ],
    ],
    [
        2056665600000,
        [
            -6561690655.431123,
            -3603242878.851329,
            2153632706.699005,
        ],
    ],
    [
        2057270400000,
        [
            -6556900749.631083,
            -3588829841.468522,
            2159328521.765284,
        ],
    ],
    [
        2057875200000,
        [
            -6554286346.329335,
            -3574095730.166893,
            2165163731.015348,
        ],
    ],
    [
        2058480000000,
        [
            -6553852487.945074,
            -3559290243.025259,
            2171030301.284187,
        ],
    ],
    [
        2059084800000,
        [
            -6555580838.355658,
            -3544643152.442685,
            2176827226.766442,
        ],
    ],
    [
        2059689600000,
        [
            -6559437981.972063,
            -3530387771.81446,
            2182453308.695166,
        ],
    ],
    [
        2060294400000,
        [
            -6565352840.094862,
            -3516765430.117856,
            2187805342.8653,
        ],
    ],
    [
        2060899200000,
        [
            -6573206614.717385,
            -3503996413.311846,
            2192787774.096379,
        ],
    ],
    [
        2061504000000,
        [
            -6582866786.737649,
            -3492270216.21826,
            2197317117.54867,
        ],
    ],
    [
        2062108800000,
        [
            -6594191546.374607,
            -3481770186.595259,
            2201314044.013017,
        ],
    ],
    [
        2062713600000,
        [
            -6607007976.626302,
            -3472676104.744947,
            2204702002.908252,
        ],
    ],
    [
        2063318400000,
        [
            -6621106648.03356,
            -3465134732.298333,
            2207417025.967641,
        ],
    ],
    [
        2063923200000,
        [
            -6636277912.800964,
            -3459256553.712219,
            2209409978.328478,
        ],
    ],
    [
        2064528000000,
        [
            -6652311772.498492,
            -3455141234.664038,
            2210638034.462966,
        ],
    ],
    [
        2065132800000,
        [
            -6668976360.341092,
            -3452877902.690219,
            2211063871.078128,
        ],
    ],
    [
        2065737600000,
        [
            -6686016885.442062,
            -3452516073.5731,
            2210665390.025406,
        ],
    ],
    [
        2066342400000,
        [
            -6703192438.214674,
            -3454068607.824176,
            2209435896.507845,
        ],
    ],
    [
        2066947200000,
        [
            -6720271250.999655,
            -3457537345.727381,
            2207375201.884634,
        ],
    ],
    [
        2067552000000,
        [
            -6737009343.11539,
            -3462910611.636882,
            2204489580.534678,
        ],
    ],
    [
        2068156800000,
        [
            -6753153933.802027,
            -3470135080.452576,
            2200801253.576069,
        ],
    ],
    [
        2068761600000,
        [
            -6768479207.735355,
            -3479124537.845987,
            2196346606.601941,
        ],
    ],
    [
        2069366400000,
        [
            -6782777378.530819,
            -3489785103.894629,
            2191167157.40767,
        ],
    ],
    [
        2069971200000,
        [
            -6795837588.97208,
            -3502009784.861984,
            2185310372.135864,
        ],
    ],
    [
        2070576000000,
        [
            -6807454058.408122,
            -3515651903.05334,
            2178838726.217638,
        ],
    ],
    [
        2071180800000,
        [
            -6817459377.043312,
            -3530539331.09533,
            2171825992.674828,
        ],
    ],
    [
        2071785600000,
        [
            -6825711854.083864,
            -3546498847.172462,
            2164348259.805406,
        ],
    ],
    [
        2072390400000,
        [
            -6832074738.836999,
            -3563347942.136395,
            2156485567.082728,
        ],
    ],
    [
        2072995200000,
        [
            -6836429130.868864,
            -3580870526.363056,
            2148330328.071979,
        ],
    ],
    [
        2073600000000,
        [
            -6838703336.121998,
            -3598836353.418344,
            2139981679.273759,
        ],
    ],
    [
        2074204800000,
        [
            -6838856716.137154,
            -3617024024.057691,
            2131536722.92775,
        ],
    ],
    [
        2074809600000,
        [
            -6836859070.608353,
            -3635210451.458656,
            2123092886.022366,
        ],
    ],
    [
        2075414400000,
        [
            -6832707799.279214,
            -3653149440.216372,
            2114755541.743666,
        ],
    ],
    [
        2076019200000,
        [
            -6826451797.779949,
            -3670595797.392705,
            2106630513.013646,
        ],
    ],
    [
        2076624000000,
        [
            -6818171650.07162,
            -3687326172.119921,
            2098815831.616215,
        ],
    ],
    [
        2077228800000,
        [
            -6807958840.57517,
            -3703126367.011077,
            2091404827.09679,
        ],
    ],
    [
        2077833600000,
        [
            -6795936108.602591,
            -3717772907.091456,
            2084492980.834701,
        ],
    ],
    [
        2078438400000,
        [
            -6782274611.705941,
            -3731060750.868659,
            2078168957.073586,
        ],
    ],
    [
        2079043200000,
        [
            -6767170239.899405,
            -3742820583.393603,
            2072507413.368493,
        ],
    ],
    [
        2079648000000,
        [
            -6750822626.708996,
            -3752903545.840149,
            2067573080.290398,
        ],
    ],
    [
        2080252800000,
        [
            -6733457570.209407,
            -3761165232.271325,
            2063427153.575699,
        ],
    ],
    [
        2080857600000,
        [
            -6715337105.238178,
            -3767495213.780284,
            2060117552.858914,
        ],
    ],
    [
        2081462400000,
        [
            -6696732350.843834,
            -3771829047.792877,
            2057673502.69647,
        ],
    ],
    [
        2082067200000,
        [
            -6677903304.980259,
            -3774129468.296649,
            2056111076.48824,
        ],
    ],
    [
        2082672000000,
        [
            -6659122901.463273,
            -3774371979.345826,
            2055439503.165593,
        ],
    ],
    [
        2083276800000,
        [
            -6640681065.729393,
            -3772574244.768724,
            2055651439.307324,
        ],
    ],
    [
        2083881600000,
        [
            -6622855623.193435,
            -3768801595.891768,
            2056719859.431502,
        ],
    ],
    [
        2084486400000,
        [
            -6605895069.931986,
            -3763144005.858621,
            2058605416.977957,
        ],
    ],
    [
        2085091200000,
        [
            -6590044783.653879,
            -3755703173.685339,
            2061262677.320825,
        ],
    ],
    [
        2085696000000,
        [
            -6575547113.09519,
            -3746620598.425427,
            2064630848.867524,
        ],
    ],
    [
        2086300800000,
        [
            -6562612514.025061,
            -3736076820.859663,
            2068632934.02411,
        ],
    ],
    [
        2086905600000,
        [
            -6551407773.389494,
            -3724264644.403594,
            2073184778.034583,
        ],
    ],
    [
        2087510400000,
        [
            -6542085083.735219,
            -3711378951.534971,
            2078200641.239402,
        ],
    ],
    [
        2088115200000,
        [
            -6534779811.762023,
            -3697643383.195364,
            2083584313.930846,
        ],
    ],
    [
        2088720000000,
        [
            -6529583507.447363,
            -3683304939.788893,
            2089229908.997323,
        ],
    ],
    [
        2089324800000,
        [
            -6526538993.629436,
            -3668604983.083641,
            2095032011.939536,
        ],
    ],
    [
        2089929600000,
        [
            -6525672177.617026,
            -3653773809.724174,
            2100889687.806786,
        ],
    ],
    [
        2090534400000,
        [
            -6526987766.012671,
            -3639056300.839103,
            2106697669.904105,
        ],
    ],
    [
        2091139200000,
        [
            -6530444650.449875,
            -3624703781.032177,
            2112348060.998987,
        ],
    ],
    [
        2091744000000,
        [
            -6535957747.871414,
            -3610944537.01954,
            2117740915.133423,
        ],
    ],
    [
        2092348800000,
        [
            -6543431386.230903,
            -3597984770.713816,
            2122785962.313847,
        ],
    ],
    [
        2092953600000,
        [
            -6552752184.071937,
            -3586033207.671848,
            2127393734.463165,
        ],
    ],
    [
        2093558400000,
        [
            -6563766589.251418,
            -3575291363.841305,
            2131477741.923619,
        ],
    ],
    [
        2094163200000,
        [
            -6576288454.359895,
            -3565924849.065724,
            2134965019.425542,
        ],
    ],
    [
        2094768000000,
        [
            -6590132398.517056,
            -3558071260.307875,
            2137795296.548704,
        ],
    ],
    [
        2095372800000,
        [
            -6605103007.871305,
            -3551863203.448006,
            2139912213.425228,
        ],
    ],
    [
        2095977600000,
        [
            -6620974303.474314,
            -3547417222.798488,
            2141265903.269598,
        ],
    ],
    [
        2096582400000,
        [
            -6637501960.990142,
            -3544806677.711545,
            2141823224.786017,
        ],
    ],
    [
        2097187200000,
        [
            -6654455214.800194,
            -3544076216.013315,
            2141564472.166881,
        ],
    ],
    [
        2097792000000,
        [
            -6671602093.271953,
            -3545262528.119151,
            2140474954.882879,
        ],
    ],
    [
        2098396800000,
        [
            -6688690920.755792,
            -3548381761.866487,
            2138548102.58178,
        ],
    ],
    [
        2099001600000,
        [
            -6705466422.887181,
            -3553404609.329446,
            2135795148.172614,
        ],
    ],
    [
        2099606400000,
        [
            -6721699087.286514,
            -3560276537.321471,
            2132239635.633079,
        ],
    ],
    [
        2100211200000,
        [
            -6737166715.832202,
            -3568935845.861623,
            2127909582.149465,
        ],
    ],
    [
        2100816000000,
        [
            -6751638259.468249,
            -3579299396.274673,
            2122841232.254458,
        ],
    ],
    [
        2101420800000,
        [
            -6764893324.609636,
            -3591240631.802394,
            2117087907.685945,
        ],
    ],
    [
        2102025600000,
        [
            -6776748055.126303,
            -3604614635.353675,
            2110712568.152257,
        ],
    ],
    [
        2102630400000,
        [
            -6787033523.901217,
            -3619273461.855252,
            2103780632.023318,
        ],
    ],
    [
        2103235200000,
        [
            -6795582092.986585,
            -3635050238.328475,
            2096364414.09734,
        ],
    ],
    [
        2103840000000,
        [
            -6802249896.76142,
            -3651740979.22684,
            2088550813.129546,
        ],
    ],
    [
        2104444800000,
        [
            -6806938205.424057,
            -3669133547.095963,
            2080432141.615783,
        ],
    ],
    [
        2105049600000,
        [
            -6809569094.29274,
            -3687020437.617295,
            2072099602.828392,
        ],
    ],
    [
        2105654400000,
        [
            -6810074140.041644,
            -3705181472.350269,
            2063648378.571585,
        ],
    ],
    [
        2106259200000,
        [
            -6808419259.001083,
            -3723370210.848351,
            2055183866.615435,
        ],
    ],
    [
        2106864000000,
        [
            -6804620239.318364,
            -3741345782.867359,
            2046811035.794181,
        ],
    ],
    [
        2107468800000,
        [
            -6798715887.181935,
            -3758883119.948258,
            2038628624.864037,
        ],
    ],
    [
        2108073600000,
        [
            -6790758422.158141,
            -3775754370.949543,
            2030734885.12159,
        ],
    ],
    [
        2108678400000,
        [
            -6780839761.997401,
            -3791720266.107389,
            2023232269.091938,
        ],
    ],
    [
        2109283200000,
        [
            -6769099811.321414,
            -3806563422.943587,
            2016215761.12366,
        ],
    ],
    [
        2109888000000,
        [
            -6755697231.61771,
            -3820095384.518983,
            2009768117.724745,
        ],
    ],
    [
        2110492800000,
        [
            -6740800794.984951,
            -3832136488.953601,
            2003966436.343248,
        ],
    ],
    [
        2111097600000,
        [
            -6724616191.59581,
            -3842511711.653848,
            1998885524.654802,
        ],
    ],
    [
        2111702400000,
        [
            -6707386215.935239,
            -3851083551.575651,
            1994585928.620482,
        ],
    ],
    [
        2112307200000,
        [
            -6689359812.76648,
            -3857754501.449878,
            1991110849.952216,
        ],
    ],
    [
        2112912000000,
        [
            -6670784320.470355,
            -3862444707.213511,
            1988493871.050891,
        ],
    ],
    [
        2113516800000,
        [
            -6651932449.541358,
            -3865091081.429067,
            1986761497.155134,
        ],
    ],
    [
        2114121600000,
        [
            -6633094876.99831,
            -3865677796.263797,
            1985921693.432936,
        ],
    ],
    [
        2114726400000,
        [
            -6614549223.818439,
            -3864232730.96859,
            1985963168.078414,
        ],
    ],
    [
        2115331200000,
        [
            -6596554420.987211,
            -3860802483.915303,
            1986864485.168843,
        ],
    ],
    [
        2115936000000,
        [
            -6579378354.107348,
            -3855453667.571841,
            1988596149.101762,
        ],
    ],
    [
        2116540800000,
        [
            -6563284838.492923,
            -3848299869.186216,
            1991110142.569034,
        ],
    ],
    [
        2117145600000,
        [
            -6548504854.042094,
            -3839491662.20085,
            1994341826.953153,
        ],
    ],
    [
        2117750400000,
        [
            -6535235175.645487,
            -3829189584.595896,
            1998220244.495079,
        ],
    ],
    [
        2118355200000,
        [
            -6523667366.161236,
            -3817567617.779833,
            2002669580.989066,
        ],
    ],
    [
        2118960000000,
        [
            -6513971477.42759,
            -3804836802.780562,
            2007599637.281038,
        ],
    ],
    [
        2119564800000,
        [
            -6506271353.037928,
            -3791229930.854066,
            2012909937.71603,
        ],
    ],
    [
        2120169600000,
        [
            -6500649272.98082,
            -3776974198.461386,
            2018500571.728663,
        ],
    ],
    [
        2120774400000,
        [
            -6497176093.273808,
            -3762297992.757944,
            2024272379.934723,
        ],
    ],
    [
        2121379200000,
        [
            -6495893089.082552,
            -3747452023.174222,
            2030117980.802491,
        ],
    ],
    [
        2121984000000,
        [
            -6496791756.909593,
            -3732690623.480968,
            2035927322.583543,
        ],
    ],
    [
        2122588800000,
        [
            -6499824915.240442,
            -3718246003.477134,
            2041598316.939996,
        ],
    ],
    [
        2123193600000,
        [
            -6504936613.624867,
            -3704339655.859052,
            2047035054.466722,
        ],
    ],
    [
        2123798400000,
        [
            -6512042356.702719,
            -3691201431.397349,
            2052139171.5109,
        ],
    ],
    [
        2124403200000,
        [
            -6521012765.322861,
            -3679049121.308196,
            2056816189.886508,
        ],
    ],
    [
        2125008000000,
        [
            -6531690462.591774,
            -3668065591.450449,
            2060985439.19731,
        ],
    ],
    [
        2125612800000,
        [
            -6543917869.819181,
            -3658415469.89651,
            2064575932.431111,
        ],
    ],
    [
        2126217600000,
        [
            -6557515580.762017,
            -3650261756.179749,
            2067518235.735137,
        ],
    ],
    [
        2126822400000,
        [
            -6572269090.207491,
            -3643744636.864502,
            2069751237.684371,
        ],
    ],
    [
        2127427200000,
        [
            -6587950390.668571,
            -3638962041.94924,
            2071231140.152107,
        ],
    ],
    [
        2128032000000,
        [
            -6604342059.361883,
            -3635991474.968648,
            2071924981.650636,
        ],
    ],
    [
        2128636800000,
        [
            -6621213771.195663,
            -3634903315.319655,
            2071803406.567086,
        ],
    ],
    [
        2129241600000,
        [
            -6638311747.486188,
            -3635739315.64407,
            2070847719.083248,
        ],
    ],
    [
        2129846400000,
        [
            -6655384032.342823,
            -3638496752.190696,
            2069057836.963708,
        ],
    ],
    [
        2130451200000,
        [
            -6672199877.948274,
            -3643154772.679684,
            2066443656.349546,
        ],
    ],
    [
        2131056000000,
        [
            -6688524761.474374,
            -3649683709.61089,
            2063019089.721463,
        ],
    ],
    [
        2131660800000,
        [
            -6704112670.345758,
            -3658023577.331718,
            2058809328.903682,
        ],
    ],
    [
        2132265600000,
        [
            -6718734120.411681,
            -3668072000.467134,
            2053857612.572068,
        ],
    ],
    [
        2132870400000,
        [
            -6732190326.392803,
            -3679714279.369061,
            2048214693.001479,
        ],
    ],
    [
        2133475200000,
        [
            -6744287230.895638,
            -3692828514.870797,
            2041934322.845006,
        ],
    ],
    [
        2134080000000,
        [
            -6754830898.006974,
            -3707264492.198586,
            2035080638.050496,
        ],
    ],
    [
        2134684800000,
        [
            -6763657284.209568,
            -3722835755.739115,
            2027733497.767397,
        ],
    ],
    [
        2135289600000,
        [
            -6770640851.917397,
            -3739352522.230875,
            2019976330.25376,
        ],
    ],
    [
        2135894400000,
        [
            -6775667941.3138,
            -3756622884.819179,
            2011893050.318331,
        ],
    ],
    [
        2136499200000,
        [
            -6778635333.757601,
            -3774432499.25496,
            2003575460.803078,
        ],
    ],
    [
        2137104000000,
        [
            -6779480583.797958,
            -3792541295.453989,
            1995126889.05446,
        ],
    ],
    [
        2137708800000,
        [
            -6778184614.58434,
            -3810718180.784628,
            1986648760.861594,
        ],
    ],
    [
        2138313600000,
        [
            -6774744402.710438,
            -3828738767.540682,
            1978238849.020561,
        ],
    ],
    [
        2138918400000,
        [
            -6769174328.42764,
            -3846366057.44634,
            1969998666.898695,
        ],
    ],
    [
        2139523200000,
        [
            -6761535667.009541,
            -3863352112.026983,
            1962035225.492206,
        ],
    ],
    [
        2140128000000,
        [
            -6751932512.067601,
            -3879473033.659446,
            1954446894.818456,
        ],
    ],
    [
        2140732800000,
        [
            -6740483534.135093,
            -3894523376.735641,
            1947322995.214822,
        ],
    ],
    [
        2141337600000,
        [
            -6727325388.121099,
            -3908297477.433774,
            1940751363.241165,
        ],
    ],
    [
        2141942400000,
        [
            -6712640063.605918,
            -3920595837.223416,
            1934818307.181611,
        ],
    ],
    [
        2142547200000,
        [
            -6696643637.058896,
            -3931258239.958513,
            1929594631.318569,
        ],
    ],
    [
        2143152000000,
        [
            -6679557261.967569,
            -3940154384.77524,
            1925136844.645295,
        ],
    ],
    [
        2143756800000,
        [
            -6661612114.087955,
            -3947164881.523497,
            1921495313.927312,
        ],
    ],
    [
        2144361600000,
        [
            -6643074042.267016,
            -3952191402.092217,
            1918712781.972815,
        ],
    ],
    [
        2144966400000,
        [
            -6624225501.760341,
            -3955185495.213968,
            1916811607.236802,
        ],
    ],
    [
        2145571200000,
        [
            -6605337076.618711,
            -3956134602.088589,
            1915797044.678088,
        ],
    ],
    [
        2146176000000,
        [
            -6586674334.039742,
            -3955041695.810549,
            1915666384.562065,
        ],
    ],
    [
        2146780800000,
        [
            -6568520406.859275,
            -3951938077.545779,
            1916406445.144593,
        ],
    ],
    [
        2147385600000,
        [
            -6551152700.458946,
            -3946906140.777987,
            1917982812.733392,
        ],
    ],
    [
        2147990400000,
        [
            -6534817421.275595,
            -3940060444.984189,
            1920345456.045469,
        ],
    ],
    [
        2148595200000,
        [
            -6519739618.730928,
            -3931525967.081433,
            1923438811.540941,
        ],
    ],
    [
        2149200000000,
        [
            -6506145002.617948,
            -3921453068.329924,
            1927198336.538007,
        ],
    ],
    [
        2149804800000,
        [
            -6494233619.997142,
            -3910034030.964379,
            1931541866.831424,
        ],
    ],
    [
        2150409600000,
        [
            -6484159859.888893,
            -3897480086.729093,
            1936377294.517188,
        ],
    ],
    [
        2151014400000,
        [
            -6476046921.997652,
            -3883999730.460914,
            1941612952.503502,
        ],
    ],
    [
        2151619200000,
        [
            -6470008558.256519,
            -3869816285.31298,
            1947152893.544368,
        ],
    ],
    [
        2152224000000,
        [
            -6466121375.466314,
            -3855179400.962079,
            1952889911.254872,
        ],
    ],
    [
        2152828800000,
        [
            -6464411453.109394,
            -3840339798.504173,
            1958714601.249995,
        ],
    ],
    [
        2153433600000,
        [
            -6464873520.590803,
            -3825529818.435935,
            1964525121.435545,
        ],
    ],
    [
        2154038400000,
        [
            -6467491916.401624,
            -3810984207.094445,
            1970220777.147736,
        ],
    ],
    [
        2154643200000,
        [
            -6472212139.658704,
            -3796947938.139807,
            1975696184.059131,
        ],
    ],
    [
        2155248000000,
        [
            -6478933623.438559,
            -3783650310.805568,
            1980851037.95491,
        ],
    ],
    [
        2155852800000,
        [
            -6487532935.990252,
            -3771289493.299292,
            1985598510.874408,
        ],
    ],
    [
        2156457600000,
        [
            -6497882279.110748,
            -3760056630.490245,
            1989856987.599752,
        ],
    ],
    [
        2157062400000,
        [
            -6509820416.522407,
            -3750140616.690248,
            1993545181.406792,
        ],
    ],
    [
        2157667200000,
        [
            -6523150382.397122,
            -3741702493.062546,
            1996592198.292682,
        ],
    ],
    [
        2158272000000,
        [
            -6537665701.429343,
            -3734864838.808928,
            1998944197.825551,
        ],
    ],
    [
        2158876800000,
        [
            -6553164700.395536,
            -3729738670.47703,
            2000554434.240323,
        ],
    ],
    [
        2159481600000,
        [
            -6569421138.127104,
            -3726425049.848194,
            2001379490.953763,
        ],
    ],
    [
        2160086400000,
        [
            -6586185734.224494,
            -3724990198.009932,
            2001389427.425534,
        ],
    ],
    [
        2160691200000,
        [
            -6603214551.413808,
            -3725459909.878753,
            2000572592.231255,
        ],
    ],
    [
        2161296000000,
        [
            -6620277907.799,
            -3727848422.753858,
            1998924262.912224,
        ],
    ],
    [
        2161900800000,
        [
            -6637131441.259913,
            -3732156494.563324,
            1996444308.718195,
        ],
    ],
    [
        2162505600000,
        [
            -6653520781.283554,
            -3738347553.9826,
            1993147247.021754,
        ],
    ],
    [
        2163110400000,
        [
            -6669211403.771858,
            -3746347050.535623,
            1989065174.459756,
        ],
    ],
    [
        2163715200000,
        [
            -6683991492.287399,
            -3756072503.400373,
            1984235292.342171,
        ],
    ],
    [
        2164320000000,
        [
            -6697644346.639243,
            -3767427875.924369,
            1978699234.454528,
        ],
    ],
    [
        2164924800000,
        [
            -6709955848.793353,
            -3780281262.591286,
            1972512803.178061,
        ],
    ],
    [
        2165529600000,
        [
            -6720745030.50905,
            -3794469063.808062,
            1965746963.833032,
        ],
    ],
    [
        2166134400000,
        [
            -6729860586.402771,
            -3809826572.361908,
            1958474493.270985,
        ],
    ],
    [
        2166739200000,
        [
            -6737155323.204269,
            -3826178819.121969,
            1950771035.145944,
        ],
    ],
    [
        2167344000000,
        [
            -6742496116.804272,
            -3843320481.879114,
            1942724235.231898,
        ],
    ],
    [
        2167948800000,
        [
            -6745794109.412522,
            -3861024763.649522,
            1934432736.291932,
        ],
    ],
    [
        2168553600000,
        [
            -6746994705.52819,
            -3879073907.957082,
            1925992195.115421,
        ],
    ],
    [
        2169158400000,
        [
            -6746054218.59703,
            -3897246909.757835,
            1917497991.129143,
        ],
    ],
    [
        2169763200000,
        [
            -6742951817.84009,
            -3915302250.833882,
            1909053525.997018,
        ],
    ],
    [
        2170368000000,
        [
            -6737717850.765135,
            -3932991179.378347,
            1900767246.099863,
        ],
    ],
    [
        2170972800000,
        [
            -6730417190.895083,
            -3950087276.172858,
            1892738421.732614,
        ],
    ],
    [
        2171577600000,
        [
            -6721127643.675786,
            -3966371293.80388,
            1885061447.320254,
        ],
    ],
    [
        2172182400000,
        [
            -6709953177.365125,
            -3981616804.331254,
            1877833281.195826,
        ],
    ],
    [
        2172787200000,
        [
            -6697048691.36975,
            -3995607143.141056,
            1871148728.904036,
        ],
    ],
    [
        2173392000000,
        [
            -6682596828.703691,
            -4008162530.15105,
            1865086694.603815,
        ],
    ],
    [
        2173996800000,
        [
            -6666787553.672647,
            -4019121818.498411,
            1859716180.834921,
        ],
    ],
    [
        2174601600000,
        [
            -6649832157.867515,
            -4028330303.367138,
            1855103180.513537,
        ],
    ],
    [
        2175206400000,
        [
            -6631983293.269885,
            -4035659088.852622,
            1851304674.352416,
        ],
    ],
    [
        2175811200000,
        [
            -6613506116.428839,
            -4041027642.730095,
            1848356393.000837,
        ],
    ],
    [
        2176416000000,
        [
            -6594659185.428682,
            -4044381850.49302,
            1846280773.181029,
        ],
    ],
    [
        2177020800000,
        [
            -6575709543.689322,
            -4045682680.182409,
            1845093824.368554,
        ],
    ],
    [
        2177625600000,
        [
            -6556948055.103466,
            -4044926681.13635,
            1844798304.733406,
        ],
    ],
    [
        2178230400000,
        [
            -6538656854.380903,
            -4042161934.706071,
            1845374025.297812,
        ],
    ],
    [
        2178835200000,
        [
            -6521093040.475571,
            -4037462209.666112,
            1846787868.067976,
        ],
    ],
    [
        2179440000000,
        [
            -6504506048.3534,
            -4030915608.856693,
            1849000932.393724,
        ],
    ],
    [
        2180044800000,
        [
            -6489149477.721878,
            -4022645673.835577,
            1851961021.209291,
        ],
    ],
    [
        2180649600000,
        [
            -6475247438.942612,
            -4012819855.775791,
            1855595994.863107,
        ],
    ],
    [
        2181254400000,
        [
            -6462983281.448066,
            -4001620803.165326,
            1859825465.918433,
        ],
    ],
    [
        2181859200000,
        [
            -6452520479.03237,
            -3989235411.530925,
            1864567952.380807,
        ],
    ],
    [
        2182464000000,
        [
            -6444012208.987746,
            -3975877060.356545,
            1869732362.56059,
        ],
    ],
    [
        2183068800000,
        [
            -6437568607.595193,
            -3961787264.357718,
            1875214202.77679,
        ],
    ],
    [
        2183673600000,
        [
            -6433252132.888761,
            -3947206202.065946,
            1880908108.406383,
        ],
    ],
    [
        2184278400000,
        [
            -6431102105.930956,
            -3932363674.230326,
            1886714273.045583,
        ],
    ],
    [
        2184883200000,
        [
            -6431142298.665955,
            -3917503320.336154,
            1892528505.563526,
        ],
    ],
    [
        2185488000000,
        [
            -6433349820.924866,
            -3902878889.610208,
            1898240737.095941,
        ],
    ],
    [
        2186092800000,
        [
            -6437657261.847571,
            -3888726106.171342,
            1903747516.036002,
        ],
    ],
    [
        2186697600000,
        [
            -6443979813.383658,
            -3875257117.661737,
            1908956968.598303,
        ],
    ],
    [
        2187302400000,
        [
            -6452220117.521288,
            -3862686889.639091,
            1913777324.447566,
        ],
    ],
    [
        2187907200000,
        [
            -6462238623.331895,
            -3851225316.928876,
            1918117259.37373,
        ],
    ],
    [
        2188512000000,
        [
            -6473861576.207671,
            -3841051634.969183,
            1921897813.399153,
        ],
    ],
    [
        2189116800000,
        [
            -6486909206.103581,
            -3832313304.268896,
            1925055414.583541,
        ],
    ],
    [
        2189721600000,
        [
            -6501196798.834918,
            -3825153880.745631,
            1927529204.990976,
        ],
    ],
    [
        2190326400000,
        [
            -6516506362.341823,
            -3819701631.832987,
            1929263008.226145,
        ],
    ],
    [
        2190931200000,
        [
            -6532599277.524503,
            -3816046809.066935,
            1930216476.43341,
        ],
    ],
    [
        2191536000000,
        [
            -6549244321.682621,
            -3814245287.956725,
            1930365968.532131,
        ],
    ],
    [
        2192140800000,
        [
            -6566214203.70816,
            -3814346728.737728,
            1929691237.135823,
        ],
    ],
    [
        2192745600000,
        [
            -6583258882.417844,
            -3816380060.794551,
            1928178970.904051,
        ],
    ],
    [
        2193350400000,
        [
            -6600121894.63993,
            -3820333535.140072,
            1925833122.274618,
        ],
    ],
    [
        2193955200000,
        [
            -6616567448.852454,
            -3826163148.126455,
            1922673550.316028,
        ],
    ],
    [
        2194560000000,
        [
            -6632372032.307547,
            -3833819925.327648,
            1918722610.039683,
        ],
    ],
    [
        2195164800000,
        [
            -6647300176.297543,
            -3843232687.826997,
            1914010229.04201,
        ],
    ],
    [
        2195769600000,
        [
            -6661123676.942937,
            -3854290865.768791,
            1908583332.896523,
        ],
    ],
    [
        2196374400000,
        [
            -6673647234.871407,
            -3866857669.1146,
            1902502190.840015,
        ],
    ],
    [
        2196979200000,
        [
            -6684694943.626489,
            -3880795599.904487,
            1895827313.516008,
        ],
    ],
    [
        2197584000000,
        [
            -6694089384.744228,
            -3895947119.352759,
            1888625935.290315,
        ],
    ],
    [
        2198188800000,
        [
            -6701672932.370877,
            -3912120455.220792,
            1880980357.355006,
        ],
    ],
    [
        2198793600000,
        [
            -6707331320.458005,
            -3929107410.567996,
            1872981974.01407,
        ],
    ],
    [
        2199398400000,
        [
            -6710974821.421692,
            -3946706492.933371,
            1864718767.544601,
        ],
    ],
    [
        2200003200000,
        [
            -6712521221.377035,
            -3964702230.903725,
            1856282977.711915,
        ],
    ],
    [
        2200608000000,
        [
            -6711918185.659915,
            -3982854365.670792,
            1847778133.326679,
        ],
    ],
    [
        2201212800000,
        [
            -6709163835.506982,
            -4000919889.550889,
            1839310880.493791,
        ],
    ],
    [
        2201817600000,
        [
            -6704282363.682687,
            -4018673231.745143,
            1830979356.707753,
        ],
    ],
    [
        2202422400000,
        [
            -6697310828.966731,
            -4035884749.831006,
            1822881863.605089,
        ],
    ],
    [
        2203027200000,
        [
            -6688321328.612881,
            -4052313492.47084,
            1815122451.021772,
        ],
    ],
    [
        2203632000000,
        [
            -6677437389.011482,
            -4067732457.289578,
            1807800960.440568,
        ],
    ],
    [
        2204236800000,
        [
            -6664803902.420211,
            -4081945010.454356,
            1801002711.308809,
        ],
    ],
    [
        2204841600000,
        [
            -6650577213.822595,
            -4094762460.934005,
            1794808206.351408,
        ],
    ],
    [
        2205446400000,
        [
            -6634946040.514713,
            -4105999981.889448,
            1789297382.374289,
        ],
    ],
    [
        2206051200000,
        [
            -6618142668.10341,
            -4115503343.191975,
            1784538616.815982,
        ],
    ],
    [
        2206656000000,
        [
            -6600407824.505253,
            -4123160280.774271,
            1780580407.438539,
        ],
    ],
    [
        2207260800000,
        [
            -6581983725.20659,
            -4128876364.918362,
            1777462396.422794,
        ],
    ],
    [
        2207865600000,
        [
            -6563133594.769857,
            -4132573053.974791,
            1775218661.966039,
        ],
    ],
    [
        2208470400000,
        [
            -6544147510.854633,
            -4134213872.891157,
            1773866541.0623,
        ],
    ],
    [
        2209075200000,
        [
            -6525304166.572594,
            -4133809339.155027,
            1773401086.826643,
        ],
    ],
    [
        2209680000000,
        [
            -6506867441.407049,
            -4131390340.060495,
            1773807670.694747,
        ],
    ],
    [
        2210284800000,
        [
            -6489105665.92528,
            -4127007362.031561,
            1775064666.568032,
        ],
    ],
    [
        2210889600000,
        [
            -6472293011.710357,
            -4120754810.343221,
            1777132594.437516,
        ],
    ],
    [
        2211494400000,
        [
            -6456671222.358238,
            -4112768834.058547,
            1779951843.942778,
        ],
    ],
    [
        2212099200000,
        [
            -6442451059.209152,
            -4103198553.102464,
            1783456631.506979,
        ],
    ],
    [
        2212704000000,
        [
            -6429833022.33749,
            -4092206433.255955,
            1787577038.020918,
        ],
    ],
    [
        2213308800000,
        [
            -6419005486.918197,
            -4079990866.009346,
            1792228353.49773,
        ],
    ],
    [
        2213913600000,
        [
            -6410109345.233704,
            -4066777482.36035,
            1797311979.270151,
        ],
    ],
    [
        2214518400000,
        [
            -6403245407.974467,
            -4052790066.375553,
            1802729891.793463,
        ],
    ],
    [
        2215123200000,
        [
            -6398497495.308915,
            -4038253008.970435,
            1808385587.664289,
        ],
    ],
    [
        2215728000000,
        [
            -6395927792.915547,
            -4023413224.248124,
            1814173127.103846,
        ],
    ],
    [
        2216332800000,
        [
            -6395545977.76796,
            -4008526326.534137,
            1819980724.670309,
        ],
    ],
    [
        2216937600000,
        [
            -6397322524.586479,
            -3993829667.145067,
            1825704613.814342,
        ],
    ],
    [
        2217542400000,
        [
            -6401213618.211957,
            -3979547931.652208,
            1831248408.785923,
        ],
    ],
    [
        2218147200000,
        [
            -6407153300.724163,
            -3965915259.788931,
            1836511490.944446,
        ],
    ],
    [
        2218752000000,
        [
            -6415027223.199315,
            -3953157550.091095,
            1841394796.555858,
        ],
    ],
    [
        2219356800000,
        [
            -6424690837.258262,
            -3941469460.709851,
            1845813210.700294,
        ],
    ],
    [
        2219961600000,
        [
            -6435994639.469883,
            -3931023636.799644,
            1849693108.089775,
        ],
    ],
    [
        2220566400000,
        [
            -6448772459.424093,
            -3921993005.062574,
            1852960177.997125,
        ],
    ],
    [
        2221171200000,
        [
            -6462819378.193967,
            -3914529956.653039,
            1855547109.888421,
        ],
    ],
    [
        2221776000000,
        [
            -6477913553.527884,
            -3908748113.448502,
            1857404076.518986,
        ],
    ],
    [
        2222380800000,
        [
            -6493840250.780759,
            -3904735086.09945,
            1858494449.810675,
        ],
    ],
    [
        2222985600000,
        [
            -6510376039.125615,
            -3902574172.942083,
            1858782533.777024,
        ],
    ],
    [
        2223590400000,
        [
            -6527270556.794793,
            -3902320882.12938,
            1858242959.018112,
        ],
    ],
    [
        2224195200000,
        [
            -6544270983.958714,
            -3903989519.659194,
            1856869137.948625,
        ],
    ],
    [
        2224800000000,
        [
            -6561143716.344257,
            -3907569180.389285,
            1854667213.489285,
        ],
    ],
    [
        2225404800000,
        [
            -6577654755.607259,
            -3913043834.763589,
            1851644293.201753,
        ],
    ],
    [
        2226009600000,
        [
            -6593555356.263031,
            -3920366759.413887,
            1847819317.415109,
        ],
    ],
    [
        2226614400000,
        [
            -6608608445.463579,
            -3929451722.739984,
            1843229501.725751,
        ],
    ],
    [
        2227219200000,
        [
            -6622607165.014862,
            -3940192019.932996,
            1837922524.289928,
        ],
    ],
    [
        2227824000000,
        [
            -6635351983.829959,
            -3952478045.601409,
            1831945784.904243,
        ],
    ],
    [
        2228428800000,
        [
            -6646640450.571409,
            -3966170526.407331,
            1825358375.837504,
        ],
    ],
    [
        2229033600000,
        [
            -6656294891.915636,
            -3981096078.618407,
            1818235541.817484,
        ],
    ],
    [
        2229638400000,
        [
            -6664177175.208922,
            -3997069247.891603,
            1810659064.629735,
        ],
    ],
    [
        2230243200000,
        [
            -6670162960.28294,
            -4013906884.6611,
            1802707944.287406,
        ],
    ],
    [
        2230848000000,
        [
            -6674135671.558454,
            -4031401334.740143,
            1794470974.406133,
        ],
    ],
    [
        2231452800000,
        [
            -6676014549.320888,
            -4049320172.426903,
            1786049255.450867,
        ],
    ],
    [
        2232057600000,
        [
            -6675764895.797843,
            -4067431147.122458,
            1777544792.92625,
        ],
    ],
    [
        2232662400000,
        [
            -6673369540.851728,
            -4085512779.502363,
            1769052935.453108,
        ],
    ],
    [
        2233267200000,
        [
            -6668826799.802096,
            -4103328596.397759,
            1760675047.983098,
        ],
    ],
    [
        2233872000000,
        [
            -6662177563.134861,
            -4120630683.724241,
            1752519195.377149,
        ],
    ],
    [
        2234476800000,
        [
            -6653510188.14767,
            -4137186995.510381,
            1744687206.295792,
        ],
    ],
    [
        2235081600000,
        [
            -6642928968.478406,
            -4152787421.668036,
            1737269272.253933,
        ],
    ],
    [
        2235686400000,
        [
            -6630555535.186959,
            -4167219585.179215,
            1730356416.323387,
        ],
    ],
    [
        2236291200000,
        [
            -6616553525.674125,
            -4180275422.136551,
            1724039643.489371,
        ],
    ],
    [
        2236896000000,
        [
            -6601127528.224195,
            -4191779504.735578,
            1718396118.615288,
        ],
    ],
    [
        2237500800000,
        [
            -6584488575.29319,
            -4201589471.786843,
            1713486488.766984,
        ],
    ],
    [
        2238105600000,
        [
            -6566858610.375779,
            -4209573012.995386,
            1709367212.516641,
        ],
    ],
    [
        2238710400000,
        [
            -6548491836.418829,
            -4215616213.810657,
            1706088648.392844,
        ],
    ],
    [
        2239315200000,
        [
            -6529667973.168374,
            -4219650841.62811,
            1703681329.307707,
        ],
    ],
    [
        2239920000000,
        [
            -6510655832.410022,
            -4221647959.470802,
            1702156609.142248,
        ],
    ],
    [
        2240524800000,
        [
            -6491721269.772743,
            -4221595179.110341,
            1701519154.94146,
        ],
    ],
    [
        2241129600000,
        [
            -6473145570.943633,
            -4219505597.099772,
            1701764392.61805,
        ],
    ],
    [
        2241734400000,
        [
            -6455214396.360795,
            -4215442135.489985,
            1702865784.358761,
        ],
    ],
    [
        2242339200000,
        [
            -6438181864.620502,
            -4209503941.967159,
            1704779074.352626,
        ],
    ],
    [
        2242944000000,
        [
            -6422283194.256364,
            -4201803480.150516,
            1707455042.648195,
        ],
    ],
    [
        2243548800000,
        [
            -6407751562.9287,
            -4192475835.899591,
            1710836336.830345,
        ],
    ],
    [
        2244153600000,
        [
            -6394804524.451261,
            -4181699375.122581,
            1714846111.71026,
        ],
    ],
    [
        2244758400000,
        [
            -6383611573.114414,
            -4169675961.001156,
            1719395523.93329,
        ],
    ],
    [
        2245363200000,
        [
            -6374312470.86095,
            -4156608705.612291,
            1724396310.490848,
        ],
    ],
    [
        2245968000000,
        [
            -6367033922.338557,
            -4142712576.589487,
            1729756579.08911,
        ],
    ],
    [
        2246572800000,
        [
            -6361874443.265361,
            -4128231924.777104,
            1735370593.238426,
        ],
    ],
    [
        2247177600000,
        [
            -6358877560.572735,
            -4113416544.841677,
            1741128693.469267,
        ],
    ],
    [
        2247782400000,
        [
            -6358055576.908862,
            -4098501826.327128,
            1746928870.441751,
        ],
    ],
    [
        2248387200000,
        [
            -6359406318.011911,
            -4083721915.123689,
            1752670989.092093,
        ],
    ],
    [
        2248992000000,
        [
            -6362896172.335403,
            -4069325036.864438,
            1758247355.266831,
        ],
    ],
    [
        2249596800000,
        [
            -6368439705.511366,
            -4055547304.982979,
            1763554244.429285,
        ],
    ],
    [
        2250201600000,
        [
            -6375927410.356201,
            -4042596915.273969,
            1768501655.007716,
        ],
    ],
    [
        2250806400000,
        [
            -6385241787.470072,
            -4030670460.225109,
            1773005757.176055,
        ],
    ],
    [
        2251411200000,
        [
            -6396237677.722855,
            -4019966440.115291,
            1776980142.713668,
        ],
    ],
    [
        2252016000000,
        [
            -6408728158.748995,
            -4010657932.664406,
            1780348466.224595,
        ],
    ],
    [
        2252620800000,
        [
            -6422514433.470273,
            -4002881779.991944,
            1783051841.471983,
        ],
    ],
    [
        2253225600000,
        [
            -6437400197.564833,
            -3996757804.45287,
            1785039684.435282,
        ],
    ],
    [
        2253830400000,
        [
            -6453168725.46262,
            -3992400262.9461,
            1786261854.281482,
        ],
    ],
    [
        2254435200000,
        [
            -6469574732.180429,
            -3989889861.506388,
            1786682168.141934,
        ],
    ],
    [
        2255040000000,
        [
            -6486374890.129484,
            -3989268222.600638,
            1786283182.602628,
        ],
    ],
    [
        2255644800000,
        [
            -6503339626.391807,
            -3990559281.899714,
            1785055781.560206,
        ],
    ],
    [
        2256249600000,
        [
            -6520227160.746539,
            -3993778178.584786,
            1782992556.675161,
        ],
    ],
    [
        2256854400000,
        [
            -6536781103.719773,
            -3998902957.685445,
            1780102004.262026,
        ],
    ],
    [
        2257459200000,
        [
            -6552760603.478677,
            -4005874266.243626,
            1776410613.381876,
        ],
    ],
    [
        2258064000000,
        [
            -6567948951.662944,
            -4014618216.119757,
            1771951516.479611,
        ],
    ],
    [
        2258668800000,
        [
            -6582125361.946529,
            -4025052321.031928,
            1766759408.767782,
        ],
    ],
    [
        2259273600000,
        [
            -6595068057.504079,
            -4037057446.135504,
            1760885125.725083,
        ],
    ],
    [
        2259878400000,
        [
            -6606583386.840004,
            -4050482571.967893,
            1754395053.263203,
        ],
    ],
    [
        2260483200000,
        [
            -6616510663.267583,
            -4065168646.618201,
            1747359043.518245,
        ],
    ],
    [
        2261088000000,
        [
            -6624692651.189835,
            -4080951417.935904,
            1739847044.756614,
        ],
    ],
    [
        2261692800000,
        [
            -6630983632.902555,
            -4097634482.17971,
            1731943613.439805,
        ],
    ],
    [
        2262297600000,
        [
            -6635276879.037998,
            -4114998876.429398,
            1723744741.288691,
        ],
    ],
    [
        2262902400000,
        [
            -6637504989.014929,
            -4132827636.78869,
            1715345166.115016,
        ],
    ],
    [
        2263507200000,
        [
            -6637609821.035581,
            -4150905458.797709,
            1706836815.710271,
        ],
    ],
    [
        2264112000000,
        [
            -6635554597.421089,
            -4168993802.218064,
            1698322732.260775,
        ],
    ],
    [
        2264716800000,
        [
            -6631348929.248232,
            -4186844825.617101,
            1689911556.717261,
        ],
    ],
    [
        2265321600000,
        [
            -6625043724.296828,
            -4204226277.188999,
            1681704425.587546,
        ],
    ],
    [
        2265926400000,
        [
            -6616700874.891878,
            -4220917652.641462,
            1673795433.243638,
        ],
    ],
    [
        2266531200000,
        [
            -6606408125.785992,
            -4236688035.828737,
            1666284522.618583,
        ],
    ],
    [
        2267136000000,
        [
            -6594300673.290257,
            -4251313352.948491,
            1659270122.846573,
        ],
    ],
    [
        2267740800000,
        [
            -6580549816.323596,
            -4264600739.720271,
            1652836056.685225,
        ],
    ],
    [
        2268345600000,
        [
            -6565332548.441504,
            -4276380276.814143,
            1647054484.588631,
        ],
    ],
    [
        2268950400000,
        [
            -6548848085.704938,
            -4286485602.267121,
            1641997563.833971,
        ],
    ],
    [
        2269555200000,
        [
            -6531335290.666743,
            -4294772801.773203,
            1637729013.517623,
        ],
    ],
    [
        2270160000000,
        [
            -6513055062.004464,
            -4301142767.565789,
            1634291756.714144,
        ],
    ],
    [
        2270764800000,
        [
            -6494260503.039154,
            -4305527140.537298,
            1631714002.068682,
        ],
    ],
    [
        2271369600000,
        [
            -6475214927.754405,
            -4307871155.936493,
            1630019736.510126,
        ],
    ],
    [
        2271974400000,
        [
            -6456205203.790272,
            -4308152291.408881,
            1629220039.795549,
        ],
    ],
    [
        2272579200000,
        [
            -6437519309.443812,
            -4306399008.805248,
            1629302258.860098,
        ],
    ],
    [
        2273184000000,
        [
            -6419418803.161516,
            -4302669974.798051,
            1630239667.749554,
        ],
    ],
    [
        2273788800000,
        [
            -6402159308.152553,
            -4297038733.773508,
            1632000853.911872,
        ],
    ],
    [
        2274393600000,
        [
            -6386000821.315872,
            -4289611052.927417,
            1634541223.53409,
        ],
    ],
    [
        2274998400000,
        [
            -6371182932.024975,
            -4280539245.048657,
            1637794151.173414,
        ],
    ],
    [
        2275603200000,
        [
            -6357901924.448123,
            -4269995239.731682,
            1641683968.850415,
        ],
    ],
    [
        2276208000000,
        [
            -6346335092.053743,
            -4258157541.77571,
            1646133988.755936,
        ],
    ],
    [
        2276812800000,
        [
            -6336649205.256824,
            -4245227661.070333,
            1651058022.715791,
        ],
    ],
    [
        2277417600000,
        [
            -6328975560.532545,
            -4231440395.230456,
            1656353421.232469,
        ],
    ],
    [
        2278022400000,
        [
            -6323393469.175172,
            -4217032879.330843,
            1661916412.107356,
        ],
    ],
    [
        2278627200000,
        [
            -6319958808.038798,
            -4202235026.117113,
            1667648225.391517,
        ],
    ],
    [
        2279232000000,
        [
            -6318711025.329232,
            -4187286342.996968,
            1673446083.817626,
        ],
    ],
    [
        2279836800000,
        [
            -6319648764.863011,
            -4172443065.165538,
            1679197823.207029,
        ],
    ],
    [
        2280441600000,
        [
            -6322720248.127254,
            -4157945766.34503,
            1684798344.519449,
        ],
    ],
    [
        2281046400000,
        [
            -6327855051.18957,
            -4144014384.172396,
            1690153363.172683,
        ],
    ],
    [
        2281651200000,
        [
            -6334969132.522454,
            -4130866512.364054,
            1695169448.559287,
        ],
    ],
    [
        2282256000000,
        [
            -6343940558.091806,
            -4118721866.854762,
            1699750107.704786,
        ],
    ],
    [
        2282860800000,
        [
            -6354606431.550925,
            -4107770404.754684,
            1703812362.808965,
        ],
    ],
    [
        2283465600000,
        [
            -6366796056.380257,
            -4098172372.429607,
            1707287915.916529,
        ],
    ],
    [
        2284070400000,
        [
            -6380333233.855371,
            -4090078333.528708,
            1710112197.086542,
        ],
    ],
    [
        2284675200000,
        [
            -6395011366.115213,
            -4083630786.989578,
            1712222085.168243,
        ],
    ],
    [
        2285280000000,
        [
            -6410596469.970173,
            -4078933876.334315,
            1713572013.559319,
        ],
    ],
    [
        2285884800000,
        [
            -6426859858.32633,
            -4076058309.622702,
            1714132562.232007,
        ],
    ],
    [
        2286489600000,
        [
            -6443577278.745071,
            -4075062701.651254,
            1713878780.353353,
        ],
    ],
    [
        2287094400000,
        [
            -6460503139.927652,
            -4075991875.715492,
            1712789832.468375,
        ],
    ],
    [
        2287699200000,
        [
            -6477379345.722984,
            -4078848756.216872,
            1710864276.536974,
        ],
    ],
    [
        2288304000000,
        [
            -6493966012.090261,
            -4083603783.333155,
            1708116185.408834,
        ],
    ],
    [
        2288908800000,
        [
            -6510037408.509609,
            -4090216889.734449,
            1704563113.499659,
        ],
    ],
    [
        2289513600000,
        [
            -6525355642.153522,
            -4098632210.672422,
            1700227851.424713,
        ],
    ],
    [
        2290118400000,
        [
            -6539685108.116303,
            -4108752660.469133,
            1695152578.015346,
        ],
    ],
    [
        2290723200000,
        [
            -6552820155.345777,
            -4120453500.22927,
            1689392627.387684,
        ],
    ],
    [
        2291328000000,
        [
            -6564577927.506086,
            -4133604318.60636,
            1683004433.387936,
        ],
    ],
    [
        2291932800000,
        [
            -6574772162.689214,
            -4148060311.999414,
            1676049349.389015,
        ],
    ],
    [
        2292537600000,
        [
            -6583232798.850349,
            -4163640100.941485,
            1668606358.881876,
        ],
    ],
    [
        2293142400000,
        [
            -6589829738.823153,
            -4180143196.546836,
            1660763611.664277,
        ],
    ],
    [
        2293747200000,
        [
            -6594462489.840405,
            -4197371476.267387,
            1652606625.632672,
        ],
    ],
    [
        2294352000000,
        [
            -6597034691.671575,
            -4215117552.692969,
            1644223924.776896,
        ],
    ],
    [
        2294956800000,
        [
            -6597477897.200664,
            -4233146340.6606,
            1635718013.173996,
        ],
    ],
    [
        2295561600000,
        [
            -6595770653.999058,
            -4251216106.642211,
            1627194868.533421,
        ],
    ],
    [
        2296166400000,
        [
            -6591924432.431671,
            -4269098896.92218,
            1618752708.80759,
        ],
    ],
    [
        2296771200000,
        [
            -6585959219.213951,
            -4286566489.357451,
            1610489173.941119,
        ],
    ],
    [
        2297376000000,
        [
            -6577929936.24019,
            -4303375913.179876,
            1602510387.164565,
        ],
    ],
    [
        2297980800000,
        [
            -6567940111.492051,
            -4319293384.034665,
            1594918784.727301,
        ],
    ],
    [
        2298585600000,
        [
            -6556123298.936656,
            -4334112800.391829,
            1587802913.465428,
        ],
    ],
    [
        2299190400000,
        [
            -6542619931.452948,
            -4347639221.470325,
            1581246124.631629,
        ],
    ],
    [
        2299795200000,
        [
            -6527604633.38703,
            -4359677971.073921,
            1575333764.128919,
        ],
    ],
    [
        2300400000000,
        [
            -6511294096.63965,
            -4370060075.091425,
            1570140033.209393,
        ],
    ],
    [
        2301004800000,
        [
            -6493923504.58046,
            -4378657432.219383,
            1565719497.784764,
        ],
    ],
    [
        2301609600000,
        [
            -6475725263.470271,
            -4385362994.78939,
            1562117623.968829,
        ],
    ],
    [
        2302214400000,
        [
            -6456956040.639662,
            -4390082614.456501,
            1559376312.037942,
        ],
    ],
    [
        2302819200000,
        [
            -6437899368.421875,
            -4392760048.271399,
            1557520716.695356,
        ],
    ],
    [
        2303424000000,
        [
            -6418837764.205442,
            -4393387263.652386,
            1556553195.458543,
        ],
    ],
    [
        2304028800000,
        [
            -6400034955.821735,
            -4391980261.840085,
            1556466145.088966,
        ],
    ],
    [
        2304633600000,
        [
            -6381762669.740268,
            -4388572999.050458,
            1557246042.011703,
        ],
    ],
    [
        2305238400000,
        [
            -6364299511.867518,
            -4383240305.324875,
            1558861016.272043,
        ],
    ],
    [
        2305843200000,
        [
            -6347900852.462002,
            -4376102588.945637,
            1561257594.344122,
        ],
    ],
    [
        2306448000000,
        [
            -6332786876.988697,
            -4367297161.210013,
            1564375881.576863,
        ],
    ],
    [
        2307052800000,
        [
            -6319170040.222838,
            -4356974541.422971,
            1568151909.380411,
        ],
    ],
    [
        2307657600000,
        [
            -6307252004.949254,
            -4345318822.450308,
            1572506232.44061,
        ],
    ],
    [
        2308262400000,
        [
            -6297193770.120754,
            -4332547434.126081,
            1577343188.866703,
        ],
    ],
    [
        2308867200000,
        [
            -6289111357.356361,
            -4318879342.444831,
            1582567775.060939,
        ],
    ],
    [
        2309472000000,
        [
            -6283104579.83974,
            -4304534997.013538,
            1588085752.872484,
        ],
    ],
    [
        2310076800000,
        [
            -6279252883.227127,
            -4289754846.751462,
            1593793043.365476,
        ],
    ],
    [
        2310681600000,
        [
            -6277587293.711617,
            -4274795647.173944,
            1599576855.935913,
        ],
    ],
    [
        2311286400000,
        [
            -6278094039.342796,
            -4259897797.962485,
            1605333158.018463,
        ],
    ],
    [
        2311891200000,
        [
            -6280744224.929454,
            -4245290211.968431,
            1610964033.226775,
        ],
    ],
    [
        2312496000000,
        [
            -6285488174.565219,
            -4231207942.348574,
            1616367539.369164,
        ],
    ],
    [
        2313100800000,
        [
            -6292229530.18272,
            -4217886189.483669,
            1621440221.366636,
        ],
    ],
    [
        2313705600000,
        [
            -6300835826.018139,
            -4205528855.883468,
            1626094103.31075,
        ],
    ],
    [
        2314310400000,
        [
            -6311167839.176867,
            -4194318792.939909,
            1630251170.294436,
        ],
    ],
    [
        2314915200000,
        [
            -6323071496.688834,
            -4184434999.159265,
            1633833564.378531,
        ],
    ],
    [
        2315520000000,
        [
            -6336353860.5388,
            -4176044582.186132,
            1636767419.559446,
        ],
    ],
    [
        2316124800000,
        [
            -6350799328.327728,
            -4169273940.497174,
            1638998573.919051,
        ],
    ],
    [
        2316729600000,
        [
            -6366197279.02171,
            -4164223949.670143,
            1640484435.896857,
        ],
    ],
    [
        2317334400000,
        [
            -6382330894.50383,
            -4160986642.860739,
            1641184611.932032,
        ],
    ],
    [
        2317939200000,
        [
            -6398954892.422788,
            -4159634753.553423,
            1641066284.427826,
        ],
    ],
    [
        2318544000000,
        [
            -6415816326.270759,
            -4160196438.155184,
            1640118083.052599,
        ],
    ],
    [
        2319148800000,
        [
            -6432679381.633541,
            -4162674504.481949,
            1638339784.37023,
        ],
    ],
    [
        2319753600000,
        [
            -6449311048.199094,
            -4167062279.906311,
            1635733536.871267,
        ],
    ],
    [
        2320358400000,
        [
            -6465460819.260166,
            -4173330303.01344,
            1632311006.2573,
        ],
    ],
    [
        2320963200000,
        [
            -6480885420.737929,
            -4181405327.746259,
            1628104967.103238,
        ],
    ],
    [
        2321568000000,
        [
            -6495369856.071491,
            -4191192669.112583,
            1623157300.119424,
        ],
    ],
    [
        2322172800000,
        [
            -6508710283.594368,
            -4202591037.168368,
            1617510930.631896,
        ],
    ],
    [
        2322777600000,
        [
            -6520696083.356515,
            -4215476293.879053,
            1611218774.932156,
        ],
    ],
    [
        2323382400000,
        [
            -6531137928.122405,
            -4229685443.043465,
            1604352668.814333,
        ],
    ],
    [
        2323987200000,
        [
            -6539884261.632991,
            -4245041343.489785,
            1596990074.79758,
        ],
    ],
    [
        2324592000000,
        [
            -6546801804.511097,
            -4261366406.28582,
            1589206786.619929,
        ],
    ],
    [
        2325196800000,
        [
            -6551760247.478697,
            -4278463783.014282,
            1581087465.467274,
        ],
    ],
    [
        2325801600000,
        [
            -6554662848.446995,
            -4296106915.646725,
            1572731605.90419,
        ],
    ],
    [
        2326406400000,
        [
            -6555457469.546279,
            -4314066007.897498,
            1564239328.753725,
        ],
    ],
    [
        2327011200000,
        [
            -6554114880.280273,
            -4332120418.71541,
            1555704941.607099,
        ],
    ],
    [
        2327616000000,
        [
            -6550615948.236957,
            -4350037900.359836,
            1547228690.433698,
        ],
    ],
    [
        2328220800000,
        [
            -6544983541.385326,
            -4367569872.636534,
            1538919663.369263,
        ],
    ],
    [
        2328825600000,
        [
            -6537287194.150554,
            -4384478943.67767,
            1530881090.439484,
        ],
    ],
    [
        2329430400000,
        [
            -6527619022.659603,
            -4400549417.014267,
            1523205059.939623,
        ],
    ],
    [
        2330035200000,
        [
            -6516082971.817609,
            -4415565026.187282,
            1515985146.250038,
        ],
    ],
    [
        2330640000000,
        [
            -6502826526.484686,
            -4429309345.486243,
            1509316492.868426,
        ],
    ],
    [
        2331244800000,
        [
            -6488038353.501698,
            -4441593237.75793,
            1503281200.665907,
        ],
    ],
    [
        2331849600000,
        [
            -6471921622.037313,
            -4452262191.88022,
            1497944827.203444,
        ],
    ],
    [
        2332454400000,
        [
            -6454685129.803155,
            -4461172456.650427,
            1493369788.340057,
        ],
    ],
    [
        2333059200000,
        [
            -6436573580.123346,
            -4468195183.722771,
            1489613219.371376,
        ],
    ],
    [
        2333664000000,
        [
            -6417858493.07548,
            -4473242232.174135,
            1486713201.714684,
        ],
    ],
    [
        2334268800000,
        [
            -6398809409.929428,
            -4476268586.936679,
            1484687867.219362,
        ],
    ],
    [
        2334873600000,
        [
            -6379687785.60476,
            -4477246405.844995,
            1483549675.514147,
        ],
    ],
    [
        2335478400000,
        [
            -6360775455.373834,
            -4476171293.60556,
            1483301746.853071,
        ],
    ],
    [
        2336083200000,
        [
            -6342360512.443891,
            -4473085019.366517,
            1483925597.442307,
        ],
    ],
    [
        2336688000000,
        [
            -6324707984.233323,
            -4468071763.242808,
            1485383421.733658,
        ],
    ],
    [
        2337292800000,
        [
            -6308058579.036176,
            -4461230016.459567,
            1487633193.316026,
        ],
    ],
    [
        2337897600000,
        [
            -6292655797.518981,
            -4452680276.977908,
            1490623813.027002,
        ],
    ],
    [
        2338502400000,
        [
            -6278729320.668902,
            -4442584191.104163,
            1494284593.784146,
        ],
    ],
    [
        2339107200000,
        [
            -6266467269.215471,
            -4431134851.690272,
            1498530608.255156,
        ],
    ],
    [
        2339712000000,
        [
            -6256022020.372177,
            -4418527626.008237,
            1503278073.298141,
        ],
    ],
    [
        2340316800000,
        [
            -6247536356.540386,
            -4404969946.03411,
            1508438102.620824,
        ],
    ],
    [
        2340921600000,
        [
            -6241126357.761413,
            -4390697467.967125,
            1513907724.842339,
        ],
    ],
    [
        2341526400000,
        [
            -6236856706.419054,
            -4375960021.982791,
            1519577540.438217,
        ],
    ],
    [
        2342131200000,
        [
            -6234754523.204864,
            -4360993288.761986,
            1525346474.123981,
        ],
    ],
    [
        2342736000000,
        [
            -6234834070.321362,
            -4346032008.13811,
            1531113657.555669,
        ],
    ],
    [
        2343340800000,
        [
            -6237079705.299747,
            -4331324038.845078,
            1536770673.23095,
        ],
    ],
    [
        2343945600000,
        [
            -6241424551.05204,
            -4317113817.774779,
            1542210626.450237,
        ],
    ],
    [
        2344550400000,
        [
            -6247771666.552333,
            -4303616698.84084,
            1547341384.769308,
        ],
    ],
    [
        2345155200000,
        [
            -6256016095.904488,
            -4291036420.141796,
            1552075321.979836,
        ],
    ],
    [
        2345760000000,
        [
            -6266027368.271015,
            -4279577439.264236,
            1556322715.090853,
        ],
    ],
    [
        2346364800000,
        [
            -6277631245.822528,
            -4269427064.062294,
            1560001650.83323,
        ],
    ],
    [
        2346969600000,
        [
            -6290636614.714041,
            -4260733584.808048,
            1563049158.502976,
        ],
    ],
    [
        2347574400000,
        [
            -6304853686.984498,
            -4253627892.843106,
            1565408951.557057,
        ],
    ],
    [
        2348179200000,
        [
            -6320075365.403342,
            -4248233881.615281,
            1567026135.710885,
        ],
    ],
    [
        2348784000000,
        [
            -6336061912.30417,
            -4244649604.486265,
            1567857749.035522,
        ],
    ],
    [
        2349388800000,
        [
            -6352571832.001574,
            -4242929772.972695,
            1567881447.06857,
        ],
    ],
    [
        2349993600000,
        [
            -6369375536.862101,
            -4243110751.026317,
            1567081660.946212,
        ],
    ],
    [
        2350598400000,
        [
            -6386235277.656694,
            -4245218655.921254,
            1565445799.857103,
        ],
    ],
    [
        2351203200000,
        [
            -6402893000.522388,
            -4249249520.861486,
            1562975401.964186,
        ],
    ],
    [
        2351808000000,
        [
            -6419103757.341069,
            -4255156561.031914,
            1559692147.518276,
        ],
    ],
    [
        2352412800000,
        [
            -6434644636.555686,
            -4262877539.976311,
            1555622951.424393,
        ],
    ],
    [
        2353017600000,
        [
            -6449293340.367659,
            -4272340411.245636,
            1550797716.140458,
        ],
    ],
    [
        2353622400000,
        [
            -6462819720.46243,
            -4283442485.406857,
            1545261048.633399,
        ],
    ],
    [
        2354227200000,
        [
            -6475020452.60704,
            -4296042940.247197,
            1539075386.494375,
        ],
    ],
    [
        2354832000000,
        [
            -6485723197.873806,
            -4309991620.537558,
            1532305522.597504,
        ],
    ],
    [
        2355436800000,
        [
            -6494764043.611799,
            -4325132402.967895,
            1525017783.123384,
        ],
    ],
    [
        2356041600000,
        [
            -6501983093.167666,
            -4341281583.53796,
            1517292151.452223,
        ],
    ],
    [
        2356646400000,
        [
            -6507259166.637467,
            -4358226165.764318,
            1509222293.906171,
        ],
    ],
    [
        2357251200000,
        [
            -6510508999.853896,
            -4375753229.801385,
            1500900010.478015,
        ],
    ],
    [
        2357856000000,
        [
            -6511663642.188687,
            -4393651371.082695,
            1492415619.474195,
        ],
    ],
    [
        2358460800000,
        [
            -6510668028.090555,
            -4411688667.414483,
            1483870246.390346,
        ],
    ],
    [
        2359065600000,
        [
            -6507514329.659957,
            -4429617088.431429,
            1475372622.481114,
        ],
    ],
    [
        2359670400000,
        [
            -6502235680.827811,
            -4447201468.214535,
            1467024021.583784,
        ],
    ],
    [
        2360275200000,
        [
            -6494881415.356812,
            -4464219160.708298,
            1458919724.770213,
        ],
    ],
    [
        2360880000000,
        [
            -6485519992.590843,
            -4480437822.224916,
            1451161267.86472,
        ],
    ],
    [
        2361484800000,
        [
            -6474269552.232215,
            -4495625683.618814,
            1443850149.16226,
        ],
    ],
    [
        2362089600000,
        [
            -6461285529.456414,
            -4509578795.31892,
            1437073959.777993,
        ],
    ],
    [
        2362694400000,
        [
            -6446734659.916618,
            -4522118393.032287,
            1430909108.757609,
        ],
    ],
    [
        2363299200000,
        [
            -6430800410.861718,
            -4533068317.937408,
            1425432994.896067,
        ],
    ],
    [
        2363904000000,
        [
            -6413709656.276124,
            -4542269971.259728,
            1420715171.648316,
        ],
    ],
    [
        2364508800000,
        [
            -6395714074.00171,
            -4549606097.969144,
            1416805506.173235,
        ],
    ],
    [
        2365113600000,
        [
            -6377063492.464537,
            -4554994607.861171,
            1413738694.486314,
        ],
    ],
    [
        2365718400000,
        [
            -6358013539.840141,
            -4558365129.676797,
            1411546481.607015,
        ],
    ],
    [
        2366323200000,
        [
            -6338848351.673031,
            -4559676793.853102,
            1410247146.502247,
        ],
    ],
    [
        2366928000000,
        [
            -6319856879.301243,
            -4558936972.442596,
            1409836398.945328,
        ],
    ],
    [
        2367532800000,
        [
            -6301307252.615663,
            -4556190209.67585,
            1410294254.63048,
        ],
    ],
    [
        2368137600000,
        [
            -6283457524.733219,
            -4551493785.092853,
            1411597293.105329,
        ],
    ],
    [
        2368742400000,
        [
            -6266575377.884564,
            -4544936759.034214,
            1413707240.289892,
        ],
    ],
    [
        2369347200000,
        [
            -6250911643.145066,
            -4536653175.39227,
            1416564785.820464,
        ],
    ],
    [
        2369952000000,
        [
            -6236677990.67854,
            -4526805747.257338,
            1420098942.495345,
        ],
    ],
    [
        2370556800000,
        [
            -6224062385.645801,
            -4515561449.85774,
            1424238842.833879,
        ],
    ],
    [
        2371161600000,
        [
            -6213246840.051807,
            -4503111434.126241,
            1428901747.263288,
        ],
    ],
    [
        2371766400000,
        [
            -6204380502.184453,
            -4489679623.869745,
            1433989313.697553,
        ],
    ],
    [
        2372371200000,
        [
            -6197562373.263707,
            -4475502195.502399,
            1439398943.584657,
        ],
    ],
    [
        2372976000000,
        [
            -6192862584.385589,
            -4460805241.362769,
            1445034160.777823,
        ],
    ],
    [
        2373580800000,
        [
            -6190338169.765597,
            -4445826143.80643,
            1450791984.713051,
        ],
    ],
    [
        2374185600000,
        [
            -6190007033.085907,
            -4430819106.474909,
            1456560926.718301,
        ],
    ],
    [
        2374790400000,
        [
            -6191835981.541177,
            -4416032139.389463,
            1462233513.269849,
        ],
    ],
    [
        2375395200000,
        [
            -6195767645.751184,
            -4401688858.082082,
            1467714276.717355,
        ],
    ],
    [
        2376000000000,
        [
            -6201733079.922544,
            -4388011910.522401,
            1472906416.856587,
        ],
    ],
    [
        2376604800000,
        [
            -6209626814.19486,
            -4375226461.554931,
            1477711060.547789,
        ],
    ],
    [
        2377209600000,
        [
            -6219299472.513598,
            -4363536110.056982,
            1482040260.941607,
        ],
    ],
    [
        2377814400000,
        [
            -6230589140.601734,
            -4353110079.3915,
            1485822003.296034,
        ],
    ],
    [
        2378419200000,
        [
            -6243329312.484773,
            -4344108622.339428,
            1488986315.719856,
        ],
    ],
    [
        2379024000000,
        [
            -6257324850.951766,
            -4336684585.258421,
            1491465739.165509,
        ],
    ],
    [
        2379628800000,
        [
            -6272348339.358779,
            -4330959085.658232,
            1493208364.061752,
        ],
    ],
    [
        2380233600000,
        [
            -6288174367.408553,
            -4327014466.263106,
            1494179676.832468,
        ],
    ],
    [
        2380838400000,
        [
            -6304581894.962331,
            -4324921027.370333,
            1494348479.460325,
        ],
    ],
    [
        2381443200000,
        [
            -6321331112.897877,
            -4324736298.709081,
            1493688721.959688,
        ],
    ],
    [
        2382048000000,
        [
            -6338163116.26023,
            -4326480951.021447,
            1492192304.362952,
        ],
    ],
    [
        2382652800000,
        [
            -6354835643.687675,
            -4330137396.397019,
            1489867853.982353,
        ],
    ],
    [
        2383257600000,
        [
            -6371119697.968564,
            -4335677050.189536,
            1486726839.29091,
        ],
    ],
    [
        2383862400000,
        [
            -6386777525.295864,
            -4343056978.316711,
            1482786873.055083,
        ],
    ],
    [
        2384467200000,
        [
            -6401565643.995296,
            -4352196480.776616,
            1478084023.325211,
        ],
    ],
    [
        2385072000000,
        [
            -6415270668.959518,
            -4362981122.128365,
            1472668712.632031,
        ],
    ],
    [
        2385676800000,
        [
            -6427700537.540527,
            -4375289876.442151,
            1466592320.977408,
        ],
    ],
    [
        2386281600000,
        [
            -6438663809.361766,
            -4388989143.020217,
            1459911906.119942,
        ],
    ],
    [
        2386886400000,
        [
            -6447976246.191364,
            -4403910541.708125,
            1452701707.744402,
        ],
    ],
    [
        2387491200000,
        [
            -6455495297.102141,
            -4419860239.975844,
            1445046367.241371,
        ],
    ],
    [
        2388096000000,
        [
            -6461106383.158214,
            -4436645496.64935,
            1437028239.84696,
        ],
    ],
    [
        2388700800000,
        [
            -6464703433.463702,
            -4454066345.300698,
            1428733333.661232,
        ],
    ],
    [
        2389305600000,
        [
            -6466199033.490546,
            -4471895164.241879,
            1420261667.851986,
        ],
    ],
    [
        2389910400000,
        [
            -6465555943.764875,
            -4489891182.624145,
            1411718010.467775,
        ],
    ],
    [
        2390515200000,
        [
            -6462768694.522969,
            -4507825848.974038,
            1403200176.807042,
        ],
    ],
    [
        2391120000000,
        [
            -6457844873.335965,
            -4525472527.636979,
            1394805961.793552,
        ],
    ],
    [
        2391724800000,
        [
            -6450818457.730216,
            -4542588164.813649,
            1386642121.949255,
        ],
    ],
    [
        2392329600000,
        [
            -6441776582.418981,
            -4558932583.322785,
            1378812918.671737,
        ],
    ],
    [
        2392934400000,
        [
            -6430836479.190248,
            -4574291628.43688,
            1371409905.055556,
        ],
    ],
    [
        2393539200000,
        [
            -6418126862.431057,
            -4588464880.345203,
            1364519776.36537,
        ],
    ],
    [
        2394144000000,
        [
            -6403803751.770689,
            -4601249165.273371,
            1358232016.25908,
        ],
    ],
    [
        2394748800000,
        [
            -6388070983.461573,
            -4612461632.493811,
            1352625765.617711,
        ],
    ],
    [
        2395353600000,
        [
            -6371152734.26281,
            -4621958951.14338,
            1347761885.100708,
        ],
    ],
    [
        2395958400000,
        [
            -6353274849.00958,
            -4629622466.530296,
            1343691908.392279,
        ],
    ],
    [
        2396563200000,
        [
            -6334682653.311438,
            -4635342687.081314,
            1340464701.174989,
        ],
    ],
    [
        2397168000000,
        [
            -6315654757.637787,
            -4639044533.408552,
            1338112418.065048,
        ],
    ],
    [
        2397772800000,
        [
            -6296472258.810719,
            -4640700603.694845,
            1336645697.954327,
        ],
    ],
    [
        2398377600000,
        [
            -6277401086.074354,
            -4640312960.828935,
            1336064012.207853,
        ],
    ],
    [
        2398982400000,
        [
            -6258712057.994967,
            -4637897738.362557,
            1336361735.766488,
        ],
    ],
    [
        2399587200000,
        [
            -6240689028.957392,
            -4633511023.841455,
            1337513922.899001,
        ],
    ],
    [
        2400192000000,
        [
            -6223596882.856609,
            -4627255031.815356,
            1339475092.711135,
        ],
    ],
    [
        2400796800000,
        [
            -6207667147.592479,
            -4619256312.959928,
            1342190987.442013,
        ],
    ],
    [
        2401401600000,
        [
            -6193121171.598066,
            -4609650626.850364,
            1345604058.997896,
        ],
    ],
    [
        2402006400000,
        [
            -6180174467.218367,
            -4598608815.006279,
            1349639421.293202,
        ],
    ],
    [
        2402611200000,
        [
            -6169005761.686394,
            -4586336375.868255,
            1354206931.402217,
        ],
    ],
    [
        2403216000000,
        [
            -6159748099.846306,
            -4573049047.255963,
            1359213860.523293,
        ],
    ],
    [
        2403820800000,
        [
            -6152515723.657752,
            -4558959481.975637,
            1364569194.608493,
        ],
    ],
    [
        2404425600000,
        [
            -6147405870.204866,
            -4544303394.362778,
            1370169766.583734,
        ],
    ],
    [
        2405030400000,
        [
            -6144470201.281333,
            -4529334299.818521,
            1375904772.583778,
        ],
    ],
    [
        2405635200000,
        [
            -6143712348.455786,
            -4514298082.552806,
            1381668582.452165,
        ],
    ],
    [
        2406240000000,
        [
            -6145118044.626277,
            -4499423580.383903,
            1387362959.881079,
        ],
    ],
    [
        2406844800000,
        [
            -6148654264.109054,
            -4484949336.896562,
            1392883383.466274,
        ],
    ],
    [
        2407449600000,
        [
            -6154243176.881566,
            -4471115328.950735,
            1398125109.031904,
        ],
    ],
    [
        2408054400000,
        [
            -6161765675.825827,
            -4458137881.209064,
            1402995478.432439,
        ],
    ],
    [
        2408659200000,
        [
            -6171093452.805373,
            -4446205773.37421,
            1407413355.691198,
        ],
    ],
    [
        2409264000000,
        [
            -6182084508.498108,
            -4435507261.06818,
            1411295913.673335,
        ],
    ],
    [
        2409868800000,
        [
            -6194559330.4137,
            -4426219853.535526,
            1414565698.393595,
        ],
    ],
    [
        2410473600000,
        [
            -6208309300.724033,
            -4418486275.49184,
            1417162104.363652,
        ],
    ],
    [
        2411078400000,
        [
            -6223129226.398964,
            -4412416789.441304,
            1419037739.188217,
        ],
    ],
    [
        2411683200000,
        [
            -6238808327.844044,
            -4408115532.044371,
            1420146160.407816,
        ],
    ],
    [
        2412288000000,
        [
            -6255108599.911909,
            -4405668678.315971,
            1420449719.387183,
        ],
    ],
    [
        2412892800000,
        [
            -6271777077.320563,
            -4405121738.58169,
            1419930074.390818,
        ],
    ],
    [
        2413497600000,
        [
            -6288577583.070338,
            -4406488078.606939,
            1418581543.015389,
        ],
    ],
    [
        2414102400000,
        [
            -6305276887.279473,
            -4409773510.462937,
            1416400263.641368,
        ],
    ],
    [
        2414707200000,
        [
            -6321625614.473904,
            -4414962897.205013,
            1413392707.80521,
        ],
    ],
    [
        2415312000000,
        [
            -6337373657.420244,
            -4421999072.142476,
            1409585119.447241,
        ],
    ],
    [
        2415916800000,
        [
            -6352300179.516505,
            -4430797187.945581,
            1405014112.414754,
        ],
    ],
    [
        2416521600000,
        [
            -6366195164.347623,
            -4441266820.00765,
            1399717553.007974,
        ],
    ],
    [
        2417126400000,
        [
            -6378843359.67376,
            -4453297137.639785,
            1393743587.050038,
        ],
    ],
    [
        2417731200000,
        [
            -6390042332.557412,
            -4466737955.927554,
            1387158791.897485,
        ],
    ],
    [
        2418336000000,
        [
            -6399629817.024408,
            -4481419406.79631,
            1380036380.923686,
        ],
    ],
    [
        2418940800000,
        [
            -6407461089.670251,
            -4497171252.170324,
            1372448886.905757,
        ],
    ],
    [
        2419545600000,
        [
            -6413396184.21172,
            -4513806911.414023,
            1364477485.394582,
        ],
    ],
    [
        2420150400000,
        [
            -6417320060.105469,
            -4531107344.565795,
            1356218537.783132,
        ],
    ],
    [
        2420755200000,
        [
            -6419166189.201309,
            -4548845407.791975,
            1347769850.795554,
        ],
    ],
    [
        2421360000000,
        [
            -6418890108.071365,
            -4566802328.254066,
            1339225116.519794,
        ],
    ],
    [
        2421964800000,
        [
            -6416459601.676552,
            -4584750883.534908,
            1330683334.414032,
        ],
    ],
    [
        2422569600000,
        [
            -6411876272.613944,
            -4602442739.762314,
            1322253432.270886,
        ],
    ],
    [
        2423174400000,
        [
            -6405193947.234525,
            -4619636547.125175,
            1314039157.494941,
        ],
    ],
    [
        2423779200000,
        [
            -6396488604.520964,
            -4636111357.566457,
            1306135302.173295,
        ],
    ],
    [
        2424384000000,
        [
            -6385850709.051734,
            -4651648931.119924,
            1298637194.026442,
        ],
    ],
    [
        2424988800000,
        [
            -6373407355.845323,
            -4666024662.546063,
            1291643295.408846,
        ],
    ],
    [
        2425593600000,
        [
            -6359334006.375308,
            -4679037932.780772,
            1285239500.240321,
        ],
    ],
    [
        2426198400000,
        [
            -6343821183.39471,
            -4690521630.19057,
            1279497437.871473,
        ],
    ],
    [
        2426803200000,
        [
            -6327068112.103813,
            -4700322997.81742,
            1274484275.580844,
        ],
    ],
    [
        2427408000000,
        [
            -6309304941.0693,
            -4708297518.226064,
            1270263554.792498,
        ],
    ],
    [
        2428012800000,
        [
            -6290796944.574108,
            -4714339541.312647,
            1266879840.281777,
        ],
    ],
    [
        2428617600000,
        [
            -6271809211.070862,
            -4718386442.184024,
            1264359643.833427,
        ],
    ],
    [
        2429222400000,
        [
            -6252601569.266623,
            -4720397128.965601,
            1262721931.120058,
        ],
    ],
    [
        2429827200000,
        [
            -6233451248.667711,
            -4720347809.51473,
            1261977693.51927,
        ],
    ],
    [
        2430432000000,
        [
            -6214650015.154261,
            -4718261058.016788,
            1262115808.302099,
        ],
    ],
    [
        2431036800000,
        [
            -6196469228.813097,
            -4714203296.428206,
            1263107022.332757,
        ],
    ],
    [
        2431641600000,
        [
            -6179157284.316286,
            -4708260657.643625,
            1264915302.887456,
        ],
    ],
    [
        2432246400000,
        [
            -6162963847.300267,
            -4700536034.79252,
            1267496493.280008,
        ],
    ],
    [
        2432851200000,
        [
            -6148131573.67673,
            -4691175800.755823,
            1270785768.847816,
        ],
    ],
    [
        2433456000000,
        [
            -6134864328.04922,
            -4680360513.992092,
            1274704587.670697,
        ],
    ],
    [
        2434060800000,
        [
            -6123328952.102192,
            -4668279130.898923,
            1279172425.401502,
        ],
    ],
    [
        2434665600000,
        [
            -6113681971.89013,
            -4655127890.962474,
            1284104408.072448,
        ],
    ],
    [
        2435270400000,
        [
            -6106057612.94247,
            -4641135157.564536,
            1289400190.072755,
        ],
    ],
    [
        2435875200000,
        [
            -6100541017.779183,
            -4626546663.200117,
            1294953191.66727,
        ],
    ],
    [
        2436480000000,
        [
            -6097175484.639203,
            -4611600032.562369,
            1300661806.384537,
        ],
    ],
    [
        2437084800000,
        [
            -6095991295.286944,
            -4596526853.41769,
            1306425559.887193,
        ],
    ],
    [
        2437689600000,
        [
            -6096990827.313134,
            -4581576481.686907,
            1312135065.765625,
        ],
    ],
    [
        2438294400000,
        [
            -6100127008.526775,
            -4566997673.397924,
            1317682671.714386,
        ],
    ],
    [
        2438899200000,
        [
            -6105315942.523239,
            -4553015249.987596,
            1322972290.471462,
        ],
    ],
    [
        2439504000000,
        [
            -6112466311.783198,
            -4539836570.769422,
            1327913658.408082,
        ],
    ],
    [
        2440108800000,
        [
            -6121461559.640511,
            -4527674489.173816,
            1332413292.739538,
        ],
    ],
    [
        2440713600000,
        [
            -6132142801.166216,
            -4516726818.480428,
            1336385868.659963,
        ],
    ],
    [
        2441318400000,
        [
            -6144325985.137375,
            -4507156108.682072,
            1339762231.601014,
        ],
    ],
    [
        2441923200000,
        [
            -6157829978.817344,
            -4499101077.312706,
            1342481591.099692,
        ],
    ],
    [
        2442528000000,
        [
            -6172455663.140479,
            -4492698011.004013,
            1344483748.537929,
        ],
    ],
    [
        2443132800000,
        [
            -6187972477.075635,
            -4488058903.678228,
            1345720809.442803,
        ],
    ],
    [
        2443737600000,
        [
            -6204139175.862053,
            -4485254540.817941,
            1346163307.576143,
        ],
    ],
    [
        2444342400000,
        [
            -6220729055.674031,
            -4484330887.020181,
            1345790414.127141,
        ],
    ],
    [
        2444947200000,
        [
            -6237506151.516319,
            -4485327795.619818,
            1344583844.947603,
        ],
    ],
    [
        2445552000000,
        [
            -6254215066.517649,
            -4488256357.182367,
            1342539640.603164,
        ],
    ],
    [
        2446156800000,
        [
            -6270604573.069519,
            -4493085193.123476,
            1339672494.690431,
        ],
    ],
    [
        2446761600000,
        [
            -6286448949.939277,
            -4499761545.299445,
            1336004180.06751,
        ],
    ],
    [
        2447366400000,
        [
            -6301521821.080299,
            -4508226286.971387,
            1331559464.388121,
        ],
    ],
    [
        2447971200000,
        [
            -6315589349.045119,
            -4518391043.406018,
            1326377657.336612,
        ],
    ],
    [
        2448576000000,
        [
            -6328436009.253838,
            -4530127684.099668,
            1320515222.718522,
        ],
    ],
    [
        2449180800000,
        [
            -6339881345.276811,
            -4543293769.64247,
            1314032668.513573,
        ],
    ],
    [
        2449785600000,
        [
            -6349752067.374379,
            -4557743290.28641,
            1306992612.446262,
        ],
    ],
    [
        2450390400000,
        [
            -6357878774.328006,
            -4573304248.050614,
            1299470719.355361,
        ],
    ],
    [
        2450995200000,
        [
            -6364123067.024487,
            -4589771552.21645,
            1291556590.053058,
        ],
    ],
    [
        2451600000000,
        [
            -6368389094.819525,
            -4606936357.495045,
            1283339418.052623,
        ],
    ],
    [
        2452204800000,
        [
            -6370594312.781005,
            -4624592409.055679,
            1274908166.499612,
        ],
    ],
    [
        2452809600000,
        [
            -6370669631.476677,
            -4642514767.57257,
            1266361527.938797,
        ],
    ],
    [
        2453414400000,
        [
            -6368586721.778358,
            -4660456391.115891,
            1257807030.064188,
        ],
    ],
    [
        2454019200000,
        [
            -6364363635.519661,
            -4678180522.91416,
            1249345905.854439,
        ],
    ],
    [
        2454624000000,
        [
            -6358034241.697552,
            -4695462681.330281,
            1241075281.865273,
        ],
    ],
    [
        2455228800000,
        [
            -6349651234.635307,
            -4712070830.70904,
            1233096988.086663,
        ],
    ],
    [
        2455833600000,
        [
            -6339312223.955345,
            -4727765700.032628,
            1225514906.941069,
        ],
    ],
    [
        2456438400000,
        [
            -6327158683.586811,
            -4742334709.171144,
            1218419760.061664,
        ],
    ],
    [
        2457043200000,
        [
            -6313343943.275075,
            -4755589405.636259,
            1211893322.492729,
        ],
    ],
    [
        2457648000000,
        [
            -6298038268.59818,
            -4767346628.33191,
            1206016281.373696,
        ],
    ],
    [
        2458252800000,
        [
            -6281452587.384746,
            -4777432066.685919,
            1200864091.457688,
        ],
    ],
    [
        2458857600000,
        [
            -6263830431.246903,
            -4785713446.881141,
            1196492664.800069,
        ],
    ],
    [
        2459462400000,
        [
            -6245414936.060268,
            -4792092756.61683,
            1192944818.964944,
        ],
    ],
    [
        2460067200000,
        [
            -6226455656.626499,
            -4796487236.981007,
            1190257733.355893,
        ],
    ],
    [
        2460672000000,
        [
            -6207229786.792913,
            -4798835250.303101,
            1188457776.7303,
        ],
    ],
    [
        2461276800000,
        [
            -6188027727.415732,
            -4799126239.073214,
            1187548152.486929,
        ],
    ],
    [
        2461881600000,
        [
            -6169120858.044901,
            -4797387034.231211,
            1187517772.108161,
        ],
    ],
    [
        2462486400000,
        [
            -6150770734.851557,
            -4793661628.220959,
            1188348840.666046,
        ],
    ],
    [
        2463091200000,
        [
            -6133248921.708821,
            -4788018697.557755,
            1190011013.336779,
        ],
    ],
    [
        2463696000000,
        [
            -6116817800.150695,
            -4780576743.089931,
            1192451673.544998,
        ],
    ],
    [
        2464300800000,
        [
            -6101701960.803015,
            -4771484615.861975,
            1195607014.671203,
        ],
    ],
    [
        2464905600000,
        [
            -6088101037.239882,
            -4760900235.403653,
            1199409769.594302,
        ],
    ],
    [
        2465510400000,
        [
            -6076209661.60812,
            -4749000068.409401,
            1203782650.004014,
        ],
    ],
    [
        2466115200000,
        [
            -6066195243.462543,
            -4735999422.747811,
            1208631270.64356,
        ],
    ],
    [
        2466720000000,
        [
            -6058175557.101061,
            -4722128561.241643,
            1213856687.107413,
        ],
    ],
    [
        2467324800000,
        [
            -6052235958.372164,
            -4707611937.925042,
            1219362647.66001,
        ],
    ],
    [
        2467929600000,
        [
            -6048450046.49679,
            -4692680650.894394,
            1225047965.281692,
        ],
    ],
    [
        2468534400000,
        [
            -6046855313.588234,
            -4677588890.888658,
            1230801641.187184,
        ],
    ],
    [
        2469139200000,
        [
            -6047437994.791254,
            -4662587602.034049,
            1236515906.602809,
        ],
    ],
    [
        2469744000000,
        [
            -6050154269.531509,
            -4647906269.746583,
            1242092145.441232,
        ],
    ],
    [
        2470348800000,
        [
            -6054950817.297997,
            -4633769154.57548,
            1247431928.543688,
        ],
    ],
    [
        2470953600000,
        [
            -6061738408.952923,
            -4620408791.956874,
            1252433899.938309,
        ],
    ],
    [
        2471558400000,
        [
            -6070383580.078884,
            -4608038778.443978,
            1257006604.868352,
        ],
    ],
    [
        2472163200000,
        [
            -6080732672.141144,
            -4596839561.433645,
            1261072481.18672,
        ],
    ],
    [
        2472768000000,
        [
            -6092630703.036182,
            -4586978481.255416,
            1264557600.086824,
        ],
    ],
    [
        2473372800000,
        [
            -6105892862.49885,
            -4578620499.404081,
            1267390143.896668,
        ],
    ],
    [
        2473977600000,
        [
            -6120301920.239801,
            -4571900958.188121,
            1269512674.271682,
        ],
    ],
    [
        2474582400000,
        [
            -6135633979.962624,
            -4566915957.374815,
            1270883979.086238,
        ],
    ],
    [
        2475187200000,
        [
            -6151674136.066438,
            -4563745632.035351,
            1271467817.26839,
        ],
    ],
    [
        2475792000000,
        [
            -6168186296.488999,
            -4562461712.147318,
            1271233012.462318,
        ],
    ],
    [
        2476396800000,
        [
            -6184915322.351789,
            -4563100670.127342,
            1270165036.501932,
        ],
    ],
    [
        2477001600000,
        [
            -6201613760.153183,
            -4565658723.002097,
            1268265747.81384,
        ],
    ],
    [
        2477606400000,
        [
            -6218053159.919828,
            -4570117639.388684,
            1265541509.914416,
        ],
    ],
    [
        2478211200000,
        [
            -6233993147.990415,
            -4576448594.082447,
            1262004946.650283,
        ],
    ],
    [
        2478816000000,
        [
            -6249187598.831451,
            -4584586121.039717,
            1257685721.440285,
        ],
    ],
    [
        2479420800000,
        [
            -6263411899.368476,
            -4594427619.31955,
            1252628280.95168,
        ],
    ],
    [
        2480025600000,
        [
            -6276469138.590787,
            -4605861133.732205,
            1246879662.264963,
        ],
    ],
    [
        2480630400000,
        [
            -6288159542.690847,
            -4618765154.644491,
            1240492872.808802,
        ],
    ],
    [
        2481235200000,
        [
            -6298290141.152989,
            -4632984034.394964,
            1233536624.398357,
        ],
    ],
    [
        2481840000000,
        [
            -6306702086.373879,
            -4648331890.958306,
            1226091194.924788,
        ],
    ],
    [
        2482444800000,
        [
            -6313271056.675044,
            -4664621957.589109,
            1218236164.502339,
        ],
    ],
    [
        2483049600000,
        [
            -6317877961.210014,
            -4681662258.782239,
            1210055296.186586,
        ],
    ],
    [
        2483654400000,
        [
            -6320421465.697647,
            -4699233341.487989,
            1201644879.745111,
        ],
    ],
    [
        2484259200000,
        [
            -6320844555.521467,
            -4717096416.776629,
            1193107845.179335,
        ],
    ],
    [
        2484864000000,
        [
            -6319128496.181511,
            -4735023798.934513,
            1184541669.730557,
        ],
    ],
    [
        2485468800000,
        [
            -6315265203.740302,
            -4752790523.331043,
            1176044626.164374,
        ],
    ],
    [
        2486073600000,
        [
            -6309271733.338767,
            -4770155117.964261,
            1167722445.734011,
        ],
    ],
    [
        2486678400000,
        [
            -6301214840.298796,
            -4786871522.148592,
            1159680937.527026,
        ],
    ],
    [
        2487283200000,
        [
            -6291197937.338574,
            -4802719695.554607,
            1152014449.47844,
        ],
    ],
    [
        2487888000000,
        [
            -6279335003.338674,
            -4817493050.832273,
            1144813481.181222,
        ],
    ],
    [
        2488492800000,
        [
            -6265766027.374733,
            -4830982383.726808,
            1138169658.921621,
        ],
    ],
    [
        2489097600000,
        [
            -6250678199.750453,
            -4842990563.980757,
            1132167347.906446,
        ],
    ],
    [
        2489702400000,
        [
            -6234285826.041147,
            -4853361655.728719,
            1126873304.736204,
        ],
    ],
    [
        2490307200000,
        [
            -6216805621.318578,
            -4861963607.618445,
            1122345876.308354,
        ],
    ],
    [
        2490912000000,
        [
            -6198472574.20133,
            -4868674583.72708,
            1118638679.183308,
        ],
    ],
    [
        2491516800000,
        [
            -6179557011.422248,
            -4873399000.278139,
            1115791893.790389,
        ],
    ],
    [
        2492121600000,
        [
            -6160338537.030449,
            -4876092939.293073,
            1113823926.308321,
        ],
    ],
    [
        2492726400000,
        [
            -6141083364.916162,
            -4876741423.815752,
            1112742483.381768,
        ],
    ],
    [
        2493331200000,
        [
            -6122061152.467705,
            -4875345960.889391,
            1112547543.029316,
        ],
    ],
    [
        2493936000000,
        [
            -6103558399.89392,
            -4871940806.050341,
            1113222909.516558,
        ],
    ],
    [
        2494540800000,
        [
            -6085848683.748529,
            -4866612768.835731,
            1114730549.629203,
        ],
    ],
    [
        2495145600000,
        [
            -6069173827.747278,
            -4859473206.026688,
            1117023466.592815,
        ],
    ],
    [
        2495750400000,
        [
            -6053763130.253922,
            -4850646198.867167,
            1120048289.046192,
        ],
    ],
    [
        2496355200000,
        [
            -6039844417.911922,
            -4840285079.903587,
            1123737163.332285,
        ],
    ],
    [
        2496960000000,
        [
            -6027613118.504773,
            -4828585980.966904,
            1128004926.659537,
        ],
    ],
    [
        2497564800000,
        [
            -6017219420.616249,
            -4815756124.655726,
            1132763044.211949,
        ],
    ],
    [
        2498169600000,
        [
            -6008790992.859314,
            -4802003276.812272,
            1137921614.10021,
        ],
    ],
    [
        2498774400000,
        [
            -6002442674.286832,
            -4787553677.898195,
            1143381165.731132,
        ],
    ],
    [
        2499379200000,
        [
            -5998245938.528802,
            -4772659913.518836,
            1149032346.641668,
        ],
    ],
    [
        2499984000000,
        [
            -5996223294.432994,
            -4757568024.928881,
            1154769785.184264,
        ],
    ],
    [
        2500588800000,
        [
            -5996374253.023703,
            -4742509594.601259,
            1160492988.726151,
        ],
    ],
    [
        2501193600000,
        [
            -5998683540.833482,
            -4727722295.148105,
            1166097544.318762,
        ],
    ],
    [
        2501798400000,
        [
            -6003091192.225895,
            -4713452985.462923,
            1171476865.435752,
        ],
    ],
    [
        2502403200000,
        [
            -6009494132.257047,
            -4699925909.210594,
            1176534995.239017,
        ],
    ],
    [
        2503008000000,
        [
            -6017773990.232938,
            -4687338533.165516,
            1181185970.384655,
        ],
    ],
    [
        2503612800000,
        [
            -6027802946.377439,
            -4675885035.938986,
            1185344263.611292,
        ],
    ],
    [
        2504217600000,
        [
            -6039414084.963765,
            -4665755132.522262,
            1188928304.762195,
        ],
    ],
    [
        2504822400000,
        [
            -6052409293.227489,
            -4657104692.104379,
            1191871702.380225,
        ],
    ],
    [
        2505427200000,
        [
            -6066587259.774004,
            -4650055830.539729,
            1194120926.943523,
        ],
    ],
    [
        2506032000000,
        [
            -6081746041.845462,
            -4644722715.88604,
            1195625206.997054,
        ],
    ],
    [
        2506636800000,
        [
            -6097653584.228768,
            -4641206223.089208,
            1196341686.26018,
        ],
    ],
    [
        2507241600000,
        [
            -6114060948.011653,
            -4639567472.455745,
            1196244927.682964,
        ],
    ],
    [
        2507846400000,
        [
            -6130729249.625266,
            -4639832230.286658,
            1195322975.032518,
        ],
    ],
    [
        2508451200000,
        [
            -6147428375.437273,
            -4642017953.217738,
            1193567108.640344,
        ],
    ],
    [
        2509056000000,
        [
            -6163908148.167838,
            -4646124330.02946,
            1190978494.412202,
        ],
    ],
    [
        2509660800000,
        [
            -6179916032.843019,
            -4652109886.589686,
            1187576003.295264,
        ],
    ],
    [
        2510265600000,
        [
            -6195222291.658296,
            -4659900634.452084,
            1183390754.845316,
        ],
    ],
    [
        2510870400000,
        [
            -6209614533.174714,
            -4669417315.788024,
            1178456145.63597,
        ],
    ],
    [
        2511475200000,
        [
            -6222870428.727592,
            -4680562131.522183,
            1172815723.783455,
        ],
    ],
    [
        2512080000000,
        [
            -6234779086.067246,
            -4693198575.274199,
            1166529350.50734,
        ],
    ],
    [
        2512684800000,
        [
            -6245163976.949273,
            -4707164312.154066,
            1159666290.384181,
        ],
    ],
    [
        2513289600000,
        [
            -6253873012.080423,
            -4722297825.894541,
            1152295844.886269,
        ],
    ],
    [
        2513894400000,
        [
            -6260753766.394595,
            -4738421924.440827,
            1144496072.67311,
        ],
    ],
    [
        2514499200000,
        [
            -6265677523.130319,
            -4755327105.886744,
            1136358249.350515,
        ],
    ],
    [
        2515104000000,
        [
            -6268559499.386922,
            -4772788615.476553,
            1127978557.711769,
        ],
    ],
    [
        2515708800000,
        [
            -6269343939.587431,
            -4790591855.782701,
            1119449589.670813,
        ],
    ],
    [
        2516313600000,
        [
            -6267982507.388659,
            -4808513360.799274,
            1110869533.377496,
        ],
    ],
    [
        2516918400000,
        [
            -6264459648.363498,
            -4826308013.221681,
            1102344872.867673,
        ],
    ],
    [
        2517523200000,
        [
            -6258809410.696382,
            -4843729909.642093,
            1093980840.109509,
        ],
    ],
    [
        2518128000000,
        [
            -6251094867.048231,
            -4860555774.32474,
            1085874078.084513,
        ],
    ],
    [
        2518732800000,
        [
            -6241389866.959394,
            -4876563800.950248,
            1078122093.296751,
        ],
    ],
    [
        2519337600000,
        [
            -6229804122.738617,
            -4891524741.461712,
            1070824277.88902,
        ],
    ],
    [
        2519942400000,
        [
            -6216495797.870774,
            -4905225531.429304,
            1064071550.260588,
        ],
    ],
    [
        2520547200000,
        [
            -6201644786.866212,
            -4917489511.627085,
            1057940626.150722,
        ],
    ],
    [
        2521152000000,
        [
            -6185437805.824869,
            -4928152869.974603,
            1052503860.678048,
        ],
    ],
    [
        2521756800000,
        [
            -6168091922.965071,
            -4937059040.020195,
            1047828951.382278,
        ],
    ],
    [
        2522361600000,
        [
            -6149862456.297621,
            -4944083285.432295,
            1043968511.530867,
        ],
    ],
    [
        2522966400000,
        [
            -6131010628.943219,
            -4949148095.264465,
            1040956542.39148,
        ],
    ],
    [
        2523571200000,
        [
            -6111792393.080055,
            -4952196407.454156,
            1038819051.674534,
        ],
    ],
    [
        2524176000000,
        [
            -6092480237.137838,
            -4953188344.113837,
            1037572978.387583,
        ],
    ],
];
export const makemakeSunSvs = [
    [
        631152000000,
        [
            -6042160944.054669,
            1182157879.927186,
            4416076047.20532,
        ],
    ],
    [
        631756800000,
        [
            -6043260695.372538,
            1180092462.928864,
            4415599713.241445,
        ],
    ],
    [
        632361600000,
        [
            -6044359758.968478,
            1178026830.972332,
            4415122849.282108,
        ],
    ],
    [
        632966400000,
        [
            -6045458129.682475,
            1175960986.713213,
            4414645456.317142,
        ],
    ],
    [
        633571200000,
        [
            -6046555804.053599,
            1173894933.294047,
            4414167535.72298,
        ],
    ],
    [
        634176000000,
        [
            -6047652779.54565,
            1171828673.67165,
            4413689088.822495,
        ],
    ],
    [
        634780800000,
        [
            -6048749054.080353,
            1169762210.718652,
            4413210116.892096,
        ],
    ],
    [
        635385600000,
        [
            -6049844625.969699,
            1167695547.355086,
            4412730621.22806,
        ],
    ],
    [
        635990400000,
        [
            -6050939493.978223,
            1165628686.571111,
            4412250603.16978,
        ],
    ],
    [
        636595200000,
        [
            -6052033657.4075,
            1163561631.366599,
            4411770064.082222,
        ],
    ],
    [
        637200000000,
        [
            -6053127116.17326,
            1161494384.616507,
            4411289005.299018,
        ],
    ],
    [
        637804800000,
        [
            -6054219870.831418,
            1159426948.827355,
            4410807428.002737,
        ],
    ],
    [
        638409600000,
        [
            -6055311922.359948,
            1157359325.753004,
            4410325333.004983,
        ],
    ],
    [
        639014400000,
        [
            -6056403271.275497,
            1155291516.216486,
            4409842720.567536,
        ],
    ],
    [
        639619200000,
        [
            -6057493916.641853,
            1153223521.203939,
            4409359590.89141,
        ],
    ],
    [
        640224000000,
        [
            -6058583857.328886,
            1151155343.278528,
            4408875945.009747,
        ],
    ],
    [
        640828800000,
        [
            -6059673093.880847,
            1149086985.609134,
            4408391784.469087,
        ],
    ],
    [
        641433600000,
        [
            -6060761628.145054,
            1147018450.598191,
            4407907110.56329,
        ],
    ],
    [
        642038400000,
        [
            -6061849462.365393,
            1144949739.716819,
            4407421924.155782,
        ],
    ],
    [
        642643200000,
        [
            -6062936598.780953,
            1142880853.735055,
            4406936225.764179,
        ],
    ],
    [
        643248000000,
        [
            -6064023039.510032,
            1140811792.89769,
            4406450015.644376,
        ],
    ],
    [
        643852800000,
        [
            -6065108786.523724,
            1138742557.017598,
            4405963293.838743,
        ],
    ],
    [
        644457600000,
        [
            -6066193841.650814,
            1136673145.507687,
            4405476060.193724,
        ],
    ],
    [
        645062400000,
        [
            -6067278206.59098,
            1134603557.337124,
            4404988314.336778,
        ],
    ],
    [
        645667200000,
        [
            -6068361882.850814,
            1132533790.858297,
            4404500055.575279,
        ],
    ],
    [
        646272000000,
        [
            -6069444871.289829,
            1130463843.55249,
            4404011282.710584,
        ],
    ],
    [
        646876800000,
        [
            -6070527170.998703,
            1128393712.407269,
            4403521994.119395,
        ],
    ],
    [
        647481600000,
        [
            -6071608779.113011,
            1126323395.642553,
            4403032188.651816,
        ],
    ],
    [
        648086400000,
        [
            -6072689692.957717,
            1124252893.308642,
            4402541866.168063,
        ],
    ],
    [
        648691200000,
        [
            -6073769911.058441,
            1122182205.809534,
            4402051026.848989,
        ],
    ],
    [
        649296000000,
        [
            -6074849432.372356,
            1120111333.157443,
            4401559670.712271,
        ],
    ],
    [
        649900800000,
        [
            -6075928255.71622,
            1118040275.139036,
            4401067797.636076,
        ],
    ],
    [
        650505600000,
        [
            -6077006379.656924,
            1115969031.572143,
            4400575407.479338,
        ],
    ],
    [
        651110400000,
        [
            -6078083802.584769,
            1113897602.452481,
            4400082500.162835,
        ],
    ],
    [
        651715200000,
        [
            -6079160522.841641,
            1111825988.005479,
            4399589075.70612,
        ],
    ],
    [
        652320000000,
        [
            -6080236538.866852,
            1109754188.651989,
            4399095134.221389,
        ],
    ],
    [
        652924800000,
        [
            -6081311849.320408,
            1107682204.854815,
            4398600675.842611,
        ],
    ],
    [
        653529600000,
        [
            -6082386453.016501,
            1105610036.800912,
            4398105700.548579,
        ],
    ],
    [
        654134400000,
        [
            -6083460348.248979,
            1103537684.172518,
            4397610207.971766,
        ],
    ],
    [
        654739200000,
        [
            -6084533531.788804,
            1101465147.042411,
            4397114197.774925,
        ],
    ],
    [
        655344000000,
        [
            -6085605999.889772,
            1099392427.436138,
            4396617670.593421,
        ],
    ],
    [
        655948800000,
        [
            -6086677750.431249,
            1097319528.64058,
            4396120627.892639,
        ],
    ],
    [
        656553600000,
        [
            -6087748782.883177,
            1095246453.664258,
            4395623071.147022,
        ],
    ],
    [
        657158400000,
        [
            -6088819097.426715,
            1093173204.892677,
            4395125001.570119,
        ],
    ],
    [
        657763200000,
        [
            -6089888694.541842,
            1091099784.248888,
            4394626420.162937,
        ],
    ],
    [
        658368000000,
        [
            -6090957574.905216,
            1089026193.319047,
            4394127327.775491,
        ],
    ],
    [
        658972800000,
        [
            -6092025739.379365,
            1086952433.391203,
            4393627725.130934,
        ],
    ],
    [
        659577600000,
        [
            -6093093189.023996,
            1084878505.432339,
            4393127612.818269,
        ],
    ],
    [
        660182400000,
        [
            -6094159925.107894,
            1082804409.996706,
            4392626991.247555,
        ],
    ],
    [
        660787200000,
        [
            -6095225949.053473,
            1080730147.016152,
            4392125860.534148,
        ],
    ],
    [
        661392000000,
        [
            -6096291262.040789,
            1078655715.484922,
            4391624220.290265,
        ],
    ],
    [
        661996800000,
        [
            -6097355863.913129,
            1076581113.630773,
            4391122069.602887,
        ],
    ],
    [
        662601600000,
        [
            -6098419752.655853,
            1074506340.483405,
            4390619407.816555,
        ],
    ],
    [
        663206400000,
        [
            -6099482926.313607,
            1072431396.77846,
            4390116235.213348,
        ],
    ],
    [
        663811200000,
        [
            -6100545384.276069,
            1070356283.568585,
            4389612552.401771,
        ],
    ],
    [
        664416000000,
        [
            -6101607126.549727,
            1068281001.282533,
            4389108359.735291,
        ],
    ],
    [
        665020800000,
        [
            -6102668153.045495,
            1066205549.824535,
            4388603657.287523,
        ],
    ],
    [
        665625600000,
        [
            -6103728463.357578,
            1064129928.848382,
            4388098444.971107,
        ],
    ],
    [
        666230400000,
        [
            -6104788056.755812,
            1062054137.940206,
            4387592722.62948,
        ],
    ],
    [
        666835200000,
        [
            -6105846932.246394,
            1059978176.717045,
            4387086490.090397,
        ],
    ],
    [
        667440000000,
        [
            -6106905088.661593,
            1057902044.854002,
            4386579747.184058,
        ],
    ],
    [
        668044800000,
        [
            -6107962524.747978,
            1055825742.011332,
            4386072493.707555,
        ],
    ],
    [
        668649600000,
        [
            -6109019239.117533,
            1053749267.607797,
            4385564729.293077,
        ],
    ],
    [
        669254400000,
        [
            -6110075229.669236,
            1051672620.611738,
            4385056453.230959,
        ],
    ],
    [
        669859200000,
        [
            -6111130492.536407,
            1049595800.307605,
            4384547664.765133,
        ],
    ],
    [
        670464000000,
        [
            -6112185022.759045,
            1047518808.022292,
            4384038364.081003,
        ],
    ],
    [
        671068800000,
        [
            -6113238816.586261,
            1045441646.845642,
            4383528552.392061,
        ],
    ],
    [
        671673600000,
        [
            -6114291871.809509,
            1043364320.059897,
            4383018231.133873,
        ],
    ],
    [
        672278400000,
        [
            -6115344186.95433,
            1041286830.683951,
            4382507401.636543,
        ],
    ],
    [
        672883200000,
        [
            -6116395760.895545,
            1039209181.629688,
            4381996065.169562,
        ],
    ],
    [
        673488000000,
        [
            -6117446592.826146,
            1037131375.834097,
            4381484223.011929,
        ],
    ],
    [
        674092800000,
        [
            -6118496682.332808,
            1035053416.281835,
            4380971876.476281,
        ],
    ],
    [
        674697600000,
        [
            -6119546029.489569,
            1032975305.945524,
            4380459026.892244,
        ],
    ],
    [
        675302400000,
        [
            -6120594634.942627,
            1030897047.645559,
            4379945675.546921,
        ],
    ],
    [
        675907200000,
        [
            -6121642499.928669,
            1028818643.788174,
            4379431823.554215,
        ],
    ],
    [
        676512000000,
        [
            -6122689625.989458,
            1026740095.971722,
            4378917471.622697,
        ],
    ],
    [
        677116800000,
        [
            -6123736013.978628,
            1024661404.939497,
            4378402619.935261,
        ],
    ],
    [
        677721600000,
        [
            -6124781663.299512,
            1022582571.905298,
            4377887268.785804,
        ],
    ],
    [
        678326400000,
        [
            -6125826573.556061,
            1020503599.674058,
            4377371419.356326,
        ],
    ],
    [
        678931200000,
        [
            -6126870746.112699,
            1018424491.357308,
            4376855073.199175,
        ],
    ],
    [
        679536000000,
        [
            -6127914183.47276,
            1016345249.188182,
            4376338231.545323,
        ],
    ],
    [
        680140800000,
        [
            -6128956888.441942,
            1014265874.478344,
            4375820895.199309,
        ],
    ],
    [
        680745600000,
        [
            -6129998863.792827,
            1012186367.844692,
            4375303064.629191,
        ],
    ],
    [
        681350400000,
        [
            -6131040112.167592,
            1010106729.363666,
            4374784740.041442,
        ],
    ],
    [
        681955200000,
        [
            -6132080636.052569,
            1008026958.64835,
            4374265921.420898,
        ],
    ],
    [
        682560000000,
        [
            -6133120437.778582,
            1005947054.865952,
            4373746608.540442,
        ],
    ],
    [
        683164800000,
        [
            -6134159519.521753,
            1003867016.674067,
            4373226800.926193,
        ],
    ],
    [
        683769600000,
        [
            -6135197883.194801,
            1001786842.021219,
            4372706497.737773,
        ],
    ],
    [
        684374400000,
        [
            -6136235529.870339,
            999706527.9204538,
            4372185697.584558,
        ],
    ],
    [
        684979200000,
        [
            -6137272458.615496,
            997626071.0536963,
            4371664398.723604,
        ],
    ],
    [
        685584000000,
        [
            -6138308666.708954,
            995545469.5699494,
            4371142600.037724,
        ],
    ],
    [
        686188800000,
        [
            -6139344151.876351,
            993464723.2423805,
            4370620301.345506,
        ],
    ],
    [
        686793600000,
        [
            -6140378912.875942,
            991383831.9543519,
            4370097502.646882,
        ],
    ],
    [
        687398400000,
        [
            -6141412948.651383,
            989302795.1818821,
            4369574203.75174,
        ],
    ],
    [
        688003200000,
        [
            -6142446257.84288,
            987221612.23089,
            4369050404.348535,
        ],
    ],
    [
        688608000000,
        [
            -6143478838.717151,
            985140282.4988372,
            4368526104.129246,
        ],
    ],
    [
        689212800000,
        [
            -6144510689.25211,
            983058805.627022,
            4368001302.872185,
        ],
    ],
    [
        689817600000,
        [
            -6145541807.272237,
            980977181.5634834,
            4367476000.482741,
        ],
    ],
    [
        690422400000,
        [
            -6146572190.603538,
            978895410.5380851,
            4366950196.990044,
        ],
    ],
    [
        691027200000,
        [
            -6147601837.198391,
            976813492.9084221,
            4366423892.472524,
        ],
    ],
    [
        691632000000,
        [
            -6148630745.024004,
            974731428.8438264,
            4365897086.873763,
        ],
    ],
    [
        692236800000,
        [
            -6149658911.287885,
            972649218.214674,
            4365369779.860672,
        ],
    ],
    [
        692841600000,
        [
            -6150686331.618464,
            970566861.7514329,
            4364841971.356785,
        ],
    ],
    [
        693446400000,
        [
            -6151713001.536823,
            968484362.4052036,
            4364313662.422395,
        ],
    ],
    [
        694051200000,
        [
            -6152738918.40153,
            966401724.2821326,
            4363784854.889302,
        ],
    ],
    [
        694656000000,
        [
            -6153764081.101042,
            964318951.2534957,
            4363255550.589958,
        ],
    ],
    [
        695260800000,
        [
            -6154788489.258802,
            962236046.7488995,
            4362725751.169065,
        ],
    ],
    [
        695865600000,
        [
            -6155812142.926778,
            960153013.906802,
            4362195458.137477,
        ],
    ],
    [
        696470400000,
        [
            -6156835042.535798,
            958069855.6577739,
            4361664672.91733,
        ],
    ],
    [
        697075200000,
        [
            -6157857188.912213,
            955986574.7211666,
            4361133396.847991,
        ],
    ],
    [
        697680000000,
        [
            -6158878583.30553,
            953903173.5390694,
            4360601631.159603,
        ],
    ],
    [
        698284800000,
        [
            -6159899227.404728,
            951819654.1346344,
            4360069376.90478,
        ],
    ],
    [
        698889600000,
        [
            -6160919123.254787,
            949736017.8430996,
            4359536634.811489,
        ],
    ],
    [
        699494400000,
        [
            -6161938272.753021,
            947652264.9753513,
            4359003405.055692,
        ],
    ],
    [
        700099200000,
        [
            -6162956676.473023,
            945568395.1565955,
            4358469687.324131,
        ],
    ],
    [
        700704000000,
        [
            -6163974333.494151,
            943484409.0023491,
            4357935481.694939,
        ],
    ],
    [
        701308800000,
        [
            -6164991243.505264,
            941400308.5753369,
            4357400789.102145,
        ],
    ],
    [
        701913600000,
        [
            -6166007407.657643,
            939316095.8455195,
            4356865610.602923,
        ],
    ],
    [
        702518400000,
        [
            -6167022827.68883,
            937231771.9526981,
            4356329946.893248,
        ],
    ],
    [
        703123200000,
        [
            -6168037505.271564,
            935147337.3674648,
            4355793798.325853,
        ],
    ],
    [
        703728000000,
        [
            -6169051441.813402,
            933062792.1454259,
            4355257165.023872,
        ],
    ],
    [
        704332800000,
        [
            -6170064638.432615,
            930978136.0890852,
            4354720046.962556,
        ],
    ],
    [
        704937600000,
        [
            -6171077095.99122,
            928893368.8343263,
            4354182444.015848,
        ],
    ],
    [
        705542400000,
        [
            -6172088815.153764,
            926808489.86869,
            4353644355.968465,
        ],
    ],
    [
        706147200000,
        [
            -6173099796.434779,
            924723498.4454192,
            4353105782.470495,
        ],
    ],
    [
        706752000000,
        [
            -6174110040.065305,
            922638393.3472468,
            4352566722.892532,
        ],
    ],
    [
        707356800000,
        [
            -6175119545.260611,
            920553172.7692132,
            4352027176.181991,
        ],
    ],
    [
        707961600000,
        [
            -6176128309.230582,
            918467835.3622069,
            4351487141.312699,
        ],
    ],
    [
        708566400000,
        [
            -6177136328.285992,
            916382381.8638611,
            4350946618.265894,
        ],
    ],
    [
        709171200000,
        [
            -6178143599.988041,
            914296814.424416,
            4350405607.888704,
        ],
    ],
    [
        709776000000,
        [
            -6179150123.115671,
            912211135.1725514,
            4349864111.121123,
        ],
    ],
    [
        710380800000,
        [
            -6180155896.87764,
            910125345.964637,
            4349322128.777779,
        ],
    ],
    [
        710985600000,
        [
            -6181160920.613191,
            908039448.5903963,
            4348779661.625464,
        ],
    ],
    [
        711590400000,
        [
            -6182165193.801367,
            905953444.9145966,
            4348236710.45992,
        ],
    ],
    [
        712195200000,
        [
            -6183168716.159122,
            903867336.9092432,
            4347693276.134782,
        ],
    ],
    [
        712800000000,
        [
            -6184171487.755742,
            901781126.6020911,
            4347149359.548959,
        ],
    ],
    [
        713404800000,
        [
            -6185173509.116639,
            899694815.9356694,
            4346604961.586375,
        ],
    ],
    [
        714009600000,
        [
            -6186174781.24073,
            897608406.4901812,
            4346060082.975123,
        ],
    ],
    [
        714614400000,
        [
            -6187175305.246202,
            895521899.0944154,
            4345514724.049023,
        ],
    ],
    [
        715219200000,
        [
            -6188175081.300468,
            893435293.9489533,
            4344968884.709047,
        ],
    ],
    [
        715824000000,
        [
            -6189174108.183387,
            891348592.1395975,
            4344422565.193172,
        ],
    ],
    [
        716428800000,
        [
            -6190172385.253923,
            889261796.3800089,
            4343875766.683639,
        ],
    ],
    [
        717033600000,
        [
            -6191169913.644481,
            887174909.508376,
            4343328490.63395,
        ],
    ],
    [
        717638400000,
        [
            -6192166695.472283,
            885087933.5118393,
            4342780738.171359,
        ],
    ],
    [
        718243200000,
        [
            -6193162733.097241,
            883000869.5736526,
            4342232510.04955,
        ],
    ],
    [
        718848000000,
        [
            -6194158028.85259,
            880913718.2867045,
            4341683806.738174,
        ],
    ],
    [
        719452800000,
        [
            -6195152584.971584,
            878826479.7847675,
            4341134628.487629,
        ],
    ],
    [
        720057600000,
        [
            -6196146403.571828,
            876739153.8017197,
            4340584975.360133,
        ],
    ],
    [
        720662400000,
        [
            -6197139486.660942,
            874651739.6713899,
            4340034847.230096,
        ],
    ],
    [
        721267200000,
        [
            -6198131836.133568,
            872564236.2388529,
            4339484243.735068,
        ],
    ],
    [
        721872000000,
        [
            -6199123453.619756,
            870476641.6314795,
            4338933164.135209,
        ],
    ],
    [
        722476800000,
        [
            -6200114339.788201,
            868388953.0789231,
            4338381607.141222,
        ],
    ],
    [
        723081600000,
        [
            -6201104493.210412,
            866301167.7602506,
            4337829571.244355,
        ],
    ],
    [
        723686400000,
        [
            -6202093911.028755,
            864213284.5655048,
            4337277055.721033,
        ],
    ],
    [
        724291200000,
        [
            -6203082591.16056,
            862125303.8001881,
            4336724060.697217,
        ],
    ],
    [
        724896000000,
        [
            -6204070532.490863,
            860037225.7114434,
            4336170586.374052,
        ],
    ],
    [
        725500800000,
        [
            -6205057734.011889,
            857949050.1629803,
            4335616632.757375,
        ],
    ],
    [
        726105600000,
        [
            -6206044194.420664,
            855860776.9031723,
            4335062199.7513,
        ],
    ],
    [
        726710400000,
        [
            -6207029912.084265,
            853772405.8078169,
            4334507287.276377,
        ],
    ],
    [
        727315200000,
        [
            -6208014885.132919,
            851683937.0159252,
            4333951895.344125,
        ],
    ],
    [
        727920000000,
        [
            -6208999111.596865,
            849595370.980333,
            4333396024.091146,
        ],
    ],
    [
        728524800000,
        [
            -6209982589.559611,
            847506708.4278622,
            4332839673.767495,
        ],
    ],
    [
        729129600000,
        [
            -6210965317.264722,
            845417950.1811852,
            4332282844.647491,
        ],
    ],
    [
        729734400000,
        [
            -6211947292.926339,
            843329096.832952,
            4331725536.832315,
        ],
    ],
    [
        730339200000,
        [
            -6212928513.841927,
            841240148.7732131,
            4331167750.170559,
        ],
    ],
    [
        730944000000,
        [
            -6213908975.815342,
            839151107.5750213,
            4330609484.938185,
        ],
    ],
    [
        731548800000,
        [
            -6214888675.00667,
            837061977.0458025,
            4330050742.593497,
        ],
    ],
    [
        732153600000,
        [
            -6215867609.556135,
            834972761.8659211,
            4329491525.221611,
        ],
    ],
    [
        732758400000,
        [
            -6216845779.044337,
            832883466.3908553,
            4328931834.843458,
        ],
    ],
    [
        733363200000,
        [
            -6217823183.776466,
            830794094.5574543,
            4328371673.297621,
        ],
    ],
    [
        733968000000,
        [
            -6218799824.545845,
            828704650.0241457,
            4327811042.297888,
        ],
    ],
    [
        734572800000,
        [
            -6219775702.607502,
            826615136.2257792,
            4327249943.467718,
        ],
    ],
    [
        735177600000,
        [
            -6220750819.699906,
            824525556.3457861,
            4326688378.335855,
        ],
    ],
    [
        735782400000,
        [
            -6221725178.070993,
            822435913.22624,
            4326126348.299236,
        ],
    ],
    [
        736387200000,
        [
            -6222698780.483425,
            820346209.1960382,
            4325563854.539701,
        ],
    ],
    [
        736992000000,
        [
            -6223671630.085244,
            818256445.7655314,
            4325000897.854832,
        ],
    ],
    [
        737596800000,
        [
            -6224643729.781123,
            816166623.3118918,
            4324437478.431263,
        ],
    ],
    [
        738201600000,
        [
            -6225615081.021826,
            814076741.6396568,
            4323873596.024205,
        ],
    ],
    [
        738806400000,
        [
            -6226585684.044484,
            811986801.7008104,
            4323309250.905785,
        ],
    ],
    [
        739411200000,
        [
            -6227555540.040672,
            809896805.5964513,
            4322744444.094395,
        ],
    ],
    [
        740016000000,
        [
            -6228524651.582857,
            807806755.0049466,
            4322179176.561767,
        ],
    ],
    [
        740620800000,
        [
            -6229493021.677491,
            805716650.6557405,
            4321613448.854996,
        ],
    ],
    [
        741225600000,
        [
            -6230460653.190868,
            803626492.5413506,
            4321047261.150447,
        ],
    ],
    [
        741830400000,
        [
            -6231427548.677711,
            801536280.158635,
            4320480613.36399,
        ],
    ],
    [
        742435200000,
        [
            -6232393710.354873,
            799446012.6580253,
            4319913505.226105,
        ],
    ],
    [
        743040000000,
        [
            -6233359140.123235,
            797355688.9226012,
            4319345936.323541,
        ],
    ],
    [
        743644800000,
        [
            -6234323839.61141,
            795265307.5781442,
            4318777906.105465,
        ],
    ],
    [
        744249600000,
        [
            -6235287810.193707,
            793174866.8915355,
            4318209413.826489,
        ],
    ],
    [
        744854400000,
        [
            -6236251052.773037,
            791084364.5273073,
            4317640458.388865,
        ],
    ],
    [
        745459200000,
        [
            -6237213566.908509,
            788993797.5511601,
            4317071038.248099,
        ],
    ],
    [
        746064000000,
        [
            -6238175349.980115,
            786903163.7380983,
            4316501152.018914,
        ],
    ],
    [
        746668800000,
        [
            -6239136398.70644,
            784812462.9945444,
            4315930799.386092,
        ],
    ],
    [
        747273600000,
        [
            -6240096711.031397,
            782721696.3457539,
            4315359980.753218,
        ],
    ],
    [
        747878400000,
        [
            -6241056285.790092,
            780630864.692066,
            4314788696.537995,
        ],
    ],
    [
        748483200000,
        [
            -6242015121.97553,
            778539968.7298795,
            4314216947.048975,
        ],
    ],
    [
        749088000000,
        [
            -6242973218.51694,
            776449009.1915561,
            4313644732.586643,
        ],
    ],
    [
        749692800000,
        [
            -6243930574.324277,
            774357986.9960995,
            4313072053.525612,
        ],
    ],
    [
        750297600000,
        [
            -6244887188.408492,
            772266903.2931426,
            4312498910.34897,
        ],
    ],
    [
        750902400000,
        [
            -6245843060.018723,
            770175759.422147,
            4311925303.640463,
        ],
    ],
    [
        751507200000,
        [
            -6246798188.767809,
            768084556.7726576,
            4311351234.023933,
        ],
    ],
    [
        752112000000,
        [
            -6247752574.647933,
            765993296.4950811,
            4310776702.01277,
        ],
    ],
    [
        752716800000,
        [
            -6248706217.602601,
            763901979.1349539,
            4310201707.773489,
        ],
    ],
    [
        753321600000,
        [
            -6249659116.425977,
            761810604.9641666,
            4309626251.19263,
        ],
    ],
    [
        753926400000,
        [
            -6250611268.73702,
            759719175.6139057,
            4309050332.750969,
        ],
    ],
    [
        754531200000,
        [
            -6251562673.161004,
            757627694.3810647,
            4308473953.918363,
        ],
    ],
    [
        755136000000,
        [
            -6252513330.141465,
            755536164.6037707,
            4307897116.375105,
        ],
    ],
    [
        755740800000,
        [
            -6253463241.070158,
            753444588.8914833,
            4307319821.514962,
        ],
    ],
    [
        756345600000,
        [
            -6254412407.659686,
            751352969.224415,
            4306742070.437259,
        ],
    ],
    [
        756950400000,
        [
            -6255360831.744494,
            749261307.1349249,
            4306163864.026547,
        ],
    ],
    [
        757555200000,
        [
            -6256308515.239131,
            747169603.799949,
            4305585203.000335,
        ],
    ],
    [
        758160000000,
        [
            -6257255460.139894,
            745077860.0639027,
            4305006087.923402,
        ],
    ],
    [
        758764800000,
        [
            -6258201668.540362,
            742986076.3993266,
            4304426519.189507,
        ],
    ],
    [
        759369600000,
        [
            -6259147142.622663,
            740894252.7692716,
            4303846496.947304,
        ],
    ],
    [
        759974400000,
        [
            -6260091884.448754,
            738802388.3491311,
            4303266020.929678,
        ],
    ],
    [
        760579200000,
        [
            -6261035895.132319,
            736710481.3995093,
            4302685090.298788,
        ],
    ],
    [
        761184000000,
        [
            -6261979173.794906,
            734618530.3423918,
            4302103704.110768,
        ],
    ],
    [
        761788800000,
        [
            -6262921718.670186,
            732526535.3574663,
            4301521862.280451,
        ],
    ],
    [
        762393600000,
        [
            -6263863529.128595,
            730434497.6516011,
            4300939565.398046,
        ],
    ],
    [
        762998400000,
        [
            -6264804605.501007,
            728342418.0847108,
            4300356813.973173,
        ],
    ],
    [
        763603200000,
        [
            -6265744948.221684,
            726250296.9984661,
            4299773608.250272,
        ],
    ],
    [
        764208000000,
        [
            -6266684557.476898,
            724158134.4905809,
            4299189948.31406,
        ],
    ],
    [
        764812800000,
        [
            -6267623433.16879,
            722065930.6337548,
            4298605834.197835,
        ],
    ],
    [
        765417600000,
        [
            -6268561574.984135,
            719973685.5965929,
            4298021265.950167,
        ],
    ],
    [
        766022400000,
        [
            -6269498982.501745,
            717881399.6874453,
            4297436243.664486,
        ],
    ],
    [
        766627200000,
        [
            -6270435655.313443,
            715789073.3086587,
            4296850767.462504,
        ],
    ],
    [
        767232000000,
        [
            -6271371593.079564,
            713696706.7680342,
            4296264837.39512,
        ],
    ],
    [
        767836800000,
        [
            -6272306795.223421,
            711604299.9737438,
            4295678453.244409,
        ],
    ],
    [
        768441600000,
        [
            -6273241259.934423,
            709511852.6595142,
            4295091614.53819,
        ],
    ],
    [
        769046400000,
        [
            -6274174983.900334,
            707419365.9729036,
            4294504321.369577,
        ],
    ],
    [
        769651200000,
        [
            -6275107964.431551,
            705326843.1652256,
            4293916574.986183,
        ],
    ],
    [
        770256000000,
        [
            -6276040200.698576,
            703234288.0593555,
            4293328377.101871,
        ],
    ],
    [
        770860800000,
        [
            -6276971693.033745,
            701141704.0907576,
            4292739729.315342,
        ],
    ],
    [
        771465600000,
        [
            -6277902442.312931,
            699049094.3232213,
            4292150633.059003,
        ],
    ],
    [
        772070400000,
        [
            -6278832449.790054,
            696956461.5951724,
            4291561089.66571,
        ],
    ],
    [
        772675200000,
        [
            -6279761717.103627,
            694863808.5672709,
            4290971100.401527,
        ],
    ],
    [
        773280000000,
        [
            -6280690246.319229,
            692771137.6877946,
            4290380666.458889,
        ],
    ],
    [
        773884800000,
        [
            -6281618039.971869,
            690678451.0916927,
            4289789788.914604,
        ],
    ],
    [
        774489600000,
        [
            -6282545101.076768,
            688585750.4067557,
            4289198468.634933,
        ],
    ],
    [
        775094400000,
        [
            -6283471432.963107,
            686493036.4198854,
            4288606706.087239,
        ],
    ],
    [
        775699200000,
        [
            -6284397038.529728,
            684400308.8129082,
            4288014501.128253,
        ],
    ],
    [
        776304000000,
        [
            -6285321919.080301,
            682307566.9667107,
            4287421853.318577,
        ],
    ],
    [
        776908800000,
        [
            -6286246075.0184,
            680214811.6231182,
            4286828762.887352,
        ],
    ],
    [
        777513600000,
        [
            -6287169507.959251,
            678122044.4368879,
            4286235230.715819,
        ],
    ],
    [
        778118400000,
        [
            -6288092220.769156,
            676029266.4582769,
            4285641257.533582,
        ],
    ],
    [
        778723200000,
        [
            -6289014216.611714,
            673936477.7942107,
            4285046843.640234,
        ],
    ],
    [
        779328000000,
        [
            -6289935498.455852,
            671843677.8478699,
            4284451988.982683,
        ],
    ],
    [
        779932800000,
        [
            -6290856068.934618,
            669750865.5414232,
            4283856693.258703,
        ],
    ],
    [
        780537600000,
        [
            -6291775930.322507,
            667658039.4499751,
            4283260955.984194,
        ],
    ],
    [
        781142400000,
        [
            -6292695084.553477,
            665565197.8699273,
            4282664776.528515,
        ],
    ],
    [
        781747200000,
        [
            -6293613533.256319,
            663472338.8162272,
            4282068154.112552,
        ],
    ],
    [
        782352000000,
        [
            -6294531277.745867,
            661379459.9000325,
            4281471087.737318,
        ],
    ],
    [
        782956800000,
        [
            -6295448318.716401,
            659286558.0826163,
            4280873576.014626,
        ],
    ],
    [
        783561600000,
        [
            -6296364655.249949,
            657193629.8316692,
            4280275617.140833,
        ],
    ],
    [
        784166400000,
        [
            -6297280284.228625,
            655100672.6595135,
            4279677209.650012,
        ],
    ],
    [
        784771200000,
        [
            -6298195202.205301,
            653007686.2344807,
            4279078353.193677,
        ],
    ],
    [
        785376000000,
        [
            -6299109406.947962,
            650914671.1086143,
            4278479048.013253,
        ],
    ],
    [
        785980800000,
        [
            -6300022896.88281,
            648821627.6931996,
            4277879294.327032,
        ],
    ],
    [
        786585600000,
        [
            -6300935670.443372,
            646728556.3121645,
            4277279092.283574,
        ],
    ],
    [
        787190400000,
        [
            -6301847725.923436,
            644635457.45703,
            4276678442.075751,
        ],
    ],
    [
        787795200000,
        [
            -6302759061.557188,
            642542331.9363675,
            4276077344.023088,
        ],
    ],
    [
        788400000000,
        [
            -6303669675.664819,
            640449180.9208863,
            4275475798.606475,
        ],
    ],
    [
        789004800000,
        [
            -6304579566.815312,
            638356005.9006474,
            4274873806.45928,
        ],
    ],
    [
        789609600000,
        [
            -6305488733.973652,
            636262808.5317078,
            4274271368.299486,
        ],
    ],
    [
        790214400000,
        [
            -6306397176.506353,
            634169590.3210233,
            4273668484.762475,
        ],
    ],
    [
        790819200000,
        [
            -6307304893.666519,
            632076352.289686,
            4273065156.169927,
        ],
    ],
    [
        791424000000,
        [
            -6308211883.509706,
            629983095.5257639,
            4272461382.716384,
        ],
    ],
    [
        792028800000,
        [
            -6309118143.324515,
            627889822.8313155,
            4271857165.398705,
        ],
    ],
    [
        792633600000,
        [
            -6310023671.88853,
            625796538.5544398,
            4271252506.166387,
        ],
    ],
    [
        793238400000,
        [
            -6310928469.887782,
            623703246.9267759,
            4270647407.083767,
        ],
    ],
    [
        793843200000,
        [
            -6311832539.011546,
            621609951.4736857,
            4270041869.928165,
        ],
    ],
    [
        794448000000,
        [
            -6312735881.419906,
            619516655.1304692,
            4269435896.203854,
        ],
    ],
    [
        795052800000,
        [
            -6313638499.584987,
            617423360.3790578,
            4268829487.205513,
        ],
    ],
    [
        795657600000,
        [
            -6314540396.253816,
            615330069.2966654,
            4268222644.04679,
        ],
    ],
    [
        796262400000,
        [
            -6315441574.441222,
            613236783.5408103,
            4267615367.657339,
        ],
    ],
    [
        796867200000,
        [
            -6316342037.428676,
            611143504.2723111,
            4267007658.74653,
        ],
    ],
    [
        797472000000,
        [
            -6317241788.720591,
            609050231.9739213,
            4266399517.706106,
        ],
    ],
    [
        798076800000,
        [
            -6318140831.742299,
            606956966.1397184,
            4265790944.416024,
        ],
    ],
    [
        798681600000,
        [
            -6319039168.863873,
            604863705.2495911,
            4265181938.131652,
        ],
    ],
    [
        799286400000,
        [
            -6319936800.514097,
            602770448.0814445,
            4264572498.093831,
        ],
    ],
    [
        799891200000,
        [
            -6320833726.671988,
            600677195.0561453,
            4263962624.402022,
        ],
    ],
    [
        800496000000,
        [
            -6321729948.593506,
            598583947.1593797,
            4263352317.616557,
        ],
    ],
    [
        801100800000,
        [
            -6322625468.325835,
            596490704.7431508,
            4262741578.066128,
        ],
    ],
    [
        801705600000,
        [
            -6323520287.884562,
            594397467.4989194,
            4262130405.745254,
        ],
    ],
    [
        802310400000,
        [
            -6324414408.948818,
            592304234.7448376,
            4261518800.432415,
        ],
    ],
    [
        802915200000,
        [
            -6325307832.825253,
            590211005.6377301,
            4260906761.795165,
        ],
    ],
    [
        803520000000,
        [
            -6326200560.500448,
            588117779.2945284,
            4260294289.455484,
        ],
    ],
    [
        804124800000,
        [
            -6327092592.729237,
            586024554.8410577,
            4259681383.019678,
        ],
    ],
    [
        804729600000,
        [
            -6327983930.13326,
            583931331.3682603,
            4259068042.059733,
        ],
    ],
    [
        805334400000,
        [
            -6328874573.208953,
            581838107.7398275,
            4258454266.006012,
        ],
    ],
    [
        805939200000,
        [
            -6329764521.903194,
            579744882.3294977,
            4257840053.957914,
        ],
    ],
    [
        806544000000,
        [
            -6330653774.554495,
            577651653.4826646,
            4257225404.816278,
        ],
    ],
    [
        807148800000,
        [
            -6331542328.012807,
            575558421.2377374,
            4256610318.211872,
        ],
    ],
    [
        807753600000,
        [
            -6332430179.927258,
            573465187.6067863,
            4255994794.890363,
        ],
    ],
    [
        808358400000,
        [
            -6333317329.578688,
            571371954.9773251,
            4255378835.944074,
        ],
    ],
    [
        808963200000,
        [
            -6334203777.098659,
            569278725.3957235,
            4254762442.348728,
        ],
    ],
    [
        809568000000,
        [
            -6335089522.959878,
            567185500.66863,
            4254145614.966714,
        ],
    ],
    [
        810172800000,
        [
            -6335974567.879791,
            565092282.5133427,
            4253528354.620684,
        ],
    ],
    [
        810777600000,
        [
            -6336858912.864127,
            562999072.6016232,
            4252910662.125899,
        ],
    ],
    [
        811382400000,
        [
            -6337742559.277303,
            560905872.521185,
            4252292538.282279,
        ],
    ],
    [
        811987200000,
        [
            -6338625508.909055,
            558812683.6650769,
            4251673983.828132,
        ],
    ],
    [
        812592000000,
        [
            -6339507763.996518,
            556719507.0156962,
            4251054999.333244,
        ],
    ],
    [
        813196800000,
        [
            -6340389327.018974,
            554626342.7873238,
            4250435584.992747,
        ],
    ],
    [
        813801600000,
        [
            -6341270199.845158,
            552533190.2431694,
            4249815740.446674,
        ],
    ],
    [
        814406400000,
        [
            -6342150382.700751,
            550440048.7482369,
            4249195465.240361,
        ],
    ],
    [
        815011200000,
        [
            -6343029875.324017,
            548346919.263497,
            4248574759.746697,
        ],
    ],
    [
        815616000000,
        [
            -6343908678.906882,
            546253803.487976,
            4247953624.912485,
        ],
    ],
    [
        816220800000,
        [
            -6344786795.809896,
            544160702.4642882,
            4247332061.486209,
        ],
    ],
    [
        816825600000,
        [
            -6345664228.654902,
            542067616.3955503,
            4246710069.827172,
        ],
    ],
    [
        817430400000,
        [
            -6346540979.921009,
            539974544.8909811,
            4246087649.994689,
        ],
    ],
    [
        818035200000,
        [
            -6347417051.840464,
            537881487.1614372,
            4245464801.840519,
        ],
    ],
    [
        818640000000,
        [
            -6348292446.390859,
            535788442.1290593,
            4244841525.064344,
        ],
    ],
    [
        819244800000,
        [
            -6349167165.321446,
            533695408.4726842,
            4244217819.237491,
        ],
    ],
    [
        819849600000,
        [
            -6350041210.190495,
            531602384.5963172,
            4243593683.785772,
        ],
    ],
    [
        820454400000,
        [
            -6350914582.33325,
            529509368.467813,
            4242969117.895018,
        ],
    ],
    [
        821059200000,
        [
            -6351787282.459348,
            527416357.3631008,
            4242344120.326998,
        ],
    ],
    [
        821664000000,
        [
            -6352659309.572055,
            525323348.1906465,
            4241718689.474388,
        ],
    ],
    [
        822268800000,
        [
            -6353530660.709676,
            523230339.1827337,
            4241092824.230685,
        ],
    ],
    [
        822873600000,
        [
            -6354401333.066659,
            521137330.5968295,
            4240466524.577969,
        ],
    ],
    [
        823478400000,
        [
            -6355271325.132421,
            519044323.2577128,
            4239839790.919369,
        ],
    ],
    [
        824083200000,
        [
            -6356140635.970351,
            516951317.7439865,
            4239212623.563021,
        ],
    ],
    [
        824688000000,
        [
            -6357009264.641287,
            514858314.5225824,
            4238585022.727838,
        ],
    ],
    [
        825292800000,
        [
            -6357877210.097831,
            512765314.1925871,
            4237956988.657228,
        ],
    ],
    [
        825897600000,
        [
            -6358744471.267918,
            510672317.6185672,
            4237328521.694399,
        ],
    ],
    [
        826502400000,
        [
            -6359611047.193282,
            508579325.9666278,
            4236699622.312636,
        ],
    ],
    [
        827107200000,
        [
            -6360476937.18376,
            506486340.6538448,
            4236070291.102387,
        ],
    ],
    [
        827712000000,
        [
            -6361342140.949115,
            504393363.1802116,
            4235440528.694859,
        ],
    ],
    [
        828316800000,
        [
            -6362206658.55041,
            502300394.7960181,
            4234810335.580633,
        ],
    ],
    [
        828921600000,
        [
            -6363070489.758571,
            500207436.2322259,
            4234179711.902092,
        ],
    ],
    [
        829526400000,
        [
            -6363933633.024292,
            498114488.5102662,
            4233548657.783629,
        ],
    ],
    [
        830131200000,
        [
            -6364796086.364327,
            496021554.5205446,
            4232917174.272582,
        ],
    ],
    [
        830736000000,
        [
            -6365657849.539105,
            493928638.4175548,
            4232285263.248902,
        ],
    ],
    [
        831340800000,
        [
            -6366518924.09751,
            491835744.031432,
            4231652926.588988,
        ],
    ],
    [
        831945600000,
        [
            -6367379312.479009,
            489742874.463046,
            4231020165.864342,
        ],
    ],
    [
        832550400000,
        [
            -6368239017.568192,
            487650032.2243658,
            4230386982.378503,
        ],
    ],
    [
        833155200000,
        [
            -6369098042.570667,
            485557219.3540046,
            4229753377.22383,
        ],
    ],
    [
        833760000000,
        [
            -6369956390.984233,
            483464437.446545,
            4229119351.301622,
        ],
    ],
    [
        834364800000,
        [
            -6370814066.592015,
            481371687.6210961,
            4228484905.311344,
        ],
    ],
    [
        834969600000,
        [
            -6371671073.455967,
            479278970.4241372,
            4227850039.703903,
        ],
    ],
    [
        835574400000,
        [
            -6372527415.847423,
            477186285.618774,
            4227214754.566736,
        ],
    ],
    [
        836179200000,
        [
            -6373383097.853826,
            475093631.8637668,
            4226579049.415347,
        ],
    ],
    [
        836784000000,
        [
            -6374238122.286189,
            473001006.8366897,
            4225942923.148441,
        ],
    ],
    [
        837388800000,
        [
            -6375092490.053663,
            470908408.7558025,
            4225306374.79752,
        ],
    ],
    [
        837993600000,
        [
            -6375946201.986854,
            468815837.3846854,
            4224669404.253057,
        ],
    ],
    [
        838598400000,
        [
            -6376799260.200709,
            466723292.69706,
            4224032011.692037,
        ],
    ],
    [
        839203200000,
        [
            -6377651667.386641,
            464630773.8868697,
            4223394196.974038,
        ],
    ],
    [
        839808000000,
        [
            -6378503426.057255,
            462538279.453593,
            4222755959.605754,
        ],
    ],
    [
        840412800000,
        [
            -6379354538.291444,
            460445807.4899455,
            4222117298.864551,
        ],
    ],
    [
        841017600000,
        [
            -6380205005.704817,
            458353355.8826625,
            4221478213.898101,
        ],
    ],
    [
        841622400000,
        [
            -6381054829.493728,
            456260922.4297624,
            4220838703.786262,
        ],
    ],
    [
        842227200000,
        [
            -6381904010.511501,
            454168504.8881435,
            4220198767.568431,
        ],
    ],
    [
        842832000000,
        [
            -6382752549.34795,
            452076100.9244185,
            4219558404.219089,
        ],
    ],
    [
        843436800000,
        [
            -6383600446.284657,
            449983707.9140559,
            4218917612.529147,
        ],
    ],
    [
        844041600000,
        [
            -6384447700.742932,
            447891322.7383724,
            4218276390.933488,
        ],
    ],
    [
        844646400000,
        [
            -6385294310.218422,
            445798942.5075127,
            4217634737.780123,
        ],
    ],
    [
        845251200000,
        [
            -6386140270.837763,
            443706566.3204119,
            4216992652.321994,
        ],
    ],
    [
        845856000000,
        [
            -6386985579.678424,
            441614195.119109,
            4216350134.874532,
        ],
    ],
    [
        846460800000,
        [
            -6387830235.205778,
            439521830.1222767,
            4215707186.020046,
        ],
    ],
    [
        847065600000,
        [
            -6388674236.473102,
            437429472.3393937,
            4215063806.262234,
        ],
    ],
    [
        847670400000,
        [
            -6389517582.724459,
            435337122.7373203,
            4214419996.072336,
        ],
    ],
    [
        848275200000,
        [
            -6390360273.366528,
            433244782.3935361,
            4213775755.967804,
        ],
    ],
    [
        848880000000,
        [
            -6391202308.055667,
            431152452.537965,
            4213131086.544796,
        ],
    ],
    [
        849484800000,
        [
            -6392043686.806798,
            429060134.5101703,
            4212485988.468938,
        ],
    ],
    [
        850089600000,
        [
            -6392884410.096152,
            426967829.6352589,
            4211840462.423091,
        ],
    ],
    [
        850694400000,
        [
            -6393724478.903735,
            424875538.978542,
            4211194508.984896,
        ],
    ],
    [
        851299200000,
        [
            -6394563894.469416,
            422783262.9621797,
            4210548128.40143,
        ],
    ],
    [
        851904000000,
        [
            -6395402657.350192,
            420691001.286782,
            4209901320.454541,
        ],
    ],
    [
        852508800000,
        [
            -6396240766.615464,
            418598754.2037569,
            4209254085.062011,
        ],
    ],
    [
        853113600000,
        [
            -6397078221.428975,
            416506523.7193758,
            4208606423.089595,
        ],
    ],
    [
        853718400000,
        [
            -6397915022.718544,
            414414312.378338,
            4207958335.878856,
        ],
    ],
    [
        854323200000,
        [
            -6398751172.63363,
            412322122.0219975,
            4207309824.531484,
        ],
    ],
    [
        854928000000,
        [
            -6399586673.710007,
            410229953.7088087,
            4206660889.783419,
        ],
    ],
    [
        855532800000,
        [
            -6400421528.537591,
            408137807.9322447,
            4206011532.089371,
        ],
    ],
    [
        856137600000,
        [
            -6401255739.676127,
            406045684.7680461,
            4205361751.694562,
        ],
    ],
    [
        856742400000,
        [
            -6402089309.644746,
            403953583.9412064,
            4204711548.670524,
        ],
    ],
    [
        857347200000,
        [
            -6402922240.936314,
            401861504.8316509,
            4204060922.919949,
        ],
    ],
    [
        857952000000,
        [
            -6403754536.032014,
            399769446.3991903,
            4203409874.137689,
        ],
    ],
    [
        858556800000,
        [
            -6404586197.312809,
            397677406.9734823,
            4202758401.688199,
        ],
    ],
    [
        859161600000,
        [
            -6405417226.520615,
            395585384.0007736,
            4202106504.412435,
        ],
    ],
    [
        859766400000,
        [
            -6406247623.601928,
            393493374.5698563,
            4201454180.786225,
        ],
    ],
    [
        860371200000,
        [
            -6407077386.81809,
            391401377.1830876,
            4200801429.874382,
        ],
    ],
    [
        860976000000,
        [
            -6407906514.96862,
            389309392.0102226,
            4200148251.69298,
        ],
    ],
    [
        861580800000,
        [
            -6408735008.080849,
            387217419.3580695,
            4199494646.459052,
        ],
    ],
    [
        862185600000,
        [
            -6409562866.571127,
            385125459.0804764,
            4198840614.183665,
        ],
    ],
    [
        862790400000,
        [
            -6410390090.727547,
            383033510.7850235,
            4198186154.723771,
        ],
    ],
    [
        863395200000,
        [
            -6411216680.62179,
            380941574.0802497,
            4197531267.900276,
        ],
    ],
    [
        864000000000,
        [
            -6412042636.181129,
            378849648.7141824,
            4196875953.574983,
        ],
    ],
    [
        864604800000,
        [
            -6412867957.310929,
            376757734.6233647,
            4196220211.685561,
        ],
    ],
    [
        865209600000,
        [
            -6413692644.035438,
            374665831.8958199,
            4195564042.237308,
        ],
    ],
    [
        865814400000,
        [
            -6414516696.610025,
            372573940.6086432,
            4194907445.226092,
        ],
    ],
    [
        866419200000,
        [
            -6415340115.409204,
            370482060.5034358,
            4194250420.45272,
        ],
    ],
    [
        867024000000,
        [
            -6416162900.163404,
            368390190.8356681,
            4193592967.364094,
        ],
    ],
    [
        867628800000,
        [
            -6416985049.070573,
            366298331.4623697,
            4192935085.544305,
        ],
    ],
    [
        868233600000,
        [
            -6417806560.138397,
            364206484.2598482,
            4192276775.614774,
        ],
    ],
    [
        868838400000,
        [
            -6418627433.174522,
            362114652.1434555,
            4191618038.921997,
        ],
    ],
    [
        869443200000,
        [
            -6419447669.526276,
            360022837.6325837,
            4190958876.749969,
        ],
    ],
    [
        870048000000,
        [
            -6420267271.245173,
            357931042.61104,
            4190299290.112223,
        ],
    ],
    [
        870652800000,
        [
            -6421086240.737616,
            355839268.482224,
            4189639279.80561,
        ],
    ],
    [
        871257600000,
        [
            -6421904580.685549,
            353747516.2658187,
            4188978846.460952,
        ],
    ],
    [
        871862400000,
        [
            -6422722294.03946,
            351655786.6095144,
            4188317990.555609,
        ],
    ],
    [
        872467200000,
        [
            -6423539384.025389,
            349564079.7402315,
            4187656712.394698,
        ],
    ],
    [
        873072000000,
        [
            -6424355854.144327,
            347472395.3434833,
            4186995012.052426,
        ],
    ],
    [
        873676800000,
        [
            -6425171708.081578,
            345380732.3195838,
            4186332889.237401,
        ],
    ],
    [
        874281600000,
        [
            -6425986949.21797,
            343289088.462783,
            4185670343.07444,
        ],
    ],
    [
        874886400000,
        [
            -6426801579.45838,
            341197460.7673576,
            4185007372.149329,
        ],
    ],
    [
        875491200000,
        [
            -6427615598.954726,
            339105847.0983977,
            4184343975.374138,
        ],
    ],
    [
        876096000000,
        [
            -6428429008.165183,
            337014246.7831658,
            4183680152.517056,
        ],
    ],
    [
        876700800000,
        [
            -6429241808.812646,
            334922659.1170478,
            4183015903.502907,
        ],
    ],
    [
        877305600000,
        [
            -6430054003.03541,
            332831082.5924894,
            4182351227.91116,
        ],
    ],
    [
        877910400000,
        [
            -6430865592.71819,
            330739515.0653226,
            4181686124.992187,
        ],
    ],
    [
        878515200000,
        [
            -6431676579.287802,
            328647954.0333431,
            4181020593.790582,
        ],
    ],
    [
        879120000000,
        [
            -6432486963.696629,
            326556396.8222837,
            4180354633.237435,
        ],
    ],
    [
        879724800000,
        [
            -6433296746.468361,
            324464840.6938557,
            4179688242.206511,
        ],
    ],
    [
        880329600000,
        [
            -6434105927.772797,
            322373282.8842937,
            4179021419.535509,
        ],
    ],
    [
        880934400000,
        [
            -6434914507.494492,
            320281720.5389478,
            4178354163.990517,
        ],
    ],
    [
        881539200000,
        [
            -6435722485.134847,
            318190150.4940441,
            4177686474.131118,
        ],
    ],
    [
        882144000000,
        [
            -6436529859.134312,
            316098569.1475728,
            4177018348.162783,
        ],
    ],
    [
        882748800000,
        [
            -6437336625.876335,
            314006973.4446294,
            4176349784.351659,
        ],
    ],
    [
        883353600000,
        [
            -6438142780.703046,
            311915362.5537697,
            4175680782.01756,
        ],
    ],
    [
        883958400000,
        [
            -6438948320.136052,
            309823737.2973592,
            4175011341.452979,
        ],
    ],
    [
        884563200000,
        [
            -6439753241.953547,
            307732098.6820639,
            4174341463.140203,
        ],
    ],
    [
        885168000000,
        [
            -6440557544.416058,
            305640447.6017999,
            4173671147.507771,
        ],
    ],
    [
        885772800000,
        [
            -6441361225.969062,
            303548785.0327126,
            4173000395.000843,
        ],
    ],
    [
        886377600000,
        [
            -6442164285.265599,
            301457112.1700314,
            4172329206.155483,
        ],
    ],
    [
        886982400000,
        [
            -6442966721.281278,
            299365430.4523472,
            4171657581.624231,
        ],
    ],
    [
        887587200000,
        [
            -6443768533.444918,
            297273741.4998437,
            4170985522.159131,
        ],
    ],
    [
        888192000000,
        [
            -6444569721.757606,
            295182046.9628553,
            4170313028.547297,
        ],
    ],
    [
        888796800000,
        [
            -6445370286.829021,
            293090348.235613,
            4169640101.467315,
        ],
    ],
    [
        889401600000,
        [
            -6446170229.557968,
            290998646.0496042,
            4168966741.245538,
        ],
    ],
    [
        890006400000,
        [
            -6446969550.092689,
            288906940.5330395,
            4168292947.787437,
        ],
    ],
    [
        890611200000,
        [
            -6447768247.314322,
            286815232.663859,
            4167618721.308005,
        ],
    ],
    [
        891216000000,
        [
            -6448566320.741084,
            284723525.0965714,
            4166944062.978827,
        ],
    ],
    [
        891820800000,
        [
            -6449363771.825701,
            282631820.6857319,
            4166268974.281638,
        ],
    ],
    [
        892425600000,
        [
            -6450160603.205164,
            280540121.4362899,
            4165593456.377019,
        ],
    ],
    [
        893030400000,
        [
            -6450956817.933739,
            278448428.5110785,
            4164917510.03531,
        ],
    ],
    [
        893635200000,
        [
            -6451752419.19537,
            276356742.4292592,
            4164241135.718394,
        ],
    ],
    [
        894240000000,
        [
            -6452547410.220073,
            274265063.1848753,
            4163564333.638972,
        ],
    ],
    [
        894844800000,
        [
            -6453341794.259115,
            272173390.2927492,
            4162887103.786084,
        ],
    ],
    [
        895449600000,
        [
            -6454135574.580541,
            270081722.7759044,
            4162209445.920414,
        ],
    ],
    [
        896054400000,
        [
            -6454928754.456561,
            267990059.0674126,
            4161531359.521959,
        ],
    ],
    [
        896659200000,
        [
            -6455721337.011134,
            265898396.7739649,
            4160852843.648237,
        ],
    ],
    [
        897264000000,
        [
            -6456513324.539965,
            263806732.4679579,
            4160173896.751969,
        ],
    ],
    [
        897868800000,
        [
            -6457304717.34433,
            261715062.4591666,
            4159494516.97056,
        ],
    ],
    [
        898473600000,
        [
            -6458095514.264535,
            259623384.5654447,
            4158814703.124543,
        ],
    ],
    [
        899078400000,
        [
            -6458885714.885393,
            257531697.922387,
            4158134454.841068,
        ],
    ],
    [
        899683200000,
        [
            -6459675319.805113,
            255440001.4851005,
            4157453771.777113,
        ],
    ],
    [
        900288000000,
        [
            -6460464329.751988,
            253348293.6524762,
            4156772653.322148,
        ],
    ],
    [
        900892800000,
        [
            -6461252745.138401,
            251256572.5279021,
            4156091098.68564,
        ],
    ],
    [
        901497600000,
        [
            -6462040565.995488,
            249164836.1683569,
            4155409107.01756,
        ],
    ],
    [
        902102400000,
        [
            -6462827792.042287,
            247073082.7283533,
            4154726677.486623,
        ],
    ],
    [
        902707200000,
        [
            -6463614422.800894,
            244981310.5203423,
            4154043809.318924,
        ],
    ],
    [
        903312000000,
        [
            -6464400457.730017,
            242889517.9880028,
            4153360501.792435,
        ],
    ],
    [
        903916800000,
        [
            -6465185896.318144,
            240797703.5459319,
            4152676754.156749,
        ],
    ],
    [
        904521600000,
        [
            -6465970737.898476,
            238705865.2690338,
            4151992565.444698,
        ],
    ],
    [
        905126400000,
        [
            -6466754980.774183,
            236614000.8965779,
            4151307934.381752,
        ],
    ],
    [
        905731200000,
        [
            -6467538621.559341,
            234522109.1804385,
            4150622860.037143,
        ],
    ],
    [
        906336000000,
        [
            -6468321656.930112,
            232430191.0417841,
            4149937342.624062,
        ],
    ],
    [
        906940800000,
        [
            -6469104085.330567,
            230338248.2950022,
            4149251382.996996,
        ],
    ],
    [
        907545600000,
        [
            -6469885906.48056,
            228246282.4172594,
            4148564981.946692,
        ],
    ],
    [
        908150400000,
        [
            -6470667120.635984,
            226154294.4481345,
            4147878140.074067,
        ],
    ],
    [
        908755200000,
        [
            -6471447728.335722,
            224062285.1525537,
            4147190857.855933,
        ],
    ],
    [
        909360000000,
        [
            -6472227730.372514,
            221970255.1018482,
            4146503135.690629,
        ],
    ],
    [
        909964800000,
        [
            -6473007127.818646,
            219878204.6706297,
            4145814973.904439,
        ],
    ],
    [
        910569600000,
        [
            -6473785922.059855,
            217786133.970821,
            4145126372.725077,
        ],
    ],
    [
        911174400000,
        [
            -6474564114.813254,
            215694042.7046366,
            4144437332.209755,
        ],
    ],
    [
        911779200000,
        [
            -6475341708.022359,
            213601929.8842573,
            4143747852.088599,
        ],
    ],
    [
        912384000000,
        [
            -6476118703.275106,
            211509793.5239715,
            4143057931.54304,
        ],
    ],
    [
        912988800000,
        [
            -6476895100.612491,
            209417631.1544304,
            4142367569.35922,
        ],
    ],
    [
        913593600000,
        [
            -6477670898.677361,
            207325441.5515099,
            4141676764.868189,
        ],
    ],
    [
        914198400000,
        [
            -6478446096.8976,
            205233224.8637926,
            4140985518.240736,
        ],
    ],
    [
        914803200000,
        [
            -6479220696.039803,
            203140981.0463181,
            4140293829.707524,
        ],
    ],
    [
        915408000000,
        [
            -6479994697.295304,
            201048709.2861422,
            4139601699.155881,
        ],
    ],
    [
        916012800000,
        [
            -6480768101.707417,
            198956408.2049923,
            4138909126.176248,
        ],
    ],
    [
        916617600000,
        [
            -6481540910.013991,
            196864076.1031794,
            4138216110.172949,
        ],
    ],
    [
        917222400000,
        [
            -6482313122.641999,
            194771711.1085836,
            4137522650.439358,
        ],
    ],
    [
        917827200000,
        [
            -6483084739.751385,
            192679311.2519076,
            4136828746.198156,
        ],
    ],
    [
        918432000000,
        [
            -6483855761.300424,
            190586874.471141,
            4136134396.605515,
        ],
    ],
    [
        919036800000,
        [
            -6484626187.087738,
            188494398.5045423,
            4135439600.692886,
        ],
    ],
    [
        919641600000,
        [
            -6485396016.572062,
            186401880.6373446,
            4134744357.207326,
        ],
    ],
    [
        920246400000,
        [
            -6486165248.047258,
            184309317.6589265,
            4134048664.497227,
        ],
    ],
    [
        920851200000,
        [
            -6486933877.769953,
            182216707.0921796,
            4133352521.072754,
        ],
    ],
    [
        921456000000,
        [
            -6487701901.385551,
            180124048.6650631,
            4132655926.534266,
        ],
    ],
    [
        922060800000,
        [
            -6488469315.898163,
            178031343.3632133,
            4131958881.265543,
        ],
    ],
    [
        922665600000,
        [
            -6489236119.411806,
            175938592.1192594,
            4131261385.702531,
        ],
    ],
    [
        923270400000,
        [
            -6490002310.384114,
            173845795.6789959,
            4130563440.181137,
        ],
    ],
    [
        923875200000,
        [
            -6490767887.38787,
            171752954.8197492,
            4129865045.027025,
        ],
    ],
    [
        924480000000,
        [
            -6491532849.147955,
            169660070.4849547,
            4129166200.630606,
        ],
    ],
    [
        925084800000,
        [
            -6492297194.655888,
            167567143.8112417,
            4128466907.474157,
        ],
    ],
    [
        925689600000,
        [
            -6493060923.29983,
            165474176.0710734,
            4127767166.116973,
        ],
    ],
    [
        926294400000,
        [
            -6493824034.982096,
            163381168.5189123,
            4127066977.129177,
        ],
    ],
    [
        926899200000,
        [
            -6494586530.131926,
            161288122.0911643,
            4126366340.937909,
        ],
    ],
    [
        927504000000,
        [
            -6495348409.292006,
            159195037.0188507,
            4125665257.583812,
        ],
    ],
    [
        928108800000,
        [
            -6496109672.014243,
            157101913.0888814,
            4124963726.7532,
        ],
    ],
    [
        928713600000,
        [
            -6496870316.714083,
            155008751.240845,
            4124261748.623547,
        ],
    ],
    [
        929318400000,
        [
            -6497630342.798347,
            152915553.9756,
            4123559324.310317,
        ],
    ],
    [
        929923200000,
        [
            -6498389751.563076,
            150822323.740231,
            4122856455.105177,
        ],
    ],
    [
        930528000000,
        [
            -6499148545.323301,
            148729062.0956708,
            4122153141.948517,
        ],
    ],
    [
        931132800000,
        [
            -6499906726.739942,
            146635769.7962453,
            4121449385.408911,
        ],
    ],
    [
        931737600000,
        [
            -6500664298.58602,
            144542446.9724823,
            4120745185.762506,
        ],
    ],
    [
        932342400000,
        [
            -6501421263.678343,
            142449093.2281967,
            4120040543.042813,
        ],
    ],
    [
        932947200000,
        [
            -6502177624.85511,
            140355707.6695984,
            4119335457.05793,
        ],
    ],
    [
        933552000000,
        [
            -6502933384.968762,
            138262288.8752783,
            4118629927.376647,
        ],
    ],
    [
        934156800000,
        [
            -6503688546.858626,
            136168834.7728323,
            4117923953.26148,
        ],
    ],
    [
        934761600000,
        [
            -6504443113.137631,
            134075342.3767981,
            4117217533.507189,
        ],
    ],
    [
        935366400000,
        [
            -6505197085.377951,
            131981807.65125,
            4116510666.282434,
        ],
    ],
    [
        935971200000,
        [
            -6505950463.017046,
            129888226.5361525,
            4115803349.562969,
        ],
    ],
    [
        936576000000,
        [
            -6506703244.334449,
            127794596.6068644,
            4115095582.116726,
        ],
    ],
    [
        937180800000,
        [
            -6507455428.516917,
            125700916.462224,
            4114387363.387461,
        ],
    ],
    [
        937785600000,
        [
            -6508207015.555645,
            123607184.3335841,
            4113678692.736454,
        ],
    ],
    [
        938390400000,
        [
            -6508958005.371561,
            121513397.893578,
            4112969569.244112,
        ],
    ],
    [
        938995200000,
        [
            -6509708397.440516,
            119419554.5483923,
            4112259991.820946,
        ],
    ],
    [
        939600000000,
        [
            -6510458190.749238,
            117325651.6825072,
            4111549959.326835,
        ],
    ],
    [
        940204800000,
        [
            -6511207383.864282,
            115231686.8042316,
            4110839470.648616,
        ],
    ],
    [
        940809600000,
        [
            -6511955975.043661,
            113137657.6131317,
            4110128524.740178,
        ],
    ],
    [
        941414400000,
        [
            -6512703962.365976,
            111043561.9784082,
            4109417120.616896,
        ],
    ],
    [
        942019200000,
        [
            -6513451343.802734,
            108949397.7758253,
            4108705257.268978,
        ],
    ],
    [
        942624000000,
        [
            -6514198116.950337,
            106855162.5984879,
            4107992933.472797,
        ],
    ],
    [
        943228800000,
        [
            -6514944278.068304,
            104760853.9498197,
            4107280147.788805,
        ],
    ],
    [
        943833600000,
        [
            -6515689821.738801,
            102666470.8065113,
            4106566899.356865,
        ],
    ],
    [
        944438400000,
        [
            -6516434742.948036,
            100572014.4254701,
            4105853188.540337,
        ],
    ],
    [
        945043200000,
        [
            -6517179038.445896,
            98477486.8617843,
            4105139016.27413,
        ],
    ],
    [
        945648000000,
        [
            -6517922706.103338,
            96382889.96151786,
            4104424383.460264,
        ],
    ],
    [
        946252800000,
        [
            -6518665744.292456,
            94288225.36260977,
            4103709290.905755,
        ],
    ],
    [
        946857600000,
        [
            -6519408151.729098,
            92193494.64724483,
            4102993739.390701,
        ],
    ],
    [
        947462400000,
        [
            -6520149927.497346,
            90098699.39478439,
            4102277729.703251,
        ],
    ],
    [
        948067200000,
        [
            -6520891071.112783,
            88003841.14889568,
            4101561262.633608,
        ],
    ],
    [
        948672000000,
        [
            -6521631582.586093,
            85908921.31619155,
            4100844338.932059,
        ],
    ],
    [
        949276800000,
        [
            -6522371462.456899,
            83813940.97178626,
            4100126959.214498,
        ],
    ],
    [
        949881600000,
        [
            -6523110711.66053,
            81718900.52337877,
            4099409123.775055,
        ],
    ],
    [
        950486400000,
        [
            -6523849330.834335,
            79623799.4198862,
            4098690832.364204,
        ],
    ],
    [
        951091200000,
        [
            -6524587319.152772,
            77528636.87845528,
            4097972084.461537,
        ],
    ],
    [
        951696000000,
        [
            -6525324674.921259,
            75433413.5559553,
            4097252880.234912,
        ],
    ],
    [
        952300800000,
        [
            -6526061397.728095,
            73338131.19641083,
            4096533220.5793,
        ],
    ],
    [
        952905600000,
        [
            -6526797488.589261,
            71242791.0744105,
            4095813106.303573,
        ],
    ],
    [
        953510400000,
        [
            -6527532949.000025,
            69147393.59262416,
            4095092537.819537,
        ],
    ],
    [
        954115200000,
        [
            -6528267780.428073,
            67051938.49748001,
            4094371515.206102,
        ],
    ],
    [
        954720000000,
        [
            -6529001984.168362,
            64956425.08813776,
            4093650038.306482,
        ],
    ],
    [
        955324800000,
        [
            -6529735561.320423,
            62860852.33576052,
            4092928106.789286,
        ],
    ],
    [
        955929600000,
        [
            -6530468512.805865,
            60765218.93644329,
            4092205720.177452,
        ],
    ],
    [
        956534400000,
        [
            -6531200839.402226,
            58669523.29421424,
            4091482877.840654,
        ],
    ],
    [
        957139200000,
        [
            -6531932541.735706,
            56573763.38719436,
            4090759578.920208,
        ],
    ],
    [
        957744000000,
        [
            -6532663619.990932,
            54477936.50515309,
            4090035822.155181,
        ],
    ],
    [
        958348800000,
        [
            -6533394072.938177,
            52382039.34827804,
            4089311605.830026,
        ],
    ],
    [
        958953600000,
        [
            -6534123897.263066,
            50286069.49699892,
            4088586928.485432,
        ],
    ],
    [
        959558400000,
        [
            -6534853089.342392,
            48190026.59847748,
            4087861789.73121,
        ],
    ],
    [
        960163200000,
        [
            -6535581646.868092,
            46093911.14074779,
            4087136189.754745,
        ],
    ],
    [
        960768000000,
        [
            -6536309568.32465,
            43997723.3608874,
            4086410128.67858,
        ],
    ],
    [
        961372800000,
        [
            -6537036852.299324,
            41901463.26027364,
            4085683606.492448,
        ],
    ],
    [
        961977600000,
        [
            -6537763497.299986,
            39805130.85107514,
            4084956623.162193,
        ],
    ],
    [
        962582400000,
        [
            -6538489501.80931,
            37708726.30241731,
            4084229178.710604,
        ],
    ],
    [
        963187200000,
        [
            -6539214864.406675,
            35612249.98335414,
            4083501273.251348,
        ],
    ],
    [
        963792000000,
        [
            -6539939583.907238,
            33515702.42056045,
            4082772906.980516,
        ],
    ],
    [
        964396800000,
        [
            -6540663659.48691,
            31419084.15016912,
            4082044080.111598,
        ],
    ],
    [
        965001600000,
        [
            -6541387090.674895,
            29322395.41226362,
            4081314792.714125,
        ],
    ],
    [
        965606400000,
        [
            -6542109876.845978,
            27225635.80900959,
            4080585044.482337,
        ],
    ],
    [
        966211200000,
        [
            -6542832016.111219,
            25128804.80447996,
            4079854834.892196,
        ],
    ],
    [
        966816000000,
        [
            -6543553505.613843,
            23031903.38464915,
            4079124164.124731,
        ],
    ],
    [
        967420800000,
        [
            -6544274343.765062,
            20934934.01928393,
            4078393033.284096,
        ],
    ],
    [
        968025600000,
        [
            -6544994530.748759,
            18837899.01019128,
            4077661443.57437,
        ],
    ],
    [
        968630400000,
        [
            -6545714067.607743,
            16740799.86839719,
            4076929395.878785,
        ],
    ],
    [
        969235200000,
        [
            -6546432955.676483,
            14643637.44069418,
            4076196890.774784,
        ],
    ],
    [
        969840000000,
        [
            -6547151196.403258,
            12546412.07188099,
            4075463928.607887,
        ],
    ],
    [
        970444800000,
        [
            -6547868791.304176,
            10449123.67958848,
            4074730509.531682,
        ],
    ],
    [
        971049600000,
        [
            -6548585741.952291,
            8351771.765087835,
            4073996633.516237,
        ],
    ],
    [
        971654400000,
        [
            -6549302049.976722,
            6254355.362992423,
            4073262300.323791,
        ],
    ],
    [
        972259200000,
        [
            -6550017717.026518,
            4156872.88885391,
            4072527509.425049,
        ],
    ],
    [
        972864000000,
        [
            -6550732744.494318,
            2059321.854123077,
            4071792259.818496,
        ],
    ],
    [
        973468800000,
        [
            -6551447132.580153,
            -38301.17070883096,
            4071056549.91263,
        ],
    ],
    [
        974073600000,
        [
            -6552160879.362504,
            -2135999.284252257,
            4070320378.106838,
        ],
    ],
    [
        974678400000,
        [
            -6552873982.20448,
            -4233773.818366114,
            4069583743.700898,
        ],
    ],
    [
        975283200000,
        [
            -6553586439.576107,
            -6331625.319089083,
            4068846646.555631,
        ],
    ],
    [
        975888000000,
        [
            -6554298250.653502,
            -8429554.77914112,
            4068109086.387627,
        ],
    ],
    [
        976492800000,
        [
            -6555009414.499574,
            -10527563.68531273,
            4067371062.652748,
        ],
    ],
    [
        977097600000,
        [
            -6555719929.764527,
            -12625653.72189781,
            4066632574.666541,
        ],
    ],
    [
        977702400000,
        [
            -6556429794.668077,
            -14723826.54728145,
            4065893621.714241,
        ],
    ],
    [
        978307200000,
        [
            -6557139007.07511,
            -16822083.66517414,
            4065154203.119543,
        ],
    ],
    [
        978912000000,
        [
            -6557847564.608652,
            -18920426.37171349,
            4064414318.276617,
        ],
    ],
    [
        979516800000,
        [
            -6558555464.774545,
            -21018855.79650085,
            4063673966.633297,
        ],
    ],
    [
        980121600000,
        [
            -6559262705.002776,
            -23117373.0931221,
            4062933147.586251,
        ],
    ],
    [
        980726400000,
        [
            -6559969282.27502,
            -25215979.71585618,
            4062191860.287931,
        ],
    ],
    [
        981331200000,
        [
            -6560675192.097244,
            -27314677.0250259,
            4061450103.745302,
        ],
    ],
    [
        981936000000,
        [
            -6561380428.534419,
            -29413464.59728189,
            4060707877.721824,
        ],
    ],
    [
        982540800000,
        [
            -6562084986.487397,
            -31512339.84526145,
            4059965183.174128,
        ],
    ],
    [
        983145600000,
        [
            -6562788862.646857,
            -33611299.61835698,
            4059222021.494989,
        ],
    ],
    [
        983750400000,
        [
            -6563492054.743342,
            -35710340.99204108,
            4058478394.014819,
        ],
    ],
    [
        984355200000,
        [
            -6564194561.024417,
            -37809461.19927996,
            4057734301.986752,
        ],
    ],
    [
        984960000000,
        [
            -6564896380.154234,
            -39908657.49570039,
            4056989746.652568,
        ],
    ],
    [
        985564800000,
        [
            -6565597511.258738,
            -42007927.13109711,
            4056244729.268351,
        ],
    ],
    [
        986169600000,
        [
            -6566297953.997601,
            -44107267.40430906,
            4055499251.089521,
        ],
    ],
    [
        986774400000,
        [
            -6566997708.630987,
            -46206675.78943238,
            4054753313.318049,
        ],
    ],
    [
        987379200000,
        [
            -6567696776.042911,
            -48306150.16466979,
            4054006916.990788,
        ],
    ],
    [
        987984000000,
        [
            -6568395157.54848,
            -50405689.1831137,
            4053260062.769694,
        ],
    ],
    [
        988588800000,
        [
            -6569092854.067649,
            -52505292.49844948,
            4052512750.743627,
        ],
    ],
    [
        989193600000,
        [
            -6569789865.047701,
            -54604959.79367124,
            4051764980.842989,
        ],
    ],
    [
        989798400000,
        [
            -6570486189.498042,
            -56704689.2518384,
            4051016753.770766,
        ],
    ],
    [
        990403200000,
        [
            -6571181827.977905,
            -58804478.33239363,
            4050268070.799957,
        ],
    ],
    [
        991008000000,
        [
            -6571876782.378066,
            -60904325.21908952,
            4049518932.982487,
        ],
    ],
    [
        991612800000,
        [
            -6572571054.986221,
            -63004229.05514506,
            4048769340.93056,
        ],
    ],
    [
        992217600000,
        [
            -6573264648.047245,
            -65104189.71169585,
            4048019294.897527,
        ],
    ],
    [
        992822400000,
        [
            -6573957563.634395,
            -67204207.59760174,
            4047268794.867797,
        ],
    ],
    [
        993427200000,
        [
            -6574649803.620507,
            -69304283.55432719,
            4046517840.610564,
        ],
    ],
    [
        994032000000,
        [
            -6575341369.683455,
            -71404418.81347361,
            4045766431.702545,
        ],
    ],
    [
        994636800000,
        [
            -6576032263.323112,
            -73504615.02760623,
            4045014567.511719,
        ],
    ],
    [
        995241600000,
        [
            -6576722485.814896,
            -75604874.42612544,
            4044262247.106704,
        ],
    ],
    [
        995846400000,
        [
            -6577412037.811273,
            -77705200.07221296,
            4043509469.07471,
        ],
    ],
    [
        996451200000,
        [
            -6578100918.258358,
            -79805595.58449402,
            4042756231.55356,
        ],
    ],
    [
        997056000000,
        [
            -6578789124.023983,
            -81906063.47567353,
            4042002533.075523,
        ],
    ],
    [
        997660800000,
        [
            -6579476651.943673,
            -84006604.33539617,
            4041248373.210389,
        ],
    ],
    [
        998265600000,
        [
            -6580163500.044966,
            -86107218.24235372,
            4040493751.932138,
        ],
    ],
    [
        998870400000,
        [
            -6580849666.841287,
            -88207905.621325,
            4039738669.08172,
        ],
    ],
    [
        999475200000,
        [
            -6581535150.717128,
            -90308667.11340971,
            4038983124.36648,
        ],
    ],
    [
        1000080000000,
        [
            -6582219949.796025,
            -92409503.31317015,
            4038227117.481071,
        ],
    ],
    [
        1000684800000,
        [
            -6582904062.009326,
            -94510414.61357473,
            4037470648.192209,
        ],
    ],
    [
        1001289600000,
        [
            -6583587485.225045,
            -96611401.14832482,
            4036713716.378512,
        ],
    ],
    [
        1001894400000,
        [
            -6584270217.395831,
            -98712462.81974559,
            4035956322.027683,
        ],
    ],
    [
        1002499200000,
        [
            -6584952256.689622,
            -100813599.4414488,
            4035198465.171864,
        ],
    ],
    [
        1003104000000,
        [
            -6585633601.453739,
            -102914811.0448764,
            4034440145.719509,
        ],
    ],
    [
        1003708800000,
        [
            -6586314249.607325,
            -105016098.1470037,
            4033681363.250072,
        ],
    ],
    [
        1004313600000,
        [
            -6586994197.594703,
            -107117460.9857647,
            4032922117.315825,
        ],
    ],
    [
        1004918400000,
        [
            -6587673441.162189,
            -109218897.8932692,
            4032162408.394444,
        ],
    ],
    [
        1005523200000,
        [
            -6588351977.57803,
            -111320405.7730152,
            4031402237.868254,
        ],
    ],
    [
        1006128000000,
        [
            -6589029805.78095,
            -113421981.6966716,
            4030641607.191207,
        ],
    ],
    [
        1006732800000,
        [
            -6589706925.490961,
            -115523623.3374666,
            4029880517.569991,
        ],
    ],
    [
        1007337600000,
        [
            -6590383336.75914,
            -117625328.8200532,
            4029118970.002379,
        ],
    ],
    [
        1007942400000,
        [
            -6591059039.853902,
            -119727096.5872334,
            4028356965.341239,
        ],
    ],
    [
        1008547200000,
        [
            -6591734035.250272,
            -121828925.3558671,
            4027594504.321143,
        ],
    ],
    [
        1009152000000,
        [
            -6592408323.644169,
            -123930814.1366544,
            4026831587.552845,
        ],
    ],
    [
        1009756800000,
        [
            -6593081905.96926,
            -126032762.321127,
            4026068215.48142,
        ],
    ],
    [
        1010361600000,
        [
            -6593754783.356948,
            -128134769.8825213,
            4025304388.276892,
        ],
    ],
    [
        1010966400000,
        [
            -6594426956.78997,
            -130236837.6955741,
            4024540105.628767,
        ],
    ],
    [
        1011571200000,
        [
            -6595098426.059318,
            -132338967.4579364,
            4023775366.68032,
        ],
    ],
    [
        1012176000000,
        [
            -6595769189.085365,
            -134441160.2229379,
            4023010170.741654,
        ],
    ],
    [
        1012780800000,
        [
            -6596439243.684933,
            -136543415.3083522,
            4022244518.05483,
        ],
    ],
    [
        1013385600000,
        [
            -6597108589.051142,
            -138645731.5853718,
            4021478409.257095,
        ],
    ],
    [
        1013990400000,
        [
            -6597777225.111341,
            -140748108.5357165,
            4020711844.74724,
        ],
    ],
    [
        1014595200000,
        [
            -6598445151.76735,
            -142850546.2055628,
            4019944824.628407,
        ],
    ],
    [
        1015200000000,
        [
            -6599112368.640443,
            -144953044.9318709,
            4019177348.824245,
        ],
    ],
    [
        1015804800000,
        [
            -6599778875.049953,
            -147055605.1542347,
            4018409417.173091,
        ],
    ],
    [
        1016409600000,
        [
            -6600444670.066617,
            -149158227.3125197,
            4017641029.483659,
        ],
    ],
    [
        1017014400000,
        [
            -6601109752.59672,
            -151260911.8149603,
            4016872185.555949,
        ],
    ],
    [
        1017619200000,
        [
            -6601774121.469358,
            -153363659.1016758,
            4016102885.151344,
        ],
    ],
    [
        1018224000000,
        [
            -6602437775.406844,
            -155466469.8589933,
            4015333127.870042,
        ],
    ],
    [
        1018828800000,
        [
            -6603100712.505174,
            -157569345.254977,
            4014562912.966558,
        ],
    ],
    [
        1019433600000,
        [
            -6603762929.161984,
            -159672286.299561,
            4013792239.576023,
        ],
    ],
    [
        1020038400000,
        [
            -6604424420.515138,
            -161775292.0984899,
            4013021107.688737,
        ],
    ],
    [
        1020643200000,
        [
            -6605085182.762454,
            -163878359.903776,
            4012249518.361176,
        ],
    ],
    [
        1021248000000,
        [
            -6605745213.69147,
            -165981486.7093559,
            4011477472.91715,
        ],
    ],
    [
        1021852800000,
        [
            -6606404511.872402,
            -168084669.8057935,
            4010704972.567748,
        ],
    ],
    [
        1022457600000,
        [
            -6607063076.225141,
            -170187906.6398243,
            4009932018.442854,
        ],
    ],
    [
        1023062400000,
        [
            -6607720905.965813,
            -172291194.6726369,
            4009158611.664169,
        ],
    ],
    [
        1023667200000,
        [
            -6608378000.673327,
            -174394531.3481652,
            4008384753.3733,
        ],
    ],
    [
        1024272000000,
        [
            -6609034360.377637,
            -176497914.1447909,
            4007610444.718771,
        ],
    ],
    [
        1024876800000,
        [
            -6609689985.641202,
            -178601340.7051689,
            4006835686.80157,
        ],
    ],
    [
        1025481600000,
        [
            -6610344877.583228,
            -180704809.0822595,
            4006060480.553388,
        ],
    ],
    [
        1026086400000,
        [
            -6610999037.632114,
            -182808318.1240165,
            4005284826.512967,
        ],
    ],
    [
        1026691200000,
        [
            -6611652466.588588,
            -184911867.5876997,
            4004508724.675448,
        ],
    ],
    [
        1027296000000,
        [
            -6612305163.737599,
            -187015456.925059,
            4003732175.056501,
        ],
    ],
    [
        1027900800000,
        [
            -6612957128.309645,
            -189119083.9971645,
            4002955178.537172,
        ],
    ],
    [
        1028505600000,
        [
            -6613608361.2098,
            -191222746.2076389,
            4002177736.443948,
        ],
    ],
    [
        1029110400000,
        [
            -6614258864.515373,
            -193326441.7850924,
            4001399849.816823,
        ],
    ],
    [
        1029715200000,
        [
            -6614908640.601424,
            -195430169.881963,
            4000621519.269976,
        ],
    ],
    [
        1030320000000,
        [
            -6615557691.772908,
            -197533930.3421739,
            3999842745.080808,
        ],
    ],
    [
        1030924800000,
        [
            -6616206020.158373,
            -199637723.5330217,
            3999063527.270638,
        ],
    ],
    [
        1031529600000,
        [
            -6616853627.683983,
            -201741550.2567827,
            3998283865.64999,
        ],
    ],
    [
        1032134400000,
        [
            -6617500516.076006,
            -203845411.7223585,
            3997503759.83358,
        ],
    ],
    [
        1032739200000,
        [
            -6618146686.868039,
            -205949309.5948177,
            3996723209.21304,
        ],
    ],
    [
        1033344000000,
        [
            -6618792141.316219,
            -208053246.1771862,
            3995942212.848321,
        ],
    ],
    [
        1033948800000,
        [
            -6619436879.886887,
            -210157224.6490554,
            3995160769.283309,
        ],
    ],
    [
        1034553600000,
        [
            -6620080901.107619,
            -212261248.5765629,
            3994378876.683604,
        ],
    ],
    [
        1035158400000,
        [
            -6620724201.573458,
            -214365320.1340338,
            3993596533.781309,
        ],
    ],
    [
        1035763200000,
        [
            -6621366778.154424,
            -216469439.7136235,
            3992813740.305862,
        ],
    ],
    [
        1036368000000,
        [
            -6622008628.800157,
            -218573607.4262222,
            3992030496.258423,
        ],
    ],
    [
        1036972800000,
        [
            -6622649751.72842,
            -220677823.7268611,
            3991246801.485823,
        ],
    ],
    [
        1037577600000,
        [
            -6623290144.898959,
            -222782089.2037056,
            3990462655.730621,
        ],
    ],
    [
        1038182400000,
        [
            -6623929805.930925,
            -224886404.3114641,
            3989678058.756858,
        ],
    ],
    [
        1038787200000,
        [
            -6624568732.190368,
            -226990769.2153184,
            3988893010.434725,
        ],
    ],
    [
        1039392000000,
        [
            -6625206920.932059,
            -229095183.7277005,
            3988107510.781913,
        ],
    ],
    [
        1039996800000,
        [
            -6625844369.461764,
            -231199647.3329921,
            3987321559.961081,
        ],
    ],
    [
        1040601600000,
        [
            -6626481075.274301,
            -233304159.3377941,
            3986535158.208983,
        ],
    ],
    [
        1041206400000,
        [
            -6627117035.981527,
            -235408719.1873213,
            3985748305.656578,
        ],
    ],
    [
        1041811200000,
        [
            -6627752248.604174,
            -237513326.6419094,
            3984961002.159532,
        ],
    ],
    [
        1042416000000,
        [
            -6628386708.664816,
            -239617980.7549828,
            3984173247.75005,
        ],
    ],
    [
        1043020800000,
        [
            -6629020411.442826,
            -241722678.4031994,
            3983385043.553835,
        ],
    ],
    [
        1043625600000,
        [
            -6629653354.048706,
            -243827415.1796454,
            3982596391.531332,
        ],
    ],
    [
        1044230400000,
        [
            -6630285535.260381,
            -245932186.8791458,
            3981807293.671968,
        ],
    ],
    [
        1044835200000,
        [
            -6630916954.692201,
            -248036989.7860779,
            3981017751.759952,
        ],
    ],
    [
        1045440000000,
        [
            -6631547612.443509,
            -250141820.5333925,
            3980227767.419635,
        ],
    ],
    [
        1046044800000,
        [
            -6632177509.027741,
            -252246676.0151179,
            3979437342.161869,
        ],
    ],
    [
        1046649600000,
        [
            -6632806645.376792,
            -254351553.3861995,
            3978646477.391651,
        ],
    ],
    [
        1047254400000,
        [
            -6633435022.858582,
            -256456450.1243424,
            3977855174.383878,
        ],
    ],
    [
        1047859200000,
        [
            -6634062643.286366,
            -258561364.163102,
            3977063434.219788,
        ],
    ],
    [
        1048464000000,
        [
            -6634689508.842683,
            -260666294.1464754,
            3976271257.64905,
        ],
    ],
    [
        1049068800000,
        [
            -6635315621.622008,
            -262771239.7709467,
            3975478644.864832,
        ],
    ],
    [
        1049673600000,
        [
            -6635940982.479089,
            -264876201.5491423,
            3974685595.514961,
        ],
    ],
    [
        1050278400000,
        [
            -6636565590.657049,
            -266981179.1898237,
            3973892109.532085,
        ],
    ],
    [
        1050883200000,
        [
            -6637189445.796029,
            -269086170.9153811,
            3973098187.708948,
        ],
    ],
    [
        1051488000000,
        [
            -6637812548.993448,
            -271191174.9438844,
            3972303831.018055,
        ],
    ],
    [
        1052092800000,
        [
            -6638434901.97795,
            -273296190.3340962,
            3971509040.074978,
        ],
    ],
    [
        1052697600000,
        [
            -6639056506.40981,
            -275401216.8543716,
            3970713815.135185,
        ],
    ],
    [
        1053302400000,
        [
            -6639677363.65448,
            -277506254.7174055,
            3969918156.210613,
        ],
    ],
    [
        1053907200000,
        [
            -6640297474.751089,
            -279611304.4055444,
            3969122063.157159,
        ],
    ],
    [
        1054512000000,
        [
            -6640916840.444104,
            -281716366.5740961,
            3968325535.726213,
        ],
    ],
    [
        1055116800000,
        [
            -6641535461.243127,
            -283821442.0225509,
            3967528573.582072,
        ],
    ],
    [
        1055721600000,
        [
            -6642153337.477724,
            -285926531.7661015,
            3966731176.264669,
        ],
    ],
    [
        1056326400000,
        [
            -6642770469.195998,
            -288031637.2582657,
            3965933343.054929,
        ],
    ],
    [
        1056931200000,
        [
            -6643386855.500004,
            -290136760.5481357,
            3965135072.816433,
        ],
    ],
    [
        1057536000000,
        [
            -6644002493.504885,
            -292241903.3668204,
            3964336364.37006,
        ],
    ],
    [
        1058140800000,
        [
            -6644617379.217465,
            -294347065.421298,
            3963537217.491354,
        ],
    ],
    [
        1058745600000,
        [
            -6645231509.774124,
            -296452244.8593454,
            3962737632.889718,
        ],
    ],
    [
        1059350400000,
        [
            -6645844883.584867,
            -298557439.7680111,
            3961937611.419233,
        ],
    ],
    [
        1059955200000,
        [
            -6646457499.529168,
            -300662648.5111876,
            3961137153.812363,
        ],
    ],
    [
        1060560000000,
        [
            -6647069356.615505,
            -302767869.5332522,
            3960336260.74823,
        ],
    ],
    [
        1061164800000,
        [
            -6647680453.974665,
            -304873101.208981,
            3959534932.932194,
        ],
    ],
    [
        1061769600000,
        [
            -6648290790.952283,
            -306978341.8043017,
            3958733171.127955,
        ],
    ],
    [
        1062374400000,
        [
            -6648900367.220112,
            -309083589.5212511,
            3957930976.147969,
        ],
    ],
    [
        1062979200000,
        [
            -6649509182.878843,
            -311188842.6291623,
            3957128348.798149,
        ],
    ],
    [
        1063584000000,
        [
            -6650117238.486156,
            -313294099.7262126,
            3956325289.746143,
        ],
    ],
    [
        1064188800000,
        [
            -6650724534.749206,
            -315399360.1262593,
            3955521799.28857,
        ],
    ],
    [
        1064793600000,
        [
            -6651331071.500491,
            -317504623.8223732,
            3954717877.27041,
        ],
    ],
    [
        1065398400000,
        [
            -6651936847.095059,
            -319609890.0586342,
            3953913523.791537,
        ],
    ],
    [
        1066003200000,
        [
            -6652541860.238766,
            -321715156.3830094,
            3953108739.908091,
        ],
    ],
    [
        1066608000000,
        [
            -6653146111.384938,
            -323820420.049875,
            3952303527.033447,
        ],
    ],
    [
        1067212800000,
        [
            -6653749602.031103,
            -325925679.1029047,
            3951497886.291348,
        ],
    ],
    [
        1067817600000,
        [
            -6654352333.936658,
            -328030932.3695767,
            3950691818.441282,
        ],
    ],
    [
        1068422400000,
        [
            -6654954308.830291,
            -330136179.239937,
            3949885323.968817,
        ],
    ],
    [
        1069027200000,
        [
            -6655555528.334427,
            -332241419.5241486,
            3949078403.155223,
        ],
    ],
    [
        1069632000000,
        [
            -6656155993.954299,
            -334346653.38547,
            3948271056.112365,
        ],
    ],
    [
        1070236800000,
        [
            -6656755707.090671,
            -336451881.3334804,
            3947463282.786728,
        ],
    ],
    [
        1070841600000,
        [
            -6657354669.048803,
            -338557104.3029936,
            3946655082.916189,
        ],
    ],
    [
        1071446400000,
        [
            -6657952880.919557,
            -340662323.8725036,
            3945846455.89798,
        ],
    ],
    [
        1072051200000,
        [
            -6658550342.953995,
            -342767542.4767203,
            3945037400.606336,
        ],
    ],
    [
        1072656000000,
        [
            -6659147053.412508,
            -344872762.6923305,
            3944227915.64986,
        ],
    ],
    [
        1073260800000,
        [
            -6659743009.007653,
            -346977985.4526538,
            3943418000.365573,
        ],
    ],
    [
        1073865600000,
        [
            -6660338207.147075,
            -349083210.1235095,
            3942607655.004822,
        ],
    ],
    [
        1074470400000,
        [
            -6660932646.32673,
            -351188436.0180699,
            3941796879.958266,
        ],
    ],
    [
        1075075200000,
        [
            -6661526325.273464,
            -353293662.8275158,
            3940985675.430002,
        ],
    ],
    [
        1075680000000,
        [
            -6662119242.500014,
            -355398890.3766684,
            3940174041.51496,
        ],
    ],
    [
        1076284800000,
        [
            -6662711396.252263,
            -357504118.3815144,
            3939361978.316085,
        ],
    ],
    [
        1076889600000,
        [
            -6663302784.595799,
            -359609346.3147351,
            3938549486.018653,
        ],
    ],
    [
        1077494400000,
        [
            -6663893405.54814,
            -361714573.3576679,
            3937736564.923794,
        ],
    ],
    [
        1078099200000,
        [
            -6664483257.227929,
            -363819798.440235,
            3936923215.43771,
        ],
    ],
    [
        1078704000000,
        [
            -6665072337.965754,
            -365925020.4133853,
            3936109437.987281,
        ],
    ],
    [
        1079308800000,
        [
            -6665660646.14991,
            -368030238.3767706,
            3935295232.826668,
        ],
    ],
    [
        1079913600000,
        [
            -6666248179.388312,
            -370135451.7311689,
            3934480599.921577,
        ],
    ],
    [
        1080518400000,
        [
            -6666834933.790828,
            -372240658.9079737,
            3933665539.554341,
        ],
    ],
    [
        1081123200000,
        [
            -6667420905.629524,
            -374345856.1519712,
            3932850053.148785,
        ],
    ],
    [
        1081728000000,
        [
            -6668006093.130002,
            -376451038.7461163,
            3932034142.80583,
        ],
    ],
    [
        1082332800000,
        [
            -6668590496.03475,
            -378556202.3136951,
            3931217810.568107,
        ],
    ],
    [
        1082937600000,
        [
            -6669174114.838499,
            -380661342.9680243,
            3930401058.267347,
        ],
    ],
    [
        1083542400000,
        [
            -6669756950.510996,
            -382766457.1676545,
            3929583887.580451,
        ],
    ],
    [
        1084147200000,
        [
            -6670339004.452912,
            -384871541.6485062,
            3928766300.069197,
        ],
    ],
    [
        1084752000000,
        [
            -6670920278.508537,
            -386976593.4403083,
            3927948297.180961,
        ],
    ],
    [
        1085356800000,
        [
            -6671500774.985868,
            -389081609.9447842,
            3927129880.217106,
        ],
    ],
    [
        1085961600000,
        [
            -6672080496.66081,
            -391186589.0917605,
            3926311050.257674,
        ],
    ],
    [
        1086566400000,
        [
            -6672659446.665383,
            -393291529.6252337,
            3925491808.003977,
        ],
    ],
    [
        1087171200000,
        [
            -6673237627.917265,
            -395396431.4303831,
            3924672153.55091,
        ],
    ],
    [
        1087776000000,
        [
            -6673815041.91328,
            -397501295.0875403,
            3923852086.505286,
        ],
    ],
    [
        1088380800000,
        [
            -6674391688.747968,
            -399606120.1601024,
            3923031606.90642,
        ],
    ],
    [
        1088985600000,
        [
            -6674967569.259473,
            -401710904.9558415,
            3922210715.579191,
        ],
    ],
    [
        1089590400000,
        [
            -6675542685.666257,
            -403815648.0909027,
            3921389413.366535,
        ],
    ],
    [
        1090195200000,
        [
            -6676117040.643178,
            -405920349.1177358,
            3920567700.698993,
        ],
    ],
    [
        1090800000000,
        [
            -6676690636.703126,
            -408025008.3317611,
            3919745577.633544,
        ],
    ],
    [
        1091404800000,
        [
            -6677263476.006873,
            -410129626.5181992,
            3918923043.967745,
        ],
    ],
    [
        1092009600000,
        [
            -6677835560.333529,
            -412234204.7911861,
            3918100099.320189,
        ],
    ],
    [
        1092614400000,
        [
            -6678406891.103621,
            -414338744.5051993,
            3917276743.176826,
        ],
    ],
    [
        1093219200000,
        [
            -6678977469.426187,
            -416443247.2343603,
            3916452974.902623,
        ],
    ],
    [
        1093824000000,
        [
            -6679547296.128134,
            -418547714.8588081,
            3915628793.693368,
        ],
    ],
    [
        1094428800000,
        [
            -6680116371.577653,
            -420652149.7973642,
            3914804198.427291,
        ],
    ],
    [
        1095033600000,
        [
            -6680684694.879333,
            -422756555.0611401,
            3913979187.546648,
        ],
    ],
    [
        1095638400000,
        [
            -6681252262.947247,
            -424860933.0685392,
            3913153759.587936,
        ],
    ],
    [
        1096243200000,
        [
            -6681819071.817498,
            -426965284.0928626,
            3912327914.140484,
        ],
    ],
    [
        1096848000000,
        [
            -6682385118.682311,
            -429069607.0998524,
            3911501651.603395,
        ],
    ],
    [
        1097452800000,
        [
            -6682950401.703485,
            -431173901.0822792,
            3910674972.447109,
        ],
    ],
    [
        1098057600000,
        [
            -6683514919.252342,
            -433278165.2099613,
            3909847877.048965,
        ],
    ],
    [
        1098662400000,
        [
            -6684078669.656705,
            -435382398.593174,
            3909020365.788811,
        ],
    ],
    [
        1099267200000,
        [
            -6684641651.237939,
            -437486600.124472,
            3908192439.133975,
        ],
    ],
    [
        1099872000000,
        [
            -6685203862.432589,
            -439590768.4299374,
            3907364097.675862,
        ],
    ],
    [
        1100476800000,
        [
            -6685765301.932861,
            -441694901.9062805,
            3906535342.124056,
        ],
    ],
    [
        1101081600000,
        [
            -6686325968.818233,
            -443798998.8541306,
            3905706173.24947,
        ],
    ],
    [
        1101686400000,
        [
            -6686885862.591404,
            -445903057.756762,
            3904876591.741183,
        ],
    ],
    [
        1102291200000,
        [
            -6687444982.809056,
            -448007077.6585857,
            3904046597.969058,
        ],
    ],
    [
        1102896000000,
        [
            -6688003328.011366,
            -450111057.9460047,
            3903216191.993761,
        ],
    ],
    [
        1103500800000,
        [
            -6688560895.497799,
            -452214996.770413,
            3902385374.390477,
        ],
    ],
    [
        1104105600000,
        [
            -6689117683.433045,
            -454318890.521748,
            3901554146.753421,
        ],
    ],
    [
        1104710400000,
        [
            -6689673691.872834,
            -456422735.4143274,
            3900722510.960121,
        ],
    ],
    [
        1105315200000,
        [
            -6690228921.941774,
            -458526528.3738478,
            3899890468.617191,
        ],
    ],
    [
        1105920000000,
        [
            -6690783375.15955,
            -460630266.9759263,
            3899058021.027798,
        ],
    ],
    [
        1106524800000,
        [
            -6691337053.217003,
            -462733949.2638024,
            3898225169.269838,
        ],
    ],
    [
        1107129600000,
        [
            -6691889957.925791,
            -464837573.6533685,
            3897391914.244846,
        ],
    ],
    [
        1107734400000,
        [
            -6692442091.215441,
            -466941138.9096589,
            3896558256.693002,
        ],
    ],
    [
        1108339200000,
        [
            -6692993455.145077,
            -469044644.1842561,
            3895724197.176378,
        ],
    ],
    [
        1108944000000,
        [
            -6693544051.896238,
            -471148089.1457434,
            3894889736.009797,
        ],
    ],
    [
        1109548800000,
        [
            -6694093883.590099,
            -473251474.2507305,
            3894054873.097631,
        ],
    ],
    [
        1110153600000,
        [
            -6694642951.519109,
            -475354800.9185025,
            3893219607.760606,
        ],
    ],
    [
        1110758400000,
        [
            -6695191255.036312,
            -477458070.5871741,
            3892383939.123819,
        ],
    ],
    [
        1111363200000,
        [
            -6695738792.426547,
            -479561283.0331829,
            3891547867.103041,
        ],
    ],
    [
        1111968000000,
        [
            -6696285563.023344,
            -481664436.8980218,
            3890711392.340421,
        ],
    ],
    [
        1112572800000,
        [
            -6696831567.197527,
            -483767531.131098,
            3889874515.429465,
        ],
    ],
    [
        1113177600000,
        [
            -6697376805.475908,
            -485870565.2429059,
            3889037236.684657,
        ],
    ],
    [
        1113782400000,
        [
            -6697921278.146251,
            -487973539.0363153,
            3888199556.239777,
        ],
    ],
    [
        1114387200000,
        [
            -6698464985.203665,
            -490076452.3768234,
            3887361474.160417,
        ],
    ],
    [
        1114992000000,
        [
            -6699007926.413285,
            -492179305.0627562,
            3886522990.514948,
        ],
    ],
    [
        1115596800000,
        [
            -6699550101.414781,
            -494282096.7738057,
            3885684105.407984,
        ],
    ],
    [
        1116201600000,
        [
            -6700091509.843342,
            -496384827.1068483,
            3884844818.969174,
        ],
    ],
    [
        1116806400000,
        [
            -6700632151.39742,
            -498487495.7500403,
            3884005131.26313,
        ],
    ],
    [
        1117411200000,
        [
            -6701172025.581784,
            -500590102.7893563,
            3883165042.095718,
        ],
    ],
    [
        1118016000000,
        [
            -6701711130.753164,
            -502692648.5768564,
            3882324550.983192,
        ],
    ],
    [
        1118620800000,
        [
            -6702249463.678023,
            -504795132.2255383,
            3881483657.909304,
        ],
    ],
    [
        1119225600000,
        [
            -6702787021.526028,
            -506897550.713629,
            3880642364.01086,
        ],
    ],
    [
        1119830400000,
        [
            -6703323803.308763,
            -508999900.3299563,
            3879800670.956657,
        ],
    ],
    [
        1120435200000,
        [
            -6703859809.253859,
            -511102177.744583,
            3878958580.313931,
        ],
    ],
    [
        1121040000000,
        [
            -6704395040.138318,
            -513204380.035004,
            3878116093.469791,
        ],
    ],
    [
        1121644800000,
        [
            -6704929497.091852,
            -515306504.5332531,
            3877273211.698146,
        ],
    ],
    [
        1122249600000,
        [
            -6705463181.591794,
            -517408548.7673051,
            3876429936.196989,
        ],
    ],
    [
        1122854400000,
        [
            -6705996095.500213,
            -519510510.4863744,
            3875586268.085739,
        ],
    ],
    [
        1123459200000,
        [
            -6706528241.103021,
            -521612387.7515152,
            3874742208.368137,
        ],
    ],
    [
        1124064000000,
        [
            -6707059621.122993,
            -523714179.1143504,
            3873897757.845229,
        ],
    ],
    [
        1124668800000,
        [
            -6707590238.577905,
            -525815883.9336759,
            3873052916.938237,
        ],
    ],
    [
        1125273600000,
        [
            -6708120096.099704,
            -527917502.666332,
            3872207685.468644,
        ],
    ],
    [
        1125878400000,
        [
            -6708649194.740889,
            -530019036.1869962,
            3871362062.902964,
        ],
    ],
    [
        1126483200000,
        [
            -6709177534.438471,
            -532120484.0811443,
            3870516049.316906,
        ],
    ],
    [
        1127088000000,
        [
            -6709705116.173432,
            -534221844.864247,
            3869669645.505315,
        ],
    ],
    [
        1127692800000,
        [
            -6710231942.204885,
            -536323117.5346528,
            3868822852.178866,
        ],
    ],
    [
        1128297600000,
        [
            -6710758015.115999,
            -538424302.0021018,
            3867975669.636956,
        ],
    ],
    [
        1128902400000,
        [
            -6711283337.28321,
            -540525398.8567625,
            3867128097.835536,
        ],
    ],
    [
        1129507200000,
        [
            -6711807910.723229,
            -542626409.1334293,
            3866280136.495514,
        ],
    ],
    [
        1130112000000,
        [
            -6712331737.071993,
            -544727334.1663414,
            3865431785.175265,
        ],
    ],
    [
        1130716800000,
        [
            -6712854817.608419,
            -546828175.5117671,
            3864583043.310446,
        ],
    ],
    [
        1131321600000,
        [
            -6713377153.298413,
            -548928934.9405128,
            3863733910.217515,
        ],
    ],
    [
        1131926400000,
        [
            -6713898744.805261,
            -551029614.5460451,
            3862884385.031027,
        ],
    ],
    [
        1132531200000,
        [
            -6714419592.235929,
            -553130216.9872395,
            3862034466.54078,
        ],
    ],
    [
        1133136000000,
        [
            -6714939694.214161,
            -555230745.4117839,
            3861184153.129037,
        ],
    ],
    [
        1133740800000,
        [
            -6715459047.162597,
            -557331202.0278708,
            3860333443.450973,
        ],
    ],
    [
        1134345600000,
        [
            -6715977647.011089,
            -559431586.8212658,
            3859482337.288785,
        ],
    ],
    [
        1134950400000,
        [
            -6716495490.932887,
            -561531898.7054172,
            3858630835.109073,
        ],
    ],
    [
        1135555200000,
        [
            -6717012576.900831,
            -563632136.6605172,
            3857778937.400369,
        ],
    ],
    [
        1136160000000,
        [
            -6717528903.001591,
            -565732299.7440827,
            3856926644.589061,
        ],
    ],
    [
        1136764800000,
        [
            -6718044467.261561,
            -567832386.843947,
            3856073957.146955,
        ],
    ],
    [
        1137369600000,
        [
            -6718559267.719696,
            -569932396.5309016,
            3855220875.672527,
        ],
    ],
    [
        1137974400000,
        [
            -6719073302.570836,
            -572032327.01851,
            3854367400.92378,
        ],
    ],
    [
        1138579200000,
        [
            -6719586570.32587,
            -574132176.2108265,
            3853513533.807646,
        ],
    ],
    [
        1139184000000,
        [
            -6720099069.95798,
            -576231941.8564285,
            3852659275.312979,
        ],
    ],
    [
        1139788800000,
        [
            -6720610800.92335,
            -578331621.860037,
            3851804626.348168,
        ],
    ],
    [
        1140393600000,
        [
            -6721121762.699335,
            -580431214.6482487,
            3850949587.501522,
        ],
    ],
    [
        1140998400000,
        [
            -6721631953.690242,
            -582530718.7457696,
            3850094159.159284,
        ],
    ],
    [
        1141603200000,
        [
            -6722141371.423243,
            -584630131.1373707,
            3849238342.407297,
        ],
    ],
    [
        1142208000000,
        [
            -6722650014.783842,
            -586729447.2075436,
            3848382139.302266,
        ],
    ],
    [
        1142812800000,
        [
            -6723157884.631477,
            -588828662.4099786,
            3847525552.051567,
        ],
    ],
    [
        1143417600000,
        [
            -6723664982.900341,
            -590927772.9613272,
            3846668582.557358,
        ],
    ],
    [
        1144022400000,
        [
            -6724171312.011671,
            -593026775.7440536,
            3845811232.415324,
        ],
    ],
    [
        1144627200000,
        [
            -6724676874.686089,
            -595125668.1584699,
            3844953502.981638,
        ],
    ],
    [
        1145232000000,
        [
            -6725181673.893301,
            -597224448.06209,
            3844095395.406876,
        ],
    ],
    [
        1145836800000,
        [
            -6725685712.836962,
            -599323113.773706,
            3843236910.638169,
        ],
    ],
    [
        1146441600000,
        [
            -6726188994.948549,
            -601421664.1374714,
            3842378049.389302,
        ],
    ],
    [
        1147046400000,
        [
            -6726691523.84792,
            -603520098.6861616,
            3841518812.053343,
        ],
    ],
    [
        1147651200000,
        [
            -6727193303.076221,
            -605618417.9385866,
            3840659198.518922,
        ],
    ],
    [
        1148256000000,
        [
            -6727694335.180014,
            -607716623.4821303,
            3839799208.032932,
        ],
    ],
    [
        1148860800000,
        [
            -6728194620.72008,
            -609814716.7774665,
            3838938839.736905,
        ],
    ],
    [
        1149465600000,
        [
            -6728694159.558685,
            -611912697.6700599,
            3838078093.595209,
        ],
    ],
    [
        1150070400000,
        [
            -6729192952.737878,
            -614010565.2969842,
            3837216970.103998,
        ],
    ],
    [
        1150675200000,
        [
            -6729691002.130774,
            -616108319.3756381,
            3836355469.564255,
        ],
    ],
    [
        1151280000000,
        [
            -6730188309.586619,
            -618205960.2941964,
            3835493591.941498,
        ],
    ],
    [
        1151884800000,
        [
            -6730684876.592726,
            -620303488.8222396,
            3834631336.981176,
        ],
    ],
    [
        1152489600000,
        [
            -6731180704.229338,
            -622400905.8868273,
            3833768704.318777,
        ],
    ],
    [
        1153094400000,
        [
            -6731675793.221813,
            -624498212.4420096,
            3832905693.54959,
        ],
    ],
    [
        1153699200000,
        [
            -6732170144.031081,
            -626595409.412118,
            3832042304.26268,
        ],
    ],
    [
        1154304000000,
        [
            -6732663756.957459,
            -628692497.7249724,
            3831178536.02811,
        ],
    ],
    [
        1154908800000,
        [
            -6733156632.168998,
            -630789478.4900025,
            3830314388.299071,
        ],
    ],
    [
        1155513600000,
        [
            -6733648769.336241,
            -632886353.2719074,
            3829449860.222593,
        ],
    ],
    [
        1156118400000,
        [
            -6734140166.598199,
            -634983123.7403402,
            3828584950.714915,
        ],
    ],
    [
        1156723200000,
        [
            -6734630820.477668,
            -637079789.9925256,
            3827719659.34514,
        ],
    ],
    [
        1157328000000,
        [
            -6735120728.104597,
            -639176350.0459205,
            3826853986.834393,
        ],
    ],
    [
        1157932800000,
        [
            -6735609888.261614,
            -641272801.4025736,
            3825987934.327532,
        ],
    ],
    [
        1158537600000,
        [
            -6736098300.64411,
            -643369141.8765222,
            3825121502.874764,
        ],
    ],
    [
        1159142400000,
        [
            -6736585965.304007,
            -645465369.5220156,
            3824254693.414003,
        ],
    ],
    [
        1159747200000,
        [
            -6737072882.529788,
            -647561482.475177,
            3823387506.845951,
        ],
    ],
    [
        1160352000000,
        [
            -6737559052.883392,
            -649657478.9004383,
            3822519944.070546,
        ],
    ],
    [
        1160956800000,
        [
            -6738044477.269172,
            -651753357.0208594,
            3821652005.98272,
        ],
    ],
    [
        1161561600000,
        [
            -6738529157.001465,
            -653849115.2191125,
            3820783693.43075,
        ],
    ],
    [
        1162166400000,
        [
            -6739013093.834894,
            -655944752.238936,
            3819915007.117267,
        ],
    ],
    [
        1162771200000,
        [
            -6739496289.794189,
            -658040267.5295428,
            3819045947.402972,
        ],
    ],
    [
        1163376000000,
        [
            -6739978746.390329,
            -660135661.4740198,
            3818176514.108282,
        ],
    ],
    [
        1163980800000,
        [
            -6740460463.523855,
            -662230934.464283,
            3817306706.89805,
        ],
    ],
    [
        1164585600000,
        [
            -6740941440.421585,
            -664326085.3103553,
            3816436526.231914,
        ],
    ],
    [
        1165190400000,
        [
            -6741421677.692455,
            -666421111.9002683,
            3815565973.227552,
        ],
    ],
    [
        1165795200000,
        [
            -6741901177.212814,
            -668516012.670418,
            3814695048.864982,
        ],
    ],
    [
        1166400000000,
        [
            -6742379941.202665,
            -670610786.8710339,
            3813823753.749561,
        ],
    ],
    [
        1167004800000,
        [
            -6742857971.788704,
            -672705434.3298779,
            3812952088.192545,
        ],
    ],
    [
        1167609600000,
        [
            -6743335270.891974,
            -674799955.2521597,
            3812080052.305024,
        ],
    ],
    [
        1168214400000,
        [
            -6743811840.221311,
            -676894350.1093559,
            3811207646.054467,
        ],
    ],
    [
        1168819200000,
        [
            -6744287681.302451,
            -678988619.5940636,
            3810334869.288907,
        ],
    ],
    [
        1169424000000,
        [
            -6744762795.5196,
            -681082764.6496669,
            3809461721.721735,
        ],
    ],
    [
        1170028800000,
        [
            -6745237184.098948,
            -683176786.6253617,
            3808588202.842879,
        ],
    ],
    [
        1170633600000,
        [
            -6745710847.757308,
            -685270687.5428551,
            3807714311.735053,
        ],
    ],
    [
        1171238400000,
        [
            -6746183785.660772,
            -687364469.8763024,
            3806840047.078044,
        ],
    ],
    [
        1171843200000,
        [
            -6746655994.984242,
            -689458134.9446026,
            3805965407.956215,
        ],
    ],
    [
        1172448000000,
        [
            -6747127472.911873,
            -691551682.0056764,
            3805090394.543961,
        ],
    ],
    [
        1173052800000,
        [
            -6747598217.978508,
            -693645109.6436595,
            3804215007.49801,
        ],
    ],
    [
        1173657600000,
        [
            -6748068229.412575,
            -695738416.7002907,
            3803339247.386165,
        ],
    ],
    [
        1174262400000,
        [
            -6748537506.508613,
            -697831602.1855375,
            3802463114.664784,
        ],
    ],
    [
        1174867200000,
        [
            -6749006048.488923,
            -699924665.0324284,
            3801586609.790887,
        ],
    ],
    [
        1175472000000,
        [
            -6749473854.57304,
            -702017603.9584801,
            3800709733.299768,
        ],
    ],
    [
        1176076800000,
        [
            -6749940924.107542,
            -704110417.4259833,
            3799832485.837211,
        ],
    ],
    [
        1176681600000,
        [
            -6750407256.713176,
            -706203103.6876513,
            3798954868.149243,
        ],
    ],
    [
        1177286400000,
        [
            -6750872852.41449,
            -708295660.944666,
            3798076881.011506,
        ],
    ],
    [
        1177891200000,
        [
            -6751337711.61118,
            -710388087.6673737,
            3797198525.056875,
        ],
    ],
    [
        1178496000000,
        [
            -6751801834.4943,
            -712480382.8987972,
            3796319800.556195,
        ],
    ],
    [
        1179100800000,
        [
            -6752265219.97329,
            -714572545.5732458,
            3795440707.675803,
        ],
    ],
    [
        1179705600000,
        [
            -6752727866.32377,
            -716664572.885185,
            3794561247.422001,
        ],
    ],
    [
        1180310400000,
        [
            -6753189773.41734,
            -718756460.6710702,
            3793681421.675245,
        ],
    ],
    [
        1180915200000,
        [
            -6753650942.948409,
            -720848205.0417649,
            3792801232.349238,
        ],
    ],
    [
        1181520000000,
        [
            -6754111377.523619,
            -722939802.8750929,
            3791920681.041286,
        ],
    ],
    [
        1182124800000,
        [
            -6754571080.169929,
            -725031251.6823258,
            3791039769.060464,
        ],
    ],
    [
        1182729600000,
        [
            -6755030054.190955,
            -727122549.4785471,
            3790158497.489539,
        ],
    ],
    [
        1183334400000,
        [
            -6755488303.131514,
            -729213694.7405409,
            3789276867.210791,
        ],
    ],
    [
        1183939200000,
        [
            -6755945830.76806,
            -731304686.4268076,
            3788394878.900584,
        ],
    ],
    [
        1184544000000,
        [
            -6756402641.102388,
            -733395524.0611826,
            3787512532.989377,
        ],
    ],
    [
        1185148800000,
        [
            -6756858738.303427,
            -735486207.9251845,
            3786629829.557262,
        ],
    ],
    [
        1185753600000,
        [
            -6757314126.35968,
            -737576739.3716528,
            3785746768.13361,
        ],
    ],
    [
        1186358400000,
        [
            -6757768808.040963,
            -739667120.7785739,
            3784863347.61618,
        ],
    ],
    [
        1186963200000,
        [
            -6758222784.126989,
            -741757354.1248164,
            3783979566.952912,
        ],
    ],
    [
        1187568000000,
        [
            -6758676055.070073,
            -743847439.7973615,
            3783095425.951318,
        ],
    ],
    [
        1188172800000,
        [
            -6759128622.549496,
            -745937377.8031504,
            3782210924.791069,
        ],
    ],
    [
        1188777600000,
        [
            -6759580488.865118,
            -748027168.8635924,
            3781326063.374117,
        ],
    ],
    [
        1189382400000,
        [
            -6760031656.143348,
            -750116814.3774323,
            3780440841.258827,
        ],
    ],
    [
        1189987200000,
        [
            -6760482126.055653,
            -752206316.1264254,
            3779555257.783646,
        ],
    ],
    [
        1190592000000,
        [
            -6760931899.78426,
            -754295676.0623413,
            3778669312.172077,
        ],
    ],
    [
        1191196800000,
        [
            -6761380978.069088,
            -756384896.180323,
            3777783003.599141,
        ],
    ],
    [
        1191801600000,
        [
            -6761829361.289337,
            -758473978.4624355,
            3776896331.223287,
        ],
    ],
    [
        1192406400000,
        [
            -6762277049.553137,
            -760562924.9148154,
            3776009294.168669,
        ],
    ],
    [
        1193011200000,
        [
            -6762724042.682369,
            -762651737.7544672,
            3775121891.416352,
        ],
    ],
    [
        1193616000000,
        [
            -6763170339.73014,
            -764740419.6352394,
            3774234121.626132,
        ],
    ],
    [
        1194220800000,
        [
            -6763615937.916309,
            -766828973.050241,
            3773345983.338221,
        ],
    ],
    [
        1194825600000,
        [
            -6764060832.964537,
            -768917398.5682364,
            3772457475.943693,
        ],
    ],
    [
        1195430400000,
        [
            -6764505021.432744,
            -771005694.7518594,
            3771568599.964131,
        ],
    ],
    [
        1196035200000,
        [
            -6764948501.361389,
            -773093859.7427297,
            3770679356.267551,
        ],
    ],
    [
        1196640000000,
        [
            -6765391271.490906,
            -775181891.8550619,
            3769789745.666958,
        ],
    ],
    [
        1197244800000,
        [
            -6765833330.82452,
            -777269789.4343494,
            3768899768.948756,
        ],
    ],
    [
        1197849600000,
        [
            -6766274678.5847,
            -779357550.7026638,
            3768009426.950677,
        ],
    ],
    [
        1198454400000,
        [
            -6766715314.29775,
            -781445173.716378,
            3767118720.594437,
        ],
    ],
    [
        1199059200000,
        [
            -6767155237.902736,
            -783532656.4105471,
            3766227650.875997,
        ],
    ],
    [
        1199664000000,
        [
            -6767594449.854916,
            -785619996.7230066,
            3765336218.813869,
        ],
    ],
    [
        1200268800000,
        [
            -6768032951.176053,
            -787707192.8346633,
            3764444425.330774,
        ],
    ],
    [
        1200873600000,
        [
            -6768470743.2476,
            -789794243.5535021,
            3763552271.032522,
        ],
    ],
    [
        1201478400000,
        [
            -6768907826.9257,
            -791881148.4661318,
            3762659756.041127,
        ],
    ],
    [
        1202083200000,
        [
            -6769344201.619651,
            -793967906.791329,
            3761766880.517582,
        ],
    ],
    [
        1202688000000,
        [
            -6769779866.670881,
            -796054516.0338397,
            3760873645.529724,
        ],
    ],
    [
        1203292800000,
        [
            -6770214823.176208,
            -798140973.0473473,
            3759980052.678915,
        ],
    ],
    [
        1203897600000,
        [
            -6770649073.567714,
            -800227275.3782449,
            3759086103.343562,
        ],
    ],
    [
        1204502400000,
        [
            -6771082620.734502,
            -802313421.4126091,
            3758191798.513783,
        ],
    ],
    [
        1205107200000,
        [
            -6771515467.648739,
            -804399410.1603973,
            3757297138.871405,
        ],
    ],
    [
        1205712000000,
        [
            -6771947617.262914,
            -806485241.0998294,
            3756402124.865112,
        ],
    ],
    [
        1206316800000,
        [
            -6772379072.489508,
            -808570914.1033506,
            3755506756.749703,
        ],
    ],
    [
        1206921600000,
        [
            -6772809836.208047,
            -810656429.4243808,
            3754611034.594832,
        ],
    ],
    [
        1207526400000,
        [
            -6773239911.276323,
            -812741787.7605903,
            3753714958.252409,
        ],
    ],
    [
        1208131200000,
        [
            -6773669300.455225,
            -814826990.4474581,
            3752818527.244553,
        ],
    ],
    [
        1208736000000,
        [
            -6774098005.923488,
            -816912039.7212716,
            3751921740.571054,
        ],
    ],
    [
        1209340800000,
        [
            -6774526028.135816,
            -818996938.3034575,
            3751024596.81045,
        ],
    ],
    [
        1209945600000,
        [
            -6774953365.719659,
            -821081687.6605469,
            3750127095.035443,
        ],
    ],
    [
        1210550400000,
        [
            -6775380017.644617,
            -823166287.5172592,
            3749229235.293935,
        ],
    ],
    [
        1211155200000,
        [
            -6775805984.123851,
            -825250737.3588098,
            3748331017.895413,
        ],
    ],
    [
        1211760000000,
        [
            -6776231265.810478,
            -827335037.1276277,
            3747432442.950505,
        ],
    ],
    [
        1212364800000,
        [
            -6776655863.234662,
            -829419187.0420744,
            3746533510.404319,
        ],
    ],
    [
        1212969600000,
        [
            -6777079776.694002,
            -831503187.3401564,
            3745634220.156929,
        ],
    ],
    [
        1213574400000,
        [
            -6777503006.320404,
            -833587038.1317977,
            3744734572.14453,
        ],
    ],
    [
        1214179200000,
        [
            -6777925552.20183,
            -835670739.3432709,
            3743834566.377672,
        ],
    ],
    [
        1214784000000,
        [
            -6778347414.523709,
            -837754290.7470428,
            3742934202.936829,
        ],
    ],
    [
        1215388800000,
        [
            -6778768593.688059,
            -839837692.1125762,
            3742033481.902188,
        ],
    ],
    [
        1215993600000,
        [
            -6779189090.23446,
            -841920943.521595,
            3741132403.17637,
        ],
    ],
    [
        1216598400000,
        [
            -6779608904.140349,
            -844004045.5703202,
            3740230966.304605,
        ],
    ],
    [
        1217203200000,
        [
            -6780028033.853799,
            -846086998.410586,
            3739329170.888866,
        ],
    ],
    [
        1217808000000,
        [
            -6780446477.412404,
            -848169800.2259365,
            3738427017.521504,
        ],
    ],
    [
        1218412800000,
        [
            -6780864234.550141,
            -850252448.0192169,
            3737524507.58778,
        ],
    ],
    [
        1219017600000,
        [
            -6781281306.59223,
            -852334939.1258452,
            3736621642.452383,
        ],
    ],
    [
        1219622400000,
        [
            -6781697695.591248,
            -854417271.5281163,
            3735718423.208372,
        ],
    ],
    [
        1220227200000,
        [
            -6782113403.937378,
            -856499443.701345,
            3734814850.725718,
        ],
    ],
    [
        1220832000000,
        [
            -6782528434.264211,
            -858581454.5040351,
            3733910925.706981,
        ],
    ],
    [
        1221436800000,
        [
            -6782942789.43757,
            -860663303.1546303,
            3733006648.705045,
        ],
    ],
    [
        1222041600000,
        [
            -6783356472.561734,
            -862744989.2693152,
            3732102020.109475,
        ],
    ],
    [
        1222646400000,
        [
            -6783769486.981776,
            -864826512.9686677,
            3731197040.094896,
        ],
    ],
    [
        1223251200000,
        [
            -6784181836.210083,
            -866907875.1027844,
            3730291708.497254,
        ],
    ],
    [
        1223856000000,
        [
            -6784593523.493339,
            -868989077.5724149,
            3729386024.600413,
        ],
    ],
    [
        1224460800000,
        [
            -6785004550.682289,
            -871070123.1189708,
            3728479987.132995,
        ],
    ],
    [
        1225065600000,
        [
            -6785414917.773516,
            -873151013.7193971,
            3727573595.078931,
        ],
    ],
    [
        1225670400000,
        [
            -6785824624.868883,
            -875231749.7755921,
            3726666848.313066,
        ],
    ],
    [
        1226275200000,
        [
            -6786233673.3504,
            -877312331.5391841,
            3725759746.960118,
        ],
    ],
    [
        1226880000000,
        [
            -6786642065.100762,
            -879392759.993824,
            3724852290.839655,
        ],
    ],
    [
        1227484800000,
        [
            -6787049801.796689,
            -881473036.7264205,
            3723944479.457575,
        ],
    ],
    [
        1228089600000,
        [
            -6787456884.687359,
            -883553163.6436248,
            3723036312.129563,
        ],
    ],
    [
        1228694400000,
        [
            -6787863314.579263,
            -885633142.7796052,
            3722127788.076267,
        ],
    ],
    [
        1229299200000,
        [
            -6788269091.888749,
            -887712976.1854593,
            3721218906.481116,
        ],
    ],
    [
        1229904000000,
        [
            -6788674216.724979,
            -889792665.8889519,
            3720309666.513103,
        ],
    ],
    [
        1230508800000,
        [
            -6789078688.971486,
            -891872213.9552412,
            3719400067.295058,
        ],
    ],
    [
        1231113600000,
        [
            -6789482508.223283,
            -893951622.7012146,
            3718490107.774684,
        ],
    ],
    [
        1231718400000,
        [
            -6789885673.179633,
            -896030894.8712407,
            3717579786.559839,
        ],
    ],
    [
        1232323200000,
        [
            -6790288180.608548,
            -898110032.7925899,
            3716669102.254796,
        ],
    ],
    [
        1232928000000,
        [
            -6790690026.132827,
            -900189036.6491724,
            3715758054.457005,
        ],
    ],
    [
        1233532800000,
        [
            -6791091206.521365,
            -902267904.8464065,
            3714846643.79389,
        ],
    ],
    [
        1234137600000,
        [
            -6791491719.946858,
            -904346635.5467634,
            3713934871.124689,
        ],
    ],
    [
        1234742400000,
        [
            -6791891565.19537,
            -906425227.0671698,
            3713022737.243093,
        ],
    ],
    [
        1235347200000,
        [
            -6792290741.320686,
            -908503677.7042136,
            3712110242.933352,
        ],
    ],
    [
        1235952000000,
        [
            -6792689247.642926,
            -910581985.5969799,
            3711197389.043758,
        ],
    ],
    [
        1236556800000,
        [
            -6793087083.849727,
            -912660148.7025443,
            3710284176.512387,
        ],
    ],
    [
        1237161600000,
        [
            -6793484250.114985,
            -914738164.8570449,
            3709370606.350632,
        ],
    ],
    [
        1237766400000,
        [
            -6793880747.207668,
            -916816031.9222314,
            3708456679.581563,
        ],
    ],
    [
        1238371200000,
        [
            -6794276576.528558,
            -918893748.0599443,
            3707542397.103706,
        ],
    ],
    [
        1238976000000,
        [
            -6794671739.826182,
            -920971312.1373678,
            3706627759.452623,
        ],
    ],
    [
        1239580800000,
        [
            -6795066238.197301,
            -923048723.7511314,
            3705712766.692462,
        ],
    ],
    [
        1240185600000,
        [
            -6795460071.405247,
            -925125981.8680573,
            3704797419.079645,
        ],
    ],
    [
        1240790400000,
        [
            -6795853239.622567,
            -927203083.8027908,
            3703881717.797828,
        ],
    ],
    [
        1241395200000,
        [
            -6796245744.915641,
            -929280026.5795368,
            3702965664.392179,
        ],
    ],
    [
        1242000000000,
        [
            -6796637590.580168,
            -931356808.0860945,
            3702049260.091106,
        ],
    ],
    [
        1242604800000,
        [
            -6797028780.326303,
            -933433427.1095053,
            3701132505.708966,
        ],
    ],
    [
        1243209600000,
        [
            -6797419317.958008,
            -935509883.1277295,
            3700215401.729374,
        ],
    ],
    [
        1243814400000,
        [
            -6797809207.27828,
            -937586176.1760936,
            3699297948.370938,
        ],
    ],
    [
        1244419200000,
        [
            -6798198452.06083,
            -939662306.7890234,
            3698380145.618552,
        ],
    ],
    [
        1245024000000,
        [
            -6798587056.044799,
            -941738276.0004274,
            3697461993.224641,
        ],
    ],
    [
        1245628800000,
        [
            -6798975022.92645,
            -943814085.426062,
            3696543490.665179,
        ],
    ],
    [
        1246233600000,
        [
            -6799362356.231372,
            -945889737.4820472,
            3695624637.0095,
        ],
    ],
    [
        1246838400000,
        [
            -6799749058.699074,
            -947965235.6137292,
            3694705430.732973,
        ],
    ],
    [
        1247443200000,
        [
            -6800135131.105927,
            -950040583.6461129,
            3693785869.939663,
        ],
    ],
    [
        1248048000000,
        [
            -6800520572.57166,
            -952115783.9937512,
            3692865953.347126,
        ],
    ],
    [
        1248652800000,
        [
            -6800905382.783858,
            -954190837.6183866,
            3691945680.535599,
        ],
    ],
    [
        1249257600000,
        [
            -6801289562.471422,
            -956265745.5469797,
            3691025051.181356,
        ],
    ],
    [
        1249862400000,
        [
            -6801673112.531153,
            -958340509.3455377,
            3690104064.70757,
        ],
    ],
    [
        1250467200000,
        [
            -6802056033.540559,
            -960415130.8738794,
            3689182720.358881,
        ],
    ],
    [
        1251072000000,
        [
            -6802438325.677373,
            -962489612.0267067,
            3688261017.325189,
        ],
    ],
    [
        1251676800000,
        [
            -6802819988.787183,
            -964563954.5810747,
            3687338954.823965,
        ],
    ],
    [
        1252281600000,
        [
            -6803201022.500611,
            -966638160.1294981,
            3686416532.1422,
        ],
    ],
    [
        1252886400000,
        [
            -6803581426.370651,
            -968712230.0987736,
            3685493748.635186,
        ],
    ],
    [
        1253491200000,
        [
            -6803961199.978243,
            -970786165.8977115,
            3684570603.653926,
        ],
    ],
    [
        1254096000000,
        [
            -6804340342.790577,
            -972859969.2223638,
            3683647096.363815,
        ],
    ],
    [
        1254700800000,
        [
            -6804718853.348525,
            -974933642.1223081,
            3682723225.622606,
        ],
    ],
    [
        1255305600000,
        [
            -6805096728.489079,
            -977007185.7693369,
            3681798990.556487,
        ],
    ],
    [
        1255910400000,
        [
            -6805473964.90782,
            -979080599.1445125,
            3680874391.423748,
        ],
    ],
    [
        1256515200000,
        [
            -6805850561.034127,
            -981153880.1647664,
            3679949429.209042,
        ],
    ],
    [
        1257120000000,
        [
            -6806226516.66322,
            -983227027.0147737,
            3679024104.876552,
        ],
    ],
    [
        1257724800000,
        [
            -6806601832.181078,
            -985300038.3091444,
            3678098419.206726,
        ],
    ],
    [
        1258329600000,
        [
            -6806976508.280383,
            -987372912.9291185,
            3677172372.858468,
        ],
    ],
    [
        1258934400000,
        [
            -6807350545.92371,
            -989445649.9327893,
            3676245966.418081,
        ],
    ],
    [
        1259539200000,
        [
            -6807723946.369951,
            -991518248.5522554,
            3675319200.408427,
        ],
    ],
    [
        1260144000000,
        [
            -6808096711.211383,
            -993590708.254505,
            3674392075.264993,
        ],
    ],
    [
        1260748800000,
        [
            -6808468842.39847,
            -995663028.88058,
            3673464591.26847,
        ],
    ],
    [
        1261353600000,
        [
            -6808840342.158389,
            -997735210.9150484,
            3672536748.396133,
        ],
    ],
    [
        1261958400000,
        [
            -6809211212.475924,
            -999807255.812639,
            3671608546.096633,
        ],
    ],
    [
        1262563200000,
        [
            -6809581453.918268,
            -1001879165.605208,
            3670679983.380405,
        ],
    ],
    [
        1263168000000,
        [
            -6809951065.570664,
            -1003950941.204137,
            3669751059.721337,
        ],
    ],
    [
        1263772800000,
        [
            -6810320047.181391,
            -1006022582.04768,
            3668821775.468262,
        ],
    ],
    [
        1264377600000,
        [
            -6810688399.927718,
            -1008094087.65802,
            3667892131.092555,
        ],
    ],
    [
        1264982400000,
        [
            -6811056125.530796,
            -1010165458.330531,
            3666962126.727355,
        ],
    ],
    [
        1265587200000,
        [
            -6811423225.634978,
            -1012236694.963072,
            3666031762.192842,
        ],
    ],
    [
        1266192000000,
        [
            -6811789701.625922,
            -1014307798.810391,
            3665101037.10636,
        ],
    ],
    [
        1266796800000,
        [
            -6812155554.615501,
            -1016378771.332442,
            3664169950.959018,
        ],
    ],
    [
        1267401600000,
        [
            -6812520785.479611,
            -1018449614.117722,
            3663238503.157112,
        ],
    ],
    [
        1268006400000,
        [
            -6812885394.91872,
            -1020520328.875338,
            3662306693.028663,
        ],
    ],
    [
        1268611200000,
        [
            -6813249383.501904,
            -1022590917.532916,
            3661374519.771242,
        ],
    ],
    [
        1269216000000,
        [
            -6813612751.516143,
            -1024661382.482946,
            3660441982.299965,
        ],
    ],
    [
        1269820800000,
        [
            -6813975498.200418,
            -1026731726.681703,
            3659509079.110216,
        ],
    ],
    [
        1270425600000,
        [
            -6814337620.783313,
            -1028801952.548243,
            3658575808.760946,
        ],
    ],
    [
        1271030400000,
        [
            -6814699115.687428,
            -1030872060.37757,
            3657642170.842289,
        ],
    ],
    [
        1271635200000,
        [
            -6815059980.624268,
            -1032942049.103525,
            3656708165.780747,
        ],
    ],
    [
        1272240000000,
        [
            -6815420214.482761,
            -1035011917.694367,
            3655773794.078295,
        ],
    ],
    [
        1272844800000,
        [
            -6815779816.550454,
            -1037081665.360842,
            3654839056.117527,
        ],
    ],
    [
        1273449600000,
        [
            -6816138786.23355,
            -1039151291.34107,
            3653903952.245717,
        ],
    ],
    [
        1274054400000,
        [
            -6816497123.07704,
            -1041220794.756336,
            3652968482.853458,
        ],
    ],
    [
        1274659200000,
        [
            -6816854826.871834,
            -1043290174.576337,
            3652032648.405268,
        ],
    ],
    [
        1275264000000,
        [
            -6817211897.779647,
            -1045359429.669358,
            3651096449.428151,
        ],
    ],
    [
        1275868800000,
        [
            -6817568336.448128,
            -1047428558.945572,
            3650159886.450846,
        ],
    ],
    [
        1276473600000,
        [
            -6817924144.035051,
            -1049497561.641482,
            3649222959.859493,
        ],
    ],
    [
        1277078400000,
        [
            -6818279321.844406,
            -1051566437.711553,
            3648285669.656883,
        ],
    ],
    [
        1277683200000,
        [
            -6818633870.251326,
            -1053635187.66782,
            3647348015.443634,
        ],
    ],
    [
        1278288000000,
        [
            -6818987788.359924,
            -1055703811.041951,
            3646409997.211668,
        ],
    ],
    [
        1278892800000,
        [
            -6819341076.033686,
            -1057772305.752592,
            3645471615.900258,
        ],
    ],
    [
        1279497600000,
        [
            -6819693735.001803,
            -1059840669.658968,
            3644532872.688254,
        ],
    ],
    [
        1280102400000,
        [
            -6820045768.042703,
            -1061908901.501125,
            3643593768.414152,
        ],
    ],
    [
        1280707200000,
        [
            -6820397178.263374,
            -1063977000.851081,
            3642654303.533776,
        ],
    ],
    [
        1281312000000,
        [
            -6820747968.839798,
            -1066044967.918868,
            3641714478.202449,
        ],
    ],
    [
        1281916800000,
        [
            -6821098142.941499,
            -1068112803.442063,
            3640774292.330647,
        ],
    ],
    [
        1282521600000,
        [
            -6821447703.707948,
            -1070180508.645564,
            3639833745.606449,
        ],
    ],
    [
        1283126400000,
        [
            -6821796654.242571,
            -1072248085.259798,
            3638892837.487462,
        ],
    ],
    [
        1283731200000,
        [
            -6822144997.592896,
            -1074315535.627911,
            3637951567.142609,
        ],
    ],
    [
        1284336000000,
        [
            -6822492736.569356,
            -1076382862.951738,
            3637009933.301904,
        ],
    ],
    [
        1284940800000,
        [
            -6822839872.99954,
            -1078450071.465163,
            3636067934.085305,
        ],
    ],
    [
        1285545600000,
        [
            -6823186406.587705,
            -1080517165.534284,
            3635125567.362788,
        ],
    ],
    [
        1286150400000,
        [
            -6823532335.666121,
            -1082584147.923024,
            3634182831.755272,
        ],
    ],
    [
        1286755200000,
        [
            -6823877659.347917,
            -1084651020.190283,
            3633239726.64117,
        ],
    ],
    [
        1287360000000,
        [
            -6824222377.608202,
            -1086717784.139038,
            3632296251.385225,
        ],
    ],
    [
        1287964800000,
        [
            -6824566490.401215,
            -1088784442.09223,
            3631352405.09324,
        ],
    ],
    [
        1288569600000,
        [
            -6824909997.252266,
            -1090850996.608049,
            3630408186.714734,
        ],
    ],
    [
        1289174400000,
        [
            -6825252897.206875,
            -1092917450.225889,
            3629463595.1657,
        ],
    ],
    [
        1289779200000,
        [
            -6825595188.904596,
            -1094983805.314519,
            3628518629.409331,
        ],
    ],
    [
        1290384000000,
        [
            -6825936870.698499,
            -1097050064.000975,
            3627573288.498288,
        ],
    ],
    [
        1290988800000,
        [
            -6826277940.794379,
            -1099116228.187587,
            3626627571.572149,
        ],
    ],
    [
        1291593600000,
        [
            -6826618397.343957,
            -1101182299.70703,
            3625681477.776896,
        ],
    ],
    [
        1292198400000,
        [
            -6826958238.232281,
            -1103248280.618531,
            3624735006.078155,
        ],
    ],
    [
        1292803200000,
        [
            -6827297460.170289,
            -1105314173.112006,
            3623788155.212993,
        ],
    ],
    [
        1293408000000,
        [
            -6827636058.196239,
            -1107379978.045975,
            3622840924.41534,
        ],
    ],
    [
        1294012800000,
        [
            -6827974027.61677,
            -1109445693.953195,
            3621893314.146112,
        ],
    ],
    [
        1294617600000,
        [
            -6828311365.566117,
            -1111511318.433144,
            3620945325.51045,
        ],
    ],
    [
        1295222400000,
        [
            -6828648070.447141,
            -1113576849.28096,
            3619996959.597838,
        ],
    ],
    [
        1295827200000,
        [
            -6828984141.264121,
            -1115642284.543272,
            3619048217.385847,
        ],
    ],
    [
        1296432000000,
        [
            -6829319577.431484,
            -1117707622.370985,
            3618099099.803129,
        ],
    ],
    [
        1297036800000,
        [
            -6829654378.783082,
            -1119772860.965858,
            3617149607.764285,
        ],
    ],
    [
        1297641600000,
        [
            -6829988545.625345,
            -1121837998.614002,
            3616199742.163729,
        ],
    ],
    [
        1298246400000,
        [
            -6830322078.791633,
            -1123903033.786175,
            3615249503.834562,
        ],
    ],
    [
        1298851200000,
        [
            -6830654979.67082,
            -1125967965.325596,
            3614298893.45825,
        ],
    ],
    [
        1299456000000,
        [
            -6830987250.088966,
            -1128032792.77354,
            3613347911.385406,
        ],
    ],
    [
        1300060800000,
        [
            -6831318891.669674,
            -1130097516.689717,
            3612396557.404994,
        ],
    ],
    [
        1300665600000,
        [
            -6831649904.64054,
            -1132162138.052485,
            3611444830.947069,
        ],
    ],
    [
        1301270400000,
        [
            -6831980288.187521,
            -1134226656.560071,
            3610492732.032377,
        ],
    ],
    [
        1301875200000,
        [
            -6832310042.627688,
            -1136291070.75318,
            3609540261.436677,
        ],
    ],
    [
        1302480000000,
        [
            -6832639169.744843,
            -1138355379.598416,
            3608587419.883323,
        ],
    ],
    [
        1303084800000,
        [
            -6832967671.837168,
            -1140419582.984658,
            3607634207.682011,
        ],
    ],
    [
        1303689600000,
        [
            -6833295551.161324,
            -1142483681.518283,
            3606680624.782145,
        ],
    ],
    [
        1304294400000,
        [
            -6833622809.765334,
            -1144547676.300559,
            3605726670.875029,
        ],
    ],
    [
        1304899200000,
        [
            -6833949449.458204,
            -1146611568.795576,
            3604772345.460855,
        ],
    ],
    [
        1305504000000,
        [
            -6834275471.824179,
            -1148675360.766107,
            3603817647.883046,
        ],
    ],
    [
        1306108800000,
        [
            -6834600878.256371,
            -1150739054.277657,
            3602862577.327246,
        ],
    ],
    [
        1306713600000,
        [
            -6834925669.959415,
            -1152802651.814645,
            3601907132.756318,
        ],
    ],
    [
        1307318400000,
        [
            -6835249847.702024,
            -1154866156.533684,
            3600951312.745396,
        ],
    ],
    [
        1307923200000,
        [
            -6835573410.903761,
            -1156929572.234383,
            3599995115.398149,
        ],
    ],
    [
        1308528000000,
        [
            -6835896356.838076,
            -1158992901.999142,
            3599038538.985601,
        ],
    ],
    [
        1309132800000,
        [
            -6836218682.227387,
            -1161056146.839205,
            3598081582.82933,
        ],
    ],
    [
        1309737600000,
        [
            -6836540385.043932,
            -1163119306.777945,
            3597124246.904022,
        ],
    ],
    [
        1310342400000,
        [
            -6836861464.104683,
            -1165182382.045635,
            3596166531.151967,
        ],
    ],
    [
        1310947200000,
        [
            -6837181918.34444,
            -1167245373.122749,
            3595208435.379783,
        ],
    ],
    [
        1311552000000,
        [
            -6837501746.602492,
            -1169308280.492444,
            3594249959.364502,
        ],
    ],
    [
        1312156800000,
        [
            -6837820947.667418,
            -1171371104.485973,
            3593291102.937824,
        ],
    ],
    [
        1312761600000,
        [
            -6838139520.396582,
            -1173433845.23381,
            3592331866.02287,
        ],
    ],
    [
        1313366400000,
        [
            -6838457463.854072,
            -1175496502.702173,
            3591372248.628627,
        ],
    ],
    [
        1313971200000,
        [
            -6838774777.437605,
            -1177559076.831481,
            3590412250.790229,
        ],
    ],
    [
        1314576000000,
        [
            -6839091460.889701,
            -1179621567.828049,
            3589451872.416786,
        ],
    ],
    [
        1315180800000,
        [
            -6839407513.848042,
            -1181683976.522255,
            3588491113.057192,
        ],
    ],
    [
        1315785600000,
        [
            -6839722934.741578,
            -1183746303.986018,
            3587529971.994831,
        ],
    ],
    [
        1316390400000,
        [
            -6840037720.86517,
            -1185808549.887149,
            3586568449.139977,
        ],
    ],
    [
        1316995200000,
        [
            -6840351870.587049,
            -1187870712.292703,
            3585606545.369772,
        ],
    ],
    [
        1317600000000,
        [
            -6840665384.062984,
            -1189932789.310434,
            3584644261.731631,
        ],
    ],
    [
        1318204800000,
        [
            -6840978262.346942,
            -1191994779.814104,
            3583681598.969573,
        ],
    ],
    [
        1318809600000,
        [
            -6841290506.779499,
            -1194056683.336167,
            3582718557.523678,
        ],
    ],
    [
        1319414400000,
        [
            -6841602118.791739,
            -1196118499.893326,
            3581755137.607722,
        ],
    ],
    [
        1320019200000,
        [
            -6841913099.857429,
            -1198180229.899693,
            3580791339.254518,
        ],
    ],
    [
        1320624000000,
        [
            -6842223451.48549,
            -1200241874.14643,
            3579827162.328854,
        ],
    ],
    [
        1321228800000,
        [
            -6842533175.225254,
            -1202303433.841888,
            3578862606.508339,
        ],
    ],
    [
        1321833600000,
        [
            -6842842272.644724,
            -1204364910.749936,
            3577897671.207836,
        ],
    ],
    [
        1322438400000,
        [
            -6843150745.097559,
            -1206426307.465791,
            3576932355.407395,
        ],
    ],
    [
        1323043200000,
        [
            -6843458592.858037,
            -1208487627.51127,
            3575966657.510014,
        ],
    ],
    [
        1323648000000,
        [
            -6843765814.106874,
            -1210548874.190217,
            3575000575.84517,
        ],
    ],
    [
        1324252800000,
        [
            -6844072406.132998,
            -1212610049.030411,
            3574034109.622016,
        ],
    ],
    [
        1324857600000,
        [
            -6844378367.301606,
            -1214671152.591513,
            3573067258.697259,
        ],
    ],
    [
        1325462400000,
        [
            -6844683696.80472,
            -1216732185.792235,
            3572100022.834982,
        ],
    ],
    [
        1326067200000,
        [
            -6844988393.816494,
            -1218793150.035767,
            3571132401.546049,
        ],
    ],
    [
        1326672000000,
        [
            -6845292457.161442,
            -1220854046.923215,
            3570164394.200245,
        ],
    ],
    [
        1327276800000,
        [
            -6845595885.287404,
            -1222914878.029183,
            3569196000.136477,
        ],
    ],
    [
        1327881600000,
        [
            -6845898676.339684,
            -1224975644.77474,
            3568227218.731264,
        ],
    ],
    [
        1328486400000,
        [
            -6846200828.273347,
            -1227036348.377217,
            3567258049.430214,
        ],
    ],
    [
        1329091200000,
        [
            -6846502338.978664,
            -1229096989.890902,
            3566288491.732604,
        ],
    ],
    [
        1329696000000,
        [
            -6846803206.336059,
            -1231157570.392571,
            3565318545.091833,
        ],
    ],
    [
        1330300800000,
        [
            -6847103427.894277,
            -1233218091.274939,
            3564348208.720018,
        ],
    ],
    [
        1330905600000,
        [
            -6847402999.866192,
            -1235278553.966452,
            3563377481.629354,
        ],
    ],
    [
        1331510400000,
        [
            -6847701916.957997,
            -1237338958.302893,
            3562406363.481402,
        ],
    ],
    [
        1332115200000,
        [
            -6848000174.555684,
            -1239399301.929194,
            3561434855.131969,
        ],
    ],
    [
        1332720000000,
        [
            -6848297769.882076,
            -1241459581.857009,
            3560462957.919335,
        ],
    ],
    [
        1333324800000,
        [
            -6848594701.286826,
            -1243519795.368758,
            3559490673.109674,
        ],
    ],
    [
        1333929600000,
        [
            -6848890967.667466,
            -1245579939.983589,
            3558518001.858787,
        ],
    ],
    [
        1334534400000,
        [
            -6849186568.334924,
            -1247640013.31589,
            3557544945.278784,
        ],
    ],
    [
        1335139200000,
        [
            -6849481503.042491,
            -1249700013.03697,
            3556571504.467839,
        ],
    ],
    [
        1335744000000,
        [
            -6849775772.047211,
            -1251759936.921012,
            3555597680.499253,
        ],
    ],
    [
        1336348800000,
        [
            -6850069376.168675,
            -1253819782.960404,
            3554623474.373803,
        ],
    ],
    [
        1336953600000,
        [
            -6850362316.811468,
            -1255879549.578269,
            3553648886.91671,
        ],
    ],
    [
        1337558400000,
        [
            -6850654595.797359,
            -1257939235.982864,
            3552673918.579033,
        ],
    ],
    [
        1338163200000,
        [
            -6850946214.599813,
            -1259998842.431036,
            3551698569.225371,
        ],
    ],
    [
        1338768000000,
        [
            -6851237173.204876,
            -1262058369.381498,
            3550722838.47525,
        ],
    ],
    [
        1339372800000,
        [
            -6851527470.915417,
            -1264117815.878282,
            3549746726.656464,
        ],
    ],
    [
        1339977600000,
        [
            -6851817108.430992,
            -1266177180.115246,
            3548770234.724626,
        ],
    ],
    [
        1340582400000,
        [
            -6852106087.800914,
            -1268236460.94554,
            3547793363.456429,
        ],
    ],
    [
        1341187200000,
        [
            -6852394411.471087,
            -1270295658.195459,
            3546816113.186507,
        ],
    ],
    [
        1341792000000,
        [
            -6852682081.8047,
            -1272354772.435403,
            3545838483.882327,
        ],
    ],
    [
        1342396800000,
        [
            -6852969100.940008,
            -1274413804.775856,
            3544860475.239533,
        ],
    ],
    [
        1343001600000,
        [
            -6853255470.759392,
            -1276472756.750617,
            3543882086.741119,
        ],
    ],
    [
        1343606400000,
        [
            -6853541192.895816,
            -1278531630.264093,
            3542903317.685184,
        ],
    ],
    [
        1344211200000,
        [
            -6853826268.753609,
            -1280590427.609615,
            3541924167.175188,
        ],
    ],
    [
        1344816000000,
        [
            -6854110699.478065,
            -1282649151.608207,
            3540944634.039576,
        ],
    ],
    [
        1345420800000,
        [
            -6854394485.609425,
            -1284707805.863716,
            3539964716.655592,
        ],
    ],
    [
        1346025600000,
        [
            -6854677626.048102,
            -1286766394.573837,
            3538984412.938086,
        ],
    ],
    [
        1346630400000,
        [
            -6854960117.516713,
            -1288824920.95158,
            3538003721.121378,
        ],
    ],
    [
        1347235200000,
        [
            -6855241956.477897,
            -1290883386.202465,
            3537022640.498298,
        ],
    ],
    [
        1347840000000,
        [
            -6855523140.565719,
            -1292941790.844764,
            3536041170.856787,
        ],
    ],
    [
        1348444800000,
        [
            -6855803667.962357,
            -1295000135.677288,
            3535059311.891555,
        ],
    ],
    [
        1349049600000,
        [
            -6856083536.743612,
            -1297058421.692933,
            3534077063.175757,
        ],
    ],
    [
        1349654400000,
        [
            -6856362744.724092,
            -1299116649.811086,
            3533094424.281556,
        ],
    ],
    [
        1350259200000,
        [
            -6856641289.522865,
            -1301174820.714441,
            3532111394.868406,
        ],
    ],
    [
        1350864000000,
        [
            -6856919168.695211,
            -1303232934.786141,
            3531127974.725478,
        ],
    ],
    [
        1351468800000,
        [
            -6857196379.885047,
            -1305290992.132648,
            3530144163.771535,
        ],
    ],
    [
        1352073600000,
        [
            -6857472920.964588,
            -1307348992.717705,
            3529159961.995436,
        ],
    ],
    [
        1352678400000,
        [
            -6857748790.028353,
            -1309406936.65887,
            3528175369.296049,
        ],
    ],
    [
        1353283200000,
        [
            -6858023984.853704,
            -1311464824.528818,
            3527190385.265717,
        ],
    ],
    [
        1353888000000,
        [
            -6858298501.831617,
            -1313522656.722743,
            3526205009.418951,
        ],
    ],
    [
        1354492800000,
        [
            -6858572336.515145,
            -1315580431.799117,
            3525219242.138436,
        ],
    ],
    [
        1355097600000,
        [
            -6858845485.883782,
            -1317638146.736311,
            3524233084.776444,
        ],
    ],
    [
        1355702400000,
        [
            -6859117948.688272,
            -1319695798.571659,
            3523246538.819449,
        ],
    ],
    [
        1356307200000,
        [
            -6859389724.561283,
            -1321753384.935155,
            3522259605.515664,
        ],
    ],
    [
        1356912000000,
        [
            -6859660813.525348,
            -1323810903.918322,
            3521272285.899054,
        ],
    ],
    [
        1357516800000,
        [
            -6859931215.862705,
            -1325868353.937618,
            3520284580.8537,
        ],
    ],
    [
        1358121600000,
        [
            -6860200932.100072,
            -1327925733.6885,
            3519296491.141352,
        ],
    ],
    [
        1358726400000,
        [
            -6860469963.020822,
            -1329983042.164994,
            3518308017.396364,
        ],
    ],
    [
        1359331200000,
        [
            -6860738309.680854,
            -1332040278.744435,
            3517319160.085628,
        ],
    ],
    [
        1359936000000,
        [
            -6861005973.376304,
            -1334097443.380871,
            3516329919.404802,
        ],
    ],
    [
        1360540800000,
        [
            -6861272955.336777,
            -1336154536.926176,
            3515340295.077153,
        ],
    ],
    [
        1361145600000,
        [
            -6861539255.73389,
            -1338211561.13291,
            3514350286.25067,
        ],
    ],
    [
        1361750400000,
        [
            -6861804872.860473,
            -1340268517.299437,
            3513359892.137411,
        ],
    ],
    [
        1362355200000,
        [
            -6862069804.717136,
            -1342325405.008389,
            3512369112.851799,
        ],
    ],
    [
        1362960000000,
        [
            -6862334050.66712,
            -1344382223.285781,
            3511377948.962204,
        ],
    ],
    [
        1363564800000,
        [
            -6862597610.896377,
            -1346438971.76525,
            3510386400.811467,
        ],
    ],
    [
        1364169600000,
        [
            -6862860485.607408,
            -1348495650.698043,
            3509394468.425694,
        ],
    ],
    [
        1364774400000,
        [
            -6863122674.727036,
            -1350552260.676603,
            3508402151.628625,
        ],
    ],
    [
        1365379200000,
        [
            -6863384177.870344,
            -1352608802.436106,
            3507409450.140293,
        ],
    ],
    [
        1365984000000,
        [
            -6863644994.387382,
            -1354665276.743727,
            3506416363.636848,
        ],
    ],
    [
        1366588800000,
        [
            -6863905123.443402,
            -1356721684.358213,
            3505422891.775865,
        ],
    ],
    [
        1367193600000,
        [
            -6864164564.106844,
            -1358778026.081124,
            3504429034.173229,
        ],
    ],
    [
        1367798400000,
        [
            -6864423315.33904,
            -1360834302.955712,
            3503434790.290899,
        ],
    ],
    [
        1368403200000,
        [
            -6864681375.534223,
            -1362890516.520261,
            3502440159.249128,
        ],
    ],
    [
        1369008000000,
        [
            -6864938741.448048,
            -1364946668.288241,
            3501445139.988743,
        ],
    ],
    [
        1369612800000,
        [
            -6865195408.412025,
            -1367002758.0086,
            3500449732.219091,
        ],
    ],
    [
        1370217600000,
        [
            -6865451372.638044,
            -1369058783.483811,
            3499453936.751518,
        ],
    ],
    [
        1370822400000,
        [
            -6865706631.954926,
            -1371114742.167596,
            3498457754.720811,
        ],
    ],
    [
        1371427200000,
        [
            -6865961185.018229,
            -1373170631.824378,
            3497461187.150928,
        ],
    ],
    [
        1372032000000,
        [
            -6866215030.829568,
            -1375226450.410066,
            3496464234.970216,
        ],
    ],
    [
        1372636800000,
        [
            -6866468168.660493,
            -1377282195.921649,
            3495466899.086683,
        ],
    ],
    [
        1373241600000,
        [
            -6866720598.110742,
            -1379337866.356581,
            3494469180.419914,
        ],
    ],
    [
        1373846400000,
        [
            -6866972319.192031,
            -1381393459.756914,
            3493471079.891537,
        ],
    ],
    [
        1374451200000,
        [
            -6867223332.406815,
            -1383448974.329481,
            3492472598.375472,
        ],
    ],
    [
        1375056000000,
        [
            -6867473638.777843,
            -1385504408.676766,
            3491473736.584569,
        ],
    ],
    [
        1375660800000,
        [
            -6867723239.635479,
            -1387559762.17051,
            3490474494.856208,
        ],
    ],
    [
        1376265600000,
        [
            -6867972135.74133,
            -1389615035.123583,
            3489474872.97682,
        ],
    ],
    [
        1376870400000,
        [
            -6868220326.297383,
            -1391670227.694161,
            3488474870.671409,
        ],
    ],
    [
        1377475200000,
        [
            -6868467810.200116,
            -1393725338.46089,
            3487474488.501005,
        ],
    ],
    [
        1378080000000,
        [
            -6868714587.917354,
            -1395780365.381772,
            3486473727.55054,
        ],
    ],
    [
        1378684800000,
        [
            -6868960661.12482,
            -1397835307.16488,
            3485472588.663509,
        ],
    ],
    [
        1379289600000,
        [
            -6869206031.799951,
            -1399890163.430733,
            3484471072.264772,
        ],
    ],
    [
        1379894400000,
        [
            -6869450701.820589,
            -1401944934.476546,
            3483469178.447196,
        ],
    ],
    [
        1380499200000,
        [
            -6869694672.84993,
            -1403999621.094167,
            3482466907.058125,
        ],
    ],
    [
        1381104000000,
        [
            -6869937946.311473,
            -1406054224.470275,
            3481464257.750009,
        ],
    ],
    [
        1381708800000,
        [
            -6870180523.395531,
            -1408108746.147558,
            3480461230.000528,
        ],
    ],
    [
        1382313600000,
        [
            -6870422405.074455,
            -1410163188.061071,
            3479457823.092284,
        ],
    ],
    [
        1382918400000,
        [
            -6870663592.041744,
            -1412217552.703197,
            3478454036.014745,
        ],
    ],
    [
        1383523200000,
        [
            -6870904084.263293,
            -1414271843.370276,
            3477449867.281285,
        ],
    ],
    [
        1384128000000,
        [
            -6871143879.860898,
            -1416326063.781173,
            3476445315.011477,
        ],
    ],
    [
        1384732800000,
        [
            -6871382974.922938,
            -1418380216.345045,
            3475440377.830194,
        ],
    ],
    [
        1385337600000,
        [
            -6871621365.651216,
            -1420434301.545579,
            3474435055.411753,
        ],
    ],
    [
        1385942400000,
        [
            -6871859049.387435,
            -1422488319.406694,
            3473429347.795465,
        ],
    ],
    [
        1386547200000,
        [
            -6872096023.854052,
            -1424542270.233043,
            3472423254.90309,
        ],
    ],
    [
        1387152000000,
        [
            -6872332286.590369,
            -1426596154.435387,
            3471416776.565304,
        ],
    ],
    [
        1387756800000,
        [
            -6872567834.854319,
            -1428649972.264194,
            3470409912.645715,
        ],
    ],
    [
        1388361600000,
        [
            -6872802665.710014,
            -1430703723.65385,
            3469402663.125579,
        ],
    ],
    [
        1388966400000,
        [
            -6873036776.172939,
            -1432757408.16309,
            3468395028.144005,
        ],
    ],
    [
        1389571200000,
        [
            -6873270163.37542,
            -1434811025.003299,
            3467387007.994509,
        ],
    ],
    [
        1390176000000,
        [
            -6873502824.71208,
            -1436864573.188304,
            3466378603.056093,
        ],
    ],
    [
        1390780800000,
        [
            -6873734757.798561,
            -1438918051.851656,
            3465369813.617175,
        ],
    ],
    [
        1391385600000,
        [
            -6873965959.82512,
            -1440971460.480939,
            3464360639.682916,
        ],
    ],
    [
        1391990400000,
        [
            -6874196426.577945,
            -1443024798.036042,
            3463351081.346109,
        ],
    ],
    [
        1392595200000,
        [
            -6874426153.46104,
            -1445078061.396623,
            3462341139.725553,
        ],
    ],
    [
        1393200000000,
        [
            -6874655137.666275,
            -1447131246.06264,
            3461330816.821473,
        ],
    ],
    [
        1393804800000,
        [
            -6874883378.165742,
            -1449184347.718374,
            3460320114.685229,
        ],
    ],
    [
        1394409600000,
        [
            -6875110874.848096,
            -1451237362.605376,
            3459309035.13751,
        ],
    ],
    [
        1395014400000,
        [
            -6875337628.116708,
            -1453290287.389809,
            3458297579.80513,
        ],
    ],
    [
        1395619200000,
        [
            -6875563638.793968,
            -1455343119.06608,
            3457285750.170487,
        ],
    ],
    [
        1396224000000,
        [
            -6875788908.111871,
            -1457395854.948208,
            3456273547.583039,
        ],
    ],
    [
        1396828800000,
        [
            -6876013437.719314,
            -1459448492.72285,
            3455260973.239253,
        ],
    ],
    [
        1397433600000,
        [
            -6876237229.684759,
            -1461501030.569809,
            3454248028.125444,
        ],
    ],
    [
        1398038400000,
        [
            -6876460286.427137,
            -1463553467.398401,
            3453234712.890509,
        ],
    ],
    [
        1398643200000,
        [
            -6876682610.303407,
            -1465605803.187244,
            3452221027.626913,
        ],
    ],
    [
        1399248000000,
        [
            -6876904202.494169,
            -1467658038.838279,
            3451206971.837382,
        ],
    ],
    [
        1399852800000,
        [
            -6877125062.451139,
            -1469710174.630103,
            3450192545.207003,
        ],
    ],
    [
        1400457600000,
        [
            -6877345189.781934,
            -1471762209.320551,
            3449177748.280108,
        ],
    ],
    [
        1401062400000,
        [
            -6877564585.514945,
            -1473814141.542953,
            3448162581.846557,
        ],
    ],
    [
        1401667200000,
        [
            -6877783251.34402,
            -1475865970.758402,
            3447147046.354663,
        ],
    ],
    [
        1402272000000,
        [
            -6878001188.883818,
            -1477917697.161065,
            3446131141.883473,
        ],
    ],
    [
        1402876800000,
        [
            -6878218399.417315,
            -1479969321.403154,
            3445114868.261396,
        ],
    ],
    [
        1403481600000,
        [
            -6878434883.858079,
            -1482020844.407534,
            3444098225.159351,
        ],
    ],
    [
        1404086400000,
        [
            -6878650642.782048,
            -1484072267.261165,
            3443081212.147106,
        ],
    ],
    [
        1404691200000,
        [
            -6878865676.489624,
            -1486123591.176531,
            3442063828.715703,
        ],
    ],
    [
        1405296000000,
        [
            -6879079985.068177,
            -1488174817.549694,
            3441046074.247737,
        ],
    ],
    [
        1405900800000,
        [
            -6879293568.320476,
            -1490225948.168779,
            3440027947.892972,
        ],
    ],
    [
        1406505600000,
        [
            -6879506425.167974,
            -1492276985.403493,
            3439009448.39946,
        ],
    ],
    [
        1407110400000,
        [
            -6879718552.57977,
            -1494327931.420722,
            3437990574.41582,
        ],
    ],
    [
        1407715200000,
        [
            -6879929946.221873,
            -1496378786.431821,
            3436971325.489445,
        ],
    ],
    [
        1408320000000,
        [
            -6880140602.751526,
            -1498429548.936456,
            3435951702.169366,
        ],
    ],
    [
        1408924800000,
        [
            -6880350520.152732,
            -1500480217.267123,
            3434931705.212121,
        ],
    ],
    [
        1409529600000,
        [
            -6880559696.927036,
            -1502530790.020719,
            3433911335.264576,
        ],
    ],
    [
        1410134400000,
        [
            -6880768131.711112,
            -1504581265.875299,
            3432890592.92072,
        ],
    ],
    [
        1410739200000,
        [
            -6880975823.253683,
            -1506631643.431692,
            3431869478.803813,
        ],
    ],
    [
        1411344000000,
        [
            -6881182770.503571,
            -1508681921.166948,
            3430847993.601707,
        ],
    ],
    [
        1411948800000,
        [
            -6881388972.719374,
            -1510732097.472883,
            3429826138.060246,
        ],
    ],
    [
        1412553600000,
        [
            -6881594429.572897,
            -1512782170.778114,
            3428803912.932567,
        ],
    ],
    [
        1413158400000,
        [
            -6881799141.18824,
            -1514832139.794862,
            3427781318.855941,
        ],
    ],
    [
        1413763200000,
        [
            -6882003107.879516,
            -1516882003.900987,
            3426758356.12573,
        ],
    ],
    [
        1414368000000,
        [
            -6882206329.181995,
            -1518931763.181694,
            3425735024.578154,
        ],
    ],
    [
        1414972800000,
        [
            -6882408803.106622,
            -1520981417.102837,
            3424711324.227164,
        ],
    ],
    [
        1415577600000,
        [
            -6882610527.805357,
            -1523030963.380295,
            3423687256.046164,
        ],
    ],
    [
        1416182400000,
        [
            -6882811503.15897,
            -1525080399.258073,
            3422662821.454424,
        ],
    ],
    [
        1416787200000,
        [
            -6883011730.179673,
            -1527129722.698079,
            3421638021.623371,
        ],
    ],
    [
        1417392000000,
        [
            -6883211210.192327,
            -1529178932.427325,
            3420612857.36937,
        ],
    ],
    [
        1417996800000,
        [
            -6883409944.516753,
            -1531228027.714555,
            3419587329.242023,
        ],
    ],
    [
        1418601600000,
        [
            -6883607934.388657,
            -1533277008.22061,
            3418561437.5968,
        ],
    ],
    [
        1419206400000,
        [
            -6883805180.952113,
            -1535325873.927789,
            3417535182.631913,
        ],
    ],
    [
        1419811200000,
        [
            -6884001685.277158,
            -1537374625.130578,
            3416508564.394037,
        ],
    ],
    [
        1420416000000,
        [
            -6884197448.377026,
            -1539423262.509252,
            3415481582.738839,
        ],
    ],
    [
        1421020800000,
        [
            -6884392471.115288,
            -1541471787.340871,
            3414454237.205858,
        ],
    ],
    [
        1421625600000,
        [
            -6884586753.645099,
            -1543520201.740259,
            3413426526.828129,
        ],
    ],
    [
        1422230400000,
        [
            -6884780294.255566,
            -1545568508.07621,
            3412398450.320239,
        ],
    ],
    [
        1422835200000,
        [
            -6884973089.588802,
            -1547616707.190941,
            3411370007.047202,
        ],
    ],
    [
        1423440000000,
        [
            -6885165136.880715,
            -1549664798.251765,
            3410341197.330748,
        ],
    ],
    [
        1424044800000,
        [
            -6885356434.557951,
            -1551712780.283891,
            3409312021.686798,
        ],
    ],
    [
        1424649600000,
        [
            -6885546981.39084,
            -1553760652.710677,
            3408282480.443218,
        ],
    ],
    [
        1425254400000,
        [
            -6885736775.999364,
            -1555808415.13491,
            3407252573.799552,
        ],
    ],
    [
        1425859200000,
        [
            -6885925816.776284,
            -1557856067.093352,
            3406222301.944405,
        ],
    ],
    [
        1426464000000,
        [
            -6886114101.963272,
            -1559903607.919103,
            3405191665.131461,
        ],
    ],
    [
        1427068800000,
        [
            -6886301629.776021,
            -1561951036.691483,
            3404160663.714413,
        ],
    ],
    [
        1427673600000,
        [
            -6886488398.547817,
            -1563998352.271585,
            3403129298.138899,
        ],
    ],
    [
        1428278400000,
        [
            -6886674406.842673,
            -1566045553.464665,
            3402097568.864606,
        ],
    ],
    [
        1428883200000,
        [
            -6886859653.333284,
            -1568092639.342654,
            3401065476.178748,
        ],
    ],
    [
        1429488000000,
        [
            -6887044136.017659,
            -1570139609.362566,
            3400033020.05147,
        ],
    ],
    [
        1430092800000,
        [
            -6887227851.38515,
            -1572186462.216899,
            3399000200.664887,
        ],
    ],
    [
        1430697600000,
        [
            -6887410795.869647,
            -1574233194.471457,
            3397967019.294326,
        ],
    ],
    [
        1431302400000,
        [
            -6887592967.790715,
            -1576279801.627356,
            3396933477.946636,
        ],
    ],
    [
        1431907200000,
        [
            -6887774367.042012,
            -1578326279.517882,
            3395899578.587345,
        ],
    ],
    [
        1432512000000,
        [
            -6887954994.285438,
            -1580372624.520865,
            3394865322.950362,
        ],
    ],
    [
        1433116800000,
        [
            -6888134850.633607,
            -1582418833.41086,
            3393830712.591427,
        ],
    ],
    [
        1433721600000,
        [
            -6888313937.589651,
            -1584464903.277928,
            3392795748.933086,
        ],
    ],
    [
        1434326400000,
        [
            -6888492257.053036,
            -1586510831.532632,
            3391760433.270536,
        ],
    ],
    [
        1434931200000,
        [
            -6888669811.335738,
            -1588556615.972963,
            3390724766.745254,
        ],
    ],
    [
        1435536000000,
        [
            -6888846603.166655,
            -1590602254.92573,
            3389688750.277144,
        ],
    ],
    [
        1436140800000,
        [
            -6889022635.596428,
            -1592647747.513784,
            3388652384.418455,
        ],
    ],
    [
        1436745600000,
        [
            -6889197911.483641,
            -1594693093.990245,
            3387615669.127615,
        ],
    ],
    [
        1437350400000,
        [
            -6889372432.307828,
            -1596738295.400485,
            3386578603.831421,
        ],
    ],
    [
        1437955200000,
        [
            -6889546197.978943,
            -1598783351.903351,
            3385541188.305654,
        ],
    ],
    [
        1438560000000,
        [
            -6889719208.926763,
            -1600828262.299052,
            3384503423.146366,
        ],
    ],
    [
        1439164800000,
        [
            -6889891466.951505,
            -1602873025.56056,
            3383465309.041368,
        ],
    ],
    [
        1439769600000,
        [
            -6890062974.33888,
            -1604917641.567485,
            3382426846.286685,
        ],
    ],
    [
        1440374400000,
        [
            -6890233733.19739,
            -1606962110.937248,
            3381388034.807144,
        ],
    ],
    [
        1440979200000,
        [
            -6890403745.248033,
            -1609006434.760706,
            3380348874.273823,
        ],
    ],
    [
        1441584000000,
        [
            -6890573011.791517,
            -1611050614.429281,
            3379309364.18997,
        ],
    ],
    [
        1442188800000,
        [
            -6890741533.733312,
            -1613094651.536665,
            3378269503.942071,
        ],
    ],
    [
        1442793600000,
        [
            -6890909311.635049,
            -1615138547.84759,
            3377229292.816913,
        ],
    ],
    [
        1443398400000,
        [
            -6891076345.755482,
            -1617182305.369315,
            3376188729.961848,
        ],
    ],
    [
        1444003200000,
        [
            -6891242635.912553,
            -1619225926.571811,
            3375147814.246386,
        ],
    ],
    [
        1444608000000,
        [
            -6891408180.749593,
            -1621269414.489523,
            3374106544.124741,
        ],
    ],
    [
        1445212800000,
        [
            -6891572976.741042,
            -1623312771.664482,
            3373064918.089982,
        ],
    ],
    [
        1445817600000,
        [
            -6891737019.289656,
            -1625355998.491688,
            3372022935.664217,
        ],
    ],
    [
        1446422400000,
        [
            -6891900304.883356,
            -1627399093.863467,
            3370980597.27075,
        ],
    ],
    [
        1447027200000,
        [
            -6892062831.076134,
            -1629442056.584206,
            3369937903.469614,
        ],
    ],
    [
        1447632000000,
        [
            -6892224595.710268,
            -1631484885.601684,
            3368894854.747402,
        ],
    ],
    [
        1448236800000,
        [
            -6892385596.631289,
            -1633527579.779549,
            3367851451.604338,
        ],
    ],
    [
        1448841600000,
        [
            -6892545831.717527,
            -1635570137.734936,
            3366807694.640451,
        ],
    ],
    [
        1449446400000,
        [
            -6892705299.003376,
            -1637612557.788447,
            3365763584.592885,
        ],
    ],
    [
        1450051200000,
        [
            -6892863996.822984,
            -1639654838.001608,
            3364719122.330114,
        ],
    ],
    [
        1450656000000,
        [
            -6893021923.946566,
            -1641696976.308252,
            3363674308.796734,
        ],
    ],
    [
        1451260800000,
        [
            -6893179079.632872,
            -1643738970.786947,
            3362629144.875639,
        ],
    ],
    [
        1451865600000,
        [
            -6893335463.312572,
            -1645780820.05149,
            3361583631.150097,
        ],
    ],
    [
        1452470400000,
        [
            -6893491073.555507,
            -1647822523.138558,
            3360537767.861214,
        ],
    ],
    [
        1453075200000,
        [
            -6893645907.66067,
            -1649864078.010303,
            3359491555.670576,
        ],
    ],
    [
        1453680000000,
        [
            -6893799963.648942,
            -1651905480.820682,
            3358444996.26444,
        ],
    ],
    [
        1454284800000,
        [
            -6893953241.493444,
            -1653946727.437281,
            3357398091.674228,
        ],
    ],
    [
        1454889600000,
        [
            -6894105742.357016,
            -1655987814.446861,
            3356350843.666116,
        ],
    ],
    [
        1455494400000,
        [
            -6894257467.866825,
            -1658028739.137814,
            3355303253.68071,
        ],
    ],
    [
        1456099200000,
        [
            -6894408419.857777,
            -1660069499.316368,
            3354255322.909643,
        ],
    ],
    [
        1456704000000,
        [
            -6894558600.307679,
            -1662110093.206282,
            3353207052.346839,
        ],
    ],
    [
        1457308800000,
        [
            -6894708011.32517,
            -1664150519.421242,
            3352158442.805695,
        ],
    ],
    [
        1457913600000,
        [
            -6894856655.153932,
            -1666190776.996519,
            3351109494.90549,
        ],
    ],
    [
        1458518400000,
        [
            -6895004534.163522,
            -1668230865.508256,
            3350060209.008767,
        ],
    ],
    [
        1459123200000,
        [
            -6895151650.687745,
            -1670270785.33154,
            3349010585.067889,
        ],
    ],
    [
        1459728000000,
        [
            -6895298006.315201,
            -1672310537.849513,
            3347960622.440072,
        ],
    ],
    [
        1460332800000,
        [
            -6895443600.732813,
            -1674350124.637236,
            3346910320.202871,
        ],
    ],
    [
        1460937600000,
        [
            -6895588432.360839,
            -1676389545.721215,
            3345859678.148258,
        ],
    ],
    [
        1461542400000,
        [
            -6895732500.532219,
            -1678428799.885041,
            3344808696.842954,
        ],
    ],
    [
        1462147200000,
        [
            -6895875805.66326,
            -1680467886.160645,
            3343757376.846385,
        ],
    ],
    [
        1462752000000,
        [
            -6896018348.360482,
            -1682506804.168267,
            3342705718.432654,
        ],
    ],
    [
        1463356800000,
        [
            -6896160128.982826,
            -1684545553.855058,
            3341653721.680372,
        ],
    ],
    [
        1463961600000,
        [
            -6896301147.572105,
            -1686584135.253282,
            3340601386.58975,
        ],
    ],
    [
        1464566400000,
        [
            -6896441403.912162,
            -1688622548.340556,
            3339548713.158311,
        ],
    ],
    [
        1465171200000,
        [
            -6896580897.633258,
            -1690660792.980413,
            3338495701.418366,
        ],
    ],
    [
        1465776000000,
        [
            -6896719628.335319,
            -1692698868.948549,
            3337442351.430956,
        ],
    ],
    [
        1466380800000,
        [
            -6896857595.668479,
            -1694736776.093005,
            3336388663.204366,
        ],
    ],
    [
        1466985600000,
        [
            -6896994799.123075,
            -1696774514.639045,
            3335334636.506061,
        ],
    ],
    [
        1467590400000,
        [
            -6897131237.127374,
            -1698812085.141826,
            3334280270.792069,
        ],
    ],
    [
        1468195200000,
        [
            -6897266906.452659,
            -1700849487.080941,
            3333225565.895026,
        ],
    ],
    [
        1468800000000,
        [
            -6897401804.049006,
            -1702886717.776983,
            3332170522.793573,
        ],
    ],
    [
        1469404800000,
        [
            -6897535928.674805,
            -1704923773.72412,
            3331115143.071243,
        ],
    ],
    [
        1470009600000,
        [
            -6897669280.36304,
            -1706960651.77037,
            3330059428.23385,
        ],
    ],
    [
        1470614400000,
        [
            -6897801859.709108,
            -1708997349.193545,
            3329003379.599566,
        ],
    ],
    [
        1471219200000,
        [
            -6897933667.641321,
            -1711033863.543641,
            3327946998.364849,
        ],
    ],
    [
        1471824000000,
        [
            -6898064705.40398,
            -1713070192.573295,
            3326890285.646118,
        ],
    ],
    [
        1472428800000,
        [
            -6898194974.589673,
            -1715106334.253803,
            3325833242.481271,
        ],
    ],
    [
        1473033600000,
        [
            -6898324477.175922,
            -1717142286.855669,
            3324775869.797293,
        ],
    ],
    [
        1473638400000,
        [
            -6898453215.540684,
            -1719178049.112803,
            3323718168.330782,
        ],
    ],
    [
        1474243200000,
        [
            -6898581192.34318,
            -1721213620.521498,
            3322660138.462015,
        ],
    ],
    [
        1474848000000,
        [
            -6898708409.906214,
            -1723249001.65095,
            3321601779.990445,
        ],
    ],
    [
        1475452800000,
        [
            -6898834869.013482,
            -1725284193.583565,
            3320543092.313473,
        ],
    ],
    [
        1476057600000,
        [
            -6898960569.147472,
            -1727319196.191077,
            3319484075.375396,
        ],
    ],
    [
        1476662400000,
        [
            -6899085510.663836,
            -1729354008.119127,
            3318424729.903299,
        ],
    ],
    [
        1477267200000,
        [
            -6899209695.232665,
            -1731388628.355353,
            3317365056.616173,
        ],
    ],
    [
        1477872000000,
        [
            -6899333124.898329,
            -1733423056.755396,
            3316305055.846286,
        ],
    ],
    [
        1478476800000,
        [
            -6899455801.510187,
            -1735457293.826937,
            3315244727.594119,
        ],
    ],
    [
        1479081600000,
        [
            -6899577726.55781,
            -1737491340.483405,
            3314184071.64028,
        ],
    ],
    [
        1479686400000,
        [
            -6899698901.152547,
            -1739525197.889997,
            3313123087.622144,
        ],
    ],
    [
        1480291200000,
        [
            -6899819326.058078,
            -1741558867.380318,
            3312061775.076799,
        ],
    ],
    [
        1480896000000,
        [
            -6899939001.743395,
            -1743592350.442477,
            3311000133.448277,
        ],
    ],
    [
        1481500800000,
        [
            -6900057928.41092,
            -1745625648.817177,
            3309938162.03154,
        ],
    ],
    [
        1482105600000,
        [
            -6900176105.791243,
            -1747658764.738432,
            3308875859.815406,
        ],
    ],
    [
        1482710400000,
        [
            -6900293532.284211,
            -1749691700.930957,
            3307813225.387212,
        ],
    ],
    [
        1483315200000,
        [
            -6900410204.130506,
            -1751724459.306396,
            3306750257.535417,
        ],
    ],
    [
        1483920000000,
        [
            -6900526116.93235,
            -1753757039.535255,
            3305686956.162108,
        ],
    ],
    [
        1484524800000,
        [
            -6900641267.55853,
            -1755789440.053331,
            3304623321.935124,
        ],
    ],
    [
        1485129600000,
        [
            -6900755653.827863,
            -1757821659.310973,
            3303559355.580722,
        ],
    ],
    [
        1485734400000,
        [
            -6900869273.787136,
            -1759853695.857069,
            3302495057.757574,
        ],
    ],
    [
        1486339200000,
        [
            -6900982125.501648,
            -1761885548.102608,
            3301430429.156231,
        ],
    ],
    [
        1486944000000,
        [
            -6901094207.113623,
            -1763917214.17475,
            3300365470.579458,
        ],
    ],
    [
        1487548800000,
        [
            -6901205516.977238,
            -1765948691.879752,
            3299300182.974002,
        ],
    ],
    [
        1488153600000,
        [
            -6901316053.81072,
            -1767979978.753108,
            3298234567.419325,
        ],
    ],
    [
        1488758400000,
        [
            -6901425816.836473,
            -1770011072.211164,
            3297168625.06268,
        ],
    ],
    [
        1489363200000,
        [
            -6901534805.810771,
            -1772041969.854789,
            3296102356.963264,
        ],
    ],
    [
        1489968000000,
        [
            -6901643020.609735,
            -1774072669.853318,
            3295035763.849073,
        ],
    ],
    [
        1490572800000,
        [
            -6901750460.138716,
            -1776103170.638436,
            3293968846.173563,
        ],
    ],
    [
        1491177600000,
        [
            -6901857122.30331,
            -1778133469.295708,
            3292901604.979115,
        ],
    ],
    [
        1491782400000,
        [
            -6901963006.189666,
            -1780163561.272491,
            3291834042.28698,
        ],
    ],
    [
        1492387200000,
        [
            -6902068112.882276,
            -1782193442.025632,
            3290766160.310132,
        ],
    ],
    [
        1492992000000,
        [
            -6902172444.587732,
            -1784223107.819996,
            3289697960.944061,
        ],
    ],
    [
        1493596800000,
        [
            -6902276003.99345,
            -1786252555.65281,
            3288629445.748621,
        ],
    ],
    [
        1494201600000,
        [
            -6902378794.051994,
            -1788281783.092586,
            3287560616.019032,
        ],
    ],
    [
        1494806400000,
        [
            -6902480817.919994,
            -1790310788.204405,
            3286491472.825996,
        ],
    ],
    [
        1495411200000,
        [
            -6902582078.937915,
            -1792339569.541801,
            3285422017.023533,
        ],
    ],
    [
        1496016000000,
        [
            -6902682580.621707,
            -1794368126.197499,
            3284352249.225588,
        ],
    ],
    [
        1496620800000,
        [
            -6902782326.629162,
            -1796396457.948715,
            3283282169.728402,
        ],
    ],
    [
        1497225600000,
        [
            -6902881320.526743,
            -1798424565.539585,
            3282211778.337837,
        ],
    ],
    [
        1497830400000,
        [
            -6902979564.938498,
            -1800452450.811721,
            3281141074.212656,
        ],
    ],
    [
        1498435200000,
        [
            -6903077060.473979,
            -1802480115.632043,
            3280070056.326284,
        ],
    ],
    [
        1499040000000,
        [
            -6903173806.798468,
            -1804507560.287996,
            3278998724.434091,
        ],
    ],
    [
        1499644800000,
        [
            -6903269804.638742,
            -1806534784.203067,
            3277927078.89716,
        ],
    ],
    [
        1500249600000,
        [
            -6903365055.590574,
            -1808561787.305039,
            3276855119.928517,
        ],
    ],
    [
        1500854400000,
        [
            -6903459561.238905,
            -1810588570.188821,
            3275782847.411139,
        ],
    ],
    [
        1501459200000,
        [
            -6903553322.784839,
            -1812615133.828353,
            3274710261.008604,
        ],
    ],
    [
        1502064000000,
        [
            -6903646340.990548,
            -1814641479.341217,
            3273637360.279844,
        ],
    ],
    [
        1502668800000,
        [
            -6903738616.231349,
            -1816667607.849296,
            3272564144.753212,
        ],
    ],
    [
        1503273600000,
        [
            -6903830148.588539,
            -1818693520.414484,
            3271490613.964363,
        ],
    ],
    [
        1503878400000,
        [
            -6903920937.958431,
            -1820719218.061841,
            3270416767.449002,
        ],
    ],
    [
        1504483200000,
        [
            -6904010984.099369,
            -1822744701.943467,
            3269342604.654222,
        ],
    ],
    [
        1505088000000,
        [
            -6904100286.322877,
            -1824769973.618063,
            3268268124.751582,
        ],
    ],
    [
        1505692800000,
        [
            -6904188842.497119,
            -1826795034.803254,
            3267193326.661259,
        ],
    ],
    [
        1506297600000,
        [
            -6904276648.774536,
            -1828819885.763682,
            3266118209.880995,
        ],
    ],
    [
        1506902400000,
        [
            -6904363701.718767,
            -1830844524.58569,
            3265042775.091318,
        ],
    ],
    [
        1507507200000,
        [
            -6904449999.5626,
            -1832868948.681298,
            3263967023.481113,
        ],
    ],
    [
        1508112000000,
        [
            -6904535541.528092,
            -1834893155.728479,
            3262890956.174807,
        ],
    ],
    [
        1508716800000,
        [
            -6904620327.226021,
            -1836917143.635984,
            3261814574.190164,
        ],
    ],
    [
        1509321600000,
        [
            -6904704356.51237,
            -1838940910.378958,
            3260737878.513707,
        ],
    ],
    [
        1509926400000,
        [
            -6904787629.520079,
            -1840964453.936814,
            3259660870.140682,
        ],
    ],
    [
        1510531200000,
        [
            -6904870146.72858,
            -1842987772.317229,
            3258583550.073699,
        ],
    ],
    [
        1511136000000,
        [
            -6904951909.034137,
            -1845010863.65021,
            3257505919.284504,
        ],
    ],
    [
        1511740800000,
        [
            -6905032917.788983,
            -1847033726.378495,
            3256427978.621233,
        ],
    ],
    [
        1512345600000,
        [
            -6905113174.664025,
            -1849056359.591148,
            3255349728.620796,
        ],
    ],
    [
        1512950400000,
        [
            -6905192680.934422,
            -1851078763.292703,
            3254271169.295527,
        ],
    ],
    [
        1513555200000,
        [
            -6905271436.339454,
            -1853100937.611056,
            3253192300.442089,
        ],
    ],
    [
        1514160000000,
        [
            -6905349439.792738,
            -1855122881.142764,
            3252113122.602322,
        ],
    ],
    [
        1514764800000,
        [
            -6905426691.519766,
            -1857144591.403931,
            3251033637.0465,
        ],
    ],
    [
        1515369600000,
        [
            -6905503193.125999,
            -1859166066.364168,
            3249953844.962705,
        ],
    ],
    [
        1515974400000,
        [
            -6905578946.661503,
            -1861187304.805475,
            3248873747.169069,
        ],
    ],
    [
        1516579200000,
        [
            -6905653954.144003,
            -1863208306.101388,
            3247793344.182453,
        ],
    ],
    [
        1517184000000,
        [
            -6905728217.431314,
            -1865229070.01416,
            3246712636.312916,
        ],
    ],
    [
        1517788800000,
        [
            -6905801738.209749,
            -1867249596.582537,
            3245631623.721112,
        ],
    ],
    [
        1518393600000,
        [
            -6905874518.020003,
            -1869269886.076569,
            3244550306.443045,
        ],
    ],
    [
        1518998400000,
        [
            -6905946558.296762,
            -1871289939.024365,
            3243468684.377195,
        ],
    ],
    [
        1519603200000,
        [
            -6906017860.360611,
            -1873309756.358611,
            3242386757.202094,
        ],
    ],
    [
        1520208000000,
        [
            -6906088425.10954,
            -1875329339.687036,
            3241304524.196028,
        ],
    ],
    [
        1520812800000,
        [
            -6906158252.021753,
            -1877348691.163211,
            3240221984.19834,
        ],
    ],
    [
        1521417600000,
        [
            -6906227338.550178,
            -1879367811.974958,
            3239139136.349435,
        ],
    ],
    [
        1522022400000,
        [
            -6906295681.971039,
            -1881386701.245385,
            3238055980.864494,
        ],
    ],
    [
        1522627200000,
        [
            -6906363280.917515,
            -1883405357.317744,
            3236972518.501012,
        ],
    ],
    [
        1523232000000,
        [
            -6906430134.805322,
            -1885423778.798357,
            3235888749.937172,
        ],
    ],
    [
        1523836800000,
        [
            -6906496243.157155,
            -1887441964.51519,
            3234804675.719299,
        ],
    ],
    [
        1524441600000,
        [
            -6906561605.43109,
            -1889459913.268806,
            3233720296.373037,
        ],
    ],
    [
        1525046400000,
        [
            -6906626221.077427,
            -1891477623.684947,
            3232635612.484772,
        ],
    ],
    [
        1525651200000,
        [
            -6906690089.662464,
            -1893495094.168226,
            3231550624.737049,
        ],
    ],
    [
        1526256000000,
        [
            -6906753211.011391,
            -1895512322.940846,
            3230465333.901817,
        ],
    ],
    [
        1526860800000,
        [
            -6906815585.338134,
            -1897529308.189516,
            3229379740.775961,
        ],
    ],
    [
        1527465600000,
        [
            -6906877213.236944,
            -1899546048.37245,
            3228293846.018437,
        ],
    ],
    [
        1528070400000,
        [
            -6906938095.157954,
            -1901562542.548743,
            3227207649.923433,
        ],
    ],
    [
        1528675200000,
        [
            -6906998230.31317,
            -1903578789.822372,
            3226121152.608757,
        ],
    ],
    [
        1529280000000,
        [
            -6907057617.090003,
            -1905594787.686935,
            3225034354.948868,
        ],
    ],
    [
        1529884800000,
        [
            -6907116255.30144,
            -1907610532.176757,
            3223947258.734209,
        ],
    ],
    [
        1530489600000,
        [
            -6907174146.608523,
            -1909626019.523697,
            3222859865.83731,
        ],
    ],
    [
        1531094400000,
        [
            -6907231293.610422,
            -1911641246.745073,
            3221772177.812011,
        ],
    ],
    [
        1531699200000,
        [
            -6907287699.305637,
            -1913656211.522442,
            3220684195.9099,
        ],
    ],
    [
        1532304000000,
        [
            -6907343366.928023,
            -1915670912.05919,
            3219595921.146573,
        ],
    ],
    [
        1532908800000,
        [
            -6907398299.904933,
            -1917685347.026356,
            3218507354.332821,
        ],
    ],
    [
        1533513600000,
        [
            -6907452501.84536,
            -1919699515.572037,
            3217418496.074158,
        ],
    ],
    [
        1534118400000,
        [
            -6907505976.533923,
            -1921713417.392481,
            3216329346.737055,
        ],
    ],
    [
        1534723200000,
        [
            -6907558727.882619,
            -1923727052.906863,
            3215239906.354354,
        ],
    ],
    [
        1535328000000,
        [
            -6907610759.62557,
            -1925740423.560999,
            3214150174.434043,
        ],
    ],
    [
        1535932800000,
        [
            -6907662074.340826,
            -1927753531.84848,
            3213060149.848069,
        ],
    ],
    [
        1536537600000,
        [
            -6907712672.555378,
            -1929766379.995862,
            3211969831.442258,
        ],
    ],
    [
        1537142400000,
        [
            -6907762554.224604,
            -1931778968.603468,
            3210879218.91491,
        ],
    ],
    [
        1537747200000,
        [
            -6907811720.461777,
            -1933791297.708633,
            3209788312.42614,
        ],
    ],
    [
        1538352000000,
        [
            -6907860173.053526,
            -1935803367.978971,
            3208697111.907108,
        ],
    ],
    [
        1538956800000,
        [
            -6907907913.632003,
            -1937815180.73131,
            3207605616.959925,
        ],
    ],
    [
        1539561600000,
        [
            -6907954943.36597,
            -1939826737.633009,
            3206513826.980009,
        ],
    ],
    [
        1540166400000,
        [
            -6908001262.92249,
            -1941838040.47715,
            3205421741.266095,
        ],
    ],
    [
        1540771200000,
        [
            -6908046872.518391,
            -1943849091.047267,
            3204329359.090949,
        ],
    ],
    [
        1541376000000,
        [
            -6908091772.009126,
            -1945859891.053473,
            3203236679.737174,
        ],
    ],
    [
        1541980800000,
        [
            -6908135960.989871,
            -1947870442.159809,
            3202143702.48513,
        ],
    ],
    [
        1542585600000,
        [
            -6908179438.809114,
            -1949880746.158918,
            3201050426.512933,
        ],
    ],
    [
        1543190400000,
        [
            -6908222204.154572,
            -1951890805.21737,
            3199956850.714464,
        ],
    ],
    [
        1543795200000,
        [
            -6908264254.006657,
            -1953900621.400682,
            3198862973.837071,
        ],
    ],
    [
        1544400000000,
        [
            -6908305583.765151,
            -1955910194.935863,
            3197768795.416028,
        ],
    ],
    [
        1545004800000,
        [
            -6908346189.554618,
            -1957919523.905465,
            3196674316.171215,
        ],
    ],
    [
        1545609600000,
        [
            -6908386069.0888,
            -1959928605.831407,
            3195579537.246279,
        ],
    ],
    [
        1546214400000,
        [
            -6908425220.917705,
            -1961937438.385324,
            3194484459.748293,
        ],
    ],
    [
        1546819200000,
        [
            -6908463643.946321,
            -1963946019.281516,
            3193389084.753907,
        ],
    ],
    [
        1547424000000,
        [
            -6908501337.369836,
            -1965954346.124548,
            3192293413.384614,
        ],
    ],
    [
        1548028800000,
        [
            -6908538300.750468,
            -1967962416.368843,
            3191197446.838542,
        ],
    ],
    [
        1548633600000,
        [
            -6908574534.121055,
            -1969970227.366312,
            3190101186.379475,
        ],
    ],
    [
        1549238400000,
        [
            -6908610038.083322,
            -1971977776.49151,
            3189004633.285182,
        ],
    ],
    [
        1549843200000,
        [
            -6908644813.859018,
            -1973985061.377027,
            3187907788.732959,
        ],
    ],
    [
        1550448000000,
        [
            -6908678863.110962,
            -1975992080.294774,
            3186810653.584036,
        ],
    ],
    [
        1551052800000,
        [
            -6908712187.113341,
            -1977998832.368832,
            3185713228.190848,
        ],
    ],
    [
        1551657600000,
        [
            -6908744785.731218,
            -1980005316.558405,
            3184615512.841565,
        ],
    ],
    [
        1552262400000,
        [
            -6908776658.57677,
            -1982011530.19155,
            3183517508.669982,
        ],
    ],
    [
        1552867200000,
        [
            -6908807806.959099,
            -1984017469.848592,
            3182419217.392029,
        ],
    ],
    [
        1553472000000,
        [
            -6908838233.603086,
            -1986023132.792834,
            3181320640.517989,
        ],
    ],
    [
        1554076800000,
        [
            -6908867941.733305,
            -1988028517.188249,
            3180221779.146081,
        ],
    ],
    [
        1554681600000,
        [
            -6908896934.656114,
            -1990033621.88383,
            3179122634.038288,
        ],
    ],
    [
        1555286400000,
        [
            -6908925215.638245,
            -1992038446.245299,
            3178023205.700636,
        ],
    ],
    [
        1555891200000,
        [
            -6908952787.878081,
            -1994042990.070049,
            3176923494.427639,
        ],
    ],
    [
        1556496000000,
        [
            -6908979654.507647,
            -1996047253.563197,
            3175823500.316258,
        ],
    ],
    [
        1557100800000,
        [
            -6909005818.602725,
            -1998051237.386901,
            3174723223.240551,
        ],
    ],
    [
        1557705600000,
        [
            -6909031283.121738,
            -2000054942.835411,
            3173622662.750789,
        ],
    ],
    [
        1558310400000,
        [
            -6909056050.47386,
            -2002058372.101222,
            3172521817.884515,
        ],
    ],
    [
        1558915200000,
        [
            -6909080121.407233,
            -2004061527.960692,
            3171420687.216339,
        ],
    ],
    [
        1559520000000,
        [
            -6909103494.709772,
            -2006064412.087295,
            3170319269.724274,
        ],
    ],
    [
        1560124800000,
        [
            -6909126169.293172,
            -2008067024.338817,
            3169217565.382131,
        ],
    ],
    [
        1560729600000,
        [
            -6909148145.307797,
            -2010069364.205795,
            3168115574.496393,
        ],
    ],
    [
        1561334400000,
        [
            -6909169423.392839,
            -2012071431.617991,
            3167013297.192369,
        ],
    ],
    [
        1561939200000,
        [
            -6909190004.069345,
            -2014073226.795436,
            3165910733.425405,
        ],
    ],
    [
        1562544000000,
        [
            -6909209887.608283,
            -2016074749.984747,
            3164807883.102749,
        ],
    ],
    [
        1563148800000,
        [
            -6909229074.092498,
            -2018076001.302721,
            3163704746.168619,
        ],
    ],
    [
        1563753600000,
        [
            -6909247563.538257,
            -2020076980.67485,
            3162601322.645426,
        ],
    ],
    [
        1564358400000,
        [
            -6909265356.037643,
            -2022077687.858788,
            3161497612.63274,
        ],
    ],
    [
        1564963200000,
        [
            -6909282451.883845,
            -2024078122.584422,
            3160393616.243373,
        ],
    ],
    [
        1565568000000,
        [
            -6909298851.522074,
            -2026078284.858723,
            3159289333.434712,
        ],
    ],
    [
        1566172800000,
        [
            -6909314554.914186,
            -2028078175.210826,
            3158184763.812639,
        ],
    ],
    [
        1566777600000,
        [
            -6909329560.514547,
            -2030077793.863711,
            3157079906.969972,
        ],
    ],
    [
        1567382400000,
        [
            -6909343866.158172,
            -2032077139.132017,
            3155974763.437848,
        ],
    ],
    [
        1567987200000,
        [
            -6909357471.255131,
            -2034076208.000289,
            3154869334.608867,
        ],
    ],
    [
        1568592000000,
        [
            -6909370376.857677,
            -2036074997.699052,
            3153763621.90756,
        ],
    ],
    [
        1569196800000,
        [
            -6909382584.777529,
            -2038073506.101221,
            3152657626.493133,
        ],
    ],
    [
        1569801600000,
        [
            -6909394097.154908,
            -2040071731.572679,
            3151551349.300831,
        ],
    ],
    [
        1570406400000,
        [
            -6909404916.349697,
            -2042069672.849304,
            3150444791.102492,
        ],
    ],
    [
        1571011200000,
        [
            -6909415044.927644,
            -2044067329.002157,
            3149337952.529449,
        ],
    ],
    [
        1571616000000,
        [
            -6909424485.667834,
            -2046064699.464844,
            3148230834.063778,
        ],
    ],
    [
        1572220800000,
        [
            -6909433241.569835,
            -2048061784.127439,
            3147123435.993097,
        ],
    ],
    [
        1572825600000,
        [
            -6909441315.797784,
            -2050058583.544435,
            3146015758.296914,
        ],
    ],
    [
        1573430400000,
        [
            -6909448711.301741,
            -2052055099.25386,
            3144907800.439032,
        ],
    ],
    [
        1574035200000,
        [
            -6909455429.740065,
            -2054051333.656297,
            3143799561.321446,
        ],
    ],
    [
        1574640000000,
        [
            -6909461470.860755,
            -2056047288.496337,
            3142691040.03123,
        ],
    ],
    [
        1575244800000,
        [
            -6909466834.332044,
            -2058042963.85058,
            3141582236.569586,
        ],
    ],
    [
        1575849600000,
        [
            -6909471521.126316,
            -2060038359.46002,
            3140473151.281155,
        ],
    ],
    [
        1576454400000,
        [
            -6909475532.828703,
            -2062033475.726736,
            3139363784.246532,
        ],
    ],
    [
        1577059200000,
        [
            -6909478870.893198,
            -2064028313.633872,
            3138254135.243587,
        ],
    ],
    [
        1577664000000,
        [
            -6909481536.399596,
            -2066022874.462608,
            3137144203.868322,
        ],
    ],
    [
        1578268800000,
        [
            -6909483530.03597,
            -2068017159.597381,
            3136033989.631279,
        ],
    ],
    [
        1578873600000,
        [
            -6909484852.154052,
            -2070011170.416066,
            3134923492.015543,
        ],
    ],
    [
        1579478400000,
        [
            -6909485502.855588,
            -2072004908.250983,
            3133812710.499722,
        ],
    ],
    [
        1580083200000,
        [
            -6909485482.080723,
            -2073998374.447361,
            3132701644.528855,
        ],
    ],
    [
        1580688000000,
        [
            -6909484789.571405,
            -2075991570.573929,
            3131590293.391076,
        ],
    ],
    [
        1581292800000,
        [
            -6909483424.327703,
            -2077984498.637431,
            3130478656.039857,
        ],
    ],
    [
        1581897600000,
        [
            -6909481383.546531,
            -2079977160.375404,
            3129366731.355455,
        ],
    ],
    [
        1582502400000,
        [
            -6909478663.172685,
            -2081969555.506152,
            3128254519.131307,
        ],
    ],
    [
        1583107200000,
        [
            -6909475260.22223,
            -2083961681.875942,
            3127142020.23168,
        ],
    ],
    [
        1583712000000,
        [
            -6909471173.229309,
            -2085953537.037155,
            3126029235.791667,
        ],
    ],
    [
        1584316800000,
        [
            -6909466401.447517,
            -2087945118.748487,
            3124916166.865385,
        ],
    ],
    [
        1584921600000,
        [
            -6909460944.452234,
            -2089936424.81968,
            3123802814.467502,
        ],
    ],
    [
        1585526400000,
        [
            -6909454802.112612,
            -2091927452.969331,
            3122689179.647776,
        ],
    ],
    [
        1586131200000,
        [
            -6909447974.678617,
            -2093918200.795058,
            3121575263.519138,
        ],
    ],
    [
        1586736000000,
        [
            -6909440462.888898,
            -2095908665.829313,
            3120461067.243729,
        ],
    ],
    [
        1587340800000,
        [
            -6909432268.07098,
            -2097898845.677255,
            3119346591.975596,
        ],
    ],
    [
        1587945600000,
        [
            -6909423392.179461,
            -2099888738.276236,
            3118231838.733088,
        ],
    ],
    [
        1588550400000,
        [
            -6909413837.54675,
            -2101878342.293709,
            3117116808.168207,
        ],
    ],
    [
        1589155200000,
        [
            -6909403605.933257,
            -2103867657.222913,
            3116001500.425199,
        ],
    ],
    [
        1589760000000,
        [
            -6909392697.705796,
            -2105856682.128908,
            3114885915.733462,
        ],
    ],
    [
        1590364800000,
        [
            -6909381113.397472,
            -2107845414.450525,
            3113770055.217205,
        ],
    ],
    [
        1590969600000,
        [
            -6909368855.36729,
            -2109833851.221561,
            3112653920.422565,
        ],
    ],
    [
        1591574400000,
        [
            -6909355927.243406,
            -2111821990.324752,
            3111537512.596763,
        ],
    ],
    [
        1592179200000,
        [
            -6909342333.066107,
            -2113809830.578945,
            3110420832.558527,
        ],
    ],
    [
        1592784000000,
        [
            -6909328076.933812,
            -2115797371.523704,
            3109303880.781267,
        ],
    ],
    [
        1593388800000,
        [
            -6909313162.897755,
            -2117784613.271734,
            3108186657.464736,
        ],
    ],
    [
        1593993600000,
        [
            -6909297594.931154,
            -2119771556.439243,
            3107069162.571648,
        ],
    ],
    [
        1594598400000,
        [
            -6909281376.923897,
            -2121758202.135388,
            3105951395.834262,
        ],
    ],
    [
        1595203200000,
        [
            -6909264512.678439,
            -2123744552.030279,
            3104833356.718003,
        ],
    ],
    [
        1595808000000,
        [
            -6909247005.804322,
            -2125730608.556003,
            3103715044.302434,
        ],
    ],
    [
        1596412800000,
        [
            -6909228859.165165,
            -2127716375.150419,
            3102596457.091927,
        ],
    ],
    [
        1597017600000,
        [
            -6909210073.707474,
            -2129701855.724589,
            3101477593.175982,
        ],
    ],
    [
        1597622400000,
        [
            -6909190648.547748,
            -2131687052.88013,
            3100358451.186812,
        ],
    ],
    [
        1598227200000,
        [
            -6909170583.181041,
            -2133671967.631976,
            3099239030.671767,
        ],
    ],
    [
        1598832000000,
        [
            -6909149878.166598,
            -2135656600.922895,
            3098119331.350001,
        ],
    ],
    [
        1599436800000,
        [
            -6909128534.278591,
            -2137640954.200571,
            3096999352.710176,
        ],
    ],
    [
        1600041600000,
        [
            -6909106551.977241,
            -2139625029.192633,
            3095879094.069372,
        ],
    ],
    [
        1600646400000,
        [
            -6909083931.312266,
            -2141608827.638116,
            3094758554.699838,
        ],
    ],
    [
        1601251200000,
        [
            -6909060671.989619,
            -2143592351.125901,
            3093637733.915502,
        ],
    ],
    [
        1601856000000,
        [
            -6909036773.492002,
            -2145575601.02123,
            3092516631.117281,
        ],
    ],
    [
        1602460800000,
        [
            -6909012235.221414,
            -2147558578.477047,
            3091395245.795882,
        ],
    ],
    [
        1603065600000,
        [
            -6908987056.617653,
            -2149541284.569923,
            3090273577.466373,
        ],
    ],
    [
        1603670400000,
        [
            -6908961237.058386,
            -2151523720.598342,
            3089151625.494426,
        ],
    ],
    [
        1604275200000,
        [
            -6908934775.114133,
            -2153505888.210734,
            3088029388.947872,
        ],
    ],
    [
        1604880000000,
        [
            -6908907667.676792,
            -2155487788.300309,
            3086906867.095268,
        ],
    ],
    [
        1605484800000,
        [
            -6908879911.317778,
            -2157469419.562891,
            3085784060.316998,
        ],
    ],
    [
        1606089600000,
        [
            -6908851504.311822,
            -2159450779.453923,
            3084660969.80507,
        ],
    ],
    [
        1606694400000,
        [
            -6908822446.413354,
            -2161431865.615383,
            3083537596.780149,
        ],
    ],
    [
        1607299200000,
        [
            -6908792738.052317,
            -2163412676.111113,
            3082413942.285964,
        ],
    ],
    [
        1607904000000,
        [
            -6908762380.017078,
            -2165393209.26931,
            3081290007.244802,
        ],
    ],
    [
        1608508800000,
        [
            -6908731373.408228,
            -2167373463.587937,
            3080165792.507977,
        ],
    ],
    [
        1609113600000,
        [
            -6908699719.664116,
            -2169353437.729794,
            3079041298.866046,
        ],
    ],
    [
        1609718400000,
        [
            -6908667420.598689,
            -2171333130.582377,
            3077916527.025677,
        ],
    ],
    [
        1610323200000,
        [
            -6908634478.429444,
            -2173312541.393251,
            3076791477.544897,
        ],
    ],
    [
        1610928000000,
        [
            -6908600895.713003,
            -2175291670.031666,
            3075666150.690924,
        ],
    ],
    [
        1611532800000,
        [
            -6908566674.880939,
            -2177270517.330864,
            3074540546.212895,
        ],
    ],
    [
        1612137600000,
        [
            -6908531817.088728,
            -2179249084.809905,
            3073414663.374239,
        ],
    ],
    [
        1612742400000,
        [
            -6908496321.946143,
            -2181227373.031201,
            3072288501.804495,
        ],
    ],
    [
        1613347200000,
        [
            -6908460189.583982,
            -2183205381.027531,
            3071162062.021276,
        ],
    ],
    [
        1613952000000,
        [
            -6908423421.627888,
            -2185183107.822477,
            3070035344.719901,
        ],
    ],
    [
        1614556800000,
        [
            -6908386020.353292,
            -2187160553.234925,
            3068908350.2562,
        ],
    ],
    [
        1615161600000,
        [
            -6908347988.012463,
            -2189137717.742843,
            3067781078.648933,
        ],
    ],
    [
        1615766400000,
        [
            -6908309326.622794,
            -2191114602.23271,
            3066653529.690366,
        ],
    ],
    [
        1616371200000,
        [
            -6908270037.939143,
            -2193091207.840469,
            3065525703.026305,
        ],
    ],
    [
        1616976000000,
        [
            -6908230123.484254,
            -2195067535.868769,
            3064397598.200698,
        ],
    ],
    [
        1617580800000,
        [
            -6908189584.604141,
            -2197043587.771276,
            3063269214.666353,
        ],
    ],
    [
        1618185600000,
        [
            -6908148422.513814,
            -2199019365.237632,
            3062140551.740302,
        ],
    ],
    [
        1618790400000,
        [
            -6908106638.174249,
            -2200994870.427472,
            3061011608.461597,
        ],
    ],
    [
        1619395200000,
        [
            -6908064231.58872,
            -2202970106.113138,
            3059882383.437358,
        ],
    ],
    [
        1620000000000,
        [
            -6908021200.774795,
            -2204945074.707207,
            3058752875.250819,
        ],
    ],
    [
        1620604800000,
        [
            -6907977542.740227,
            -2206919776.585999,
            3057623083.453245,
        ],
    ],
    [
        1621209600000,
        [
            -6907933255.677278,
            -2208894210.648774,
            3056493008.488231,
        ],
    ],
    [
        1621814400000,
        [
            -6907888339.018357,
            -2210868375.783355,
            3055362650.910701,
        ],
    ],
    [
        1622419200000,
        [
            -6907842792.635162,
            -2212842271.15589,
            3054232011.146197,
        ],
    ],
    [
        1623024000000,
        [
            -6907796616.517494,
            -2214815896.002115,
            3053101089.567288,
        ],
    ],
    [
        1623628800000,
        [
            -6907749810.777343,
            -2216789249.473809,
            3051969886.575541,
        ],
    ],
    [
        1624233600000,
        [
            -6907702375.750152,
            -2218762330.596651,
            3050838402.635481,
        ],
    ],
    [
        1624838400000,
        [
            -6907654312.116073,
            -2220735138.313861,
            3049706638.266263,
        ],
    ],
    [
        1625443200000,
        [
            -6907605621.013624,
            -2222707671.619979,
            3048574593.98579,
        ],
    ],
    [
        1626048000000,
        [
            -6907556304.074382,
            -2224679929.830463,
            3047442270.175334,
        ],
    ],
    [
        1626652800000,
        [
            -6907506363.105974,
            -2226651912.973863,
            3046309666.843234,
        ],
    ],
    [
        1627257600000,
        [
            -6907455799.056895,
            -2228623621.723616,
            3045176783.560793,
        ],
    ],
    [
        1627862400000,
        [
            -6907404611.496715,
            -2230595055.938547,
            3044043620.195237,
        ],
    ],
    [
        1628467200000,
        [
            -6907352800.518257,
            -2232566213.819313,
            3042910177.564753,
        ],
    ],
    [
        1629072000000,
        [
            -6907300368.046795,
            -2234537093.373979,
            3041776456.798298,
        ],
    ],
    [
        1629676800000,
        [
            -6907247317.095882,
            -2236507693.466232,
            3040642458.705034,
        ],
    ],
    [
        1630281600000,
        [
            -6907193651.000826,
            -2238478013.804085,
            3039508183.70669,
        ],
    ],
    [
        1630886400000,
        [
            -6907139373.131807,
            -2240448054.73592,
            3038373631.921653,
        ],
    ],
    [
        1631491200000,
        [
            -6907084486.811362,
            -2242417817.126359,
            3037238803.226548,
        ],
    ],
    [
        1632096000000,
        [
            -6907028995.290476,
            -2244387302.304707,
            3036103697.283998,
        ],
    ],
    [
        1632700800000,
        [
            -6906972901.744876,
            -2246356512.07154,
            3034968313.540233,
        ],
    ],
    [
        1633305600000,
        [
            -6906916209.263335,
            -2248325448.790209,
            3033832651.175292,
        ],
    ],
    [
        1633910400000,
        [
            -6906858920.69718,
            -2250294115.61599,
            3032696708.964116,
        ],
    ],
    [
        1634515200000,
        [
            -6906801037.98436,
            -2252262516.697882,
            3031560485.096582,
        ],
    ],
    [
        1635120000000,
        [
            -6906742560.984504,
            -2254230656.40475,
            3030423977.466902,
        ],
    ],
    [
        1635724800000,
        [
            -6906683488.005253,
            -2256198537.545643,
            3029287184.67451,
        ],
    ],
    [
        1636329600000,
        [
            -6906623818.012232,
            -2258166161.5424,
            3028150106.155528,
        ],
    ],
    [
        1636934400000,
        [
            -6906563550.909801,
            -2260133529.920663,
            3027012741.409039,
        ],
    ],
    [
        1637539200000,
        [
            -6906502686.662235,
            -2262100644.680329,
            3025875089.700967,
        ],
    ],
    [
        1638144000000,
        [
            -6906441224.851892,
            -2264067508.025623,
            3024737150.154716,
        ],
    ],
    [
        1638748800000,
        [
            -6906379164.620709,
            -2266034122.105594,
            3023598921.875532,
        ],
    ],
    [
        1639353600000,
        [
            -6906316504.748482,
            -2268000488.859734,
            3022460404.032733,
        ],
    ],
    [
        1639958400000,
        [
            -6906253243.779326,
            -2269966609.947339,
            3021321595.902326,
        ],
    ],
    [
        1640563200000,
        [
            -6906189380.168955,
            -2271932486.764375,
            3020182496.865465,
        ],
    ],
    [
        1641168000000,
        [
            -6906124912.394501,
            -2273898120.594687,
            3019043106.332072,
        ],
    ],
    [
        1641772800000,
        [
            -6906059838.790173,
            -2275863512.913375,
            3017903423.555832,
        ],
    ],
    [
        1642377600000,
        [
            -6905994156.696749,
            -2277828665.381159,
            3016763447.544559,
        ],
    ],
    [
        1642982400000,
        [
            -6905927861.821105,
            -2279793578.499509,
            3015623177.709366,
        ],
    ],
    [
        1643587200000,
        [
            -6905860950.005422,
            -2281758250.449338,
            3014482614.667335,
        ],
    ],
    [
        1644192000000,
        [
            -6905793418.966673,
            -2283722678.368096,
            3013341759.740338,
        ],
    ],
    [
        1644796800000,
        [
            -6905725267.834817,
            -2285686859.59587,
            3012200614.244058,
        ],
    ],
    [
        1645401600000,
        [
            -6905656496.435768,
            -2287650791.793707,
            3011059179.354623,
        ],
    ],
    [
        1646006400000,
        [
            -6905587105.059155,
            -2289614472.800585,
            3009917456.166529,
        ],
    ],
    [
        1646611200000,
        [
            -6905517094.44743,
            -2291577900.575907,
            3008775445.728886,
        ],
    ],
    [
        1647216000000,
        [
            -6905446465.835628,
            -2293541073.229496,
            3007633149.04095,
        ],
    ],
    [
        1647820800000,
        [
            -6905375220.994309,
            -2295503989.116652,
            3006490567.013615,
        ],
    ],
    [
        1648425600000,
        [
            -6905303362.251133,
            -2297466647.015318,
            3005347700.384892,
        ],
    ],
    [
        1649030400000,
        [
            -6905230892.38465,
            -2299429046.436504,
            3004204549.550718,
        ],
    ],
    [
        1649635200000,
        [
            -6905157814.037467,
            -2301391187.962668,
            3003061114.330498,
        ],
    ],
    [
        1650240000000,
        [
            -6905084128.512996,
            -2303353072.766785,
            3001917394.105721,
        ],
    ],
    [
        1650844800000,
        [
            -6905009835.898193,
            -2305314700.910331,
            3000773388.747447,
        ],
    ],
    [
        1651449600000,
        [
            -6904934937.224823,
            -2307276071.22931,
            2999629098.90576,
        ],
    ],
    [
        1652054400000,
        [
            -6904859435.00748,
            -2309237182.920255,
            2998484525.221819,
        ],
    ],
    [
        1652659200000,
        [
            -6904783332.303379,
            -2311198036.135134,
            2997339667.91504,
        ],
    ],
    [
        1653264000000,
        [
            -6904706632.108853,
            -2313158631.791676,
            2996194526.823202,
        ],
    ],
    [
        1653868800000,
        [
            -6904629337.171168,
            -2315118971.337374,
            2995049101.509281,
        ],
    ],
    [
        1654473600000,
        [
            -6904551449.952284,
            -2317079056.604621,
            2993903391.334271,
        ],
    ],
    [
        1655078400000,
        [
            -6904472972.641899,
            -2319038889.735894,
            2992757395.496695,
        ],
    ],
    [
        1655683200000,
        [
            -6904393907.192308,
            -2320998473.175937,
            2991611113.037621,
        ],
    ],
    [
        1656288000000,
        [
            -6904314255.330991,
            -2322957809.771566,
            2990464542.784996,
        ],
    ],
    [
        1656892800000,
        [
            -6904234018.353318,
            -2324916903.014285,
            2989317683.198144,
        ],
    ],
    [
        1657497600000,
        [
            -6904153196.273585,
            -2326875757.071848,
            2988170532.257843,
        ],
    ],
    [
        1658102400000,
        [
            -6904071786.924212,
            -2328834375.547545,
            2987023088.030232,
        ],
    ],
    [
        1658707200000,
        [
            -6903989787.350784,
            -2330792759.983639,
            2985875349.605083,
        ],
    ],
    [
        1659312000000,
        [
            -6903907195.768883,
            -2332750910.779006,
            2984727316.802642,
        ],
    ],
    [
        1659916800000,
        [
            -6903824011.295545,
            -2334708828.478912,
            2983578989.451255,
        ],
    ],
    [
        1660521600000,
        [
            -6903740233.190026,
            -2336666513.884975,
            2982430367.244936,
        ],
    ],
    [
        1661126400000,
        [
            -6903655860.606943,
            -2338623967.808811,
            2981281449.845192,
        ],
    ],
    [
        1661731200000,
        [
            -6903570892.630726,
            -2340581190.908705,
            2980132236.9687,
        ],
    ],
    [
        1662336000000,
        [
            -6903485328.392788,
            -2342538183.634301,
            2978982728.4271,
        ],
    ],
    [
        1662940800000,
        [
            -6903399167.208866,
            -2344494946.257034,
            2977832924.124448,
        ],
    ],
    [
        1663545600000,
        [
            -6903312408.708131,
            -2346451478.998858,
            2976682824.002696,
        ],
    ],
    [
        1664150400000,
        [
            -6903225052.861765,
            -2348407782.309549,
            2975532427.898721,
        ],
    ],
    [
        1664755200000,
        [
            -6903137099.589879,
            -2350363857.235147,
            2974381735.310167,
        ],
    ],
    [
        1665360000000,
        [
            -6903048547.678938,
            -2352319705.145371,
            2973230745.433213,
        ],
    ],
    [
        1665964800000,
        [
            -6902959394.649263,
            -2354275326.126875,
            2972079458.012205,
        ],
    ],
    [
        1666569600000,
        [
            -6902869638.901461,
            -2356230718.555909,
            2970927873.795829,
        ],
    ],
    [
        1667174400000,
        [
            -6902779280.645113,
            -2358185880.705089,
            2969775993.780509,
        ],
    ],
    [
        1667779200000,
        [
            -6902688321.051868,
            -2360140811.576427,
            2968623818.682831,
        ],
    ],
    [
        1668384000000,
        [
            -6902596761.601289,
            -2362095510.821001,
            2967471348.919374,
        ],
    ],
    [
        1668988800000,
        [
            -6902504603.866535,
            -2364049978.555562,
            2966318584.686475,
        ],
    ],
    [
        1669593600000,
        [
            -6902411849.46568,
            -2366004215.266501,
            2965165526.009613,
        ],
    ],
    [
        1670198400000,
        [
            -6902318500.05858,
            -2367958221.783436,
            2964012172.759385,
        ],
    ],
    [
        1670803200000,
        [
            -6902224557.358515,
            -2369911999.3134,
            2962858524.635624,
        ],
    ],
    [
        1671408000000,
        [
            -6902130023.123318,
            -2371865549.56974,
            2961704581.09781,
        ],
    ],
    [
        1672012800000,
        [
            -6902034898.961022,
            -2373818875.041334,
            2960550341.200305,
        ],
    ],
    [
        1672617600000,
        [
            -6901939185.53526,
            -2375771979.141252,
            2959395803.428878,
        ],
    ],
    [
        1673222400000,
        [
            -6901842881.484795,
            -2377724865.197436,
            2958240966.125331,
        ],
    ],
    [
        1673827200000,
        [
            -6901745984.405034,
            -2379677534.803064,
            2957085828.46712,
        ],
    ],
    [
        1674432000000,
        [
            -6901648492.929736,
            -2381629988.435028,
            2955930390.348699,
        ],
    ],
    [
        1675036800000,
        [
            -6901550406.645083,
            -2383582226.864629,
            2954774651.614376,
        ],
    ],
    [
        1675641600000,
        [
            -6901451725.221074,
            -2385534251.369878,
            2953618611.849718,
        ],
    ],
    [
        1676246400000,
        [
            -6901352448.039296,
            -2387486063.461714,
            2952462270.483685,
        ],
    ],
    [
        1676851200000,
        [
            -6901252574.149578,
            -2389437664.657315,
            2951305626.899409,
        ],
    ],
    [
        1677456000000,
        [
            -6901152102.336998,
            -2391389056.352376,
            2950148680.503444,
        ],
    ],
    [
        1678060800000,
        [
            -6901051031.228757,
            -2393340239.770592,
            2948991430.757979,
        ],
    ],
    [
        1678665600000,
        [
            -6900949359.416137,
            -2395291216.000638,
            2947833877.168158,
        ],
    ],
    [
        1679270400000,
        [
            -6900847085.518091,
            -2397241986.172532,
            2946676019.189423,
        ],
    ],
    [
        1679875200000,
        [
            -6900744207.904711,
            -2399192551.758678,
            2945517856.033772,
        ],
    ],
    [
        1680480000000,
        [
            -6900640723.726169,
            -2401142914.394608,
            2944359386.661628,
        ],
    ],
    [
        1681084800000,
        [
            -6900536628.553694,
            -2403093074.327769,
            2943200610.571274,
        ],
    ],
    [
        1681689600000,
        [
            -6900431918.444217,
            -2405043029.608529,
            2942041528.444418,
        ],
    ],
    [
        1682294400000,
        [
            -6900326591.297646,
            -2406992777.574022,
            2940882141.495115,
        ],
    ],
    [
        1682899200000,
        [
            -6900220646.206736,
            -2408942315.864584,
            2939722450.861868,
        ],
    ],
    [
        1683504000000,
        [
            -6900114082.825288,
            -2410891642.428401,
            2938562457.543606,
        ],
    ],
    [
        1684108800000,
        [
            -6900006901.200148,
            -2412840755.372524,
            2937402162.467137,
        ],
    ],
    [
        1684713600000,
        [
            -6899899101.78596,
            -2414789652.913145,
            2936241566.521624,
        ],
    ],
    [
        1685318400000,
        [
            -6899790685.49861,
            -2416738333.41169,
            2935080670.552054,
        ],
    ],
    [
        1685923200000,
        [
            -6899681653.768492,
            -2418686795.479116,
            2933919475.316772,
        ],
    ],
    [
        1686528000000,
        [
            -6899572008.563488,
            -2420635038.172568,
            2932757981.392708,
        ],
    ],
    [
        1687132800000,
        [
            -6899461752.245008,
            -2422583061.332573,
            2931596188.988112,
        ],
    ],
    [
        1687737600000,
        [
            -6899350886.864725,
            -2424530865.876425,
            2930434097.720312,
        ],
    ],
    [
        1688342400000,
        [
            -6899239412.985959,
            -2426478453.076283,
            2929271706.885928,
        ],
    ],
    [
        1688947200000,
        [
            -6899127330.254858,
            -2428425822.884518,
            2928109016.420595,
        ],
    ],
    [
        1689552000000,
        [
            -6899014639.541279,
            -2430372974.273943,
            2926946026.944048,
        ],
    ],
    [
        1690156800000,
        [
            -6898901343.078625,
            -2432319906.791908,
            2925782738.948329,
        ],
    ],
    [
        1690761600000,
        [
            -6898787443.502543,
            -2434266620.960953,
            2924619152.486919,
        ],
    ],
    [
        1691366400000,
        [
            -6898672943.330434,
            -2436213118.056602,
            2923455267.241167,
        ],
    ],
    [
        1691971200000,
        [
            -6898557844.80452,
            -2438159399.890013,
            2922291082.620674,
        ],
    ],
    [
        1692576000000,
        [
            -6898442149.858604,
            -2440105468.679536,
            2921126597.827894,
        ],
    ],
    [
        1693180800000,
        [
            -6898325860.125723,
            -2442051326.987811,
            2919961811.890851,
        ],
    ],
    [
        1693785600000,
        [
            -6898208976.962811,
            -2443996977.727837,
            2918796723.659727,
        ],
    ],
    [
        1694390400000,
        [
            -6898091501.435167,
            -2445942424.284656,
            2917631331.736502,
        ],
    ],
    [
        1694995200000,
        [
            -6897973434.019996,
            -2447887670.764843,
            2916465634.30626,
        ],
    ],
    [
        1695600000000,
        [
            -6897854773.62888,
            -2449832721.886945,
            2915299629.088838,
        ],
    ],
    [
        1696204800000,
        [
            -6897735516.92561,
            -2451777581.501053,
            2914133314.052681,
        ],
    ],
    [
        1696809600000,
        [
            -6897615660.089667,
            -2453722251.378187,
            2912966688.237442,
        ],
    ],
    [
        1697414400000,
        [
            -6897495200.444471,
            -2455666732.412301,
            2911799751.273361,
        ],
    ],
    [
        1698019200000,
        [
            -6897374135.937816,
            -2457611025.696434,
            2910632502.745094,
        ],
    ],
    [
        1698624000000,
        [
            -6897252464.45204,
            -2459555132.487896,
            2909464942.13149,
        ],
    ],
    [
        1699228800000,
        [
            -6897130183.626105,
            -2461499053.938787,
            2908297068.924174,
        ],
    ],
    [
        1699833600000,
        [
            -6897007290.919197,
            -2463442790.926263,
            2907128882.718587,
        ],
    ],
    [
        1700438400000,
        [
            -6896883783.746947,
            -2465386343.986576,
            2905960383.258067,
        ],
    ],
    [
        1701043200000,
        [
            -6896759659.639686,
            -2467329713.335789,
            2904791570.435149,
        ],
    ],
    [
        1701648000000,
        [
            -6896634916.3914,
            -2469272898.998615,
            2903622444.235528,
        ],
    ],
    [
        1702252800000,
        [
            -6896509552.08124,
            -2471215901.097795,
            2902453004.584548,
        ],
    ],
    [
        1702857600000,
        [
            -6896383564.600112,
            -2473158720.18552,
            2901283251.121477,
        ],
    ],
    [
        1703462400000,
        [
            -6896256950.57587,
            -2475101356.742593,
            2900113183.357457,
        ],
    ],
    [
        1704067200000,
        [
            -6896129705.695561,
            -2477043809.518254,
            2898942801.598908,
        ],
    ],
    [
        1704672000000,
        [
            -6896001826.976577,
            -2478986075.563754,
            2897772107.169173,
        ],
    ],
    [
        1705276800000,
        [
            -6895873313.3143,
            -2480928151.895106,
            2896601101.582059,
        ],
    ],
    [
        1705881600000,
        [
            -6895744164.600938,
            -2482870036.135869,
            2895429786.11268,
        ],
    ],
    [
        1706486400000,
        [
            -6895614381.185276,
            -2484811726.411433,
            2894258161.803746,
        ],
    ],
    [
        1707091200000,
        [
            -6895483963.71915,
            -2486753221.210353,
            2893086229.529532,
        ],
    ],
    [
        1707696000000,
        [
            -6895352913.131868,
            -2488694519.336241,
            2891913990.02449,
        ],
    ],
    [
        1708300800000,
        [
            -6895221230.635004,
            -2490635619.926097,
            2890741443.8791,
        ],
    ],
    [
        1708905600000,
        [
            -6895088917.732161,
            -2492576522.531206,
            2889568591.502226,
        ],
    ],
    [
        1709510400000,
        [
            -6894955976.188643,
            -2494517227.300707,
            2888395433.02379,
        ],
    ],
    [
        1710115200000,
        [
            -6894822407.757065,
            -2496457735.298046,
            2887221968.100387,
        ],
    ],
    [
        1710720000000,
        [
            -6894688213.239357,
            -2498398048.571614,
            2886048195.782605,
        ],
    ],
    [
        1711324800000,
        [
            -6894553391.544521,
            -2500338168.918361,
            2884874115.07926,
        ],
    ],
    [
        1711929600000,
        [
            -6894417941.072554,
            -2502278096.471056,
            2883699725.856061,
        ],
    ],
    [
        1712534400000,
        [
            -6894281861.524774,
            -2504217830.69904,
            2882525028.488272,
        ],
    ],
    [
        1713139200000,
        [
            -6894145153.485963,
            -2506157371.668587,
            2881350023.142889,
        ],
    ],
    [
        1713744000000,
        [
            -6894007817.577528,
            -2508096720.113434,
            2880174709.6511,
        ],
    ],
    [
        1714348800000,
        [
            -6893869854.127545,
            -2510035877.154866,
            2878999087.620714,
        ],
    ],
    [
        1714953600000,
        [
            -6893731263.121116,
            -2511974844.090435,
            2877823156.540238,
        ],
    ],
    [
        1715558400000,
        [
            -6893592044.242686,
            -2513913622.272845,
            2876646915.843699,
        ],
    ],
    [
        1716163200000,
        [
            -6893452196.954812,
            -2515852213.059846,
            2875470364.9408,
        ],
    ],
    [
        1716768000000,
        [
            -6893311720.588717,
            -2517790617.852841,
            2874293503.200634,
        ],
    ],
    [
        1717372800000,
        [
            -6893170614.353145,
            -2519728838.279693,
            2873116329.849794,
        ],
    ],
    [
        1717977600000,
        [
            -6893028876.933203,
            -2521666876.459838,
            2871938843.784225,
        ],
    ],
    [
        1718582400000,
        [
            -6892886505.436219,
            -2523604734.597888,
            2870761043.672565,
        ],
    ],
    [
        1719187200000,
        [
            -6892743495.394329,
            -2525542413.275956,
            2869582928.864905,
        ],
    ],
    [
        1719792000000,
        [
            -6892599843.019679,
            -2527479911.041542,
            2868404499.843935,
        ],
    ],
    [
        1720396800000,
        [
            -6892455546.152868,
            -2529417225.982905,
            2867225757.480159,
        ],
    ],
    [
        1721001600000,
        [
            -6892310603.505463,
            -2531354356.497994,
            2866046702.542484,
        ],
    ],
    [
        1721606400000,
        [
            -6892165014.13139,
            -2533291301.202417,
            2864867335.693909,
        ],
    ],
    [
        1722211200000,
        [
            -6892018777.326496,
            -2535228058.771137,
            2863687657.568429,
        ],
    ],
    [
        1722816000000,
        [
            -6891871892.678213,
            -2537164627.888734,
            2862507668.806812,
        ],
    ],
    [
        1723420800000,
        [
            -6891724360.145087,
            -2539101007.285783,
            2861327370.050602,
        ],
    ],
    [
        1724025600000,
        [
            -6891576180.13308,
            -2541037195.849402,
            2860146761.89701,
        ],
    ],
    [
        1724630400000,
        [
            -6891427353.529794,
            -2542973192.839019,
            2858965844.793778,
        ],
    ],
    [
        1725235200000,
        [
            -6891277881.523862,
            -2544908998.246593,
            2857784618.834836,
        ],
    ],
    [
        1725840000000,
        [
            -6891127764.792084,
            -2546844613.01622,
            2856603083.565427,
        ],
    ],
    [
        1726444800000,
        [
            -6890977002.429274,
            -2548780038.071987,
            2855421238.396799,
        ],
    ],
    [
        1727049600000,
        [
            -6890825592.983008,
            -2550715272.779914,
            2854239083.540714,
        ],
    ],
    [
        1727654400000,
        [
            -6890673536.453909,
            -2552650315.711946,
            2853056619.813388,
        ],
    ],
    [
        1728259200000,
        [
            -6890520834.091002,
            -2554585166.09303,
            2851873847.844992,
        ],
    ],
    [
        1728864000000,
        [
            -6890367487.462621,
            -2556519824.03527,
            2850690767.860863,
        ],
    ],
    [
        1729468800000,
        [
            -6890213498.021552,
            -2558454290.302186,
            2849507379.763776,
        ],
    ],
    [
        1730073600000,
        [
            -6890058866.982306,
            -2560388566.113626,
            2848323683.225634,
        ],
    ],
    [
        1730678400000,
        [
            -6889903595.299067,
            -2562322653.035781,
            2847139677.742901,
        ],
    ],
    [
        1731283200000,
        [
            -6889747683.678462,
            -2564256552.933883,
            2845955362.660987,
        ],
    ],
    [
        1731888000000,
        [
            -6889591132.604467,
            -2566190267.998211,
            2844770737.159579,
        ],
    ],
    [
        1732492800000,
        [
            -6889433942.301015,
            -2568123800.895189,
            2843585800.16363,
        ],
    ],
    [
        1733097600000,
        [
            -6889276112.344762,
            -2570057155.020565,
            2842400550.162565,
        ],
    ],
    [
        1733702400000,
        [
            -6889117640.593358,
            -2571990334.221743,
            2841214985.24127,
        ],
    ],
    [
        1734307200000,
        [
            -6888958522.816721,
            -2573923341.137143,
            2840029103.921981,
        ],
    ],
    [
        1734912000000,
        [
            -6888798754.749076,
            -2575856176.368768,
            2838842905.811428,
        ],
    ],
    [
        1735516800000,
        [
            -6888638333.332643,
            -2577788839.890265,
            2837656390.969625,
        ],
    ],
    [
        1736121600000,
        [
            -6888477256.025296,
            -2579721331.908076,
            2836469559.37007,
        ],
    ],
    [
        1736726400000,
        [
            -6888315520.195597,
            -2581653652.73327,
            2835282410.897655,
        ],
    ],
    [
        1737331200000,
        [
            -6888153123.00211,
            -2583585802.519285,
            2834094945.468866,
        ],
    ],
    [
        1737936000000,
        [
            -6887990061.475002,
            -2585517781.108372,
            2832907163.115659,
        ],
    ],
    [
        1738540800000,
        [
            -6887826332.658649,
            -2587449587.976759,
            2831719064.024016,
        ],
    ],
    [
        1739145600000,
        [
            -6887661933.774124,
            -2589381222.266896,
            2830530648.529392,
        ],
    ],
    [
        1739750400000,
        [
            -6887496862.365144,
            -2591312682.936206,
            2829341917.049806,
        ],
    ],
    [
        1740355200000,
        [
            -6887331116.278618,
            -2593243969.071934,
            2828152869.91481,
        ],
    ],
    [
        1740960000000,
        [
            -6887164693.07503,
            -2595175080.171651,
            2826963507.155514,
        ],
    ],
    [
        1741564800000,
        [
            -6886997588.994994,
            -2597106015.398485,
            2825773828.798082,
        ],
    ],
    [
        1742169600000,
        [
            -6886829799.739426,
            -2599036771.969874,
            2824583835.809722,
        ],
    ],
    [
        1742774400000,
        [
            -6886661322.702136,
            -2600967345.646119,
            2823393530.074894,
        ],
    ],
    [
        1743379200000,
        [
            -6886492157.132574,
            -2602897732.35175,
            2822202913.552982,
        ],
    ],
    [
        1743984000000,
        [
            -6886322303.248865,
            -2604827928.636565,
            2821011987.947805,
        ],
    ],
    [
        1744588800000,
        [
            -6886151761.784335,
            -2606757931.550566,
            2819820754.735586,
        ],
    ],
    [
        1745193600000,
        [
            -6885980533.867183,
            -2608687738.534953,
            2818629215.21896,
        ],
    ],
    [
        1745798400000,
        [
            -6885808620.999149,
            -2610617347.401492,
            2817437370.543801,
        ],
    ],
    [
        1746403200000,
        [
            -6885636025.05512,
            -2612546756.374053,
            2816245221.684508,
        ],
    ],
    [
        1747008000000,
        [
            -6885462748.281682,
            -2614475964.194827,
            2815052769.393896,
        ],
    ],
    [
        1747612800000,
        [
            -6885288793.236155,
            -2616404970.341201,
            2813860014.086926,
        ],
    ],
    [
        1748217600000,
        [
            -6885114162.418344,
            -2618333775.35859,
            2812666955.62962,
        ],
    ],
    [
        1748822400000,
        [
            -6884938857.204534,
            -2620262380.79478,
            2811473593.267482,
        ],
    ],
    [
        1749427200000,
        [
            -6884762877.136827,
            -2622190787.743166,
            2810279926.332742,
        ],
    ],
    [
        1750032000000,
        [
            -6884586221.657454,
            -2624118995.747169,
            2809085955.010958,
        ],
    ],
    [
        1750636800000,
        [
            -6884408891.569952,
            -2626047004.084399,
            2807891679.806936,
        ],
    ],
    [
        1751241600000,
        [
            -6884230888.374959,
            -2627974812.824879,
            2806697100.909983,
        ],
    ],
    [
        1751846400000,
        [
            -6884052213.483762,
            -2629902422.780759,
            2805502218.13763,
        ],
    ],
    [
        1752451200000,
        [
            -6883872867.938435,
            -2631829835.223722,
            2804307031.054969,
        ],
    ],
    [
        1753056000000,
        [
            -6883692852.367736,
            -2633757051.685378,
            2803111539.073171,
        ],
    ],
    [
        1753660800000,
        [
            -6883512167.019362,
            -2635684073.841341,
            2801915741.510402,
        ],
    ],
    [
        1754265600000,
        [
            -6883330811.824629,
            -2637610903.463526,
            2800719637.618933,
        ],
    ],
    [
        1754870400000,
        [
            -6883148786.46814,
            -2639537542.465526,
            2799523226.562492,
        ],
    ],
    [
        1755475200000,
        [
            -6882966090.343427,
            -2641463993.096451,
            2798326507.302109,
        ],
    ],
    [
        1756080000000,
        [
            -6882782722.0228,
            -2643390258.155263,
            2797129478.42051,
        ],
    ],
    [
        1756684800000,
        [
            -6882598678.175114,
            -2645316340.332039,
            2795932138.355776,
        ],
    ],
    [
        1757289600000,
        [
            -6882413953.988585,
            -2647242240.436423,
            2794734486.38582,
        ],
    ],
    [
        1757894400000,
        [
            -6882228545.487849,
            -2649167957.412397,
            2793536522.855564,
        ],
    ],
    [
        1758499200000,
        [
            -6882042450.072972,
            -2651093489.907598,
            2792338248.390284,
        ],
    ],
    [
        1759104000000,
        [
            -6881855665.718301,
            -2653018836.805007,
            2791139663.525479,
        ],
    ],
    [
        1759708800000,
        [
            -6881668190.547926,
            -2654943997.056911,
            2789940768.74977,
        ],
    ],
    [
        1760313600000,
        [
            -6881480022.7963,
            -2656868969.518326,
            2788741564.589359,
        ],
    ],
    [
        1760918400000,
        [
            -6881291160.893395,
            -2658793752.892968,
            2787542051.646626,
        ],
    ],
    [
        1761523200000,
        [
            -6881101603.575062,
            -2660718345.765802,
            2786342230.596333,
        ],
    ],
    [
        1762128000000,
        [
            -6880911349.989316,
            -2662642746.717135,
            2785142102.138935,
        ],
    ],
    [
        1762732800000,
        [
            -6880720399.747545,
            -2664566954.556428,
            2783941666.885056,
        ],
    ],
    [
        1763337600000,
        [
            -6880528752.706269,
            -2666490968.698688,
            2782740925.136452,
        ],
    ],
    [
        1763942400000,
        [
            -6880336408.061055,
            -2668414789.277075,
            2781539876.736846,
        ],
    ],
    [
        1764547200000,
        [
            -6880143363.482228,
            -2670338415.932269,
            2780338521.633978,
        ],
    ],
    [
        1765152000000,
        [
            -6879949616.595816,
            -2672261846.52412,
            2779136860.725952,
        ],
    ],
    [
        1765756800000,
        [
            -6879755166.74526,
            -2674185078.264392,
            2777934895.442862,
        ],
    ],
    [
        1766361600000,
        [
            -6879560014.518825,
            -2676108109.011523,
            2776732627.009656,
        ],
    ],
    [
        1766966400000,
        [
            -6879364160.896922,
            -2678030937.382702,
            2775530056.300672,
        ],
    ],
    [
        1767571200000,
        [
            -6879167606.904653,
            -2679953562.534582,
            2774327183.922745,
        ],
    ],
    [
        1768176000000,
        [
            -6878970353.524947,
            -2681875984.010217,
            2773124010.289141,
        ],
    ],
    [
        1768780800000,
        [
            -6878772401.690135,
            -2683798201.667982,
            2771920535.657004,
        ],
    ],
    [
        1769385600000,
        [
            -6878573752.2995,
            -2685720215.672526,
            2770716760.133583,
        ],
    ],
    [
        1769990400000,
        [
            -6878374406.238827,
            -2687642026.56523,
            2769512683.639455,
        ],
    ],
    [
        1770595200000,
        [
            -6878174364.305337,
            -2689563635.468144,
            2768308305.789922,
        ],
    ],
    [
        1771200000000,
        [
            -6877973626.703238,
            -2691485044.346803,
            2767103625.699794,
        ],
    ],
    [
        1771804800000,
        [
            -6877772191.897491,
            -2693406255.549253,
            2765898642.107706,
        ],
    ],
    [
        1772409600000,
        [
            -6877570056.6094,
            -2695327270.053849,
            2764693354.307969,
        ],
    ],
    [
        1773014400000,
        [
            -6877367218.015681,
            -2697248087.093705,
            2763487762.574886,
        ],
    ],
    [
        1773619200000,
        [
            -6877163674.551064,
            -2699168705.67952,
            2762281867.427794,
        ],
    ],
    [
        1774224000000,
        [
            -6876959425.083563,
            -2701089125.250063,
            2761075669.193183,
        ],
    ],
    [
        1774828800000,
        [
            -6876754468.368782,
            -2703009345.480055,
            2759869168.045669,
        ],
    ],
    [
        1775433600000,
        [
            -6876548802.946275,
            -2704929366.027925,
            2758662364.126977,
        ],
    ],
    [
        1776038400000,
        [
            -6876342427.204823,
            -2706849186.390519,
            2757455257.625528,
        ],
    ],
    [
        1776643200000,
        [
            -6876135339.501269,
            -2708768805.846953,
            2756247848.814457,
        ],
    ],
    [
        1777248000000,
        [
            -6875927538.29984,
            -2710688223.486592,
            2755040138.047587,
        ],
    ],
    [
        1777852800000,
        [
            -6875719022.288455,
            -2712607438.358859,
            2753832125.688922,
        ],
    ],
    [
        1778457600000,
        [
            -6875509790.287703,
            -2714526449.786156,
            2752623811.934751,
        ],
    ],
    [
        1779062400000,
        [
            -6875299840.527405,
            -2716445257.53693,
            2751415196.646287,
        ],
    ],
    [
        1779667200000,
        [
            -6875089169.721334,
            -2718363860.80188,
            2750206279.802232,
        ],
    ],
    [
        1780272000000,
        [
            -6874877774.300634,
            -2720282256.712071,
            2748997062.421237,
        ],
    ],
    [
        1780876800000,
        [
            -6874665652.482689,
            -2722200441.216364,
            2747787546.311972,
        ],
    ],
    [
        1781481600000,
        [
            -6874452804.105172,
            -2724118410.562119,
            2746577733.270509,
        ],
    ],
    [
        1782086400000,
        [
            -6874239229.787087,
            -2726036161.578404,
            2745367624.848618,
        ],
    ],
    [
        1782691200000,
        [
            -6874024930.57032,
            -2727953691.528139,
            2744157222.402793,
        ],
    ],
    [
        1783296000000,
        [
            -6873809907.843532,
            -2729870998.013933,
            2742946527.144205,
        ],
    ],
    [
        1783900800000,
        [
            -6873594163.34201,
            -2731788078.971956,
            2741735540.149522,
        ],
    ],
    [
        1784505600000,
        [
            -6873377699.16085,
            -2733704932.7282,
            2740524262.339511,
        ],
    ],
    [
        1785110400000,
        [
            -6873160517.759859,
            -2735621558.126007,
            2739312694.418185,
        ],
    ],
    [
        1785715200000,
        [
            -6872942621.883471,
            -2737537954.774761,
            2738100836.737671,
        ],
    ],
    [
        1786320000000,
        [
            -6872724014.100839,
            -2739454123.386445,
            2736888689.075875,
        ],
    ],
    [
        1786924800000,
        [
            -6872504695.651258,
            -2741370065.537375,
            2735676250.648201,
        ],
    ],
    [
        1787529600000,
        [
            -6872284666.060345,
            -2743285782.044917,
            2734463520.937942,
        ],
    ],
    [
        1788134400000,
        [
            -6872063925.139948,
            -2745201272.269619,
            2733250500.278197,
        ],
    ],
    [
        1788739200000,
        [
            -6871842474.052401,
            -2747116535.587497,
            2732037189.176365,
        ],
    ],
    [
        1789344000000,
        [
            -6871620314.482424,
            -2749031572.231783,
            2730823587.778187,
        ],
    ],
    [
        1789948800000,
        [
            -6871397447.931602,
            -2750946383.154701,
            2729609695.866856,
        ],
    ],
    [
        1790553600000,
        [
            -6871173875.487324,
            -2752860969.752705,
            2728395512.983099,
        ],
    ],
    [
        1791158400000,
        [
            -6870949597.787804,
            -2754775333.68149,
            2727181038.516563,
        ],
    ],
    [
        1791763200000,
        [
            -6870724615.050909,
            -2756689476.748223,
            2725966271.76152,
        ],
    ],
    [
        1792368000000,
        [
            -6870498927.131828,
            -2758603400.870621,
            2724751211.938912,
        ],
    ],
    [
        1792972800000,
        [
            -6870272533.576845,
            -2760517108.134948,
            2723535858.164326,
        ],
    ],
    [
        1793577600000,
        [
            -6870045433.523059,
            -2762430601.003757,
            2722320209.319313,
        ],
    ],
    [
        1794182400000,
        [
            -6869817625.03832,
            -2764343882.458892,
            2721104263.898801,
        ],
    ],
    [
        1794787200000,
        [
            -6869589104.083097,
            -2766256955.07656,
            2719888020.389571,
        ],
    ],
    [
        1795392000000,
        [
            -6869359865.386802,
            -2768169819.301488,
            2718671478.275006,
        ],
    ],
    [
        1795996800000,
        [
            -6869129904.698714,
            -2770082473.885448,
            2717454638.026436,
        ],
    ],
    [
        1796601600000,
        [
            -6868899218.953134,
            -2771994917.370428,
            2716237500.3209,
        ],
    ],
    [
        1797206400000,
        [
            -6868667805.482498,
            -2773907148.413074,
            2715020065.780229,
        ],
    ],
    [
        1797811200000,
        [
            -6868435661.697388,
            -2775819165.573875,
            2713802335.045699,
        ],
    ],
    [
        1798416000000,
        [
            -6868202785.105343,
            -2777730967.154871,
            2712584308.863368,
        ],
    ],
    [
        1799020800000,
        [
            -6867969173.432754,
            -2779642551.152198,
            2711365988.120399,
        ],
    ],
    [
        1799625600000,
        [
            -6867734824.768057,
            -2781553915.297573,
            2710147373.837792,
        ],
    ],
    [
        1800230400000,
        [
            -6867499737.697988,
            -2783465057.191188,
            2708928467.115231,
        ],
    ],
    [
        1800835200000,
        [
            -6867263911.369616,
            -2785375974.570273,
            2707709268.997331,
        ],
    ],
    [
        1801440000000,
        [
            -6867027345.217151,
            -2787286665.708909,
            2706489780.236351,
        ],
    ],
    [
        1802044800000,
        [
            -6866790037.970154,
            -2789197129.403342,
            2705270001.20294,
        ],
    ],
    [
        1802649600000,
        [
            -6866551987.071235,
            -2791107363.571105,
            2704049932.580591,
        ],
    ],
    [
        1803254400000,
        [
            -6866313190.52014,
            -2793017364.323359,
            2702829576.059182,
        ],
    ],
    [
        1803859200000,
        [
            -6866073648.295099,
            -2794927127.393215,
            2701608933.726266,
        ],
    ],
    [
        1804464000000,
        [
            -6865833361.664165,
            -2796836649.255219,
            2700388007.404502,
        ],
    ],
    [
        1805068800000,
        [
            -6865592332.406412,
            -2798745927.154736,
            2699166798.56167,
        ],
    ],
    [
        1805673600000,
        [
            -6865350562.518,
            -2800654958.919549,
            2697945308.386686,
        ],
    ],
    [
        1806278400000,
        [
            -6865108054.130646,
            -2802563742.849381,
            2696723537.845236,
        ],
    ],
    [
        1806883200000,
        [
            -6864864809.489855,
            -2804472277.679511,
            2695501487.701162,
        ],
    ],
    [
        1807488000000,
        [
            -6864620830.952106,
            -2806380562.602525,
            2694279158.507803,
        ],
    ],
    [
        1808092800000,
        [
            -6864376120.974231,
            -2808288597.372947,
            2693056550.55328,
        ],
    ],
    [
        1808697600000,
        [
            -6864130681.971975,
            -2810196382.548135,
            2691833663.718404,
        ],
    ],
    [
        1809302400000,
        [
            -6863884515.670707,
            -2812103919.721327,
            2690610497.285143,
        ],
    ],
    [
        1809907200000,
        [
            -6863637621.925156,
            -2814011210.828485,
            2689387050.183854,
        ],
    ],
    [
        1810512000000,
        [
            -6863389999.121796,
            -2815918256.37446,
            2688163321.980848,
        ],
    ],
    [
        1811116800000,
        [
            -6863141646.389797,
            -2817825055.507283,
            2686939313.065221,
        ],
    ],
    [
        1811721600000,
        [
            -6862892563.968789,
            -2819731607.537509,
            2685715023.87184,
        ],
    ],
    [
        1812326400000,
        [
            -6862642752.317595,
            -2821637912.371761,
            2684490454.553182,
        ],
    ],
    [
        1812931200000,
        [
            -6862392211.634171,
            -2823543970.263157,
            2683265605.058098,
        ],
    ],
    [
        1813536000000,
        [
            -6862140941.770289,
            -2825449781.558207,
            2682040475.252968,
        ],
    ],
    [
        1814140800000,
        [
            -6861888942.288231,
            -2827355346.547516,
            2680815065.001914,
        ],
    ],
    [
        1814745600000,
        [
            -6861636212.566159,
            -2829260665.399074,
            2679589374.207979,
        ],
    ],
    [
        1815350400000,
        [
            -6861382751.924212,
            -2831165738.175967,
            2678363402.811688,
        ],
    ],
    [
        1815955200000,
        [
            -6861128559.716911,
            -2833070564.983579,
            2677137150.717542,
        ],
    ],
    [
        1816560000000,
        [
            -6860873635.166759,
            -2834975146.270229,
            2675910617.612601,
        ],
    ],
    [
        1817164800000,
        [
            -6860617976.52021,
            -2836879482.854704,
            2674683802.861863,
        ],
    ],
    [
        1817769600000,
        [
            -6860361580.322017,
            -2838783574.633089,
            2673456706.122744,
        ],
    ],
    [
        1818374400000,
        [
            -6860104443.069341,
            -2840687419.328576,
            2672229328.184634,
        ],
    ],
    [
        1818979200000,
        [
            -6859846563.016228,
            -2842591013.685426,
            2671001670.519793,
        ],
    ],
    [
        1819584000000,
        [
            -6859587939.751604,
            -2844494354.753215,
            2669773734.556631,
        ],
    ],
    [
        1820188800000,
        [
            -6859328573.445667,
            -2846397440.019611,
            2668545521.534959,
        ],
    ],
    [
        1820793600000,
        [
            -6859068464.586091,
            -2848300267.249262,
            2667317032.569931,
        ],
    ],
    [
        1821398400000,
        [
            -6858807613.94949,
            -2850202834.402504,
            2666088268.698404,
        ],
    ],
    [
        1822003200000,
        [
            -6858546022.63026,
            -2852105139.641369,
            2664859230.884937,
        ],
    ],
    [
        1822608000000,
        [
            -6858283692.076632,
            -2854007181.399837,
            2663629919.994214,
        ],
    ],
    [
        1823212800000,
        [
            -6858020624.11025,
            -2855908958.5338,
            2662400336.718884,
        ],
    ],
    [
        1823817600000,
        [
            -6857756820.829648,
            -2857810470.602266,
            2661170481.424676,
        ],
    ],
    [
        1824422400000,
        [
            -6857492284.056008,
            -2859711718.191608,
            2659940353.924284,
        ],
    ],
    [
        1825027200000,
        [
            -6857227014.14068,
            -2861612702.471903,
            2658709953.594374,
        ],
    ],
    [
        1825632000000,
        [
            -6856961009.987809,
            -2863513423.484375,
            2657479280.29528,
        ],
    ],
    [
        1826236800000,
        [
            -6856694271.21109,
            -2865413879.892023,
            2656248334.729095,
        ],
    ],
    [
        1826841600000,
        [
            -6856426798.791568,
            -2867314070.54238,
            2655017117.673199,
        ],
    ],
    [
        1827446400000,
        [
            -6856158594.167259,
            -2869213995.099771,
            2653785629.547219,
        ],
    ],
    [
        1828051200000,
        [
            -6855889658.62564,
            -2871113653.853558,
            2652553870.450446,
        ],
    ],
    [
        1828656000000,
        [
            -6855619993.125682,
            -2873013047.466285,
            2651321840.274868,
        ],
    ],
    [
        1829260800000,
        [
            -6855349598.281164,
            -2874912176.815363,
            2650089538.783969,
        ],
    ],
    [
        1829865600000,
        [
            -6855078474.396519,
            -2876811042.908499,
            2648856965.656729,
        ],
    ],
    [
        1830470400000,
        [
            -6854806621.526205,
            -2878709646.86832,
            2647624120.496352,
        ],
    ],
    [
        1831075200000,
        [
            -6854534039.515795,
            -2880607990.025122,
            2646391002.778717,
        ],
    ],
    [
        1831680000000,
        [
            -6854260727.837143,
            -2882506074.157102,
            2645157611.700246,
        ],
    ],
    [
        1832284800000,
        [
            -6853986684.795466,
            -2884403901.555042,
            2643923946.05416,
        ],
    ],
    [
        1832889600000,
        [
            -6853711906.606963,
            -2886301473.852441,
            2642690004.752749,
        ],
    ],
    [
        1833494400000,
        [
            -6853436388.708703,
            -2888198790.478673,
            2641455787.782508,
        ],
    ],
    [
        1834099200000,
        [
            -6853160127.802999,
            -2890095849.499192,
            2640221295.960595,
        ],
    ],
    [
        1834704000000,
        [
            -6852883121.680714,
            -2891992648.963984,
            2638986530.190295,
        ],
    ],
    [
        1835308800000,
        [
            -6852605368.46275,
            -2893889187.070575,
            2637751491.29038,
        ],
    ],
    [
        1835913600000,
        [
            -6852326866.347874,
            -2895785461.937385,
            2636516180.086305,
        ],
    ],
    [
        1836518400000,
        [
            -6852047613.651371,
            -2897681471.455138,
            2635280597.491267,
        ],
    ],
    [
        1837123200000,
        [
            -6851767608.928376,
            -2899577213.248197,
            2634044744.538888,
        ],
    ],
    [
        1837728000000,
        [
            -6851486851.115777,
            -2901472684.722394,
            2632808622.373285,
        ],
    ],
    [
        1838332800000,
        [
            -6851205339.664706,
            -2903367883.209776,
            2631572232.188061,
        ],
    ],
    [
        1838937600000,
        [
            -6850923074.576975,
            -2905262806.259485,
            2630335575.078852,
        ],
    ],
    [
        1839542400000,
        [
            -6850640056.036551,
            -2907157452.030099,
            2629098651.801095,
        ],
    ],
    [
        1840147200000,
        [
            -6850356283.337383,
            -2909051819.089223,
            2627861462.772672,
        ],
    ],
    [
        1840752000000,
        [
            -6850071754.645768,
            -2910945904.854326,
            2626624008.889731,
        ],
    ],
    [
        1841356800000,
        [
            -6849786469.094018,
            -2912839705.072162,
            2625386292.029787,
        ],
    ],
    [
        1841961600000,
        [
            -6849500427.80393,
            -2914733215.416566,
            2624148314.312418,
        ],
    ],
    [
        1842566400000,
        [
            -6849213633.052978,
            -2916626432.393137,
            2622910077.5376,
        ],
    ],
    [
        1843171200000,
        [
            -6848926087.582408,
            -2918519353.290228,
            2621671583.147782,
        ],
    ],
    [
        1843776000000,
        [
            -6848637794.354375,
            -2920411976.005211,
            2620432832.302456,
        ],
    ],
    [
        1844380800000,
        [
            -6848348756.481997,
            -2922304298.955523,
            2619193825.924502,
        ],
    ],
    [
        1844985600000,
        [
            -6848058977.206158,
            -2924196321.058655,
            2617954564.713579,
        ],
    ],
    [
        1845590400000,
        [
            -6847768459.886707,
            -2926088041.77035,
            2616715049.128845,
        ],
    ],
    [
        1846195200000,
        [
            -6847477207.975125,
            -2927979461.213104,
            2615475279.320422,
        ],
    ],
    [
        1846800000000,
        [
            -6847185224.813159,
            -2929870580.442804,
            2614235254.967896,
        ],
    ],
    [
        1847404800000,
        [
            -6846892512.848427,
            -2931761401.619049,
            2612994975.108748,
        ],
    ],
    [
        1848009600000,
        [
            -6846599072.504007,
            -2933651927.059218,
            2611754438.526147,
        ],
    ],
    [
        1848614400000,
        [
            -6846304903.023203,
            -2935542157.545864,
            2610513644.739244,
        ],
    ],
    [
        1849219200000,
        [
            -6846010004.574205,
            -2937432092.833986,
            2609272593.947813,
        ],
    ],
    [
        1849824000000,
        [
            -6845714378.231077,
            -2939321733.0846,
            2608031286.261032,
        ],
    ],
    [
        1850428800000,
        [
            -6845418025.07764,
            -2941211079.107935,
            2606789721.470366,
        ],
    ],
    [
        1851033600000,
        [
            -6845120945.797908,
            -2943100132.079873,
            2605547899.153484,
        ],
    ],
    [
        1851638400000,
        [
            -6844823140.610353,
            -2944988893.295113,
            2604305818.793526,
        ],
    ],
    [
        1852243200000,
        [
            -6844524609.320369,
            -2946877364.018685,
            2603063479.857562,
        ],
    ],
    [
        1852848000000,
        [
            -6844225351.416479,
            -2948765545.414051,
            2601820881.838372,
        ],
    ],
    [
        1853452800000,
        [
            -6843925366.18542,
            -2950653438.556582,
            2600578024.252482,
        ],
    ],
    [
        1854057600000,
        [
            -6843624652.777327,
            -2952541044.583393,
            2599334906.560377,
        ],
    ],
    [
        1854662400000,
        [
            -6843323209.95133,
            -2954428364.974777,
            2598091527.983729,
        ],
    ],
    [
        1855267200000,
        [
            -6843021035.128101,
            -2956315401.400344,
            2596847887.484095,
        ],
    ],
    [
        1855872000000,
        [
            -6842718123.950303,
            -2958202154.192158,
            2595603984.528677,
        ],
    ],
    [
        1856476800000,
        [
            -6842414472.284083,
            -2960088621.415958,
            2594359819.790735,
        ],
    ],
    [
        1857081600000,
        [
            -6842110077.684699,
            -2961974800.289341,
            2593115394.54202,
        ],
    ],
    [
        1857686400000,
        [
            -6841804938.796881,
            -2963860688.236525,
            2591870710.026707,
        ],
    ],
    [
        1858291200000,
        [
            -6841499054.713038,
            -2965746282.899132,
            2590625767.390016,
        ],
    ],
    [
        1858896000000,
        [
            -6841192424.805434,
            -2967631581.969916,
            2589380567.751782,
        ],
    ],
    [
        1859500800000,
        [
            -6840885048.75301,
            -2969516583.125246,
            2588135112.248511,
        ],
    ],
    [
        1860105600000,
        [
            -6840576926.611769,
            -2971401284.046422,
            2586889402.033316,
        ],
    ],
    [
        1860710400000,
        [
            -6840268058.887431,
            -2973285682.511094,
            2585643438.23922,
        ],
    ],
    [
        1861315200000,
        [
            -6839958446.581374,
            -2975169776.577234,
            2584397221.890527,
        ],
    ],
    [
        1861920000000,
        [
            -6839648091.081027,
            -2977053564.909118,
            2583150753.722259,
        ],
    ],
    [
        1862524800000,
        [
            -6839336993.510953,
            -2978937047.083114,
            2581904033.954294,
        ],
    ],
    [
        1863129600000,
        [
            -6839025153.565196,
            -2980820222.930207,
            2580657062.525966,
        ],
    ],
    [
        1863734400000,
        [
            -6838712569.985152,
            -2982703090.848524,
            2579409840.050892,
        ],
    ],
    [
        1864339200000,
        [
            -6838399242.740217,
            -2984585648.036139,
            2578162367.921831,
        ],
    ],
    [
        1864944000000,
        [
            -6838085173.286207,
            -2986467892.070548,
            2576914647.496233,
        ],
    ],
    [
        1865548800000,
        [
            -6837770363.623262,
            -2988349821.367922,
            2575666679.755095,
        ],
    ],
    [
        1866153600000,
        [
            -6837454815.771317,
            -2990231434.980522,
            2574418465.357923,
        ],
    ],
    [
        1866758400000,
        [
            -6837138531.620324,
            -2992112732.389096,
            2573170004.738433,
        ],
    ],
    [
        1867363200000,
        [
            -6836821512.908564,
            -2993993713.386268,
            2571921298.164206,
        ],
    ],
    [
        1867968000000,
        [
            -6836503761.241367,
            -2995874378.027477,
            2570672345.763677,
        ],
    ],
    [
        1868572800000,
        [
            -6836185278.125641,
            -2997754726.650874,
            2569423147.517212,
        ],
    ],
    [
        1869177600000,
        [
            -6835866064.966693,
            -2999634760.011045,
            2568173703.182758,
        ],
    ],
    [
        1869782400000,
        [
            -6835546122.798115,
            -3001514479.545387,
            2566924012.122313,
        ],
    ],
    [
        1870387200000,
        [
            -6835225451.335513,
            -3003393887.321537,
            2565674073.228105,
        ],
    ],
    [
        1870992000000,
        [
            -6834904048.228321,
            -3005272984.631595,
            2564423885.5917,
        ],
    ],
    [
        1871596800000,
        [
            -6834581910.732469,
            -3007151770.716127,
            2563173449.354293,
        ],
    ],
    [
        1872201600000,
        [
            -6834259037.423961,
            -3009030243.917616,
            2561922765.263216,
        ],
    ],
    [
        1872806400000,
        [
            -6833935427.728819,
            -3010908402.828265,
            2560671834.005198,
        ],
    ],
    [
        1873411200000,
        [
            -6833611081.204994,
            -3012786246.302281,
            2559420656.120817,
        ],
    ],
    [
        1874016000000,
        [
            -6833285997.33779,
            -3014663773.203419,
            2558169232.114126,
        ],
    ],
    [
        1874620800000,
        [
            -6832960175.585612,
            -3016540982.247724,
            2556917562.538195,
        ],
    ],
    [
        1875225600000,
        [
            -6832633615.499814,
            -3018417871.950068,
            2555665648.033943,
        ],
    ],
    [
        1875830400000,
        [
            -6832306316.865351,
            -3020294440.655978,
            2554413489.326829,
        ],
    ],
    [
        1876435200000,
        [
            -6831978279.831968,
            -3022170686.677936,
            2553161087.168168,
        ],
    ],
    [
        1877040000000,
        [
            -6831649504.924874,
            -3024046608.58842,
            2551908442.181672,
        ],
    ],
    [
        1877644800000,
        [
            -6831319992.578788,
            -3025922205.568532,
            2550655554.632332,
        ],
    ],
    [
        1878249600000,
        [
            -6830989742.041196,
            -3027797476.972646,
            2549402424.55004,
        ],
    ],
    [
        1878854400000,
        [
            -6830658751.558935,
            -3029672420.676374,
            2548149052.637231,
        ],
    ],
    [
        1879459200000,
        [
            -6830327020.614325,
            -3031547032.993625,
            2546895440.551535,
        ],
    ],
    [
        1880064000000,
        [
            -6829994550.552379,
            -3033421310.335036,
            2545641590.091909,
        ],
    ],
    [
        1880668800000,
        [
            -6829661343.685751,
            -3035295249.896994,
            2544387502.745087,
        ],
    ],
    [
        1881273600000,
        [
            -6829327402.70853,
            -3037168849.557611,
            2543133179.687532,
        ],
    ],
    [
        1881878400000,
        [
            -6828992730.510936,
            -3039042107.721835,
            2541878621.855705,
        ],
    ],
    [
        1882483200000,
        [
            -6828657330.131456,
            -3040915023.254736,
            2540623829.98279,
        ],
    ],
    [
        1883088000000,
        [
            -6828321204.743704,
            -3042787595.480057,
            2539368804.603309,
        ],
    ],
    [
        1883692800000,
        [
            -6827984357.6517,
            -3044659824.23882,
            2538113546.025505,
        ],
    ],
    [
        1884297600000,
        [
            -6827646792.251713,
            -3046531710.046739,
            2536858054.246382,
        ],
    ],
    [
        1884902400000,
        [
            -6827308511.767338,
            -3048403254.385548,
            2535602328.770537,
        ],
    ],
    [
        1885507200000,
        [
            -6826969518.337073,
            -3050274459.781761,
            2534346368.474243,
        ],
    ],
    [
        1886112000000,
        [
            -6826629812.020367,
            -3052145328.610232,
            2533090172.141097,
        ],
    ],
    [
        1886716800000,
        [
            -6826289392.077209,
            -3054015861.593719,
            2531833739.394488,
        ],
    ],
    [
        1887321600000,
        [
            -6825948258.853626,
            -3055886058.695168,
            2530577070.413457,
        ],
    ],
    [
        1887926400000,
        [
            -6825606413.440469,
            -3057755920.402458,
            2529320165.207032,
        ],
    ],
    [
        1888531200000,
        [
            -6825263856.819366,
            -3059625447.8133,
            2528063023.475325,
        ],
    ],
    [
        1889136000000,
        [
            -6824920589.526359,
            -3061494642.336985,
            2526805644.727993,
        ],
    ],
    [
        1889740800000,
        [
            -6824576611.610452,
            -3063363505.46068,
            2525548028.397916,
        ],
    ],
    [
        1890345600000,
        [
            -6824231922.69099,
            -3065232038.608882,
            2524290173.914665,
        ],
    ],
    [
        1890950400000,
        [
            -6823886522.054708,
            -3067100243.076255,
            2523032080.742374,
        ],
    ],
    [
        1891555200000,
        [
            -6823540408.767935,
            -3068968120.049988,
            2521773748.371109,
        ],
    ],
    [
        1892160000000,
        [
            -6823193581.715896,
            -3070835670.776753,
            2520515176.223449,
        ],
    ],
    [
        1892764800000,
        [
            -6822846039.252434,
            -3072702896.826318,
            2519256363.46941,
        ],
    ],
    [
        1893369600000,
        [
            -6822497778.182727,
            -3074569799.736086,
            2517997309.103632,
        ],
    ],
    [
        1893974400000,
        [
            -6822148793.688745,
            -3076436379.32802,
            2516738012.83049,
        ],
    ],
    [
        1894579200000,
        [
            -6821799081.570246,
            -3078302633.186294,
            2515478475.570388,
        ],
    ],
    [
        1895184000000,
        [
            -6821448639.322104,
            -3080168558.216897,
            2514218698.734842,
        ],
    ],
    [
        1895788800000,
        [
            -6821097465.421176,
            -3082034151.480026,
            2512958683.70622,
        ],
    ],
    [
        1896393600000,
        [
            -6820745558.794353,
            -3083899410.123971,
            2511698431.818089,
        ],
    ],
    [
        1896998400000,
        [
            -6820392918.7242,
            -3085764331.235439,
            2510437944.42735,
        ],
    ],
    [
        1897603200000,
        [
            -6820039544.911283,
            -3087628911.799329,
            2509177222.945819,
        ],
    ],
    [
        1898208000000,
        [
            -6819685437.56666,
            -3089493148.747089,
            2507916268.829102,
        ],
    ],
    [
        1898812800000,
        [
            -6819330597.49983,
            -3091357039.079808,
            2506655083.526255,
        ],
    ],
    [
        1899417600000,
        [
            -6818975026.165516,
            -3093220580.09504,
            2505393668.370633,
        ],
    ],
    [
        1900022400000,
        [
            -6818618725.506049,
            -3095083769.759102,
            2504132024.372344,
        ],
    ],
    [
        1900627200000,
        [
            -6818261697.176369,
            -3096946606.967153,
            2502870152.006855,
        ],
    ],
    [
        1901232000000,
        [
            -6817903941.445774,
            -3098809090.654208,
            2501608051.583775,
        ],
    ],
    [
        1901836800000,
        [
            -6817545458.120465,
            -3100671218.231564,
            2500345724.185009,
        ],
    ],
    [
        1902441600000,
        [
            -6817186248.593103,
            -3102532986.267487,
            2499083171.520134,
        ],
    ],
    [
        1903046400000,
        [
            -6816826315.7198,
            -3104394391.987455,
            2497820395.118009,
        ],
    ],
    [
        1903651200000,
        [
            -6816465662.876098,
            -3106255433.567132,
            2496557396.077272,
        ],
    ],
    [
        1904256000000,
        [
            -6816104293.495635,
            -3108116109.917198,
            2495294175.137311,
        ],
    ],
    [
        1904860800000,
        [
            -6815742210.931767,
            -3109976420.500294,
            2494030732.764461,
        ],
    ],
    [
        1905465600000,
        [
            -6815379418.423219,
            -3111836365.233279,
            2492767069.20233,
        ],
    ],
    [
        1906070400000,
        [
            -6815015919.094002,
            -3113695944.451762,
            2491503184.491321,
        ],
    ],
    [
        1906675200000,
        [
            -6814651715.964899,
            -3115555158.945476,
            2490239078.450459,
        ],
    ],
    [
        1907280000000,
        [
            -6814286811.907001,
            -3117414010.114943,
            2488974750.58738,
        ],
    ],
    [
        1907884800000,
        [
            -6813921209.261979,
            -3119272500.236586,
            2487710199.914891,
        ],
    ],
    [
        1908489600000,
        [
            -6813554908.773039,
            -3121130632.241189,
            2486445424.955169,
        ],
    ],
    [
        1909094400000,
        [
            -6813187909.108994,
            -3122988408.101151,
            2485180424.547827,
        ],
    ],
    [
        1909699200000,
        [
            -6812820208.832092,
            -3124845827.904414,
            2483915198.543705,
        ],
    ],
    [
        1910304000000,
        [
            -6812451807.722309,
            -3126702891.222829,
            2482649747.205749,
        ],
    ],
    [
        1910908800000,
        [
            -6812082706.099959,
            -3128559598.029628,
            2481384070.64302,
        ],
    ],
    [
        1911513600000,
        [
            -6811712904.176101,
            -3130415948.5902,
            2480118168.79596,
        ],
    ],
    [
        1912118400000,
        [
            -6811342401.896454,
            -3132271943.192629,
            2478852041.558582,
        ],
    ],
    [
        1912723200000,
        [
            -6810971198.997948,
            -3134127581.982743,
            2477585688.867315,
        ],
    ],
    [
        1913328000000,
        [
            -6810599295.130234,
            -3135982864.896756,
            2476319110.74518,
        ],
    ],
    [
        1913932800000,
        [
            -6810226689.999248,
            -3137837791.678601,
            2475052307.303991,
        ],
    ],
    [
        1914537600000,
        [
            -6809853383.498252,
            -3139692362.009604,
            2473785278.686443,
        ],
    ],
    [
        1915142400000,
        [
            -6809479375.686137,
            -3141546575.801637,
            2472518024.906369,
        ],
    ],
    [
        1915747200000,
        [
            -6809104666.216682,
            -3143400433.476564,
            2471250545.640841,
        ],
    ],
    [
        1916352000000,
        [
            -6808729253.278992,
            -3145253935.267429,
            2469982840.495558,
        ],
    ],
    [
        1916956800000,
        [
            -6808353134.253199,
            -3147107079.566307,
            2468714909.958525,
        ],
    ],
    [
        1917561600000,
        [
            -6807976307.961601,
            -3148959863.280608,
            2467446755.447157,
        ],
    ],
    [
        1918166400000,
        [
            -6807598774.924116,
            -3150812283.454105,
            2466178378.473708,
        ],
    ],
    [
        1918771200000,
        [
            -6807220536.468934,
            -3152664337.753278,
            2464909780.29871,
        ],
    ],
    [
        1919376000000,
        [
            -6806841594.260583,
            -3154516024.327019,
            2463640961.962543,
        ],
    ],
    [
        1919980800000,
        [
            -6806461950.177177,
            -3156367341.671952,
            2462371924.350045,
        ],
    ],
    [
        1920585600000,
        [
            -6806081606.295838,
            -3158218288.587585,
            2461102668.217909,
        ],
    ],
    [
        1921190400000,
        [
            -6805700564.903475,
            -3160068864.195538,
            2459833194.189799,
        ],
    ],
    [
        1921795200000,
        [
            -6805318828.510227,
            -3161919068.023914,
            2458563502.716136,
        ],
    ],
    [
        1922400000000,
        [
            -6804936399.810779,
            -3163768900.201661,
            2457293593.968771,
        ],
    ],
    [
        1923004800000,
        [
            -6804553281.357154,
            -3165618361.775937,
            2456023467.639043,
        ],
    ],
    [
        1923609600000,
        [
            -6804169474.541029,
            -3167467454.67445,
            2454753122.852942,
        ],
    ],
    [
        1924214400000,
        [
            -6803784978.834682,
            -3169316180.292793,
            2453482558.846622,
        ],
    ],
    [
        1924819200000,
        [
            -6803399793.46373,
            -3171164538.303746,
            2452211775.774385,
        ],
    ],
    [
        1925424000000,
        [
            -6803013918.984615,
            -3173012527.874849,
            2450940774.219404,
        ],
    ],
    [
        1926028800000,
        [
            -6802627356.69664,
            -3174860148.779857,
            2449669554.535909,
        ],
    ],
    [
        1926633600000,
        [
            -6802240107.858793,
            -3176707401.377956,
            2448398116.775295,
        ],
    ],
    [
        1927238400000,
        [
            -6801852173.417589,
            -3178554286.335076,
            2447126460.802315,
        ],
    ],
    [
        1927843200000,
        [
            -6801463553.980497,
            -3180400804.427608,
            2445854586.39215,
        ],
    ],
    [
        1928448000000,
        [
            -6801074249.867998,
            -3182246956.433453,
            2444582493.28856,
        ],
    ],
    [
        1929052800000,
        [
            -6800684261.197343,
            -3184092743.093606,
            2443310181.227313,
        ],
    ],
    [
        1929657600000,
        [
            -6800293587.971422,
            -3185938165.166936,
            2442037649.910209,
        ],
    ],
    [
        1930262400000,
        [
            -6799902230.060624,
            -3187783223.633651,
            2440764898.888597,
        ],
    ],
    [
        1930867200000,
        [
            -6799510186.716424,
            -3189627919.937874,
            2439491927.377704,
        ],
    ],
    [
        1931472000000,
        [
            -6799117455.498794,
            -3191472255.409226,
            2438218734.449262,
        ],
    ],
    [
        1932076800000,
        [
            -6798724032.59452,
            -3193316229.512066,
            2436945319.995245,
        ],
    ],
    [
        1932681600000,
        [
            -6798329915.136261,
            -3195159839.765023,
            2435671685.007604,
        ],
    ],
    [
        1933286400000,
        [
            -6797935101.84762,
            -3197003083.335017,
            2434397830.791182,
        ],
    ],
    [
        1933891200000,
        [
            -6797539592.249647,
            -3198845957.641891,
            2433123758.557461,
        ],
    ],
    [
        1934496000000,
        [
            -6797143386.210942,
            -3200688460.223334,
            2431849469.450585,
        ],
    ],
    [
        1935100800000,
        [
            -6796746483.893121,
            -3202530588.584426,
            2430574964.624107,
        ],
    ],
    [
        1935705600000,
        [
            -6796348885.825568,
            -3204372340.159169,
            2429300245.272826,
        ],
    ],
    [
        1936310400000,
        [
            -6795950593.005006,
            -3206213712.358524,
            2428025312.622376,
        ],
    ],
    [
        1936915200000,
        [
            -6795551606.98967,
            -3208054702.698023,
            2426750167.876929,
        ],
    ],
    [
        1937520000000,
        [
            -6795151929.940442,
            -3209895309.041236,
            2425474812.100424,
        ],
    ],
    [
        1938124800000,
        [
            -6794751564.405475,
            -3211735529.986876,
            2424199245.995092,
        ],
    ],
    [
        1938729600000,
        [
            -6794350512.427182,
            -3213575365.025761,
            2422923469.732997,
        ],
    ],
    [
        1939334400000,
        [
            -6793948774.60543,
            -3215414813.401759,
            2421647483.475333,
        ],
    ],
    [
        1939939200000,
        [
            -6793546351.456303,
            -3217253872.76174,
            2420371288.242016,
        ],
    ],
    [
        1940544000000,
        [
            -6793143245.228641,
            -3219092540.212337,
            2419094885.54239,
        ],
    ],
    [
        1941148800000,
        [
            -6792739459.475952,
            -3220930813.666587,
            2417818276.617692,
        ],
    ],
    [
        1941753600000,
        [
            -6792334998.163343,
            -3222768691.990979,
            2416541462.275264,
        ],
    ],
    [
        1942358400000,
        [
            -6791929865.279165,
            -3224606174.785679,
            2415264442.969991,
        ],
    ],
    [
        1942963200000,
        [
            -6791524064.719245,
            -3226443262.223288,
            2413987218.881631,
        ],
    ],
    [
        1943568000000,
        [
            -6791117600.254406,
            -3228279954.968149,
            2412709789.956637,
        ],
    ],
    [
        1944172800000,
        [
            -6790710475.526054,
            -3230116254.155395,
            2411432155.919828,
        ],
    ],
    [
        1944777600000,
        [
            -6790302694.046658,
            -3231952161.445422,
            2410154316.245162,
        ],
    ],
    [
        1945382400000,
        [
            -6789894259.115056,
            -3233787679.207508,
            2408876270.047587,
        ],
    ],
    [
        1945987200000,
        [
            -6789485173.323943,
            -3235622810.772875,
            2407598015.894468,
        ],
    ],
    [
        1946592000000,
        [
            -6789075437.410241,
            -3237457560.012311,
            2406319551.90872,
        ],
    ],
    [
        1947196800000,
        [
            -6788665050.135363,
            -3239291929.586034,
            2405040876.687,
        ],
    ],
    [
        1947801600000,
        [
            -6788254010.444098,
            -3241125920.434364,
            2403761989.790273,
        ],
    ],
    [
        1948406400000,
        [
            -6787842318.367483,
            -3242959533.264037,
            2402482891.037355,
        ],
    ],
    [
        1949011200000,
        [
            -6787429974.214565,
            -3244792769.233056,
            2401203580.048652,
        ],
    ],
    [
        1949616000000,
        [
            -6787016978.003071,
            -3246625629.75233,
            2399924056.286019,
        ],
    ],
    [
        1950220800000,
        [
            -6786603329.346641,
            -3248458116.209137,
            2398644319.181465,
        ],
    ],
    [
        1950825600000,
        [
            -6786189027.521988,
            -3250290229.797586,
            2397364368.227354,
        ],
    ],
    [
        1951430400000,
        [
            -6785774071.594535,
            -3252121971.440131,
            2396084203.024333,
        ],
    ],
    [
        1952035200000,
        [
            -6785358460.567842,
            -3253953341.793771,
            2394803823.287083,
        ],
    ],
    [
        1952640000000,
        [
            -6784942193.515457,
            -3255784341.377095,
            2393523228.784578,
        ],
    ],
    [
        1953244800000,
        [
            -6784525269.520527,
            -3257614970.862758,
            2392242419.173182,
        ],
    ],
    [
        1953849600000,
        [
            -6784107687.001009,
            -3259445231.261253,
            2390961393.825494,
        ],
    ],
    [
        1954454400000,
        [
            -6783689442.766755,
            -3261275122.950202,
            2389680152.24962,
        ],
    ],
    [
        1955059200000,
        [
            -6783270533.160039,
            -3263104644.1338,
            2388398695.030262,
        ],
    ],
    [
        1955664000000,
        [
            -6782850956.200228,
            -3264933791.614346,
            2387117023.640192,
        ],
    ],
    [
        1956268800000,
        [
            -6782430711.520224,
            -3266762562.305789,
            2385835139.627832,
        ],
    ],
    [
        1956873600000,
        [
            -6782009799.537157,
            -3268590953.553825,
            2384553044.364198,
        ],
    ],
    [
        1957478400000,
        [
            -6781588221.096183,
            -3270418962.990316,
            2383270739.088511,
        ],
    ],
    [
        1958083200000,
        [
            -6781165977.409143,
            -3272246588.436512,
            2381988224.958914,
        ],
    ],
    [
        1958688000000,
        [
            -6780743070.073785,
            -3274073827.897738,
            2380705503.063015,
        ],
    ],
    [
        1959292800000,
        [
            -6780319501.106816,
            -3275900679.623316,
            2379422574.395066,
        ],
    ],
    [
        1959897600000,
        [
            -6779895272.968856,
            -3277727142.238571,
            2378139439.793636,
        ],
    ],
    [
        1960502400000,
        [
            -6779470388.509328,
            -3279553214.997669,
            2376856099.806059,
        ],
    ],
    [
        1961107200000,
        [
            -6779044850.548427,
            -3281378898.134869,
            2375572554.462175,
        ],
    ],
    [
        1961712000000,
        [
            -6778618660.756684,
            -3283204192.689557,
            2374288803.255735,
        ],
    ],
    [
        1962316800000,
        [
            -6778191819.1927,
            -3285029098.936174,
            2373004845.938559,
        ],
    ],
    [
        1962921600000,
        [
            -6777764326.255671,
            -3286853615.596858,
            2371720683.145972,
        ],
    ],
    [
        1963526400000,
        [
            -6777336183.861444,
            -3288677741.294005,
            2370436315.744347,
        ],
    ],
    [
        1964131200000,
        [
            -6776907394.653777,
            -3290501475.466498,
            2369151744.260688,
        ],
    ],
    [
        1964736000000,
        [
            -6776477961.279505,
            -3292324818.269812,
            2367866968.86079,
        ],
    ],
    [
        1965340800000,
        [
            -6776047886.145625,
            -3294147770.317106,
            2366581989.461406,
        ],
    ],
    [
        1965945600000,
        [
            -6775617171.379813,
            -3295970332.508553,
            2365296805.815496,
        ],
    ],
    [
        1966550400000,
        [
            -6775185818.85552,
            -3297792505.938918,
            2364011417.561552,
        ],
    ],
    [
        1967155200000,
        [
            -6774753830.244725,
            -3299614291.871444,
            2362725824.239603,
        ],
    ],
    [
        1967760000000,
        [
            -6774321207.067369,
            -3301435691.80807,
            2361440025.254767,
        ],
    ],
    [
        1968364800000,
        [
            -6773887950.595927,
            -3303256707.70834,
            2360154019.74582,
        ],
    ],
    [
        1968969600000,
        [
            -6773454061.216917,
            -3305077342.166493,
            2358867806.419477,
        ],
    ],
    [
        1969574400000,
        [
            -6773019537.361054,
            -3306897597.567191,
            2357581383.885462,
        ],
    ],
    [
        1970179200000,
        [
            -6772584376.248547,
            -3308717474.347722,
            2356294751.657104,
        ],
    ],
    [
        1970784000000,
        [
            -6772148576.153836,
            -3310536971.33983,
            2355007910.198795,
        ],
    ],
    [
        1971388800000,
        [
            -6771712136.645426,
            -3312356087.289114,
            2353720860.135211,
        ],
    ],
    [
        1971993600000,
        [
            -6771275057.774059,
            -3314174821.234728,
            2352433601.961335,
        ],
    ],
    [
        1972598400000,
        [
            -6770837339.70958,
            -3315993172.311484,
            2351146136.108691,
        ],
    ],
    [
        1973203200000,
        [
            -6770398982.728436,
            -3317811139.587853,
            2349858463.030094,
        ],
    ],
    [
        1973808000000,
        [
            -6769959987.309396,
            -3319628722.016864,
            2348570583.23673,
        ],
    ],
    [
        1974412800000,
        [
            -6769520354.251668,
            -3321445918.47377,
            2347282497.292659,
        ],
    ],
    [
        1975017600000,
        [
            -6769080084.787173,
            -3323262727.881028,
            2345994205.763434,
        ],
    ],
    [
        1975622400000,
        [
            -6768639180.624352,
            -3325079149.463468,
            2344705709.089256,
        ],
    ],
    [
        1976227200000,
        [
            -6768197643.674827,
            -3326895183.137358,
            2343417007.354682,
        ],
    ],
    [
        1976832000000,
        [
            -6767755475.066563,
            -3328710829.524612,
            2342128100.185293,
        ],
    ],
    [
        1977436800000,
        [
            -6767312674.467353,
            -3330526088.587512,
            2340838987.413758,
        ],
    ],
    [
        1978041600000,
        [
            -6766869241.83139,
            -3332340958.590996,
            2339549669.82199,
        ],
    ],
    [
        1978646400000,
        [
            -6766425178.901435,
            -3334155437.453368,
            2338260148.581722,
        ],
    ],
    [
        1979251200000,
        [
            -6765980488.556986,
            -3335969523.899843,
            2336970424.576619,
        ],
    ],
    [
        1979856000000,
        [
            -6765535174.005519,
            -3337783217.495933,
            2335680498.305722,
        ],
    ],
    [
        1980460800000,
        [
            -6765089238.467779,
            -3339596518.43499,
            2334390369.968431,
        ],
    ],
    [
        1981065600000,
        [
            -6764642685.089231,
            -3341409427.400463,
            2333100039.531912,
        ],
    ],
    [
        1981670400000,
        [
            -6764195516.917853,
            -3343221945.503444,
            2331809506.763974,
        ],
    ],
    [
        1982275200000,
        [
            -6763747736.90491,
            -3345034074.278682,
            2330518771.235882,
        ],
    ],
    [
        1982880000000,
        [
            -6763299347.903017,
            -3346845815.7622,
            2329227832.28007,
        ],
    ],
    [
        1983484800000,
        [
            -6762850352.545836,
            -3348657172.704765,
            2327936688.861812,
        ],
    ],
    [
        1984089600000,
        [
            -6762400752.642488,
            -3350468148.797095,
            2326645339.393185,
        ],
    ],
    [
        1984694400000,
        [
            -6761950548.008408,
            -3352278748.021169,
            2325353781.954384,
        ],
    ],
    [
        1985299200000,
        [
            -6761499736.771203,
            -3354088972.856323,
            2324062015.27865,
        ],
    ],
    [
        1985904000000,
        [
            -6761048317.604294,
            -3355898824.224161,
            2322770039.007136,
        ],
    ],
    [
        1986508800000,
        [
            -6760596290.218148,
            -3357708303.004491,
            2321477852.923191,
        ],
    ],
    [
        1987113600000,
        [
            -6760143654.497001,
            -3359517410.511057,
            2320185456.601349,
        ],
    ],
    [
        1987718400000,
        [
            -6759690410.020138,
            -3361326148.245217,
            2318892849.481485,
        ],
    ],
    [
        1988323200000,
        [
            -6759236555.991532,
            -3363134517.635491,
            2317600030.992632,
        ],
    ],
    [
        1988928000000,
        [
            -6758782091.318681,
            -3364942519.884251,
            2316307000.635098,
        ],
    ],
    [
        1989532800000,
        [
            -6758327014.741671,
            -3366750155.900835,
            2315013758.021984,
        ],
    ],
    [
        1990137600000,
        [
            -6757871324.98318,
            -3368557426.321188,
            2313720302.87733,
        ],
    ],
    [
        1990742400000,
        [
            -6757415020.867811,
            -3370364331.657233,
            2312426634.962775,
        ],
    ],
    [
        1991347200000,
        [
            -6756958101.196277,
            -3372170872.605325,
            2311132753.895099,
        ],
    ],
    [
        1991952000000,
        [
            -6756500563.950624,
            -3373977050.120546,
            2309838659.02108,
        ],
    ],
    [
        1992556800000,
        [
            -6756042405.528003,
            -3375782864.198256,
            2308544349.98762,
        ],
    ],
    [
        1993161600000,
        [
            -6755583622.310578,
            -3377588312.565677,
            2307249827.603792,
        ],
    ],
    [
        1993766400000,
        [
            -6755124212.562269,
            -3379393391.81537,
            2305955093.434063,
        ],
    ],
    [
        1994371200000,
        [
            -6754664176.079416,
            -3381198098.757617,
            2304660149.043533,
        ],
    ],
    [
        1994976000000,
        [
            -6754203513.425278,
            -3383002430.604275,
            2303364995.8258,
        ],
    ],
    [
        1995580800000,
        [
            -6753742225.65288,
            -3384806384.82695,
            2302069635.056626,
        ],
    ],
    [
        1996185600000,
        [
            -6753280314.272388,
            -3386609959.090305,
            2300774067.933709,
        ],
    ],
    [
        1996790400000,
        [
            -6752817781.277785,
            -3388413151.273606,
            2299478295.576006,
        ],
    ],
    [
        1997395200000,
        [
            -6752354629.179706,
            -3390215959.556293,
            2298182318.989687,
        ],
    ],
    [
        1998000000000,
        [
            -6751890861.021559,
            -3392018382.581056,
            2296886138.99081,
        ],
    ],
    [
        1998604800000,
        [
            -6751426480.285642,
            -3393820419.745517,
            2295589756.047475,
        ],
    ],
    [
        1999209600000,
        [
            -6750961490.359502,
            -3395622071.549856,
            2294293170.045864,
        ],
    ],
    [
        1999814400000,
        [
            -6750495893.34162,
            -3397423339.226245,
            2292996380.370643,
        ],
    ],
    [
        2000419200000,
        [
            -6750029689.945821,
            -3399224223.05772,
            2291699386.798371,
        ],
    ],
    [
        2001024000000,
        [
            -6749562881.619328,
            -3401024722.027527,
            2290402189.908457,
        ],
    ],
    [
        2001628800000,
        [
            -6749095471.291443,
            -3402824835.383104,
            2289104790.328301,
        ],
    ],
    [
        2002233600000,
        [
            -6748627462.463077,
            -3404624563.334223,
            2287807188.267944,
        ],
    ],
    [
        2002838400000,
        [
            -6748158858.557542,
            -3406423906.884306,
            2286509383.543757,
        ],
    ],
    [
        2003443200000,
        [
            -6747689662.711703,
            -3408222867.582369,
            2285211375.689069,
        ],
    ],
    [
        2004048000000,
        [
            -6747219877.735377,
            -3410021447.366062,
            2283913164.032516,
        ],
    ],
    [
        2004652800000,
        [
            -6746749506.124749,
            -3411819648.477213,
            2282614747.742258,
        ],
    ],
    [
        2005257600000,
        [
            -6746278550.099746,
            -3413617473.443569,
            2281316125.836361,
        ],
    ],
    [
        2005862400000,
        [
            -6745807011.626407,
            -3415414925.163801,
            2280017297.135632,
        ],
    ],
    [
        2006467200000,
        [
            -6745334892.247143,
            -3417212007.138621,
            2278718260.117711,
        ],
    ],
    [
        2007072000000,
        [
            -6744862192.298982,
            -3419008723.554702,
            2277419012.785804,
        ],
    ],
    [
        2007676800000,
        [
            -6744388909.93175,
            -3420805078.170062,
            2276119553.156511,
        ],
    ],
    [
        2008281600000,
        [
            -6743915042.288898,
            -3422601072.701961,
            2274819880.23729,
        ],
    ],
    [
        2008886400000,
        [
            -6743440587.595597,
            -3424396707.558603,
            2273519993.845836,
        ],
    ],
    [
        2009491200000,
        [
            -6742965545.045238,
            -3426191983.213195,
            2272219893.858452,
        ],
    ],
    [
        2010096000000,
        [
            -6742489914.014554,
            -3427986900.388792,
            2270919580.024723,
        ],
    ],
    [
        2010700800000,
        [
            -6742013693.781536,
            -3429781459.816006,
            2269619052.063257,
        ],
    ],
    [
        2011305600000,
        [
            -6741536883.549008,
            -3431575662.061006,
            2268318309.752618,
        ],
    ],
    [
        2011910400000,
        [
            -6741059482.560214,
            -3433369507.463748,
            2267017352.974123,
        ],
    ],
    [
        2012515200000,
        [
            -6740581490.236706,
            -3435162996.162629,
            2265716181.712116,
        ],
    ],
    [
        2013120000000,
        [
            -6740102906.310715,
            -3436956128.214322,
            2264414796.004179,
        ],
    ],
    [
        2013724800000,
        [
            -6739623730.870661,
            -3438748903.857358,
            2263113195.806837,
        ],
    ],
    [
        2014329600000,
        [
            -6739143964.023181,
            -3440541323.886867,
            2261811380.763279,
        ],
    ],
    [
        2014934400000,
        [
            -6738663604.845841,
            -3442333389.484977,
            2260509350.189291,
        ],
    ],
    [
        2015539200000,
        [
            -6738182651.064904,
            -3444125100.676709,
            2259207103.869246,
        ],
    ],
    [
        2016144000000,
        [
            -6737701101.109015,
            -3445916455.682778,
            2257904642.619478,
        ],
    ],
    [
        2016748800000,
        [
            -6737218955.252111,
            -3447707452.468255,
            2256601967.584281,
        ],
    ],
    [
        2017353600000,
        [
            -6736736214.826711,
            -3449498089.688644,
            2255299079.653677,
        ],
    ],
    [
        2017958400000,
        [
            -6736252881.52772,
            -3451288366.646587,
            2253995979.418665,
        ],
    ],
    [
        2018563200000,
        [
            -6735768957.177242,
            -3453078283.104419,
            2252692667.250652,
        ],
    ],
    [
        2019168000000,
        [
            -6735284443.672923,
            -3454867839.182788,
            2251389143.3532,
        ],
    ],
    [
        2019772800000,
        [
            -6734799342.986832,
            -3456657035.332053,
            2250085407.779337,
        ],
    ],
    [
        2020377600000,
        [
            -6734313657.180143,
            -3458445872.364414,
            2248781460.417243,
        ],
    ],
    [
        2020982400000,
        [
            -6733827388.402166,
            -3460234351.577,
            2247477300.924908,
        ],
    ],
    [
        2021587200000,
        [
            -6733340538.726615,
            -3462022475.015654,
            2246172928.57197,
        ],
    ],
    [
        2022192000000,
        [
            -6732853109.422478,
            -3463810245.670004,
            2244868342.058924,
        ],
    ],
    [
        2022796800000,
        [
            -6732365099.822856,
            -3465597666.601161,
            2243563539.864159,
        ],
    ],
    [
        2023401600000,
        [
            -6731876508.074017,
            -3467384739.228409,
            2242258521.234437,
        ],
    ],
    [
        2024006400000,
        [
            -6731387333.294815,
            -3469171463.741493,
            2240953286.185341,
        ],
    ],
    [
        2024611200000,
        [
            -6730897575.665025,
            -3470957840.576725,
            2239647834.718243,
        ],
    ],
    [
        2025216000000,
        [
            -6730407235.537217,
            -3472743870.720754,
            2238342166.561859,
        ],
    ],
    [
        2025820800000,
        [
            -6729916313.018378,
            -3474529555.449303,
            2237036281.263911,
        ],
    ],
    [
        2026425600000,
        [
            -6729424807.906062,
            -3476314896.094124,
            2235730178.304102,
        ],
    ],
    [
        2027030400000,
        [
            -6728932719.746203,
            -3478099893.909943,
            2234423857.166102,
        ],
    ],
    [
        2027635200000,
        [
            -6728440047.933796,
            -3479884550.019218,
            2233117317.372393,
        ],
    ],
    [
        2028240000000,
        [
            -6727946791.831154,
            -3481668865.441484,
            2231810558.475951,
        ],
    ],
    [
        2028844800000,
        [
            -6727452950.839341,
            -3483452841.256747,
            2230503579.975883,
        ],
    ],
    [
        2029449600000,
        [
            -6726958524.16496,
            -3485236478.906677,
            2229196381.12859,
        ],
    ],
    [
        2030054400000,
        [
            -6726463509.893188,
            -3487019780.103783,
            2227888960.897392,
        ],
    ],
    [
        2030659200000,
        [
            -6725967904.462584,
            -3488802745.37217,
            2226581318.676001,
        ],
    ],
    [
        2031264000000,
        [
            -6725471704.581234,
            -3490585373.041387,
            2225273455.024215,
        ],
    ],
    [
        2031868800000,
        [
            -6724974908.777916,
            -3492367660.628532,
            2223965371.091423,
        ],
    ],
    [
        2032473600000,
        [
            -6724477516.833126,
            -3494149605.964846,
            2222657067.958388,
        ],
    ],
    [
        2033078400000,
        [
            -6723979529.098742,
            -3495931207.245847,
            2221348546.543974,
        ],
    ],
    [
        2033683200000,
        [
            -6723480946.296599,
            -3497712462.876269,
            2220039807.672375,
        ],
    ],
    [
        2034288000000,
        [
            -6722981769.520251,
            -3499493371.409061,
            2218730852.112179,
        ],
    ],
    [
        2034892800000,
        [
            -6722482000.282124,
            -3501273931.572058,
            2217421680.574052,
        ],
    ],
    [
        2035497600000,
        [
            -6721981640.562677,
            -3503054142.362108,
            2216112293.673032,
        ],
    ],
    [
        2036102400000,
        [
            -6721480692.834332,
            -3504834003.227055,
            2214802691.841386,
        ],
    ],
    [
        2036707200000,
        [
            -6720979159.939384,
            -3506613514.385721,
            2213492875.152437,
        ],
    ],
    [
        2037312000000,
        [
            -6720477044.448348,
            -3508392677.144269,
            2212182843.092023,
        ],
    ],
    [
        2037916800000,
        [
            -6719974347.46148,
            -3510171493.296878,
            2210872594.760764,
        ],
    ],
    [
        2038521600000,
        [
            -6719471068.948693,
            -3511949963.421607,
            2209562129.825065,
        ],
    ],
    [
        2039126400000,
        [
            -6718967209.91783,
            -3513728086.988062,
            2208251448.688677,
        ],
    ],
    [
        2039731200000,
        [
            -6718462772.753515,
            -3515505863.936062,
            2206940551.687786,
        ],
    ],
    [
        2040336000000,
        [
            -6717957760.259745,
            -3517283295.169885,
            2205629438.729982,
        ],
    ],
    [
        2040940800000,
        [
            -6717452175.097119,
            -3519060382.347145,
            2204318109.349772,
        ],
    ],
    [
        2041545600000,
        [
            -6716946019.610315,
            -3520837127.648288,
            2203006562.813731,
        ],
    ],
    [
        2042150400000,
        [
            -6716439295.79307,
            -3522613533.636114,
            2201694798.190641,
        ],
    ],
    [
        2042755200000,
        [
            -6715932005.298197,
            -3524389603.182664,
            2200382814.389193,
        ],
    ],
    [
        2043360000000,
        [
            -6715424149.467305,
            -3526165339.463439,
            2199070610.16065,
        ],
    ],
    [
        2043964800000,
        [
            -6714915729.330263,
            -3527940746.062603,
            2197758184.038049,
        ],
    ],
    [
        2044569600000,
        [
            -6714406745.35644,
            -3529715827.214379,
            2196445534.17595,
        ],
    ],
    [
        2045174400000,
        [
            -6713897196.542106,
            -3531490587.763908,
            2195132658.270407,
        ],
    ],
    [
        2045779200000,
        [
            -6713387079.60798,
            -3533265031.798257,
            2193819554.200044,
        ],
    ],
    [
        2046384000000,
        [
            -6712876390.586811,
            -3535039161.271073,
            2192506220.917615,
        ],
    ],
    [
        2046988800000,
        [
            -6712365126.633747,
            -3536812977.063158,
            2191192658.06301,
        ],
    ],
    [
        2047593600000,
        [
            -6711853285.631456,
            -3538586480.164091,
            2189878865.28302,
        ],
    ],
    [
        2048198400000,
        [
            -6711340865.469868,
            -3540359671.699932,
            2188564842.134096,
        ],
    ],
    [
        2048803200000,
        [
            -6710827863.843573,
            -3542132552.66735,
            2187250588.196094,
        ],
    ],
    [
        2049408000000,
        [
            -6710314278.312447,
            -3543905123.761134,
            2185936103.164313,
        ],
    ],
    [
        2050012800000,
        [
            -6709800106.441462,
            -3545677385.309142,
            2184621386.893492,
        ],
    ],
    [
        2050617600000,
        [
            -6709285345.963104,
            -3547449337.295238,
            2183306439.39857,
        ],
    ],
    [
        2051222400000,
        [
            -6708769994.932473,
            -3549220979.487548,
            2181991260.800025,
        ],
    ],
    [
        2051827200000,
        [
            -6708254051.770228,
            -3550992311.724111,
            2180675851.175206,
        ],
    ],
    [
        2052432000000,
        [
            -6707737514.848389,
            -3552763334.271158,
            2179360210.325188,
        ],
    ],
    [
        2053036800000,
        [
            -6707220381.421046,
            -3554534047.450629,
            2178044337.865734,
        ],
    ],
    [
        2053641600000,
        [
            -6706702647.723225,
            -3556304450.006887,
            2176728234.114244,
        ],
    ],
    [
        2054246400000,
        [
            -6706184311.207575,
            -3558074538.916793,
            2175411900.428298,
        ],
    ],
    [
        2054851200000,
        [
            -6705665371.295253,
            -3559844311.051811,
            2174095338.401705,
        ],
    ],
    [
        2055456000000,
        [
            -6705145828.511308,
            -3561613763.933368,
            2172778549.37811,
        ],
    ],
    [
        2056060800000,
        [
            -6704625683.889897,
            -3563382895.65521,
            2171461534.437765,
        ],
    ],
    [
        2056665600000,
        [
            -6704104938.790779,
            -3565151704.739691,
            2170144294.462154,
        ],
    ],
    [
        2057270400000,
        [
            -6703583594.859099,
            -3566920190.083097,
            2168826830.165553,
        ],
    ],
    [
        2057875200000,
        [
            -6703061654.019941,
            -3568688350.968052,
            2167509142.093819,
        ],
    ],
    [
        2058480000000,
        [
            -6702539118.480121,
            -3570456187.135951,
            2166191230.591153,
        ],
    ],
    [
        2059084800000,
        [
            -6702015990.697997,
            -3572223698.956198,
            2164873095.710991,
        ],
    ],
    [
        2059689600000,
        [
            -6701492273.138277,
            -3573990887.731124,
            2163554737.031235,
        ],
    ],
    [
        2060294400000,
        [
            -6700967967.391808,
            -3575757755.820481,
            2162236153.499089,
        ],
    ],
    [
        2060899200000,
        [
            -6700443073.136483,
            -3577524305.526648,
            2160917343.920494,
        ],
    ],
    [
        2061504000000,
        [
            -6699917589.30477,
            -3579290537.55319,
            2159598307.905108,
        ],
    ],
    [
        2062108800000,
        [
            -6699391516.028892,
            -3581056451.822758,
            2158279045.630469,
        ],
    ],
    [
        2062713600000,
        [
            -6698864854.366881,
            -3582822048.821528,
            2156959557.093946,
        ],
    ],
    [
        2063318400000,
        [
            -6698337605.424202,
            -3584587329.737117,
            2155639841.945704,
        ],
    ],
    [
        2063923200000,
        [
            -6697809769.986962,
            -3586352296.177141,
            2154319899.597827,
        ],
    ],
    [
        2064528000000,
        [
            -6697281348.460522,
            -3588116949.94501,
            2152999729.333753,
        ],
    ],
    [
        2065132800000,
        [
            -6696752340.909888,
            -3589881292.908674,
            2151679330.377941,
        ],
    ],
    [
        2065737600000,
        [
            -6696222747.13932,
            -3591645326.941707,
            2150358701.930501,
        ],
    ],
    [
        2066342400000,
        [
            -6695692566.786954,
            -3593409053.950736,
            2149037843.156963,
        ],
    ],
    [
        2066947200000,
        [
            -6695161799.352074,
            -3595172476.043304,
            2147716753.096021,
        ],
    ],
    [
        2067552000000,
        [
            -6694630443.850725,
            -3596935595.800679,
            2146395430.472944,
        ],
    ],
    [
        2068156800000,
        [
            -6694098497.792569,
            -3598698415.978008,
            2145073873.74909,
        ],
    ],
    [
        2068761600000,
        [
            -6693565956.986564,
            -3600460937.852707,
            2143752081.980243,
        ],
    ],
    [
        2069366400000,
        [
            -6693032817.712783,
            -3602223160.589906,
            2142430055.377823,
        ],
    ],
    [
        2069971200000,
        [
            -6692499077.882608,
            -3603985082.769984,
            2141107794.611503,
        ],
    ],
    [
        2070576000000,
        [
            -6691964736.33037,
            -3605746703.270104,
            2139785300.264719,
        ],
    ],
    [
        2071180800000,
        [
            -6691429792.236706,
            -3607508021.205791,
            2138462572.8074,
        ],
    ],
    [
        2071785600000,
        [
            -6690894245.001519,
            -3609269035.765657,
            2137139612.673753,
        ],
    ],
    [
        2072390400000,
        [
            -6690358094.28438,
            -3611029746.152135,
            2135816420.302032,
        ],
    ],
    [
        2072995200000,
        [
            -6689821340.079851,
            -3612790151.609699,
            2134492996.132195,
        ],
    ],
    [
        2073600000000,
        [
            -6689283982.791635,
            -3614550251.5256,
            2133169340.565473,
        ],
    ],
    [
        2074204800000,
        [
            -6688746023.27114,
            -3616310045.630512,
            2131845453.867301,
        ],
    ],
    [
        2074809600000,
        [
            -6688207462.666695,
            -3618069534.343509,
            2130521335.973618,
        ],
    ],
    [
        2075414400000,
        [
            -6687668301.676286,
            -3619828719.030244,
            2129196986.281535,
        ],
    ],
    [
        2076019200000,
        [
            -6687128539.421512,
            -3621587601.156582,
            2127872403.990309,
        ],
    ],
    [
        2076624000000,
        [
            -6686588174.256442,
            -3623346180.665656,
            2126547589.056931,
        ],
    ],
    [
        2077228800000,
        [
            -6686047205.86398,
            -3625104456.530752,
            2125222542.121813,
        ],
    ],
    [
        2077833600000,
        [
            -6685505635.228857,
            -3626862428.265006,
            2123897263.70227,
        ],
    ],
    [
        2078438400000,
        [
            -6684963463.696102,
            -3628620096.236834,
            2122571753.928115,
        ],
    ],
    [
        2079043200000,
        [
            -6684420692.502537,
            -3630377461.4397,
            2121246012.616607,
        ],
    ],
    [
        2079648000000,
        [
            -6683877322.646686,
            -3632134525.286813,
            2119920039.367994,
        ],
    ],
    [
        2080252800000,
        [
            -6683333354.870679,
            -3633891289.493999,
            2118593833.624431,
        ],
    ],
    [
        2080857600000,
        [
            -6682788789.679847,
            -3635647756.027668,
            2117267394.696971,
        ],
    ],
    [
        2081462400000,
        [
            -6682243627.37683,
            -3637403927.124852,
            2115940721.754569,
        ],
    ],
    [
        2082067200000,
        [
            -6681697868.044803,
            -3639159805.434745,
            2114613813.742023,
        ],
    ],
    [
        2082672000000,
        [
            -6681151511.216236,
            -3640915394.278393,
            2113286669.201424,
        ],
    ],
    [
        2083276800000,
        [
            -6680604554.85259,
            -3642670697.4693,
            2111959286.256118,
        ],
    ],
    [
        2083881600000,
        [
            -6680056994.811292,
            -3644425717.746298,
            2110631663.386014,
        ],
    ],
    [
        2084486400000,
        [
            -6679508826.767653,
            -3646180455.751315,
            2109303800.165794,
        ],
    ],
    [
        2085091200000,
        [
            -6678960047.663037,
            -3647934911.354829,
            2107975696.699719,
        ],
    ],
    [
        2085696000000,
        [
            -6678410655.092027,
            -3649689084.638064,
            2106647353.026334,
        ],
    ],
    [
        2086300800000,
        [
            -6677860646.651875,
            -3651442975.818316,
            2105318769.084198,
        ],
    ],
    [
        2086905600000,
        [
            -6677310019.791341,
            -3653196584.991094,
            2103989944.827802,
        ],
    ],
    [
        2087510400000,
        [
            -6676758771.879996,
            -3654949911.976538,
            2102660880.3115,
        ],
    ],
    [
        2088115200000,
        [
            -6676206900.34322,
            -3656702956.266261,
            2101331575.727714,
        ],
    ],
    [
        2088720000000,
        [
            -6675654402.817492,
            -3658455717.056039,
            2100002031.402759,
        ],
    ],
    [
        2089324800000,
        [
            -6675101277.292784,
            -3660208193.389729,
            2098672247.733443,
        ],
    ],
    [
        2089929600000,
        [
            -6674547522.109735,
            -3661960384.4662,
            2097342225.023204,
        ],
    ],
    [
        2090534400000,
        [
            -6673993135.424617,
            -3663712289.953414,
            2096011963.26096,
        ],
    ],
    [
        2091139200000,
        [
            -6673438114.140635,
            -3665463909.373969,
            2094681462.342344,
        ],
    ],
    [
        2091744000000,
        [
            -6672882454.446674,
            -3667215240.459144,
            2093350723.009972,
        ],
    ],
    [
        2092348800000,
        [
            -6672326154.080417,
            -3668966279.411197,
            2092019746.954206,
        ],
    ],
    [
        2092953600000,
        [
            -6671769212.676579,
            -3670717022.559248,
            2090688535.971937,
        ],
    ],
    [
        2093558400000,
        [
            -6671211630.870139,
            -3672467466.912534,
            2089357091.586045,
        ],
    ],
    [
        2094163200000,
        [
            -6670653409.79244,
            -3674217610.044837,
            2088025415.063115,
        ],
    ],
    [
        2094768000000,
        [
            -6670094550.927617,
            -3675967449.971476,
            2086693507.472408,
        ],
    ],
    [
        2095372800000,
        [
            -6669535056.081962,
            -3677716985.115422,
            2085361369.708555,
        ],
    ],
    [
        2095977600000,
        [
            -6668974927.378651,
            -3679466214.336912,
            2084029002.482362,
        ],
    ],
    [
        2096582400000,
        [
            -6668414167.254546,
            -3681215137.025693,
            2082696406.277559,
        ],
    ],
    [
        2097187200000,
        [
            -6667852778.408062,
            -3682963753.299014,
            2081363581.24505,
        ],
    ],
    [
        2097792000000,
        [
            -6667290763.473354,
            -3684712064.324852,
            2080030527.000855,
        ],
    ],
    [
        2098396800000,
        [
            -6666728124.010707,
            -3686460072.327374,
            2078697242.521864,
        ],
    ],
    [
        2099001600000,
        [
            -6666164859.660628,
            -3688207779.234214,
            2077363726.783005,
        ],
    ],
    [
        2099606400000,
        [
            -6665600969.703447,
            -3689955185.403714,
            2076029979.599802,
        ],
    ],
    [
        2100211200000,
        [
            -6665036454.702476,
            -3691702290.771701,
            2074696001.185938,
        ],
    ],
    [
        2100816000000,
        [
            -6664471315.950822,
            -3693449096.011614,
            2073361791.475024,
        ],
    ],
    [
        2101420800000,
        [
            -6663905554.646743,
            -3695195602.536719,
            2072027350.031807,
        ],
    ],
    [
        2102025600000,
        [
            -6663339171.584475,
            -3696941812.212037,
            2070692676.17088,
        ],
    ],
    [
        2102630400000,
        [
            -6662772167.103166,
            -3698687727.142557,
            2069357769.06046,
        ],
    ],
    [
        2103235200000,
        [
            -6662204541.119925,
            -3700433349.547826,
            2068022627.787921,
        ],
    ],
    [
        2103840000000,
        [
            -6661636293.197559,
            -3702178681.705266,
            2066687251.391498,
        ],
    ],
    [
        2104444800000,
        [
            -6661067422.621496,
            -3703923725.98324,
            2065351638.844427,
        ],
    ],
    [
        2105049600000,
        [
            -6660497928.380817,
            -3705668485.019706,
            2064015788.951019,
        ],
    ],
    [
        2105654400000,
        [
            -6659927808.703483,
            -3707412961.954585,
            2062679700.167678,
        ],
    ],
    [
        2106259200000,
        [
            -6659357059.981055,
            -3709157159.891437,
            2061343370.772504,
        ],
    ],
    [
        2106864000000,
        [
            -6658785676.973414,
            -3710901080.134128,
            2060006799.822297,
        ],
    ],
    [
        2107468800000,
        [
            -6658213655.114898,
            -3712644721.970036,
            2058669987.501758,
        ],
    ],
    [
        2108073600000,
        [
            -6657640991.2664,
            -3714388084.241647,
            2057332934.357176,
        ],
    ],
    [
        2108678400000,
        [
            -6657067682.937758,
            -3716131165.984815,
            2055995640.871364,
        ],
    ],
    [
        2109283200000,
        [
            -6656493727.821802,
            -3717873966.286194,
            2054658107.489293,
        ],
    ],
    [
        2109888000000,
        [
            -6655919123.738688,
            -3719616484.110583,
            2053320334.703696,
        ],
    ],
    [
        2110492800000,
        [
            -6655343868.719323,
            -3721358718.241251,
            2051982323.096089,
        ],
    ],
    [
        2111097600000,
        [
            -6654767961.117869,
            -3723100667.309019,
            2050644073.334667,
        ],
    ],
    [
        2111702400000,
        [
            -6654191399.721745,
            -3724842329.9017,
            2049305586.130145,
        ],
    ],
    [
        2112307200000,
        [
            -6653614183.814201,
            -3726583704.788715,
            2047966862.126048,
        ],
    ],
    [
        2112912000000,
        [
            -6653036312.996403,
            -3728324791.293236,
            2046627901.68591,
        ],
    ],
    [
        2113516800000,
        [
            -6652457786.346762,
            -3730065589.469897,
            2045288704.716055,
        ],
    ],
    [
        2114121600000,
        [
            -6651878601.458548,
            -3731806099.022239,
            2043949271.14913,
        ],
    ],
    [
        2114726400000,
        [
            -6651298755.715496,
            -3733546317.885273,
            2042609601.838282,
        ],
    ],
    [
        2115331200000,
        [
            -6650718248.201674,
            -3735286243.19313,
            2041269698.242566,
        ],
    ],
    [
        2115936000000,
        [
            -6650137079.368158,
            -3737025872.672458,
            2039929561.652005,
        ],
    ],
    [
        2116540800000,
        [
            -6649555250.146677,
            -3738765204.82923,
            2038589192.999347,
        ],
    ],
    [
        2117145600000,
        [
            -6648972761.564575,
            -3740504238.7369,
            2037248592.936056,
        ],
    ],
    [
        2117750400000,
        [
            -6648389614.643324,
            -3742242973.879732,
            2035907761.907502,
        ],
    ],
    [
        2118355200000,
        [
            -6647805810.383373,
            -3743981410.079946,
            2034566700.191578,
        ],
    ],
    [
        2118960000000,
        [
            -6647221349.776455,
            -3745719547.486876,
            2033225407.906294,
        ],
    ],
    [
        2119564800000,
        [
            -6646636233.822319,
            -3747457386.64165,
            2031883884.97674,
        ],
    ],
    [
        2120169600000,
        [
            -6646050463.46544,
            -3749194928.670189,
            2030542131.024472,
        ],
    ],
    [
        2120774400000,
        [
            -6645464039.141019,
            -3750932175.558026,
            2029200145.171973,
        ],
    ],
    [
        2121379200000,
        [
            -6644876959.648058,
            -3752669129.799915,
            2027857926.110708,
        ],
    ],
    [
        2121984000000,
        [
            -6644289221.936038,
            -3754405792.695104,
            2026515472.986658,
        ],
    ],
    [
        2122588800000,
        [
            -6643700823.227962,
            -3756142163.74505,
            2025172785.938385,
        ],
    ],
    [
        2123193600000,
        [
            -6643111762.031386,
            -3757878242.136446,
            2023829865.405316,
        ],
    ],
    [
        2123798400000,
        [
            -6642522037.353998,
            -3759614027.501611,
            2022486711.635671,
        ],
    ],
    [
        2124403200000,
        [
            -6641931648.108507,
            -3761349519.755982,
            2021143324.706784,
        ],
    ],
    [
        2125008000000,
        [
            -6641340592.983036,
            -3763084718.837525,
            2019799704.646017,
        ],
    ],
    [
        2125612800000,
        [
            -6640748870.497848,
            -3764819624.551941,
            2018455851.514673,
        ],
    ],
    [
        2126217600000,
        [
            -6640156479.120798,
            -3766554236.50942,
            2017111765.449544,
        ],
    ],
    [
        2126822400000,
        [
            -6639563417.405087,
            -3768288554.144854,
            2015767446.662929,
        ],
    ],
    [
        2127427200000,
        [
            -6638969684.110174,
            -3770022576.855511,
            2014422895.379138,
        ],
    ],
    [
        2128032000000,
        [
            -6638375278.140635,
            -3771756304.303138,
            2013078111.665515,
        ],
    ],
    [
        2128636800000,
        [
            -6637780197.885701,
            -3773489736.633213,
            2011733095.246996,
        ],
    ],
    [
        2129241600000,
        [
            -6637184440.226108,
            -3775222873.580948,
            2010387845.882367,
        ],
    ],
    [
        2129846400000,
        [
            -6636588001.538492,
            -3776955712.89807,
            2009042364.311777,
        ],
    ],
    [
        2130451200000,
        [
            -6635990879.864597,
            -3778688251.0282,
            2007696652.125025,
        ],
    ],
    [
        2131056000000,
        [
            -6635393074.908797,
            -3780420484.658298,
            2006350710.93797,
        ],
    ],
    [
        2131660800000,
        [
            -6634794587.174098,
            -3782152411.081205,
            2005004542.115725,
        ],
    ],
    [
        2132265600000,
        [
            -6634195417.56082,
            -3783884028.051283,
            2003658146.815161,
        ],
    ],
    [
        2132870400000,
        [
            -6633595567.273425,
            -3785615333.677594,
            2002311526.039571,
        ],
    ],
    [
        2133475200000,
        [
            -6632995037.814268,
            -3787346326.406541,
            2000964680.654487,
        ],
    ],
    [
        2134080000000,
        [
            -6632393830.993961,
            -3789077005.067497,
            1999617611.371233,
        ],
    ],
    [
        2134684800000,
        [
            -6631791948.93668,
            -3790807368.986691,
            1998270318.692883,
        ],
    ],
    [
        2135289600000,
        [
            -6631189394.013633,
            -3792537418.217201,
            1996922802.789952,
        ],
    ],
    [
        2135894400000,
        [
            -6630586168.434149,
            -3794267153.873068,
            1995575063.284017,
        ],
    ],
    [
        2136499200000,
        [
            -6629982273.134597,
            -3795996577.981276,
            1994227099.215075,
        ],
    ],
    [
        2137104000000,
        [
            -6629377707.220233,
            -3797725691.933017,
            1992878909.813333,
        ],
    ],
    [
        2137708800000,
        [
            -6628772469.845331,
            -3799454495.572103,
            1991530495.182042,
        ],
    ],
    [
        2138313600000,
        [
            -6628166561.486994,
            -3801182988.581041,
            1990181855.68885,
        ],
    ],
    [
        2138918400000,
        [
            -6627559983.193766,
            -3802911171.430904,
            1988832991.379155,
        ],
    ],
    [
        2139523200000,
        [
            -6626952735.840368,
            -3804639045.280775,
            1987483901.950077,
        ],
    ],
    [
        2140128000000,
        [
            -6626344819.875946,
            -3806366611.694446,
            1986134586.872051,
        ],
    ],
    [
        2140732800000,
        [
            -6625736235.288509,
            -3808093872.444208,
            1984785045.485223,
        ],
    ],
    [
        2141337600000,
        [
            -6625126981.639812,
            -3809820829.395142,
            1983435277.059123,
        ],
    ],
    [
        2141942400000,
        [
            -6624517058.131462,
            -3811547484.45691,
            1982085280.818641,
        ],
    ],
    [
        2142547200000,
        [
            -6623906463.672617,
            -3813273839.6315,
            1980735055.918145,
        ],
    ],
    [
        2143152000000,
        [
            -6623295196.815798,
            -3814999897.210827,
            1979384601.32133,
        ],
    ],
    [
        2143756800000,
        [
            -6622683255.170839,
            -3816725659.95664,
            1978033915.636108,
        ],
    ],
    [
        2144361600000,
        [
            -6622070634.343177,
            -3818451130.310575,
            1976682997.418269,
        ],
    ],
    [
        2144966400000,
        [
            -6621457328.586216,
            -3820176308.629783,
            1975331846.173543,
        ],
    ],
    [
        2145571200000,
        [
            -6620843333.112029,
            -3821901193.411876,
            1973980462.46928,
        ],
    ],
    [
        2146176000000,
        [
            -6620228644.45208,
            -3823625782.832379,
            1972628847.143858,
        ],
    ],
    [
        2146780800000,
        [
            -6619613259.667978,
            -3825350075.17324,
            1971277000.990566,
        ],
    ],
    [
        2147385600000,
        [
            -6618997175.990192,
            -3827074068.635743,
            1969924924.816189,
        ],
    ],
    [
        2147990400000,
        [
            -6618380390.819437,
            -3828797761.180802,
            1968572619.524244,
        ],
    ],
    [
        2148595200000,
        [
            -6617762901.841182,
            -3830521150.485196,
            1967220086.149787,
        ],
    ],
    [
        2149200000000,
        [
            -6617144707.162408,
            -3832244233.987471,
            1965867325.850471,
        ],
    ],
    [
        2149804800000,
        [
            -6616525805.441648,
            -3833967009.021948,
            1964514339.851556,
        ],
    ],
    [
        2150409600000,
        [
            -6615906195.953315,
            -3835689473.081923,
            1963161129.316656,
        ],
    ],
    [
        2151014400000,
        [
            -6615285878.349204,
            -3837411624.222673,
            1961807695.113704,
        ],
    ],
    [
        2151619200000,
        [
            -6614664851.710411,
            -3839133461.131152,
            1960454037.686438,
        ],
    ],
    [
        2152224000000,
        [
            -6614043113.810275,
            -3840854981.831979,
            1959100157.676887,
        ],
    ],
    [
        2152828800000,
        [
            -6613420662.780863,
            -3842576182.580057,
            1957746056.697451,
        ],
    ],
    [
        2153433600000,
        [
            -6612797498.710786,
            -3844297059.164375,
            1956391736.8077,
        ],
    ],
    [
        2154038400000,
        [
            -6612173623.049138,
            -3846017608.133181,
            1955037199.805541,
        ],
    ],
    [
        2154643200000,
        [
            -6611549037.776599,
            -3847737826.873324,
            1953682447.105793,
        ],
    ],
    [
        2155248000000,
        [
            -6610923745.073245,
            -3849457713.414862,
            1952327479.816233,
        ],
    ],
    [
        2155852800000,
        [
            -6610297747.221499,
            -3851177266.30671,
            1950972298.799126,
        ],
    ],
    [
        2156457600000,
        [
            -6609671046.577095,
            -3852896484.568428,
            1949616904.69814,
        ],
    ],
    [
        2157062400000,
        [
            -6609043645.562068,
            -3854615367.699974,
            1948261297.935493,
        ],
    ],
    [
        2157667200000,
        [
            -6608415546.65506,
            -3856333915.770514,
            1946905478.665528,
        ],
    ],
    [
        2158272000000,
        [
            -6607786752.270404,
            -3858052129.640583,
            1945549446.644425,
        ],
    ],
    [
        2158876800000,
        [
            -6607157264.169911,
            -3859770011.211618,
            1944193201.03581,
        ],
    ],
    [
        2159481600000,
        [
            -6606527082.279054,
            -3861487562.85123,
            1942836740.593969,
        ],
    ],
    [
        2160086400000,
        [
            -6605896204.864278,
            -3863204785.613605,
            1941480064.630745,
        ],
    ],
    [
        2160691200000,
        [
            -6605264630.742729,
            -3864921679.078336,
            1940123173.327491,
        ],
    ],
    [
        2161296000000,
        [
            -6604632359.858001,
            -3866638242.876417,
            1938766066.975561,
        ],
    ],
    [
        2161900800000,
        [
            -6603999392.405101,
            -3868354477.224209,
            1937408745.595758,
        ],
    ],
    [
        2162505600000,
        [
            -6603365728.307752,
            -3870070382.691354,
            1936051209.002954,
        ],
    ],
    [
        2163110400000,
        [
            -6602731367.116286,
            -3871785959.937561,
            1934693456.930532,
        ],
    ],
    [
        2163715200000,
        [
            -6602096308.061913,
            -3873501209.55423,
            1933335489.114872,
        ],
    ],
    [
        2164320000000,
        [
            -6601460550.163387,
            -3875216131.991027,
            1931977305.339968,
        ],
    ],
    [
        2164924800000,
        [
            -6600824092.356023,
            -3876930727.565786,
            1930618905.440217,
        ],
    ],
    [
        2165529600000,
        [
            -6600186933.594831,
            -3878644996.599367,
            1929260289.234424,
        ],
    ],
    [
        2166134400000,
        [
            -6599549072.728352,
            -3880358939.709722,
            1927901456.351903,
        ],
    ],
    [
        2166739200000,
        [
            -6598910507.717329,
            -3882072557.904521,
            1926542406.099461,
        ],
    ],
    [
        2167344000000,
        [
            -6598271234.801028,
            -3883785851.409439,
            1925183137.9997,
        ],
    ],
    [
        2167948800000,
        [
            -6597631249.950435,
            -3885498818.274792,
            1923823652.686043,
        ],
    ],
    [
        2168553600000,
        [
            -6596990550.828016,
            -3887211455.40694,
            1922463951.556267,
        ],
    ],
    [
        2169158400000,
        [
            -6596349136.497481,
            -3888923759.948289,
            1921104036.007994,
        ],
    ],
    [
        2169763200000,
        [
            -6595707006.634725,
            -3890635729.474645,
            1919743907.255392,
        ],
    ],
    [
        2170368000000,
        [
            -6595064161.228937,
            -3892347361.83282,
            1918383566.389726,
        ],
    ],
    [
        2170972800000,
        [
            -6594420600.543122,
            -3894058655.047684,
            1917023014.43023,
        ],
    ],
    [
        2171577600000,
        [
            -6593776325.141279,
            -3895769607.318525,
            1915662252.334419,
        ],
    ],
    [
        2172182400000,
        [
            -6593131335.925897,
            -3897480217.08004,
            1914301280.974864,
        ],
    ],
    [
        2172787200000,
        [
            -6592485634.163291,
            -3899190483.139889,
            1912940101.073456,
        ],
    ],
    [
        2173392000000,
        [
            -6591839221.409388,
            -3900900404.943775,
            1911578713.056618,
        ],
    ],
    [
        2173996800000,
        [
            -6591192099.017943,
            -3902609982.910039,
            1910217116.829341,
        ],
    ],
    [
        2174601600000,
        [
            -6590544266.974147,
            -3904319218.097729,
            1908855311.834489,
        ],
    ],
    [
        2175206400000,
        [
            -6589895723.714757,
            -3906028110.533226,
            1907493297.929943,
        ],
    ],
    [
        2175811200000,
        [
            -6589246468.232779,
            -3907736658.733634,
            1906131075.862084,
        ],
    ],
    [
        2176416000000,
        [
            -6588596500.954495,
            -3909444861.24294,
            1904768646.535794,
        ],
    ],
    [
        2177020800000,
        [
            -6587945822.873175,
            -3911152717.3784,
            1903406010.524809,
        ],
    ],
    [
        2177625600000,
        [
            -6587294434.900628,
            -3912860227.072553,
            1902043168.086869,
        ],
    ],
    [
        2178230400000,
        [
            -6586642337.671118,
            -3914567390.620028,
            1900680119.275753,
        ],
    ],
    [
        2178835200000,
        [
            -6585989531.521925,
            -3916274208.517703,
            1899316864.021006,
        ],
    ],
    [
        2179440000000,
        [
            -6585336016.529943,
            -3917980681.381243,
            1897953402.171985,
        ],
    ],
    [
        2180044800000,
        [
            -6584681792.572262,
            -3919686809.930066,
            1896589733.50727,
        ],
    ],
    [
        2180649600000,
        [
            -6584026859.373796,
            -3921392595.075819,
            1895225857.686963,
        ],
    ],
    [
        2181254400000,
        [
            -6583371216.374125,
            -3923098038.160043,
            1893861774.10621,
        ],
    ],
    [
        2181859200000,
        [
            -6582714861.997063,
            -3924803141.075682,
            1892497481.748695,
        ],
    ],
    [
        2182464000000,
        [
            -6582057792.651712,
            -3926507905.233235,
            1891132979.629508,
        ],
    ],
    [
        2183068800000,
        [
            -6581400003.815214,
            -3928212329.919238,
            1889768267.778475,
        ],
    ],
    [
        2183673600000,
        [
            -6580741492.186324,
            -3929916412.94733,
            1888403347.110065,
        ],
    ],
    [
        2184278400000,
        [
            -6580082255.663776,
            -3931620152.089302,
            1887038218.651884,
        ],
    ],
    [
        2184883200000,
        [
            -6579422292.556881,
            -3933323545.320956,
            1885672883.327667,
        ],
    ],
    [
        2185488000000,
        [
            -6578761601.28777,
            -3935026590.604026,
            1884307342.04018,
        ],
    ],
    [
        2186092800000,
        [
            -6578100180.409262,
            -3936729285.730928,
            1882941595.754566,
        ],
    ],
    [
        2186697600000,
        [
            -6577438028.717191,
            -3938431628.280662,
            1881575645.533572,
        ],
    ],
    [
        2187302400000,
        [
            -6576775145.383699,
            -3940133615.661214,
            1880209492.530276,
        ],
    ],
    [
        2187907200000,
        [
            -6576111530.083735,
            -3941835245.245147,
            1878843137.931865,
        ],
    ],
    [
        2188512000000,
        [
            -6575447183.03854,
            -3943536514.645623,
            1877476582.821217,
        ],
    ],
    [
        2189116800000,
        [
            -6574782104.691724,
            -3945237422.110891,
            1876109827.938396,
        ],
    ],
    [
        2189721600000,
        [
            -6574116294.669067,
            -3946937966.419739,
            1874742873.635521,
        ],
    ],
    [
        2190326400000,
        [
            -6573449751.351511,
            -3948638145.391488,
            1873375720.636025,
        ],
    ],
    [
        2190931200000,
        [
            -6572782473.85198,
            -3950337955.14729,
            1872008370.641961,
        ],
    ],
    [
        2191536000000,
        [
            -6572114463.242666,
            -3952037391.631391,
            1870640825.656372,
        ],
    ],
    [
        2192140800000,
        [
            -6571445721.782916,
            -3953736451.623227,
            1869273087.370293,
        ],
    ],
    [
        2192745600000,
        [
            -6570776252.178859,
            -3955435132.722078,
            1867905157.10142,
        ],
    ],
    [
        2193350400000,
        [
            -6570106057.312375,
            -3957133433.162191,
            1866537035.871251,
        ],
    ],
    [
        2193955200000,
        [
            -6569435140.162558,
            -3958831351.709861,
            1865168724.457494,
        ],
    ],
    [
        2194560000000,
        [
            -6568763503.780239,
            -3960528887.631928,
            1863800223.412834,
        ],
    ],
    [
        2195164800000,
        [
            -6568091151.279264,
            -3962226040.722109,
            1862431533.053447,
        ],
    ],
    [
        2195769600000,
        [
            -6567418085.815055,
            -3963922811.413511,
            1861062653.399058,
        ],
    ],
    [
        2196374400000,
        [
            -6566744310.412315,
            -3965619201.02864,
            1859693584.022779,
        ],
    ],
    [
        2196979200000,
        [
            -6566069827.247392,
            -3967315211.981256,
            1858324323.869048,
        ],
    ],
    [
        2197584000000,
        [
            -6565394636.480561,
            -3969010846.956443,
            1856954871.569706,
        ],
    ],
    [
        2198188800000,
        [
            -6564718736.871751,
            -3970706107.158372,
            1855585226.441813,
        ],
    ],
    [
        2198793600000,
        [
            -6564042127.953023,
            -3972400992.595652,
            1854215388.557174,
        ],
    ],
    [
        2199398400000,
        [
            -6563364810.198607,
            -3974095503.562642,
            1852845357.9645,
        ],
    ],
    [
        2200003200000,
        [
            -6562686784.12323,
            -3975789640.970154,
            1851475134.414335,
        ],
    ],
    [
        2200608000000,
        [
            -6562008049.835346,
            -3977483406.069909,
            1850104717.454159,
        ],
    ],
    [
        2201212800000,
        [
            -6561328606.96079,
            -3979176800.196258,
            1848734106.551964,
        ],
    ],
    [
        2201817600000,
        [
            -6560648454.697117,
            -3980869824.608415,
            1847363301.179171,
        ],
    ],
    [
        2202422400000,
        [
            -6559967591.915179,
            -3982562480.411366,
            1845992300.856097,
        ],
    ],
    [
        2203027200000,
        [
            -6559286017.282158,
            -3984254768.560763,
            1844621105.154736,
        ],
    ],
    [
        2203632000000,
        [
            -6558603729.345504,
            -3985946690.000128,
            1843249713.627018,
        ],
    ],
    [
        2204236800000,
        [
            -6557920726.331597,
            -3987638245.942213,
            1841878125.627024,
        ],
    ],
    [
        2204841600000,
        [
            -6557237005.257302,
            -3989329437.801434,
            1840506340.249219,
        ],
    ],
    [
        2205446400000,
        [
            -6556552561.345467,
            -3991020265.77035,
            1839134357.023635,
        ],
    ],
    [
        2206051200000,
        [
            -6555867389.874625,
            -3992710727.708045,
            1837762176.697894,
        ],
    ],
    [
        2206656000000,
        [
            -6555181487.841679,
            -3994400820.449522,
            1836389800.707915,
        ],
    ],
    [
        2207260800000,
        [
            -6554494853.461604,
            -3996090540.976166,
            1835017230.500277,
        ],
    ],
    [
        2207865600000,
        [
            -6553807485.486067,
            -3997779886.483918,
            1833644467.426174,
        ],
    ],
    [
        2208470400000,
        [
            -6553119383.007542,
            -3999468854.220729,
            1832271512.810308,
        ],
    ],
    [
        2209075200000,
        [
            -6552430545.477956,
            -4001157441.417454,
            1830898367.993293,
        ],
    ],
    [
        2209680000000,
        [
            -6551740972.776554,
            -4002845645.310011,
            1829525034.331365,
        ],
    ],
    [
        2210284800000,
        [
            -6551050665.280727,
            -4004533463.231462,
            1828151513.159737,
        ],
    ],
    [
        2210889600000,
        [
            -6550359623.91333,
            -4006220892.792491,
            1826777805.706708,
        ],
    ],
    [
        2211494400000,
        [
            -6549667850.052695,
            -4007907932.200792,
            1825403912.91948,
        ],
    ],
    [
        2212099200000,
        [
            -6548975344.941887,
            -4009594580.596944,
            1824029835.229182,
        ],
    ],
    [
        2212704000000,
        [
            -6548282108.506067,
            -4011280837.527426,
            1822655572.715219,
        ],
    ],
    [
        2213308800000,
        [
            -6547588139.596129,
            -4012966701.25075,
            1821281126.040276,
        ],
    ],
    [
        2213913600000,
        [
            -6546893438.172766,
            -4014652168.743632,
            1819906496.677515,
        ],
    ],
    [
        2214518400000,
        [
            -6546198005.761064,
            -4016337237.301499,
            1818531686.106147,
        ],
    ],
    [
        2215123200000,
        [
            -6545501844.510367,
            -4018021905.100685,
            1817156695.416421,
        ],
    ],
    [
        2215728000000,
        [
            -6544804956.617868,
            -4019706171.014484,
            1815781525.35007,
        ],
    ],
    [
        2216332800000,
        [
            -6544107344.153135,
            -4021390034.396612,
            1814406176.398844,
        ],
    ],
    [
        2216937600000,
        [
            -6543409009.02503,
            -4023073494.955392,
            1813030648.868458,
        ],
    ],
    [
        2217542400000,
        [
            -6542709952.993433,
            -4024756552.696424,
            1811654942.909713,
        ],
    ],
    [
        2218147200000,
        [
            -6542010177.699457,
            -4026439207.931827,
            1810279058.515111,
        ],
    ],
    [
        2218752000000,
        [
            -6541309684.667509,
            -4028121461.397925,
            1808902995.453784,
        ],
    ],
    [
        2219356800000,
        [
            -6540608475.072201,
            -4029803314.511784,
            1807526753.10711,
        ],
    ],
    [
        2219961600000,
        [
            -6539906548.850469,
            -4031484769.383037,
            1806150330.366531,
        ],
    ],
    [
        2220566400000,
        [
            -6539203903.835706,
            -4033165827.522615,
            1804773726.229236,
        ],
    ],
    [
        2221171200000,
        [
            -6538500537.235963,
            -4034846488.41136,
            1803396940.711122,
        ],
    ],
    [
        2221776000000,
        [
            -6537796447.511396,
            -4036526750.496974,
            1802019974.503627,
        ],
    ],
    [
        2222380800000,
        [
            -6537091634.030342,
            -4038206612.439598,
            1800642828.267627,
        ],
    ],
    [
        2222985600000,
        [
            -6536386096.315237,
            -4039886073.1859,
            1799265502.510995,
        ],
    ],
    [
        2223590400000,
        [
            -6535679833.804698,
            -4041565131.715785,
            1797887997.695087,
        ],
    ],
    [
        2224195200000,
        [
            -6534972845.888742,
            -4043243786.875885,
            1796510314.324038,
        ],
    ],
    [
        2224800000000,
        [
            -6534265132.025775,
            -4044922037.319565,
            1795132452.986705,
        ],
    ],
    [
        2225404800000,
        [
            -6533556691.881886,
            -4046599881.532787,
            1793754414.356366,
        ],
    ],
    [
        2226009600000,
        [
            -6532847525.463456,
            -4048277317.960989,
            1792376199.137172,
        ],
    ],
    [
        2226614400000,
        [
            -6532137633.14486,
            -4049954345.288519,
            1790997807.919688,
        ],
    ],
    [
        2227219200000,
        [
            -6531427015.258508,
            -4051630962.800899,
            1789619240.948242,
        ],
    ],
    [
        2227824000000,
        [
            -6530715671.010671,
            -4053307170.063687,
            1788240498.184771,
        ],
    ],
    [
        2228428800000,
        [
            -6530003598.451781,
            -4054982965.299067,
            1786861580.178634,
        ],
    ],
    [
        2229033600000,
        [
            -6529290796.66355,
            -4056658345.070186,
            1785482488.468193,
        ],
    ],
    [
        2229638400000,
        [
            -6528577266.595764,
            -4058333305.916286,
            1784103224.800726,
        ],
    ],
    [
        2230243200000,
        [
            -6527863010.201527,
            -4060007845.146839,
            1782723790.625454,
        ],
    ],
    [
        2230848000000,
        [
            -6527148029.803616,
            -4061681960.759799,
            1781344187.078191,
        ],
    ],
    [
        2231452800000,
        [
            -6526432327.886822,
            -4063355651.274363,
            1779964415.055283,
        ],
    ],
    [
        2232057600000,
        [
            -6525715907.044699,
            -4065028915.651078,
            1778584475.25614,
        ],
    ],
    [
        2232662400000,
        [
            -6524998769.966476,
            -4066701753.279146,
            1777204368.193079,
        ],
    ],
    [
        2233267200000,
        [
            -6524280919.435235,
            -4068374164.022711,
            1775824094.169774,
        ],
    ],
    [
        2233872000000,
        [
            -6523562358.300594,
            -4070046148.361418,
            1774443653.205521,
        ],
    ],
    [
        2234476800000,
        [
            -6522843089.25281,
            -4071717707.667883,
            1773063044.8646,
        ],
    ],
    [
        2235081600000,
        [
            -6522123113.980667,
            -4073388844.335501,
            1771682268.100513,
        ],
    ],
    [
        2235686400000,
        [
            -6521402432.10328,
            -4075059560.707027,
            1770301321.716278,
        ],
    ],
    [
        2236291200000,
        [
            -6520681042.238244,
            -4076729857.461265,
            1768920205.334332,
        ],
    ],
    [
        2236896000000,
        [
            -6519958944.019628,
            -4078399734.316114,
            1767538919.226273,
        ],
    ],
    [
        2237500800000,
        [
            -6519236137.920118,
            -4080069191.395962,
            1766157463.559158,
        ],
    ],
    [
        2238105600000,
        [
            -6518512624.378724,
            -4081738229.393843,
            1764775838.212764,
        ],
    ],
    [
        2238710400000,
        [
            -6517788403.435509,
            -4083406849.280099,
            1763394042.890838,
        ],
    ],
    [
        2239315200000,
        [
            -6517063474.685859,
            -4085075052.0638,
            1762012077.236579,
        ],
    ],
    [
        2239920000000,
        [
            -6516337837.342777,
            -4086742838.650944,
            1760629940.907118,
        ],
    ],
    [
        2240524800000,
        [
            -6515611490.340445,
            -4088410209.778362,
            1759247633.611555,
        ],
    ],
    [
        2241129600000,
        [
            -6514884432.454543,
            -4090077166.035561,
            1757865155.103746,
        ],
    ],
    [
        2241734400000,
        [
            -6514156662.361639,
            -4091743708.027717,
            1756482505.093638,
        ],
    ],
    [
        2242339200000,
        [
            -6513428178.344991,
            -4093409836.655773,
            1755099683.060004,
        ],
    ],
    [
        2242944000000,
        [
            -6512698977.313303,
            -4095075552.874275,
            1753716688.271899,
        ],
    ],
    [
        2243548800000,
        [
            -6511969054.535414,
            -4096740856.085666,
            1752333520.613929,
        ],
    ],
    [
        2244153600000,
        [
            -6511238405.777704,
            -4098405743.41105,
            1750950181.193654,
        ],
    ],
    [
        2244758400000,
        [
            -6510507028.586186,
            -4100070211.198236,
            1749566671.666832,
        ],
    ],
    [
        2245363200000,
        [
            -6509774921.624814,
            -4101734255.976103,
            1748182993.658858,
        ],
    ],
    [
        2245968000000,
        [
            -6509042084.088331,
            -4103397874.433119,
            1746799148.717059,
        ],
    ],
    [
        2246572800000,
        [
            -6508308515.571993,
            -4105061063.267882,
            1745415138.380438,
        ],
    ],
    [
        2247177600000,
        [
            -6507574216.115421,
            -4106723819.144817,
            1744030964.212834,
        ],
    ],
    [
        2247782400000,
        [
            -6506839186.281627,
            -4108386138.738789,
            1742646627.793546,
        ],
    ],
    [
        2248387200000,
        [
            -6506103427.233288,
            -4110048018.851899,
            1741262130.670115,
        ],
    ],
    [
        2248992000000,
        [
            -6505366940.773895,
            -4111709456.6278,
            1739877474.25602,
        ],
    ],
    [
        2249596800000,
        [
            -6504629729.208832,
            -4113370449.909635,
            1738492659.633281,
        ],
    ],
    [
        2250201600000,
        [
            -6503891794.626464,
            -4115030997.535032,
            1737107687.32859,
        ],
    ],
    [
        2250806400000,
        [
            -6503153137.745173,
            -4116691098.572739,
            1735722557.609512,
        ],
    ],
    [
        2251411200000,
        [
            -6502413758.598564,
            -4118350750.687417,
            1734337271.436298,
        ],
    ],
    [
        2252016000000,
        [
            -6501673658.656362,
            -4120009950.60058,
            1732951830.441802,
        ],
    ],
    [
        2252620800000,
        [
            -6500932840.877783,
            -4121668695.642515,
            1731566236.113438,
        ],
    ],
    [
        2253225600000,
        [
            -6500191308.75131,
            -4123326984.127171,
            1730180489.497898,
        ],
    ],
    [
        2253830400000,
        [
            -6499449065.790356,
            -4124984815.140419,
            1728794591.265401,
        ],
    ],
    [
        2254435200000,
        [
            -6498706115.378743,
            -4126642188.342142,
            1727408541.801671,
        ],
    ],
    [
        2255040000000,
        [
            -6497962460.73248,
            -4128299103.855669,
            1726022341.264199,
        ],
    ],
    [
        2255644800000,
        [
            -6497218104.89937,
            -4129955562.221145,
            1724635989.607164,
        ],
    ],
    [
        2256249600000,
        [
            -6496473050.773088,
            -4131611564.417802,
            1723249486.56998,
        ],
    ],
    [
        2256854400000,
        [
            -6495727301.06084,
            -4133267112.002995,
            1721862831.597642,
        ],
    ],
    [
        2257459200000,
        [
            -6494980857.953241,
            -4134922207.373002,
            1720476023.664216,
        ],
    ],
    [
        2258064000000,
        [
            -6494233722.107341,
            -4136576853.625261,
            1719089061.237208,
        ],
    ],
    [
        2258668800000,
        [
            -6493485892.01459,
            -4138231053.03703,
            1717701943.020188,
        ],
    ],
    [
        2259273600000,
        [
            -6492737365.823817,
            -4139884805.942622,
            1716314668.736152,
        ],
    ],
    [
        2259878400000,
        [
            -6491988142.865459,
            -4141538111.995152,
            1714927238.605584,
        ],
    ],
    [
        2260483200000,
        [
            -6491238223.065794,
            -4143190971.193332,
            1713539652.731138,
        ],
    ],
    [
        2261088000000,
        [
            -6490487606.257037,
            -4144843383.819248,
            1712151911.053283,
        ],
    ],
    [
        2261692800000,
        [
            -6489736291.995285,
            -4146495350.164463,
            1710764013.47183,
        ],
    ],
    [
        2262297600000,
        [
            -6488984279.611403,
            -4148146870.356124,
            1709375959.938648,
        ],
    ],
    [
        2262902400000,
        [
            -6488231568.33314,
            -4149797944.283382,
            1707987750.504917,
        ],
    ],
    [
        2263507200000,
        [
            -6487478157.43081,
            -4151448571.608482,
            1706599385.326574,
        ],
    ],
    [
        2264112000000,
        [
            -6486724046.354593,
            -4153098751.886304,
            1705210864.612139,
        ],
    ],
    [
        2264716800000,
        [
            -6485969234.738873,
            -4154748484.845004,
            1703822188.472028,
        ],
    ],
    [
        2265321600000,
        [
            -6485213721.896536,
            -4156397770.69239,
            1702433356.70263,
        ],
    ],
    [
        2265926400000,
        [
            -6484457505.744937,
            -4158046609.543972,
            1701044368.982068,
        ],
    ],
    [
        2266531200000,
        [
            -6483700583.233375,
            -4159694999.749791,
            1699655225.810993,
        ],
    ],
    [
        2267136000000,
        [
            -6482942952.618962,
            -4161342938.022006,
            1698265928.683843,
        ],
    ],
    [
        2267740800000,
        [
            -6482184613.924183,
            -4162990421.082055,
            1696876479.260648,
        ],
    ],
    [
        2268345600000,
        [
            -6481425568.054856,
            -4164637446.24589,
            1695486878.967814,
        ],
    ],
    [
        2268950400000,
        [
            -6480665816.287372,
            -4166284011.300096,
            1694097129.016132,
        ],
    ],
    [
        2269555200000,
        [
            -6479905360.131615,
            -4167930114.359141,
            1692707230.467664,
        ],
    ],
    [
        2270160000000,
        [
            -6479144201.315843,
            -4169575753.814011,
            1691317184.266067,
        ],
    ],
    [
        2270764800000,
        [
            -6478382341.800632,
            -4171220928.347381,
            1689926991.233821,
        ],
    ],
    [
        2271369600000,
        [
            -6477619783.797428,
            -4172865637.012991,
            1688536652.034942,
        ],
    ],
    [
        2271974400000,
        [
            -6476856529.743701,
            -4174509879.420952,
            1687146167.075824,
        ],
    ],
    [
        2272579200000,
        [
            -6476092582.020674,
            -4176153656.054446,
            1685755536.3084,
        ],
    ],
    [
        2273184000000,
        [
            -6475327941.997301,
            -4177796968.309042,
            1684364759.110861,
        ],
    ],
    [
        2273788800000,
        [
            -6474562609.148351,
            -4179439817.200553,
            1682973834.886554,
        ],
    ],
    [
        2274393600000,
        [
            -6473796582.540914,
            -4181082202.019718,
            1681582763.935876,
        ],
    ],
    [
        2274998400000,
        [
            -6473029862.582422,
            -4182724121.410862,
            1680191547.059553,
        ],
    ],
    [
        2275603200000,
        [
            -6472262450.549582,
            -4184365574.592266,
            1678800184.855654,
        ],
    ],
    [
        2276208000000,
        [
            -6471494347.763945,
            -4186006561.401504,
            1677408677.607079,
        ],
    ],
    [
        2276812800000,
        [
            -6470725555.282873,
            -4187647082.021157,
            1676017025.392612,
        ],
    ],
    [
        2277417600000,
        [
            -6469956073.858011,
            -4189287136.778084,
            1674625228.185856,
        ],
    ],
    [
        2278022400000,
        [
            -6469185903.979748,
            -4190926726.031619,
            1673233285.9151,
        ],
    ],
    [
        2278627200000,
        [
            -6468415045.955142,
            -4192565850.131793,
            1671841198.488896,
        ],
    ],
    [
        2279232000000,
        [
            -6467643499.994496,
            -4194204509.466479,
            1670448965.774784,
        ],
    ],
    [
        2279836800000,
        [
            -6466871266.207881,
            -4195842704.65286,
            1669056587.491527,
        ],
    ],
    [
        2280441600000,
        [
            -6466098344.173235,
            -4197480436.79726,
            1667664063.020574,
        ],
    ],
    [
        2281046400000,
        [
            -6465324731.869019,
            -4199117707.035215,
            1666271391.53658,
        ],
    ],
    [
        2281651200000,
        [
            -6464550425.770236,
            -4200754514.802341,
            1664878572.9371,
        ],
    ],
    [
        2282256000000,
        [
            -6463775423.129715,
            -4202390857.522569,
            1663485608.242345,
        ],
    ],
    [
        2282860800000,
        [
            -6462999722.829718,
            -4204026732.19121,
            1662092498.83565,
        ],
    ],
    [
        2283465600000,
        [
            -6462223324.610647,
            -4205662136.086801,
            1660699246.002548,
        ],
    ],
    [
        2284070400000,
        [
            -6461446228.570676,
            -4207297066.659993,
            1659305850.938985,
        ],
    ],
    [
        2284675200000,
        [
            -6460668435.085469,
            -4208931521.374351,
            1657912314.830236,
        ],
    ],
    [
        2285280000000,
        [
            -6459889944.872608,
            -4210565497.658437,
            1656518638.886782,
        ],
    ],
    [
        2285884800000,
        [
            -6459110759.085145,
            -4212198992.945855,
            1655124824.337544,
        ],
    ],
    [
        2286489600000,
        [
            -6458330879.401684,
            -4213832004.793019,
            1653730872.382328,
        ],
    ],
    [
        2287094400000,
        [
            -6457550308.070956,
            -4215464531.107397,
            1652336784.081387,
        ],
    ],
    [
        2287699200000,
        [
            -6456769047.728301,
            -4217096570.522241,
            1650942560.14362,
        ],
    ],
    [
        2288304000000,
        [
            -6455987100.563368,
            -4218728122.605816,
            1649548200.736201,
        ],
    ],
    [
        2288908800000,
        [
            -6455204467.291638,
            -4220359186.844433,
            1648153705.928848,
        ],
    ],
    [
        2289513600000,
        [
            -6454421148.296875,
            -4221989761.167024,
            1646759076.607539,
        ],
    ],
    [
        2290118400000,
        [
            -6453637145.580689,
            -4223619842.816127,
            1645364314.217693,
        ],
    ],
    [
        2290723200000,
        [
            -6452852462.482054,
            -4225249429.77687,
            1643969419.97742,
        ],
    ],
    [
        2291328000000,
        [
            -6452067102.754495,
            -4226878520.992024,
            1642574394.671784,
        ],
    ],
    [
        2291932800000,
        [
            -6451281070.141329,
            -4228507116.140386,
            1641179238.730906,
        ],
    ],
    [
        2292537600000,
        [
            -6450494368.248599,
            -4230135215.46156,
            1639783952.312975,
        ],
    ],
    [
        2293142400000,
        [
            -6449707000.51122,
            -4231762819.663625,
            1638388535.351517,
        ],
    ],
    [
        2293747200000,
        [
            -6448918970.190145,
            -4233389929.891402,
            1636992987.572312,
        ],
    ],
    [
        2294352000000,
        [
            -6448130280.377964,
            -4235016547.767311,
            1635597308.471274,
        ],
    ],
    [
        2294956800000,
        [
            -6447340933.934035,
            -4236642675.557067,
            1634201497.217188,
        ],
    ],
    [
        2295561600000,
        [
            -6446550933.050764,
            -4238268316.426437,
            1632805552.466496,
        ],
    ],
    [
        2296166400000,
        [
            -6445760278.140007,
            -4239893474.120579,
            1631409472.415057,
        ],
    ],
    [
        2296771200000,
        [
            -6444968967.523484,
            -4241518151.269042,
            1630013255.666428,
        ],
    ],
    [
        2297376000000,
        [
            -6444176999.51033,
            -4243142348.652052,
            1628616901.832977,
        ],
    ],
    [
        2297980800000,
        [
            -6443384373.518988,
            -4244766066.632973,
            1627220410.879991,
        ],
    ],
    [
        2298585600000,
        [
            -6442591089.329494,
            -4246389305.954518,
            1625823782.615387,
        ],
    ],
    [
        2299190400000,
        [
            -6441797146.476402,
            -4248012067.574975,
            1624427016.706457,
        ],
    ],
    [
        2299795200000,
        [
            -6441002544.120221,
            -4249634352.386896,
            1623030112.808811,
        ],
    ],
    [
        2300400000000,
        [
            -6440207281.116473,
            -4251256161.042278,
            1621633070.659056,
        ],
    ],
    [
        2301004800000,
        [
            -6439411356.148099,
            -4252877493.872488,
            1620235890.123863,
        ],
    ],
    [
        2301609600000,
        [
            -6438614767.882667,
            -4254498350.893563,
            1618838571.206768,
        ],
    ],
    [
        2302214400000,
        [
            -6437817515.116855,
            -4256118731.929176,
            1617441113.991879,
        ],
    ],
    [
        2302819200000,
        [
            -6437019596.751644,
            -4257738636.900502,
            1616043518.482221,
        ],
    ],
    [
        2303424000000,
        [
            -6436221011.186674,
            -4259358066.061502,
            1614645784.408623,
        ],
    ],
    [
        2304028800000,
        [
            -6435421755.324801,
            -4260977019.168877,
            1613247911.569035,
        ],
    ],
    [
        2304633600000,
        [
            -6434621825.483522,
            -4262595493.87535,
            1611849900.781986,
        ],
    ],
    [
        2305238400000,
        [
            -6433821219.625998,
            -4264213486.302694,
            1610451753.813896,
        ],
    ],
    [
        2305843200000,
        [
            -6433019937.468529,
            -4265830992.629165,
            1609053472.545927,
        ],
    ],
    [
        2306448000000,
        [
            -6432217979.628798,
            -4267448009.503738,
            1607655058.669472,
        ],
    ],
    [
        2307052800000,
        [
            -6431415347.222278,
            -4269064533.916322,
            1606256513.719617,
        ],
    ],
    [
        2307657600000,
        [
            -6430612041.778097,
            -4270680563.098237,
            1604857839.126184,
        ],
    ],
    [
        2308262400000,
        [
            -6429808065.245778,
            -4272296094.514596,
            1603459036.225381,
        ],
    ],
    [
        2308867200000,
        [
            -6429003420.01808,
            -4273911125.921625,
            1602060106.238441,
        ],
    ],
    [
        2309472000000,
        [
            -6428198108.948011,
            -4275525655.492153,
            1600661050.212976,
        ],
    ],
    [
        2310076800000,
        [
            -6427392135.297525,
            -4277139682.05566,
            1599261868.895578,
        ],
    ],
    [
        2310681600000,
        [
            -6426585502.35936,
            -4278753205.449757,
            1597862562.510349,
        ],
    ],
    [
        2311286400000,
        [
            -6425778212.374954,
            -4280366226.434204,
            1596463130.697434,
        ],
    ],
    [
        2311891200000,
        [
            -6424970265.898171,
            -4281978745.206478,
            1595063573.243922,
        ],
    ],
    [
        2312496000000,
        [
            -6424161663.603735,
            -4283590760.41017,
            1593663890.803777,
        ],
    ],
    [
        2313100800000,
        [
            -6423352407.658645,
            -4285202270.488565,
            1592264084.318613,
        ],
    ],
    [
        2313705600000,
        [
            -6422542501.010127,
            -4286813274.70802,
            1590864154.398054,
        ],
    ],
    [
        2314310400000,
        [
            -6421731946.612877,
            -4288423773.098426,
            1589464101.271319,
        ],
    ],
    [
        2314915200000,
        [
            -6420920747.155351,
            -4290033766.184852,
            1588063924.901093,
        ],
    ],
    [
        2315520000000,
        [
            -6420108905.010528,
            -4291643254.80325,
            1586663625.074786,
        ],
    ],
    [
        2316124800000,
        [
            -6419296422.258435,
            -4293252239.997025,
            1585263201.459156,
        ],
    ],
    [
        2316729600000,
        [
            -6418483300.738953,
            -4294860722.979967,
            1583862653.621806,
        ],
    ],
    [
        2317334400000,
        [
            -6417669542.106778,
            -4296468705.191934,
            1582461981.002688,
        ],
    ],
    [
        2317939200000,
        [
            -6416855147.762931,
            -4298076188.501892,
            1581061182.793545,
        ],
    ],
    [
        2318544000000,
        [
            -6416040118.282397,
            -4299683175.411936,
            1579660257.76433,
        ],
    ],
    [
        2319148800000,
        [
            -6415224452.323674,
            -4301289668.339484,
            1578259204.528281,
        ],
    ],
    [
        2319753600000,
        [
            -6414408147.145067,
            -4302895667.847232,
            1576858022.535772,
        ],
    ],
    [
        2320358400000,
        [
            -6413591200.907196,
            -4304501172.758541,
            1575456712.246354,
        ],
    ],
    [
        2320963200000,
        [
            -6412773613.110447,
            -4306106181.711541,
            1574055274.339712,
        ],
    ],
    [
        2321568000000,
        [
            -6411955383.784045,
            -4307710693.636292,
            1572653709.37362,
        ],
    ],
    [
        2322172800000,
        [
            -6411136513.079618,
            -4309314707.572346,
            1571252017.837374,
        ],
    ],
    [
        2322777600000,
        [
            -6410317001.240829,
            -4310918222.498795,
            1569850200.238889,
        ],
    ],
    [
        2323382400000,
        [
            -6409496848.69346,
            -4312521237.278051,
            1568448257.144934,
        ],
    ],
    [
        2323987200000,
        [
            -6408676056.160701,
            -4314123750.687456,
            1567046189.178493,
        ],
    ],
    [
        2324592000000,
        [
            -6407854624.774282,
            -4315725761.535573,
            1565643996.971744,
        ],
    ],
    [
        2325196800000,
        [
            -6407032556.126518,
            -4317327268.902917,
            1564241681.047573,
        ],
    ],
    [
        2325801600000,
        [
            -6406209852.037802,
            -4318928272.524441,
            1562839241.5967,
        ],
    ],
    [
        2326406400000,
        [
            -6405386513.62539,
            -4320528772.875913,
            1561436678.341169,
        ],
    ],
    [
        2327011200000,
        [
            -6404562540.493203,
            -4322128769.915484,
            1560033991.129009,
        ],
    ],
    [
        2327616000000,
        [
            -6403737932.299838,
            -4323728261.872352,
            1558631180.749981,
        ],
    ],
    [
        2328220800000,
        [
            -6402912690.43999,
            -4325327246.456935,
            1557228248.468999,
        ],
    ],
    [
        2328825600000,
        [
            -6402086817.506321,
            -4326925722.11519,
            1555825195.305383,
        ],
    ],
    [
        2329430400000,
        [
            -6401260316.444081,
            -4328523688.115058,
            1554422021.903316,
        ],
    ],
    [
        2330035200000,
        [
            -6400433190.208597,
            -4330121144.328532,
            1553018728.615983,
        ],
    ],
    [
        2330640000000,
        [
            -6399605441.672108,
            -4331718091.08179,
            1551615315.578077,
        ],
    ],
    [
        2331244800000,
        [
            -6398777073.605292,
            -4333314529.083865,
            1550211782.742899,
        ],
    ],
    [
        2331849600000,
        [
            -6397948088.684464,
            -4334910459.414968,
            1548808129.889112,
        ],
    ],
    [
        2332454400000,
        [
            -6397118489.500313,
            -4336505883.593897,
            1547404356.584246,
        ],
    ],
    [
        2333059200000,
        [
            -6396288278.466164,
            -4338100803.779105,
            1546000462.065302,
        ],
    ],
    [
        2333664000000,
        [
            -6395457457.280638,
            -4339695223.014742,
            1544596445.048167,
        ],
    ],
    [
        2334268800000,
        [
            -6394626025.77039,
            -4341289144.705868,
            1543192303.883664,
        ],
    ],
    [
        2334873600000,
        [
            -6393793981.981498,
            -4342882570.841292,
            1541788037.511195,
        ],
    ],
    [
        2335478400000,
        [
            -6392961324.399066,
            -4344475501.712768,
            1540383645.832729,
        ],
    ],
    [
        2336083200000,
        [
            -6392128052.652913,
            -4346067937.436297,
            1538979128.966648,
        ],
    ],
    [
        2336688000000,
        [
            -6391294166.679412,
            -4347659878.541764,
            1537574486.839,
        ],
    ],
    [
        2337292800000,
        [
            -6390459666.19978,
            -4349251325.757811,
            1536169719.237242,
        ],
    ],
    [
        2337897600000,
        [
            -6389624550.630464,
            -4350842279.752501,
            1534764825.932353,
        ],
    ],
    [
        2338502400000,
        [
            -6388788819.156157,
            -4352432740.981411,
            1533359806.760669,
        ],
    ],
    [
        2339107200000,
        [
            -6387952470.855528,
            -4354022709.624001,
            1531954661.664497,
        ],
    ],
    [
        2339712000000,
        [
            -6387115504.848076,
            -4355612185.604781,
            1530549390.690429,
        ],
    ],
    [
        2340316800000,
        [
            -6386277920.416475,
            -4357201168.73879,
            1529143993.919735,
        ],
    ],
    [
        2340921600000,
        [
            -6385439716.911185,
            -4358789659.039558,
            1527738471.290712,
        ],
    ],
    [
        2341526400000,
        [
            -6384600893.011047,
            -4360377656.859738,
            1526332822.445213,
        ],
    ],
    [
        2342131200000,
        [
            -6383761445.851032,
            -4361965161.802288,
            1524927047.219862,
        ],
    ],
    [
        2342736000000,
        [
            -6382921372.373709,
            -4363552171.28546,
            1523521146.554256,
        ],
    ],
    [
        2343340800000,
        [
            -6382080671.359778,
            -4365138681.505404,
            1522115122.190282,
        ],
    ],
    [
        2343945600000,
        [
            -6381239343.21025,
            -4366724688.880829,
            1520708975.882524,
        ],
    ],
    [
        2344550400000,
        [
            -6380397389.138998,
            -4368310190.306118,
            1519302709.185454,
        ],
    ],
    [
        2345155200000,
        [
            -6379554810.850199,
            -4369895183.009435,
            1517896323.502924,
        ],
    ],
    [
        2345760000000,
        [
            -6378711610.485183,
            -4371479664.473566,
            1516489820.132743,
        ],
    ],
    [
        2346364800000,
        [
            -6377867790.638575,
            -4373063632.446296,
            1515083200.270976,
        ],
    ],
    [
        2346969600000,
        [
            -6377023354.383972,
            -4374647085.014697,
            1513676464.983116,
        ],
    ],
    [
        2347574400000,
        [
            -6376178305.287154,
            -4376230020.75331,
            1512269615.134217,
        ],
    ],
    [
        2348179200000,
        [
            -6375332647.325137,
            -4377812438.996292,
            1510862651.242513,
        ],
    ],
    [
        2348784000000,
        [
            -6374486384.405301,
            -4379394340.188619,
            1509455573.248629,
        ],
    ],
    [
        2349388800000,
        [
            -6373639519.195688,
            -4380975725.618236,
            1508048380.543249,
        ],
    ],
    [
        2349993600000,
        [
            -6372792052.826733,
            -4382556595.779591,
            1506641072.815198,
        ],
    ],
    [
        2350598400000,
        [
            -6371943986.933338,
            -4384136949.792363,
            1505233650.577157,
        ],
    ],
    [
        2351203200000,
        [
            -6371095324.616532,
            -4385716786.9181,
            1503826114.457558,
        ],
    ],
    [
        2351808000000,
        [
            -6370246069.580054,
            -4387296107.365189,
            1502418464.682514,
        ],
    ],
    [
        2352412800000,
        [
            -6369396225.43611,
            -4388874912.147608,
            1501010701.079659,
        ],
    ],
    [
        2353017600000,
        [
            -6368545795.474507,
            -4390453202.825941,
            1499602823.191806,
        ],
    ],
    [
        2353622400000,
        [
            -6367694782.617621,
            -4392030981.338281,
            1498194830.360789,
        ],
    ],
    [
        2354227200000,
        [
            -6366843189.434716,
            -4393608249.906103,
            1496786721.776403,
        ],
    ],
    [
        2354832000000,
        [
            -6365991018.182282,
            -4395185011.005736,
            1495378496.492065,
        ],
    ],
    [
        2355436800000,
        [
            -6365138270.835942,
            -4396761267.438807,
            1493970153.385862,
        ],
    ],
    [
        2356041600000,
        [
            -6364284948.955736,
            -4398337022.550097,
            1492561691.024864,
        ],
    ],
    [
        2356646400000,
        [
            -6363431052.97371,
            -4399912280.354557,
            1491153107.517503,
        ],
    ],
    [
        2357251200000,
        [
            -6362576581.154107,
            -4401487044.55129,
            1489744400.926233,
        ],
    ],
    [
        2357856000000,
        [
            -6361721530.551939,
            -4403061316.823407,
            1488335570.2685,
        ],
    ],
    [
        2358460800000,
        [
            -6360865899.205497,
            -4404635097.366081,
            1486926615.455156,
        ],
    ],
    [
        2359065600000,
        [
            -6360009686.196716,
            -4406208386.330894,
            1485517536.518807,
        ],
    ],
    [
        2359670400000,
        [
            -6359152890.850728,
            -4407781184.093769,
            1484108333.382025,
        ],
    ],
    [
        2360275200000,
        [
            -6358295512.4186,
            -4409353491.020591,
            1482699005.944805,
        ],
    ],
    [
        2360880000000,
        [
            -6357437550.091111,
            -4410925307.287584,
            1481289554.178125,
        ],
    ],
    [
        2361484800000,
        [
            -6356579003.114871,
            -4412496632.81431,
            1479879978.169188,
        ],
    ],
    [
        2362089600000,
        [
            -6355719870.933146,
            -4414067467.284503,
            1478470278.123641,
        ],
    ],
    [
        2362694400000,
        [
            -6354860153.323339,
            -4415637810.259798,
            1477060454.319214,
        ],
    ],
    [
        2363299200000,
        [
            -6353999850.459533,
            -4417207661.432619,
            1475650506.97855,
        ],
    ],
    [
        2363904000000,
        [
            -6353138962.62766,
            -4418777021.006324,
            1474240436.039253,
        ],
    ],
    [
        2364508800000,
        [
            -6352277489.224517,
            -4420345889.623272,
            1472830241.092224,
        ],
    ],
    [
        2365113600000,
        [
            -6351415428.264295,
            -4421914266.906612,
            1471419922.113882,
        ],
    ],
    [
        2365718400000,
        [
            -6350552778.307848,
            -4423482150.610621,
            1470009480.124679,
        ],
    ],
    [
        2366323200000,
        [
            -6349689539.812041,
            -4425049538.088971,
            1468598916.549397,
        ],
    ],
    [
        2366928000000,
        [
            -6348825714.418856,
            -4426616427.3582,
            1467188232.580213,
        ],
    ],
    [
        2367532800000,
        [
            -6347961304.214835,
            -4428182817.102377,
            1465777429.102061,
        ],
    ],
    [
        2368137600000,
        [
            -6347096311.468393,
            -4429748706.48632,
            1464366506.769315,
        ],
    ],
    [
        2368742400000,
        [
            -6346230738.569273,
            -4431314095.051398,
            1462955466.058726,
        ],
    ],
    [
        2369347200000,
        [
            -6345364588.023495,
            -4432878982.68645,
            1461544307.287305,
        ],
    ],
    [
        2369952000000,
        [
            -6344497862.464928,
            -4434443369.658826,
            1460133030.59912,
        ],
    ],
    [
        2370556800000,
        [
            -6343630564.655163,
            -4436007256.731741,
            1458721635.904016,
        ],
    ],
    [
        2371161600000,
        [
            -6342762697.341444,
            -4437570645.420236,
            1457310122.726856,
        ],
    ],
    [
        2371766400000,
        [
            -6341894262.586721,
            -4439133538.222172,
            1455898490.014663,
        ],
    ],
    [
        2372371200000,
        [
            -6341025260.602984,
            -4440695937.878119,
            1454486736.410378,
        ],
    ],
    [
        2372976000000,
        [
            -6340155690.262444,
            -4442257845.618619,
            1453074861.240662,
        ],
    ],
    [
        2373580800000,
        [
            -6339285551.29905,
            -4443819261.354437,
            1451662864.640063,
        ],
    ],
    [
        2374185600000,
        [
            -6338414844.582845,
            -4445380185.194715,
            1450250746.76548,
        ],
    ],
    [
        2374790400000,
        [
            -6337543571.222225,
            -4446940617.844573,
            1448838507.487219,
        ],
    ],
    [
        2375395200000,
        [
            -6336671732.09785,
            -4448500560.355771,
            1447426146.469825,
        ],
    ],
    [
        2376000000000,
        [
            -6335799327.777936,
            -4450060013.883306,
            1446013663.288823,
        ],
    ],
    [
        2376604800000,
        [
            -6334926358.568391,
            -4451618979.543103,
            1444601057.507112,
        ],
    ],
    [
        2377209600000,
        [
            -6334052824.609673,
            -4453177458.348996,
            1443188328.713758,
        ],
    ],
    [
        2377814400000,
        [
            -6333178725.993905,
            -4454735451.232333,
            1441775476.520871,
        ],
    ],
    [
        2378419200000,
        [
            -6332304062.845471,
            -4456292959.190927,
            1440362500.487984,
        ],
    ],
    [
        2379024000000,
        [
            -6331428835.130425,
            -4457849983.585899,
            1438949399.939994,
        ],
    ],
    [
        2379628800000,
        [
            -6330553041.78323,
            -4459406526.128914,
            1437536173.880725,
        ],
    ],
    [
        2380233600000,
        [
            -6329676680.039142,
            -4460962587.528693,
            1436122821.645189,
        ],
    ],
    [
        2380838400000,
        [
            -6328799747.178146,
            -4462518166.307133,
            1434709343.71239,
        ],
    ],
    [
        2381443200000,
        [
            -6327922242.258263,
            -4464073260.053936,
            1433295741.215706,
        ],
    ],
    [
        2382048000000,
        [
            -6327044165.648515,
            -4465627866.65996,
            1431882015.238195,
        ],
    ],
    [
        2382652800000,
        [
            -6326165518.304323,
            -4467181984.420961,
            1430468166.686068,
        ],
    ],
    [
        2383257600000,
        [
            -6325286301.531481,
            -4468735611.878736,
            1429054196.354285,
        ],
    ],
    [
        2383862400000,
        [
            -6324406516.974981,
            -4470288747.749257,
            1427640104.969952,
        ],
    ],
    [
        2384467200000,
        [
            -6323526166.66051,
            -4471841390.940294,
            1426225893.194044,
        ],
    ],
    [
        2385072000000,
        [
            -6322645253.040144,
            -4473393540.635988,
            1424811561.588186,
        ],
    ],
    [
        2385676800000,
        [
            -6321763779.017182,
            -4474945196.46499,
            1423397110.534665,
        ],
    ],
    [
        2386281600000,
        [
            -6320881747.843831,
            -4476496358.802983,
            1421982540.071227,
        ],
    ],
    [
        2386886400000,
        [
            -6319999162.539661,
            -4478047029.10538,
            1420567849.659595,
        ],
    ],
    [
        2387491200000,
        [
            -6319116024.691109,
            -4479597209.425767,
            1419153038.32413,
        ],
    ],
    [
        2388096000000,
        [
            -6318232334.5668,
            -4481146900.709353,
            1417738105.580294,
        ],
    ],
    [
        2388700800000,
        [
            -6317348093.279138,
            -4482696102.664091,
            1416323051.731191,
        ],
    ],
    [
        2389305600000,
        [
            -6316463303.331839,
            -4484244815.341344,
            1414907877.08246,
        ],
    ],
    [
        2389910400000,
        [
            -6315577967.680874,
            -4485793039.729435,
            1413492581.52937,
        ],
    ],
    [
        2390515200000,
        [
            -6314692089.129601,
            -4487340777.558539,
            1412077164.598658,
        ],
    ],
    [
        2391120000000,
        [
            -6313805670.140577,
            -4488888031.057591,
            1410661625.557952,
        ],
    ],
    [
        2391724800000,
        [
            -6312918712.800241,
            -4490434802.801972,
            1409245963.491345,
        ],
    ],
    [
        2392329600000,
        [
            -6312031218.833407,
            -4491981095.630883,
            1407830177.341752,
        ],
    ],
    [
        2392934400000,
        [
            -6311143189.640156,
            -4493526912.631192,
            1406414265.918962,
        ],
    ],
    [
        2393539200000,
        [
            -6310254626.3113,
            -4495072257.228168,
            1404998227.847349,
        ],
    ],
    [
        2394144000000,
        [
            -6309365529.426041,
            -4496617133.418584,
            1403582061.414025,
        ],
    ],
    [
        2394748800000,
        [
            -6308475898.210225,
            -4498161545.795036,
            1402165764.461501,
        ],
    ],
    [
        2395353600000,
        [
            -6307585729.63756,
            -4499705498.300562,
            1400749334.952143,
        ],
    ],
    [
        2395958400000,
        [
            -6306695019.823118,
            -4501248992.716517,
            1399332771.912144,
        ],
    ],
    [
        2396563200000,
        [
            -6305803765.995087,
            -4502792029.562442,
            1397916075.146663,
        ],
    ],
    [
        2397168000000,
        [
            -6304911966.242982,
            -4504334609.379189,
            1396499244.520035,
        ],
    ],
    [
        2397772800000,
        [
            -6304019618.770422,
            -4505876732.831467,
            1395082279.815823,
        ],
    ],
    [
        2398377600000,
        [
            -6303126721.663109,
            -4507418400.452188,
            1393665180.8424,
        ],
    ],
    [
        2398982400000,
        [
            -6302233272.942014,
            -4508959612.471058,
            1392247947.524182,
        ],
    ],
    [
        2399587200000,
        [
            -6301339270.702386,
            -4510500368.753739,
            1390830579.944079,
        ],
    ],
    [
        2400192000000,
        [
            -6300444713.27532,
            -4512040668.829883,
            1389413078.342453,
        ],
    ],
    [
        2400796800000,
        [
            -6299549599.382934,
            -4513580512.023143,
            1387995443.062692,
        ],
    ],
    [
        2401401600000,
        [
            -6298653928.194475,
            -4515119897.733832,
            1386577674.406826,
        ],
    ],
    [
        2402006400000,
        [
            -6297757698.962342,
            -4516658825.818231,
            1385159772.397742,
        ],
    ],
    [
        2402611200000,
        [
            -6296860909.966482,
            -4518197296.335876,
            1383741736.809042,
        ],
    ],
    [
        2403216000000,
        [
            -6295963558.396721,
            -4519735307.96516,
            1382323568.004857,
        ],
    ],
    [
        2403820800000,
        [
            -6295065642.515439,
            -4521272857.590587,
            1380905267.391003,
        ],
    ],
    [
        2404425600000,
        [
            -6294167162.610157,
            -4522809941.935035,
            1379486836.648988,
        ],
    ],
    [
        2405030400000,
        [
            -6293268120.158148,
            -4524346558.427004,
            1378068277.193918,
        ],
    ],
    [
        2405635200000,
        [
            -6292368517.174649,
            -4525882705.152196,
            1376649590.140632,
        ],
    ],
    [
        2406240000000,
        [
            -6291468355.996428,
            -4527418380.700774,
            1375230776.370415,
        ],
    ],
    [
        2406844800000,
        [
            -6290567639.226263,
            -4528953584.101327,
            1373811836.567541,
        ],
    ],
    [
        2407449600000,
        [
            -6289666369.718054,
            -4530488314.823029,
            1372392771.222874,
        ],
    ],
    [
        2408054400000,
        [
            -6288764550.572102,
            -4532022572.836107,
            1370973580.606494,
        ],
    ],
    [
        2408659200000,
        [
            -6287862185.106074,
            -4533556358.763953,
            1369554264.687879,
        ],
    ],
    [
        2409264000000,
        [
            -6286959276.638181,
            -4535089674.172187,
            1368134822.96241,
        ],
    ],
    [
        2409868800000,
        [
            -6286055827.66902,
            -4536622521.735851,
            1366715254.279644,
        ],
    ],
    [
        2410473600000,
        [
            -6285151838.770499,
            -4538154904.24865,
            1365295557.258769,
        ],
    ],
    [
        2411078400000,
        [
            -6284247309.528319,
            -4539686822.979181,
            1363875731.264551,
        ],
    ],
    [
        2411683200000,
        [
            -6283342240.597215,
            -4541218278.286571,
            1362455776.290461,
        ],
    ],
    [
        2412288000000,
        [
            -6282436633.590869,
            -4542749271.035848,
            1361035692.189227,
        ],
    ],
    [
        2412892800000,
        [
            -6281530490.181396,
            -4544279802.811382,
            1359615478.462713,
        ],
    ],
    [
        2413497600000,
        [
            -6280623811.695339,
            -4545809875.637295,
            1358195134.365746,
        ],
    ],
    [
        2414102400000,
        [
            -6279716599.040799,
            -4547339491.740829,
            1356774659.020535,
        ],
    ],
    [
        2414707200000,
        [
            -6278808852.746951,
            -4548868653.411332,
            1355354051.491046,
        ],
    ],
    [
        2415312000000,
        [
            -6277900573.045532,
            -4550397362.933182,
            1353933310.821766,
        ],
    ],
    [
        2415916800000,
        [
            -6276991759.970076,
            -4551925622.602969,
            1352512436.033087,
        ],
    ],
    [
        2416521600000,
        [
            -6276082413.400373,
            -4553453434.882979,
            1351091426.038187,
        ],
    ],
    [
        2417126400000,
        [
            -6275172532.772058,
            -4554980802.677501,
            1349670279.459929,
        ],
    ],
    [
        2417731200000,
        [
            -6274262116.095876,
            -4556507729.130832,
            1348248994.632326,
        ],
    ],
    [
        2418336000000,
        [
            -6273351159.584562,
            -4558034216.052033,
            1346827570.399434,
        ],
    ],
    [
        2418940800000,
        [
            -6272439659.709864,
            -4559560263.069489,
            1345406006.777149,
        ],
    ],
    [
        2419545600000,
        [
            -6271527614.570595,
            -4561085869.083843,
            1343984304.317019,
        ],
    ],
    [
        2420150400000,
        [
            -6270615023.252163,
            -4562611033.262826,
            1342562463.508123,
        ],
    ],
    [
        2420755200000,
        [
            -6269701885.203781,
            -4564135755.023169,
            1341140484.723336,
        ],
    ],
    [
        2421360000000,
        [
            -6268788200.083989,
            -4565660033.859554,
            1339718368.297127,
        ],
    ],
    [
        2421964800000,
        [
            -6267873967.792485,
            -4567183869.275823,
            1338296114.569225,
        ],
    ],
    [
        2422569600000,
        [
            -6266959188.542851,
            -4568707260.805339,
            1336873723.885809,
        ],
    ],
    [
        2423174400000,
        [
            -6266043862.936269,
            -4570230208.10276,
            1335451196.563317,
        ],
    ],
    [
        2423779200000,
        [
            -6265127992.005585,
            -4571752711.130967,
            1334028532.798673,
        ],
    ],
    [
        2424384000000,
        [
            -6264211577.093267,
            -4573274770.491073,
            1332605732.485895,
        ],
    ],
    [
        2424988800000,
        [
            -6263294619.171422,
            -4574796387.712643,
            1331182794.995881,
        ],
    ],
    [
        2425593600000,
        [
            -6262377117.682341,
            -4576317564.534812,
            1329759719.445094,
        ],
    ],
    [
        2426198400000,
        [
            -6261459071.119797,
            -4577838301.229648,
            1328336505.655495,
        ],
    ],
    [
        2426803200000,
        [
            -6260540479.190696,
            -4579358596.934254,
            1326913154.204106,
        ],
    ],
    [
        2427408000000,
        [
            -6259621342.980938,
            -4580878451.209024,
            1325489665.609823,
        ],
    ],
    [
        2428012800000,
        [
            -6258701664.011587,
            -4582397864.445752,
            1324066040.018712,
        ],
    ],
    [
        2428617600000,
        [
            -6257781443.734092,
            -4583916837.650907,
            1322642277.267566,
        ],
    ],
    [
        2429222400000,
        [
            -6256860683.389815,
            -4585435372.23457,
            1321218376.98118,
        ],
    ],
    [
        2429827200000,
        [
            -6255939383.993056,
            -4586953469.890122,
            1319794338.633001,
        ],
    ],
    [
        2430432000000,
        [
            -6255017546.354095,
            -4588471132.541387,
            1318370161.573018,
        ],
    ],
    [
        2431036800000,
        [
            -6254095171.117964,
            -4589988362.360446,
            1316945845.018733,
        ],
    ],
    [
        2431641600000,
        [
            -6253172258.761627,
            -4591505161.902584,
            1315521387.978555,
        ],
    ],
    [
        2432246400000,
        [
            -6252248809.3095,
            -4593021534.370785,
            1314096789.076193,
        ],
    ],
    [
        2432851200000,
        [
            -6251324821.366135,
            -4594537483.52575,
            1312672046.493191,
        ],
    ],
    [
        2433456000000,
        [
            -6250400291.433607,
            -4596053012.227336,
            1311247158.671717,
        ],
    ],
    [
        2434060800000,
        [
            -6249475215.669989,
            -4597568121.234444,
            1309822125.131874,
        ],
    ],
    [
        2434665600000,
        [
            -6248549591.52419,
            -4599082810.419169,
            1308396945.986319,
        ],
    ],
    [
        2435270400000,
        [
            -6247623417.21669,
            -4600597079.863917,
            1306971621.294401,
        ],
    ],
    [
        2435875200000,
        [
            -6246696691.041726,
            -4602110929.843797,
            1305546150.993651,
        ],
    ],
    [
        2436480000000,
        [
            -6245769411.180079,
            -4603624360.570405,
            1304120535.012201,
        ],
    ],
    [
        2437084800000,
        [
            -6244841575.753007,
            -4605137372.033357,
            1302694773.354784,
        ],
    ],
    [
        2437689600000,
        [
            -6243913182.948285,
            -4606649963.943906,
            1301268866.142711,
        ],
    ],
    [
        2438294400000,
        [
            -6242984231.168056,
            -4608162135.763565,
            1299842813.611971,
        ],
    ],
    [
        2438899200000,
        [
            -6242054719.167674,
            -4609673886.839273,
            1298416616.054919,
        ],
    ],
    [
        2439504000000,
        [
            -6241124646.068192,
            -4611185216.697857,
            1296990273.665305,
        ],
    ],
    [
        2440108800000,
        [
            -6240194010.87615,
            -4612696125.383117,
            1295563786.311058,
        ],
    ],
    [
        2440713600000,
        [
            -6239262811.400118,
            -4614206612.964649,
            1294137153.688552,
        ],
    ],
    [
        2441318400000,
        [
            -6238331044.555145,
            -4615716677.882628,
            1292710376.243831,
        ],
    ],
    [
        2441923200000,
        [
            -6237398708.624496,
            -4617226316.976593,
            1291283455.397997,
        ],
    ],
    [
        2442528000000,
        [
            -6236465803.806045,
            -4618735527.153023,
            1289856392.720214,
        ],
    ],
    [
        2443132800000,
        [
            -6235532331.321126,
            -4620244306.036389,
            1288429189.495358,
        ],
    ],
    [
        2443737600000,
        [
            -6234598292.861211,
            -4621752651.867596,
            1287001846.728913,
        ],
    ],
    [
        2444342400000,
        [
            -6233663690.421614,
            -4623260563.367445,
            1285574365.210456,
        ],
    ],
    [
        2444947200000,
        [
            -6232728526.263026,
            -4624768039.689651,
            1284146745.542137,
        ],
    ],
    [
        2445552000000,
        [
            -6231792802.903001,
            -4626275080.439023,
            1282718988.134783,
        ],
    ],
    [
        2446156800000,
        [
            -6230856523.112183,
            -4627781685.750692,
            1281291093.171036,
        ],
    ],
    [
        2446761600000,
        [
            -6229919689.870761,
            -4629287856.470275,
            1279863060.509487,
        ],
    ],
    [
        2447366400000,
        [
            -6228982306.082337,
            -4630793594.46556,
            1278434889.492356,
        ],
    ],
    [
        2447971200000,
        [
            -6228044373.625931,
            -4632298902.693866,
            1277006578.814043,
        ],
    ],
    [
        2448576000000,
        [
            -6227105892.397759,
            -4633803783.963886,
            1275578127.08496,
        ],
    ],
    [
        2449180800000,
        [
            -6226166861.675683,
            -4635308239.50965,
            1274149533.73518,
        ],
    ],
    [
        2449785600000,
        [
            -6225227281.924979,
            -4636812269.975919,
            1272720798.674398,
        ],
    ],
    [
        2450390400000,
        [
            -6224287154.375663,
            -4638315876.672841,
            1271291921.576142,
        ],
    ],
    [
        2450995200000,
        [
            -6223346480.164586,
            -4639819061.638506,
            1269862901.752718,
        ],
    ],
    [
        2451600000000,
        [
            -6222405259.995234,
            -4641321827.347399,
            1268433738.271944,
        ],
    ],
    [
        2452204800000,
        [
            -6221463494.079429,
            -4642824176.486095,
            1267004430.066227,
        ],
    ],
    [
        2452809600000,
        [
            -6220521182.172024,
            -4644326111.81802,
            1265574976.002854,
        ],
    ],
    [
        2453414400000,
        [
            -6219578323.642966,
            -4645827636.11777,
            1264145374.92025,
        ],
    ],
    [
        2454019200000,
        [
            -6218634917.562515,
            -4647328752.192395,
            1262715625.618591,
        ],
    ],
    [
        2454624000000,
        [
            -6217690962.707029,
            -4648829463.044912,
            1261285726.765818,
        ],
    ],
    [
        2455228800000,
        [
            -6216746457.158748,
            -4650329772.119329,
            1259855676.717936,
        ],
    ],
    [
        2455833600000,
        [
            -6215801397.254481,
            -4651829682.876781,
            1258425473.629336,
        ],
    ],
    [
        2456438400000,
        [
            -6214855777.585518,
            -4653329197.066978,
            1256995116.369458,
        ],
    ],
    [
        2457043200000,
        [
            -6213909593.259731,
            -4654828314.283891,
            1255564604.988375,
        ],
    ],
    [
        2457648000000,
        [
            -6212962840.872519,
            -4656327033.517088,
            1254133939.983481,
        ],
    ],
    [
        2458252800000,
        [
            -6212015517.769489,
            -4657825353.903601,
            1252703121.81757,
        ],
    ],
    [
        2458857600000,
        [
            -6211067621.539483,
            -4659323274.61777,
            1251272150.922687,
        ],
    ],
    [
        2459462400000,
        [
            -6210119149.941066,
            -4660820794.696829,
            1249841027.7847,
        ],
    ],
    [
        2460067200000,
        [
            -6209170100.983367,
            -4662317912.979315,
            1248409752.985081,
        ],
    ],
    [
        2460672000000,
        [
            -6208220473.039445,
            -4663814628.134695,
            1246978327.19873,
        ],
    ],
    [
        2461276800000,
        [
            -6207270264.957863,
            -4665310938.772485,
            1245546751.150409,
        ],
    ],
    [
        2461881600000,
        [
            -6206319476.132556,
            -4666806843.661912,
            1244115025.508827,
        ],
    ],
    [
        2462486400000,
        [
            -6205368106.357893,
            -4668302342.101398,
            1242683150.679218,
        ],
    ],
    [
        2463091200000,
        [
            -6204416155.050864,
            -4669797434.154754,
            1241251126.602058,
        ],
    ],
    [
        2463696000000,
        [
            -6203463620.207795,
            -4671292119.703678,
            1239818953.156887,
        ],
    ],
    [
        2464300800000,
        [
            -6202510499.45572,
            -4672786396.929284,
            1238386631.08809,
        ],
    ],
    [
        2464905600000,
        [
            -6201556792.078207,
            -4674280263.094674,
            1236954161.802042,
        ],
    ],
    [
        2465510400000,
        [
            -6200602498.833466,
            -4675773716.023904,
            1235521546.563095,
        ],
    ],
    [
        2466115200000,
        [
            -6199647621.03551,
            -4677266754.369574,
            1234088786.259818,
        ],
    ],
    [
        2466720000000,
        [
            -6198692160.124252,
            -4678759377.408397,
            1232655881.473362,
        ],
    ],
    [
        2467324800000,
        [
            -6197736117.543811,
            -4680251584.877237,
            1231222832.555367,
        ],
    ],
    [
        2467929600000,
        [
            -6196779494.717001,
            -4681743376.89405,
            1229789639.669653,
        ],
    ],
    [
        2468534400000,
        [
            -6195822293.049893,
            -4683234753.940672,
            1228356302.803133,
        ],
    ],
    [
        2469139200000,
        [
            -6194864513.943997,
            -4684725716.917336,
            1226922821.73834,
        ],
    ],
    [
        2469744000000,
        [
            -6193906158.74224,
            -4686216267.319985,
            1225489195.952608,
        ],
    ],
    [
        2470348800000,
        [
            -6192947228.322575,
            -4687706407.517714,
            1224055424.426421,
        ],
    ],
    [
        2470953600000,
        [
            -6191987722.003276,
            -4689196140.500044,
            1222621505.662845,
        ],
    ],
    [
        2471558400000,
        [
            -6191027637.139212,
            -4690685468.237174,
            1221187438.518769,
        ],
    ],
    [
        2472163200000,
        [
            -6190066971.138453,
            -4692174390.857683,
            1219753222.84939,
        ],
    ],
    [
        2472768000000,
        [
            -6189105722.681521,
            -4693662908.062627,
            1218318858.874733,
        ],
    ],
    [
        2473372800000,
        [
            -6188143890.997691,
            -4695151019.995322,
            1216884346.635263,
        ],
    ],
    [
        2473977600000,
        [
            -6187181475.224094,
            -4696638727.113645,
            1215449685.988697,
        ],
    ],
    [
        2474582400000,
        [
            -6186218474.250994,
            -4698126029.921378,
            1214014876.732427,
        ],
    ],
    [
        2475187200000,
        [
            -6185254886.772061,
            -4699612928.803408,
            1212579918.691918,
        ],
    ],
    [
        2475792000000,
        [
            -6184290711.398881,
            -4701099423.955383,
            1211144811.765779,
        ],
    ],
    [
        2476396800000,
        [
            -6183325946.799253,
            -4702585515.396777,
            1209709555.929521,
        ],
    ],
    [
        2477001600000,
        [
            -6182360591.823736,
            -4704071203.097463,
            1208274151.17848,
        ],
    ],
    [
        2477606400000,
        [
            -6181394645.472758,
            -4705556487.26849,
            1206838597.367755,
        ],
    ],
    [
        2478211200000,
        [
            -6180428106.30042,
            -4707041368.619699,
            1205402894.012907,
        ],
    ],
    [
        2478816000000,
        [
            -6179460971.375642,
            -4708525847.596559,
            1203967040.5916,
        ],
    ],
    [
        2479420800000,
        [
            -6178493237.053293,
            -4710009922.74478,
            1202531037.500136,
        ],
    ],
    [
        2480025600000,
        [
            -6177524901.213144,
            -4711493591.16986,
            1201094886.044096,
        ],
    ],
    [
        2480630400000,
        [
            -6176555963.436755,
            -4712976850.142998,
            1199658587.604095,
        ],
    ],
    [
        2481235200000,
        [
            -6175586424.128465,
            -4714459697.550856,
            1198222143.310626,
        ],
    ],
    [
        2481840000000,
        [
            -6174616284.069811,
            -4715942131.758617,
            1196785554.077779,
        ],
    ],
    [
        2482444800000,
        [
            -6173645544.308507,
            -4717424151.490797,
            1195348820.6623,
        ],
    ],
    [
        2483049600000,
        [
            -6172674206.146524,
            -4718905755.802584,
            1193911943.684414,
        ],
    ],
    [
        2483654400000,
        [
            -6171702271.148486,
            -4720386944.11498,
            1192474923.616238,
        ],
    ],
    [
        2484259200000,
        [
            -6170729741.148149,
            -4721867716.315555,
            1191037760.734264,
        ],
    ],
    [
        2484864000000,
        [
            -6169756618.194871,
            -4723348072.970172,
            1189600455.005442,
        ],
    ],
    [
        2485468800000,
        [
            -6168782904.193434,
            -4724828015.651203,
            1188163005.87825,
        ],
    ],
    [
        2486073600000,
        [
            -6167808599.846257,
            -4726307546.870578,
            1186725412.211467,
        ],
    ],
    [
        2486678400000,
        [
            -6166833703.942804,
            -4727786668.62273,
            1185287672.980358,
        ],
    ],
    [
        2487283200000,
        [
            -6165858215.093091,
            -4729265381.277012,
            1183849788.048094,
        ],
    ],
    [
        2487888000000,
        [
            -6164882133.202399,
            -4730743684.852221,
            1182411757.636509,
        ],
    ],
    [
        2488492800000,
        [
            -6163905458.817178,
            -4732221580.07417,
            1180973581.691082,
        ],
    ],
    [
        2489097600000,
        [
            -6162928192.343808,
            -4733699068.322275,
            1179535259.825144,
        ],
    ],
    [
        2489702400000,
        [
            -6161950333.77529,
            -4735176151.34182,
            1178096791.440784,
        ],
    ],
    [
        2490307200000,
        [
            -6160971882.655287,
            -4736652831.03943,
            1176658175.82892,
        ],
    ],
    [
        2490912000000,
        [
            -6159992838.119411,
            -4738129109.36277,
            1175219412.23148,
        ],
    ],
    [
        2491516800000,
        [
            -6159013198.969572,
            -4739604988.249023,
            1173780499.869532,
        ],
    ],
    [
        2492121600000,
        [
            -6158032963.753978,
            -4741080469.66682,
            1172341437.921523,
        ],
    ],
    [
        2492726400000,
        [
            -6157052130.734386,
            -4742555555.807013,
            1170902225.409958,
        ],
    ],
    [
        2493331200000,
        [
            -6156070697.369859,
            -4744030249.295928,
            1169462861.025898,
        ],
    ],
    [
        2493936000000,
        [
            -6155088659.246613,
            -4745504552.540466,
            1168023343.360068,
        ],
    ],
    [
        2494540800000,
        [
            -6154106010.504704,
            -4746978465.956209,
            1166583671.886224,
        ],
    ],
    [
        2495145600000,
        [
            -6153122746.168939,
            -4748451987.973724,
            1165143847.192563,
        ],
    ],
    [
        2495750400000,
        [
            -6152138862.710539,
            -4749925116.610656,
            1163703870.194489,
        ],
    ],
    [
        2496355200000,
        [
            -6151154357.26161,
            -4751397850.011124,
            1162263741.760922,
        ],
    ],
    [
        2496960000000,
        [
            -6150169227.204973,
            -4752870186.286019,
            1160823462.754606,
        ],
    ],
    [
        2497564800000,
        [
            -6149183470.150727,
            -4754342123.354264,
            1159383034.113695,
        ],
    ],
    [
        2498169600000,
        [
            -6148197084.037722,
            -4755813658.899598,
            1157942456.886399,
        ],
    ],
    [
        2498774400000,
        [
            -6147210067.259516,
            -4757284790.41712,
            1156501732.221974,
        ],
    ],
    [
        2499379200000,
        [
            -6146222418.784558,
            -4758755515.344398,
            1155060861.317577,
        ],
    ],
    [
        2499984000000,
        [
            -6145234138.219037,
            -4760225831.314915,
            1153619845.295233,
        ],
    ],
    [
        2500588800000,
        [
            -6144245225.598166,
            -4761695736.556624,
            1152178684.974265,
        ],
    ],
    [
        2501193600000,
        [
            -6143255680.486744,
            -4763165230.031379,
            1150737380.71138,
        ],
    ],
    [
        2501798400000,
        [
            -6142265501.11021,
            -4764634310.254497,
            1149295932.949469,
        ],
    ],
    [
        2502403200000,
        [
            -6141274685.822556,
            -4766102974.025924,
            1147854343.055728,
        ],
    ],
    [
        2503008000000,
        [
            -6140283234.864766,
            -4767571217.581106,
            1146412612.896926,
        ],
    ],
    [
        2503612800000,
        [
            -6139291149.883147,
            -4769039037.912546,
            1144970744.090946,
        ],
    ],
    [
        2504217600000,
        [
            -6138298433.057159,
            -4770506432.904608,
            1143528737.851153,
        ],
    ],
    [
        2504822400000,
        [
            -6137305086.72967,
            -4771973401.131437,
            1142086595.061897,
        ],
    ],
    [
        2505427200000,
        [
            -6136311113.296332,
            -4773439941.717505,
            1140644316.34637,
        ],
    ],
    [
        2506032000000,
        [
            -6135316515.172018,
            -4774906054.276799,
            1139201902.099367,
        ],
    ],
    [
        2506636800000,
        [
            -6134321294.782244,
            -4776371738.910543,
            1137759352.490246,
        ],
    ],
    [
        2507241600000,
        [
            -6133325454.556259,
            -4777836996.280828,
            1136316667.424399,
        ],
    ],
    [
        2507846400000,
        [
            -6132328996.826272,
            -4779301827.814195,
            1134873846.424463,
        ],
    ],
    [
        2508451200000,
        [
            -6131331923.29952,
            -4780766235.962045,
            1133430888.435862,
        ],
    ],
    [
        2509056000000,
        [
            -6130334233.888032,
            -4782230223.738723,
            1131987791.950688,
        ],
    ],
    [
        2509660800000,
        [
            -6129335926.671727,
            -4783693792.962753,
            1130544555.940808,
        ],
    ],
    [
        2510265600000,
        [
            -6128337000.072633,
            -4785156943.86129,
            1129101180.290801,
        ],
    ],
    [
        2510870400000,
        [
            -6127337453.644741,
            -4786619676.579182,
            1127657665.069154,
        ],
    ],
    [
        2511475200000,
        [
            -6126337287.230456,
            -4788081991.818683,
            1126214010.094054,
        ],
    ],
    [
        2512080000000,
        [
            -6125336500.394813,
            -4789543890.630729,
            1124770214.98066,
        ],
    ],
    [
        2512684800000,
        [
            -6124335092.305031,
            -4791005374.142522,
            1123326279.268187,
        ],
    ],
    [
        2513289600000,
        [
            -6123333061.782167,
            -4792466443.390018,
            1121882202.50862,
        ],
    ],
    [
        2513894400000,
        [
            -6122330407.409406,
            -4793927099.237789,
            1120437984.31476,
        ],
    ],
    [
        2514499200000,
        [
            -6121327127.664348,
            -4795387342.381334,
            1118993624.367082,
        ],
    ],
    [
        2515104000000,
        [
            -6120323221.032358,
            -4796847173.469861,
            1117549122.354943,
        ],
    ],
    [
        2515708800000,
        [
            -6119318685.918026,
            -4798306593.391614,
            1116104477.810959,
        ],
    ],
    [
        2516313600000,
        [
            -6118313519.930186,
            -4799765603.421969,
            1114659689.954951,
        ],
    ],
    [
        2516918400000,
        [
            -6117307718.964004,
            -4801224204.179172,
            1113214758.155164,
        ],
    ],
    [
        2517523200000,
        [
            -6116301278.439847,
            -4802682394.114111,
            1111769682.863167,
        ],
    ],
    [
        2518128000000,
        [
            -6115294195.395503,
            -4804140170.358298,
            1110324465.378621,
        ],
    ],
    [
        2518732800000,
        [
            -6114286468.348104,
            -4805597530.18939,
            1108879107.054377,
        ],
    ],
    [
        2519337600000,
        [
            -6113278096.477992,
            -4807054471.302229,
            1107433609.070534,
        ],
    ],
    [
        2519942400000,
        [
            -6112269079.294644,
            -4808510991.649376,
            1105987972.489229,
        ],
    ],
    [
        2520547200000,
        [
            -6111259416.587088,
            -4809967089.338567,
            1104542198.309015,
        ],
    ],
    [
        2521152000000,
        [
            -6110249108.451038,
            -4811422762.621855,
            1103096287.478415,
        ],
    ],
    [
        2521756800000,
        [
            -6109238155.329234,
            -4812878009.95057,
            1101650240.875629,
        ],
    ],
    [
        2522361600000,
        [
            -6108226558.042953,
            -4814332830.104476,
            1100204059.247388,
        ],
    ],
    [
        2522966400000,
        [
            -6107214317.738115,
            -4815787222.444659,
            1098757743.07233,
        ],
    ],
    [
        2523571200000,
        [
            -6106201435.452045,
            -4817241187.257547,
            1097311292.335746,
        ],
    ],
    [
        2524176000000,
        [
            -6105187910.98386,
            -4818694725.530577,
            1095864706.535071,
        ],
    ],
];
